import { defineComponent as _e, openBlock as $, createElementBlock as j, createElementVNode as ae, toDisplayString as Ie, createCommentVNode as ue, normalizeClass as ye, renderSlot as me, createBlock as xe, unref as q, createVNode as Oe, mergeProps as Te, shallowRef as kn, watch as ze, computed as W, toValue as Ke, reactive as ei, h as Rs, getCurrentInstance as ti, inject as Wn, resolveComponent as Na, createPropsRestProxy as ga, resolveDynamicComponent as Pt, withCtx as Ee, ref as pe, onMounted as mt, Transition as wn, normalizeProps as _t, guardReactiveProps as Dt, createTextVNode as wt, toRef as Ni, normalizeStyle as Ct, Teleport as ba, useSlots as An, onUpdated as ro, onUnmounted as Ln, withModifiers as sa, Fragment as Ge, renderList as vt, useModel as Wa, mergeModels as Sn, useTemplateRef as it, nextTick as Ya, createSlots as Xa, isRef as Bi, onBeforeUnmount as io, provide as ni, withDirectives as Jt, withKeys as ai, vModelCheckbox as lo, vModelDynamic as Pi, readonly as oo, vShow as ri, createStaticVNode as Fs, TransitionGroup as Ns, getCurrentScope as Bs, onScopeDispose as Ps, shallowReadonly as Mn, version as zs, vModelRadio as Vs, toRefs as Ca, onServerPrefetch as Hs, onBeforeMount as Us, vModelText as qs } from "vue";
import { toArray as js, unrefElement as so, tryOnScopeDispose as Zs, refDebounced as Ws, useTransition as Ys, TransitionPresets as Xs, useScrollLock as uo, onClickOutside as Ga, onKeyStroke as co, useEventListener as on, useMediaQuery as Gs, usePreferredReducedMotion as fo, useVibrate as ho, useTimeoutFn as ta, useIntervalFn as Ks, useDebounceFn as Js, useElementSize as Vr, useResizeObserver as Qs, usePointerSwipe as eu } from "@vueuse/core";
import { isNotNestedPath as tu, cleanupNonNestedPath as nu, useForm as au, useField as ru } from "vee-validate";
const iu = {
  key: 0,
  class: "lc-count-bubble"
}, Hr = /* @__PURE__ */ _e({
  __name: "LcCountBubble",
  props: {
    count: {}
  },
  setup(e) {
    return (t, n) => e.count ? ($(), j("div", iu, [
      ae("span", null, Ie(Math.min(e.count, 99)), 1)
    ])) : ue("", !0);
  }
}), Qe = /* @__PURE__ */ _e({
  __name: "LcIcon",
  props: {
    name: {},
    size: { default: "medium" }
  },
  setup(e) {
    return (t, n) => ($(), j("i", {
      "aria-hidden": "true",
      class: ye(["lc-icon", `lc-icon--${e.name}`, `lc-icon--size-${e.size}`]),
      focusable: "false"
    }, null, 2));
  }
}), O1 = ["large", "medium", "small"], R1 = [
  "account-balance",
  "add",
  "alarm",
  "alert-circle",
  "alert-triangle",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-right-small",
  "arrow-up",
  "arrowhead-right",
  "award",
  "bank",
  "bell",
  "bell-off",
  "calendar",
  "camera",
  "camera-scan",
  "card-add-funds",
  "card-expired",
  "card-okay",
  "careers",
  "chat",
  "checkmark",
  "checkmark-circle",
  "checkmark-small",
  "chevron-circle",
  "chevron-close",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "close",
  "close-account",
  "close-large",
  "cloud-upload",
  "copy",
  "data",
  "day-afternoon",
  "day-evening",
  "day-midday",
  "day-morning",
  "deposit-limits",
  "download",
  "dropdown-down",
  "dropdown-left",
  "dropdown-right",
  "dropdown-up",
  "edit",
  "edit-active",
  "email",
  "emoji-bad",
  "emoji-good",
  "emoji-ok",
  "exclamation",
  "external-link",
  "eye",
  "eye-close",
  "eye-off",
  "file",
  "file-text",
  "file-type",
  "filter",
  "fire",
  "flash",
  "flash-plus",
  "game",
  "gift",
  "heart",
  "helpcenter",
  "hero",
  "hit-megahit",
  "hit-powerhit",
  "house",
  "id",
  "info",
  "info-help",
  "keno",
  "language",
  "language-lt",
  "limits",
  "limits-purchase",
  "link",
  "list",
  "loader",
  "location",
  "location-not-allowed",
  "lock",
  "login",
  "logout",
  "map",
  "mark-all-as-read",
  "menu",
  "message-circle",
  "message-square",
  "minus",
  "mobile-phone",
  "more-horizontal",
  "more-vertical",
  "orders",
  "orders-canceled",
  "orders-multiple-filled-xx",
  "orders-multiple-filled-xxx",
  "orders-multiple-xx",
  "orders-multiple-xxx",
  "orders-purchased",
  "orders-waiting-for-purchase",
  "passkey",
  "pause",
  "payment-options",
  "phone-call",
  "play",
  "play-filled",
  "plus",
  "plus-small",
  "prepaid",
  "prepaid-participating",
  "pricetag",
  "prize",
  "profile-block",
  "profile-circle",
  "profile-close",
  "profile-customer-id",
  "profile-person",
  "profile-personal-info",
  "profile-self-exclusion",
  "protect",
  "question",
  "quick-pick-settings",
  "reset",
  "retailer",
  "save",
  "scratch-autoreveal",
  "scratch-backside",
  "scratch-demo",
  "scratch-now",
  "scratch-processing",
  "scratch-scratched",
  "scratch-unscratched",
  "scratchcard",
  "search",
  "serial-number",
  "settings",
  "shopping-card-empty",
  "shopping-card-filled",
  "shopping-cart",
  "show-all",
  "shuffle-h",
  "shuffle-numbers",
  "shuffle-v",
  "spades",
  "star",
  "status-of-order",
  "subscription",
  "subscription-deactivated",
  "subscription-paused",
  "swap",
  "sync",
  "tab-lotteries",
  "tab-scratchcards",
  "ticket-processing",
  "time",
  "time-pending",
  "time-sandclock",
  "touch",
  "transaction",
  "transaction-credit-note",
  "transaction-debit-note",
  "transaction-funding",
  "transaction-refund",
  "transactions-chargeback",
  "transactions-old",
  "transactions-payout",
  "transactions-reverse-chargeback",
  "trash-empty",
  "trash-full",
  "unlock",
  "unverified-shield",
  "upload",
  "verify",
  "verify-guard",
  "verify-shield",
  "winning",
  "winning-correction",
  "zoom"
], lu = { class: "lc-badge" }, F1 = /* @__PURE__ */ _e({
  __name: "LcBadge",
  props: {
    count: {},
    icon: {}
  },
  setup(e) {
    return (t, n) => ($(), j("div", lu, [
      me(t.$slots, "icon", {}, () => [
        e.icon ? ($(), xe(q(Qe), {
          key: 0,
          name: e.icon
        }, null, 8, ["name"])) : ue("", !0)
      ]),
      Oe(q(Hr), Te({ count: e.count }, { class: "lc-badge__count" }), null, 16),
      me(t.$slots, "default")
    ]));
  }
});
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const ou = (e) => e != null;
var vo = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "area[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], Ba = /* @__PURE__ */ vo.join(","), mo = typeof Element > "u", _n = mo ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Pa = !mo && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, za = function(t, n) {
  var r;
  n === void 0 && (n = !0);
  var s = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = s === "" || s === "true", a = i || n && t && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof t.closest == "function" ? t.closest("[inert]") : za(t.parentNode));
  return a;
}, su = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, go = function(t, n, r) {
  if (za(t))
    return [];
  var s = Array.prototype.slice.apply(t.querySelectorAll(Ba));
  return n && _n.call(t, Ba) && s.unshift(t), s = s.filter(r), s;
}, Va = function(t, n, r) {
  for (var s = [], i = Array.from(t); i.length; ) {
    var a = i.shift();
    if (!za(a, !1))
      if (a.tagName === "SLOT") {
        var o = a.assignedElements(), l = o.length ? o : a.children, h = Va(l, !0, r);
        r.flatten ? s.push.apply(s, h) : s.push({
          scopeParent: a,
          candidates: h
        });
      } else {
        var v = _n.call(a, Ba);
        v && r.filter(a) && (n || !t.includes(a)) && s.push(a);
        var c = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), f = !za(c, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (c && f) {
          var m = Va(c === !0 ? a.children : c.children, !0, r);
          r.flatten ? s.push.apply(s, m) : s.push({
            scopeParent: a,
            candidates: m
          });
        } else
          i.unshift.apply(i, a.children);
      }
  }
  return s;
}, bo = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, pn = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || su(t)) && !bo(t) ? 0 : t.tabIndex;
}, uu = function(t, n) {
  var r = pn(t);
  return r < 0 && n && !bo(t) ? 0 : r;
}, cu = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, po = function(t) {
  return t.tagName === "INPUT";
}, du = function(t) {
  return po(t) && t.type === "hidden";
}, fu = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, hu = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, vu = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Pa(t), r = function(o) {
    return n.querySelectorAll('input[type="radio"][name="' + o + '"]');
  }, s;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    s = r(window.CSS.escape(t.name));
  else
    try {
      s = r(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var i = hu(s, t.form);
  return !i || i === t;
}, mu = function(t) {
  return po(t) && t.type === "radio";
}, gu = function(t) {
  return mu(t) && !vu(t);
}, bu = function(t) {
  var n, r = t && Pa(t), s = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var a, o, l;
    for (i = !!((a = s) !== null && a !== void 0 && (o = a.ownerDocument) !== null && o !== void 0 && o.contains(s) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !i && s; ) {
      var h, v, c;
      r = Pa(s), s = (h = r) === null || h === void 0 ? void 0 : h.host, i = !!((v = s) !== null && v !== void 0 && (c = v.ownerDocument) !== null && c !== void 0 && c.contains(s));
    }
  }
  return i;
}, zi = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, s = n.height;
  return r === 0 && s === 0;
}, pu = function(t, n) {
  var r = n.displayCheck, s = n.getShadowRoot;
  if (r === "full-native" && "checkVisibility" in t) {
    var i = t.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !i;
  }
  var a = getComputedStyle(t), o = a.visibility;
  if (o === "hidden" || o === "collapse")
    return !0;
  var l = _n.call(t, "details>summary:first-of-type"), h = l ? t.parentElement : t;
  if (_n.call(h, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  r === "full-native" || r === "legacy-full") {
    if (typeof s == "function") {
      for (var v = t; t; ) {
        var c = t.parentElement, f = Pa(t);
        if (c && !c.shadowRoot && s(c) === !0)
          return zi(t);
        t.assignedSlot ? t = t.assignedSlot : !c && f !== t.ownerDocument ? t = f.host : t = c;
      }
      t = v;
    }
    if (bu(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return zi(t);
  return !1;
}, yu = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var s = n.children.item(r);
          if (s.tagName === "LEGEND")
            return _n.call(n, "fieldset[disabled] *") ? !0 : !s.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Ha = function(t, n) {
  return !(n.disabled || du(n) || pu(n, t) || // For a details element with a summary, the summary element gets the focus
  fu(n) || yu(n));
}, Ur = function(t, n) {
  return !(gu(n) || pn(n) < 0 || !Ha(t, n));
}, wu = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, yo = function(t) {
  var n = [], r = [];
  return t.forEach(function(s, i) {
    var a = !!s.scopeParent, o = a ? s.scopeParent : s, l = uu(o, a), h = a ? yo(s.candidates) : o;
    l === 0 ? a ? n.push.apply(n, h) : n.push(o) : r.push({
      documentOrder: i,
      tabIndex: l,
      item: s,
      isScope: a,
      content: h
    });
  }), r.sort(cu).reduce(function(s, i) {
    return i.isScope ? s.push.apply(s, i.content) : s.push(i.content), s;
  }, []).concat(n);
}, xu = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Va([t], n.includeContainer, {
    filter: Ur.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: wu
  }) : r = go(t, n.includeContainer, Ur.bind(null, n)), yo(r);
}, ku = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Va([t], n.includeContainer, {
    filter: Ha.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = go(t, n.includeContainer, Ha.bind(null, n)), r;
}, On = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return _n.call(t, Ba) === !1 ? !1 : Ur(n, t);
}, Su = /* @__PURE__ */ vo.concat("iframe:not([inert]):not([inert] *)").join(","), pr = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return _n.call(t, Su) === !1 ? !1 : Ha(n, t);
};
function qr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function _u(e) {
  if (Array.isArray(e)) return qr(e);
}
function Vi(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = wo(e)) || t) {
      n && (e = n);
      var r = 0, s = function() {
      };
      return {
        s,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: s
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, a = !0, o = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var l = n.next();
      return a = l.done, l;
    },
    e: function(l) {
      o = !0, i = l;
    },
    f: function() {
      try {
        a || n.return == null || n.return();
      } finally {
        if (o) throw i;
      }
    }
  };
}
function Cu(e, t, n) {
  return (t = $u(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Eu(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Tu() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ui(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hi(Object(n), !0).forEach(function(r) {
      Cu(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Hi(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Au(e) {
  return _u(e) || Eu(e) || wo(e) || Tu();
}
function Lu(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function $u(e) {
  var t = Lu(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function wo(e, t) {
  if (e) {
    if (typeof e == "string") return qr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? qr(e, t) : void 0;
  }
}
var Gt = {
  // Returns the trap from the top of the stack.
  getActiveTrap: function(t) {
    return t?.length > 0 ? t[t.length - 1] : null;
  },
  // Pauses the currently active trap, then adds a new trap to the stack.
  activateTrap: function(t, n) {
    var r = Gt.getActiveTrap(t);
    n !== r && Gt.pauseTrap(t);
    var s = t.indexOf(n);
    s === -1 || t.splice(s, 1), t.push(n);
  },
  // Removes the trap from the top of the stack, then unpauses the next trap down.
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), Gt.unpauseTrap(t);
  },
  // Pauses the trap at the top of the stack.
  pauseTrap: function(t) {
    var n = Gt.getActiveTrap(t);
    n?._setPausedState(!0);
  },
  // Unpauses the trap at the top of the stack.
  unpauseTrap: function(t) {
    var n = Gt.getActiveTrap(t);
    n && !n._isManuallyPaused() && n._setPausedState(!1);
  }
}, Iu = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, Du = function(t) {
  return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
}, ra = function(t) {
  return t?.key === "Tab" || t?.keyCode === 9;
}, Mu = function(t) {
  return ra(t) && !t.shiftKey;
}, Ou = function(t) {
  return ra(t) && t.shiftKey;
}, qi = function(t) {
  return setTimeout(t, 0);
}, Gn = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
    r[s - 1] = arguments[s];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, Ea = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, Ru = [], Fu = function(t, n) {
  var r = n?.document || document, s = n?.trapStack || Ru, i = Ui({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    delayReturnFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: Mu,
    isKeyBackward: Ou
  }, n), a = {
    // containers given to createFocusTrap()
    /** @type {Array<HTMLElement>} */
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    /** @type {Array<{
     *    container: HTMLElement,
     *    tabbableNodes: Array<HTMLElement>, // empty if none
     *    focusableNodes: Array<HTMLElement>, // empty if none
     *    posTabIndexesFound: boolean,
     *    firstTabbableNode: HTMLElement|undefined,
     *    lastTabbableNode: HTMLElement|undefined,
     *    firstDomTabbableNode: HTMLElement|undefined,
     *    lastDomTabbableNode: HTMLElement|undefined,
     *    nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
     *  }>}
     */
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    // references to nodes that are siblings to the ancestors of this trap's containers.
    /** @type {Set<HTMLElement>} */
    adjacentElements: /* @__PURE__ */ new Set(),
    // references to nodes that were inert or aria-hidden before the trap was activated.
    /** @type {Set<HTMLElement>} */
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, o, l = function(T, A, z) {
    return T && T[A] !== void 0 ? T[A] : i[z || A];
  }, h = function(T, A) {
    var z = typeof A?.composedPath == "function" ? A.composedPath() : void 0;
    return a.containerGroups.findIndex(function(U) {
      var X = U.container, B = U.tabbableNodes;
      return X.contains(T) || z?.includes(X) || B.find(function(ie) {
        return ie === T;
      });
    });
  }, v = function(T) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, z = A.hasFallback, U = z === void 0 ? !1 : z, X = A.params, B = X === void 0 ? [] : X, ie = i[T];
    if (typeof ie == "function" && (ie = ie.apply(void 0, Au(B))), ie === !0 && (ie = void 0), !ie) {
      if (ie === void 0 || ie === !1)
        return ie;
      throw new Error("`".concat(T, "` was specified but was not a node, or did not return a node"));
    }
    var H = ie;
    if (typeof ie == "string") {
      try {
        H = r.querySelector(ie);
      } catch (ee) {
        throw new Error("`".concat(T, '` appears to be an invalid selector; error="').concat(ee.message, '"'));
      }
      if (!H && !U)
        throw new Error("`".concat(T, "` as selector refers to no known node"));
    }
    return H;
  }, c = function(T) {
    var A = T.activeElement;
    return A ? A.shadowRoot && A.shadowRoot.activeElement !== null ? c(A.shadowRoot) : A : null;
  }, f = function() {
    var T = v("initialFocus", {
      hasFallback: !0
    });
    if (T === !1)
      return !1;
    if (T === void 0 || T && !pr(T, i.tabbableOptions)) {
      var A = c(r);
      if (h(A) >= 0)
        T = A;
      else {
        var z = a.tabbableGroups[0], U = z && z.firstTabbableNode;
        T = U || v("fallbackFocus");
      }
    } else T === null && (T = v("fallbackFocus"));
    if (!T)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return T;
  }, m = function() {
    if (a.containerGroups = a.containers.map(function(T) {
      var A = xu(T, i.tabbableOptions), z = ku(T, i.tabbableOptions), U = A.length > 0 ? A[0] : void 0, X = A.length > 0 ? A[A.length - 1] : void 0, B = z.find(function(ee) {
        return On(ee);
      }), ie = z.slice().reverse().find(function(ee) {
        return On(ee);
      }), H = !!A.find(function(ee) {
        return pn(ee) > 0;
      });
      return {
        container: T,
        tabbableNodes: A,
        focusableNodes: z,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: H,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: U,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: X,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: B,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: ie,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(ce) {
          var we = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, ke = A.indexOf(ce);
          return ke < 0 ? we ? z.slice(z.indexOf(ce) + 1).find(function(te) {
            return On(te);
          }) : z.slice(0, z.indexOf(ce)).reverse().find(function(te) {
            return On(te);
          }) : A[ke + (we ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(T) {
      return T.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !v("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(T) {
      return T.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, u = function(T) {
    if (T !== !1 && T !== c(document)) {
      if (!T || !T.focus) {
        u(f());
        return;
      }
      T.focus({
        preventScroll: !!i.preventScroll
      }), a.mostRecentlyFocusedNode = T, Iu(T) && T.select();
    }
  }, p = function(T) {
    var A = v("setReturnFocus", {
      params: [T]
    });
    return A || (A === !1 ? !1 : T);
  }, k = function(T) {
    var A = T.target, z = T.event, U = T.isBackward, X = U === void 0 ? !1 : U;
    A = A || Ea(z), m();
    var B = null;
    if (a.tabbableGroups.length > 0) {
      var ie = h(A, z), H = ie >= 0 ? a.containerGroups[ie] : void 0;
      if (ie < 0)
        X ? B = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : B = a.tabbableGroups[0].firstTabbableNode;
      else if (X) {
        var ee = a.tabbableGroups.findIndex(function(ge) {
          var be = ge.firstTabbableNode;
          return A === be;
        });
        if (ee < 0 && (H.container === A || pr(A, i.tabbableOptions) && !On(A, i.tabbableOptions) && !H.nextTabbableNode(A, !1)) && (ee = ie), ee >= 0) {
          var ce = ee === 0 ? a.tabbableGroups.length - 1 : ee - 1, we = a.tabbableGroups[ce];
          B = pn(A) >= 0 ? we.lastTabbableNode : we.lastDomTabbableNode;
        } else ra(z) || (B = H.nextTabbableNode(A, !1));
      } else {
        var ke = a.tabbableGroups.findIndex(function(ge) {
          var be = ge.lastTabbableNode;
          return A === be;
        });
        if (ke < 0 && (H.container === A || pr(A, i.tabbableOptions) && !On(A, i.tabbableOptions) && !H.nextTabbableNode(A)) && (ke = ie), ke >= 0) {
          var te = ke === a.tabbableGroups.length - 1 ? 0 : ke + 1, he = a.tabbableGroups[te];
          B = pn(A) >= 0 ? he.firstTabbableNode : he.firstDomTabbableNode;
        } else ra(z) || (B = H.nextTabbableNode(A));
      }
    } else
      B = v("fallbackFocus");
    return B;
  }, g = function(T) {
    var A = Ea(T);
    if (!(h(A, T) >= 0)) {
      if (Gn(i.clickOutsideDeactivates, T)) {
        o.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      Gn(i.allowOutsideClick, T) || T.preventDefault();
    }
  }, b = function(T) {
    var A = Ea(T), z = h(A, T) >= 0;
    if (z || A instanceof Document)
      z && (a.mostRecentlyFocusedNode = A);
    else {
      T.stopImmediatePropagation();
      var U, X = !0;
      if (a.mostRecentlyFocusedNode)
        if (pn(a.mostRecentlyFocusedNode) > 0) {
          var B = h(a.mostRecentlyFocusedNode), ie = a.containerGroups[B].tabbableNodes;
          if (ie.length > 0) {
            var H = ie.findIndex(function(ee) {
              return ee === a.mostRecentlyFocusedNode;
            });
            H >= 0 && (i.isKeyForward(a.recentNavEvent) ? H + 1 < ie.length && (U = ie[H + 1], X = !1) : H - 1 >= 0 && (U = ie[H - 1], X = !1));
          }
        } else
          a.containerGroups.some(function(ee) {
            return ee.tabbableNodes.some(function(ce) {
              return pn(ce) > 0;
            });
          }) || (X = !1);
      else
        X = !1;
      X && (U = k({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(a.recentNavEvent)
      })), u(U || a.mostRecentlyFocusedNode || f());
    }
    a.recentNavEvent = void 0;
  }, _ = function(T) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = T;
    var z = k({
      event: T,
      isBackward: A
    });
    z && (ra(T) && T.preventDefault(), u(z));
  }, E = function(T) {
    (i.isKeyForward(T) || i.isKeyBackward(T)) && _(T, i.isKeyBackward(T));
  }, I = function(T) {
    Du(T) && Gn(i.escapeDeactivates, T) !== !1 && (T.preventDefault(), o.deactivate());
  }, L = function(T) {
    var A = Ea(T);
    h(A, T) >= 0 || Gn(i.clickOutsideDeactivates, T) || Gn(i.allowOutsideClick, T) || (T.preventDefault(), T.stopImmediatePropagation());
  }, C = function() {
    if (a.active) {
      Gt.activateTrap(s, o);
      var T;
      return i.delayInitialFocus ? T = new Promise(function(A) {
        a.delayInitialFocusTimer = qi(function() {
          u(f()), A();
        });
      }) : u(f()), r.addEventListener("focusin", b, !0), r.addEventListener("mousedown", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", L, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", E, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", I), T;
    }
  }, F = function(T) {
    a.active && !a.paused && o._setSubtreeIsolation(!1), a.adjacentElements.clear(), a.alreadySilent.clear();
    var A = /* @__PURE__ */ new Set(), z = /* @__PURE__ */ new Set(), U = Vi(T), X;
    try {
      for (U.s(); !(X = U.n()).done; ) {
        var B = X.value;
        A.add(B);
        for (var ie = typeof ShadowRoot < "u" && B.getRootNode() instanceof ShadowRoot, H = B; H; ) {
          A.add(H);
          var ee = H.parentElement, ce = [];
          ee ? ce = ee.children : !ee && ie && (ce = H.getRootNode().children, ee = H.getRootNode().host, ie = typeof ShadowRoot < "u" && ee.getRootNode() instanceof ShadowRoot);
          var we = Vi(ce), ke;
          try {
            for (we.s(); !(ke = we.n()).done; ) {
              var te = ke.value;
              z.add(te);
            }
          } catch (he) {
            we.e(he);
          } finally {
            we.f();
          }
          H = ee;
        }
      }
    } catch (he) {
      U.e(he);
    } finally {
      U.f();
    }
    A.forEach(function(he) {
      z.delete(he);
    }), a.adjacentElements = z;
  }, V = function() {
    if (a.active)
      return r.removeEventListener("focusin", b, !0), r.removeEventListener("mousedown", g, !0), r.removeEventListener("touchstart", g, !0), r.removeEventListener("click", L, !0), r.removeEventListener("keydown", E, !0), r.removeEventListener("keydown", I), o;
  }, J = function(T) {
    var A = a.mostRecentlyFocusedNode;
    if (A) {
      var z = T.some(function(X) {
        var B = Array.from(X.removedNodes);
        return B.some(function(ie) {
          return ie === A || typeof ie.contains == "function" && ie.contains(A);
        });
      });
      if (z && a.containers.some(function(X) {
        return X?.isConnected;
      })) {
        m();
        var U = f();
        u(U);
      }
    }
  }, O = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(J) : void 0, K = function() {
    O && (O.disconnect(), a.active && !a.paused && a.containers.map(function(T) {
      O.observe(T, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return o = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(T) {
      if (a.active)
        return this;
      var A = l(T, "onActivate"), z = l(T, "onPostActivate"), U = l(T, "checkCanFocusTrap"), X = Gt.getActiveTrap(s), B = !1;
      if (X && !X.paused) {
        var ie;
        (ie = X._setSubtreeIsolation) === null || ie === void 0 || ie.call(X, !1), B = !0;
      }
      try {
        U || m(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = c(r), A?.({
          trap: o
        });
        var H = function() {
          U && m();
          var we = function() {
            o._setSubtreeIsolation(!0), K(), z?.({
              trap: o
            });
          }, ke = C();
          ke ? ke.then(we) : we();
        };
        if (U)
          return U(a.containers.concat()).then(H, H), this;
        H();
      } catch (ce) {
        if (X === Gt.getActiveTrap(s) && B) {
          var ee;
          (ee = X._setSubtreeIsolation) === null || ee === void 0 || ee.call(X, !0);
        }
        throw ce;
      }
      return this;
    },
    deactivate: function(T) {
      if (!a.active)
        return this;
      var A = Ui({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, T);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, a.paused || o._setSubtreeIsolation(!1), a.alreadySilent.clear(), V(), a.active = !1, a.paused = !1, K(), Gt.deactivateTrap(s, o);
      var z = l(A, "onDeactivate"), U = l(A, "onPostDeactivate"), X = l(A, "checkCanReturnFocus"), B = l(A, "delayReturnFocus"), ie = l(A, "returnFocus", "returnFocusOnDeactivate");
      z?.({
        trap: o
      });
      var H = function() {
        ie && u(p(a.nodeFocusedBeforeActivation)), U?.({
          trap: o
        });
      }, ee = function() {
        B && ie ? qi(H) : H();
      };
      return ie && X ? (X(p(a.nodeFocusedBeforeActivation)).then(ee, ee), this) : (ee(), this);
    },
    pause: function(T) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, T)) : this;
    },
    unpause: function(T) {
      return a.active ? (a.manuallyPaused = !1, s[s.length - 1] !== this ? this : this._setPausedState(!1, T)) : this;
    },
    updateContainerElements: function(T) {
      var A = [].concat(T).filter(Boolean);
      return a.containers = A.map(function(z) {
        return typeof z == "string" ? r.querySelector(z) : z;
      }), i.isolateSubtrees && F(a.containers), a.active && (m(), a.paused || o._setSubtreeIsolation(!0)), K(), this;
    }
  }, Object.defineProperties(o, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(T, A) {
        if (a.paused === T)
          return this;
        if (a.paused = T, T) {
          var z = l(A, "onPause"), U = l(A, "onPostPause");
          z?.({
            trap: o
          }), V(), o._setSubtreeIsolation(!1), K(), U?.({
            trap: o
          });
        } else {
          var X = l(A, "onUnpause"), B = l(A, "onPostUnpause");
          X?.({
            trap: o
          });
          var ie = function() {
            m();
            var ee = function() {
              o._setSubtreeIsolation(!0), K(), B?.({
                trap: o
              });
            }, ce = C();
            ce ? ce.then(ee) : ee();
          };
          ie();
        }
        return this;
      }
    },
    _setSubtreeIsolation: {
      value: function(T) {
        i.isolateSubtrees && a.adjacentElements.forEach(function(A) {
          var z;
          T ? i.isolateSubtrees === "aria-hidden" ? ((A.ariaHidden === "true" || ((z = A.getAttribute("aria-hidden")) === null || z === void 0 ? void 0 : z.toLowerCase()) === "true") && a.alreadySilent.add(A), A.setAttribute("aria-hidden", "true")) : ((A.inert || A.hasAttribute("inert")) && a.alreadySilent.add(A), A.setAttribute("inert", !0)) : a.alreadySilent.has(A) || (i.isolateSubtrees === "aria-hidden" ? A.removeAttribute("aria-hidden") : A.removeAttribute("inert"));
        });
      }
    }
  }), o.updateContainerElements(t), o;
};
function Nu(e, t = {}) {
  let n;
  const { immediate: r, ...s } = t, i = kn(!1), a = kn(!1), o = (c) => n && n.activate(c), l = (c) => n && n.deactivate(c), h = () => {
    n && (n.pause(), a.value = !0);
  }, v = () => {
    n && (n.unpause(), a.value = !1);
  };
  return ze(W(() => js(Ke(e)).map((c) => {
    const f = Ke(c);
    return typeof f == "string" ? f : so(f);
  }).filter(ou)), (c) => {
    if (c.length)
      if (!n)
        n = Fu(c, {
          ...s,
          onActivate(f) {
            i.value = !0, t.onActivate && t.onActivate(f);
          },
          onDeactivate(f) {
            i.value = !1, t.onDeactivate && t.onDeactivate(f);
          }
        }), r && o();
      else {
        const f = n?.active;
        n?.updateContainerElements(c), !f && r && o();
      }
  }, { flush: "post" }), Zs(() => l()), {
    hasFocus: i,
    isPaused: a,
    activate: o,
    deactivate: l,
    pause: h,
    unpause: v
  };
}
const xo = /* @__PURE__ */ _e((e, { slots: t }) => {
  const n = kn(), r = ei(Nu(n, e.options));
  return () => {
    if (t.default) return Rs(e.as || "div", { ref: n }, t.default(r));
  };
}, {
  name: "UseFocusTrap",
  props: ["as", "options"]
}), Bu = 864e5, Pu = 6e4, zu = 36e5, ji = /* @__PURE__ */ Symbol.for("constructDateFrom");
function qn(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && ji in e ? e[ji](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Mt(e, t) {
  return qn(e, e);
}
function Vu(e, t, n) {
  const r = Mt(e);
  return isNaN(t) ? qn(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Hu(e, t, n) {
  const r = Mt(e);
  if (isNaN(t)) return qn(e, NaN);
  if (!t)
    return r;
  const s = r.getDate(), i = qn(e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const a = i.getDate();
  return s >= a ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    s
  ), r);
}
function Kn(e, t, n) {
  const {
    years: r = 0,
    months: s = 0,
    weeks: i = 0,
    days: a = 0,
    hours: o = 0,
    minutes: l = 0,
    seconds: h = 0
  } = t, v = Mt(e), c = s || r ? Hu(v, s + r * 12) : v, f = a || i ? Vu(c, a + i * 7) : c, m = l + o * 60, p = (h + m * 60) * 1e3;
  return qn(e, +f + p);
}
function Zi(e) {
  const t = Mt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function un(e, ...t) {
  const n = qn.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Wi(e, t) {
  const n = Mt(e);
  return n.setHours(0, 0, 0, 0), n;
}
function Uu(e, t, n) {
  const [r, s] = un(
    n?.in,
    e,
    t
  ), i = Wi(r), a = Wi(s), o = +i - Zi(i), l = +a - Zi(a);
  return Math.round((o - l) / Bu);
}
function ia(e, t) {
  const n = +Mt(e) - +Mt(t);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function qu(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function ii(e) {
  return !(!qu(e) && typeof e != "number" || isNaN(+Mt(e)));
}
function ju(e, t, n) {
  const [r, s] = un(
    n?.in,
    e,
    t
  ), i = r.getFullYear() - s.getFullYear(), a = r.getMonth() - s.getMonth();
  return i * 12 + a;
}
function Zu(e, t, n) {
  const [r, s] = un(
    n?.in,
    e,
    t
  );
  return r.getFullYear() - s.getFullYear();
}
function Wu(e, t, n) {
  const [r, s] = un(
    n?.in,
    e,
    t
  ), i = Yi(r, s), a = Math.abs(
    Uu(r, s)
  );
  r.setDate(r.getDate() - i * a);
  const o = +(Yi(r, s) === -i), l = i * (a - o);
  return l === 0 ? 0 : l;
}
function Yi(e, t) {
  const n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function li(e) {
  return (t) => {
    const r = (e ? Math[e] : Math.trunc)(t);
    return r === 0 ? 0 : r;
  };
}
function Yu(e, t, n) {
  const [r, s] = un(
    n?.in,
    e,
    t
  ), i = (+r - +s) / zu;
  return li(n?.roundingMethod)(i);
}
function ko(e, t) {
  return +Mt(e) - +Mt(t);
}
function Xu(e, t, n) {
  const r = ko(e, t) / Pu;
  return li(n?.roundingMethod)(r);
}
function Gu(e, t) {
  const n = Mt(e);
  return n.setHours(23, 59, 59, 999), n;
}
function Ku(e, t) {
  const n = Mt(e), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Ju(e, t) {
  const n = Mt(e);
  return +Gu(n) == +Ku(n);
}
function Qu(e, t, n) {
  const [r, s, i] = un(
    n?.in,
    e,
    e,
    t
  ), a = ia(s, i), o = Math.abs(
    ju(s, i)
  );
  if (o < 1) return 0;
  s.getMonth() === 1 && s.getDate() > 27 && s.setDate(30), s.setMonth(s.getMonth() - a * o);
  let l = ia(s, i) === -a;
  Ju(r) && o === 1 && ia(r, i) === 1 && (l = !1);
  const h = a * (o - +l);
  return h === 0 ? 0 : h;
}
function ec(e, t, n) {
  const r = ko(e, t) / 1e3;
  return li(n?.roundingMethod)(r);
}
function tc(e, t, n) {
  const [r, s] = un(
    n?.in,
    e,
    t
  ), i = ia(r, s), a = Math.abs(Zu(r, s));
  r.setFullYear(1584), s.setFullYear(1584);
  const o = ia(r, s) === -i, l = i * (a - +o);
  return l === 0 ? 0 : l;
}
function nc(e, t) {
  const [n, r] = un(e, t.start, t.end);
  return { start: n, end: r };
}
function ac(e, t) {
  const { start: n, end: r } = nc(t?.in, e), s = {}, i = tc(r, n);
  i && (s.years = i);
  const a = Kn(n, { years: s.years }), o = Qu(r, a);
  o && (s.months = o);
  const l = Kn(a, { months: s.months }), h = Wu(r, l);
  h && (s.days = h);
  const v = Kn(l, { days: s.days }), c = Yu(r, v);
  c && (s.hours = c);
  const f = Kn(v, { hours: s.hours }), m = Xu(r, f);
  m && (s.minutes = m);
  const u = Kn(f, { minutes: s.minutes }), p = ec(r, u);
  return p && (s.seconds = p), s;
}
function So(e) {
  return +Mt(e) < Date.now();
}
function rc(e, t, n) {
  let r = (s) => e(s, ...t);
  return n === void 0 ? r : Object.assign(r, { lazy: n, lazyArgs: t });
}
function Ka(e, t, n) {
  let r = e.length - t.length;
  if (r === 0) return e(...t);
  if (r === 1) return rc(e, t, n);
  throw Error("Wrong number of arguments");
}
function Xi(...e) {
  return Ka(ic, e);
}
const ic = (e, t) => e.length >= t;
function St(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
function Gi(e) {
  if (typeof e != "object" || !e) return !1;
  let t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function lc(...e) {
  return Ka(_o, e);
}
function _o(e, t) {
  let n = { ...e, ...t };
  for (let r in t) Object.hasOwn(e, r) && Gi(e[r]) && Gi(t[r]) && (n[r] = _o(e[r], t[r]));
  return n;
}
function Qt(...e) {
  return Ka(oc, e);
}
function oc(e, t) {
  if (!Xi(t, 1)) return { ...e };
  if (!Xi(t, 2)) {
    let { [t[0]]: r, ...s } = e;
    return s;
  }
  let n = { ...e };
  for (let r of t) delete n[r];
  return n;
}
function sc(...e) {
  return Ka(uc, e);
}
function uc(e, t) {
  let n = {};
  for (let r of t) r in e && (n[r] = e[r]);
  return n;
}
const Co = {
  general: {
    currency: "USD",
    locale: "en-US"
  },
  lcButton: {
    longPressHint: "Press & Hold"
  },
  lcCard: {
    toggleAriaLabel: "Toggle content visibility"
  },
  lcFlyOut: {
    buttonAriaLabel: "Close flyout",
    to: "#lc-fly-outs",
    visibleInSeconds: 4
  },
  lcHeader: {
    flyOutToggleAriaLabel: "Toggle flyout visibility",
    leftButtonAriaLabel: "Go back"
  },
  lcInfoButton: {
    closeButtonAriaLabel: "Close info modal",
    openButtonAriaLabel: "Open info modal"
  },
  lcLotteryCutoffTime: {
    textCutoffTime: "Cutoff time",
    textTimeIsAlmostUp: "Time’s almost up",
    textTimeToCutoff: "Time until cutoff"
  },
  lcLotteryEditorCard: {
    clearLabel: "Clear",
    quickPickLabel: "Quick Pick",
    toggleAriaLabel: "Toggle play visibility"
  },
  lcLotteryRemainingPicks: {
    doneLabel: "Done!"
  },
  lcModal: {
    closeTriggers: [],
    fullScreen: !1,
    fullSize: !1,
    isVisible: !1,
    noFocusTrap: !1,
    spacing: "large",
    to: "#lc-modals"
  },
  lcPasswordInput: {
    toggleAriaLabel: "Toggle password visibility"
  },
  lcToast: {
    closeButtonAriaLabel: "Close toast"
  }
}, je = ei(Co), N1 = (e) => {
  Object.assign(je, lc(Co, e));
}, cc = /* @__PURE__ */ Symbol(), pa = () => {
  const e = ti();
  if (!e?.proxy)
    throw new Error("No instance of Vue detected");
  return "$nuxt" in e.proxy ? Wn(cc) : null;
}, dc = () => pa() ? Na("NuxtTime") : "time", Eo = /* @__PURE__ */ _e({
  __name: "CommonDateTime",
  props: {
    day: {},
    hour: {},
    minute: {},
    month: {},
    second: {},
    weekday: {},
    year: {},
    datetime: {},
    locale: { default: () => je.general.locale }
  },
  setup(e) {
    const t = ga(e, ["datetime", "locale"]), n = dc(), r = W(() => s.value ? i.value?.toISOString() : void 0), s = W(() => i.value ? ii(i.value) : !1), i = W(() => {
      if (e.datetime)
        return new Date(e.datetime);
    });
    return (a, o) => s.value ? ($(), xe(Pt(q(n)), Te({
      key: 0,
      class: "lc-datetime"
    }, { ...t, locale: e.locale }, { datetime: r.value }), {
      default: Ee(() => [
        me(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["datetime"])) : ue("", !0);
  }
}), Yn = (e) => {
  const t = ti(), n = pa();
  return !(t?.proxy && "$router" in t.proxy) || !e ? "a" : n ? Na("NuxtLink") : Na("RouterLink");
}, oi = /* @__PURE__ */ _e({
  __name: "CommonLink",
  props: {
    href: {},
    target: {},
    to: {}
  },
  setup(e) {
    const t = Yn(e.to);
    return (n, r) => ($(), xe(Pt(q(t)), Te(n.$attrs, n.$props), {
      default: Ee(() => [
        me(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ua = /* @__PURE__ */ _e({
  __name: "CommonTransition",
  props: {
    mode: {},
    name: { default: "slide-down-sm" }
  },
  setup(e) {
    const t = pe(!1), n = Ws(t, 1);
    return mt(() => {
      t.value = !0;
    }), (r, s) => ($(), xe(wn, _t(Dt({ name: e.name, mode: e.mode })), {
      default: Ee(() => [
        q(n) ? me(r.$slots, "default", {}, void 0, void 0, 0) : ue("", !0)
      ]),
      _: 3
    }, 16));
  }
}), fc = {
  key: 0,
  class: "lc-feedback-message__content"
}, $n = /* @__PURE__ */ _e({
  __name: "FeedbackMessage",
  props: {
    content: {},
    disabled: { type: Boolean },
    variant: { default: "default" }
  },
  setup(e) {
    const t = W(() => [
      "lc-feedback-message",
      `lc-feedback-message--variant-${e.variant}`,
      {
        "lc-feedback-message--disabled": e.disabled
      }
    ]);
    return (n, r) => ($(), j("div", {
      class: ye(t.value),
      role: "alert"
    }, [
      Oe(q(ua), {
        mode: "out-in",
        name: "slide-fade"
      }, {
        default: Ee(() => [
          e.content ? ($(), j("p", fc, [
            e.variant === "error" ? ($(), xe(q(Qe), {
              key: 0,
              class: "lc-feedback-message__icon",
              name: "alert-triangle",
              size: "small"
            })) : ue("", !0),
            wt(" " + Ie(e.content), 1)
          ])) : ue("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}), To = "--vc-auto-duration", hc = `height var(${To}) cubic-bezier(0.33, 1, 0.68, 1)`, Ta = { padding: 0 }, vc = 300, mc = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: "0"
};
function Ki(e) {
  return e.value ? parseFloat(getComputedStyle(e.value).height) : 0;
}
function Ji(e) {
  if (!e.value) return {};
  const { transition: t } = getComputedStyle(e.value);
  return t === "all 0s ease 0s" || t === "all" ? { transition: hc } : { transition: t };
}
function Qi(e) {
  if (!e.value) return !0;
  const { transition: t } = getComputedStyle(e.value);
  return typeof window.requestAnimationFrame > "u" || window.matchMedia("(prefers-reduced-motion: reduce)").matches || t.includes("none") || t.includes("height 0s");
}
function gc(e = 0) {
  if (e === 0) return 0;
  const t = e / 36, n = Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
  return Number.isFinite(n) ? n : 0;
}
const bc = /* @__PURE__ */ _e({
  inheritAttrs: !0,
  __name: "Collapse",
  props: {
    when: { type: Boolean },
    baseHeight: { default: 0 },
    as: { default: "div" }
  },
  emits: ["collapse", "expand", "collapsed", "expanded"],
  setup(e, { emit: t }) {
    const n = e, r = t, s = Ni(n, "when"), i = Ni(n, "baseHeight"), a = W(() => ({ overflow: "hidden", height: `${i.value}px` })), o = W(() => ({
      ...Ta,
      ...i.value === 0 ? { display: "none" } : a.value
    })), l = pe(null), h = pe(s.value ? "expanded" : "collapsed"), v = (L) => h.value = L;
    function c() {
      return s.value ? Ta : i.value === 0 ? mc : o.value;
    }
    const f = kn(c()), m = (L) => f.value = L, u = (L) => m({ ...f.value, ...L }), p = pe(vc), k = (L) => p.value = L, g = W(() => ({ [To]: `${p.value}ms` }));
    let b = NaN;
    function _() {
      m(Ta), v("expanded"), r("expanded");
    }
    function E() {
      m(o.value), v("collapsed"), r("collapsed");
    }
    mt(() => {
      if (!l.value) return;
      const L = gc(l.value.scrollHeight - i.value);
      L > 0 && k(L), !s.value && i.value === 0 && m(o.value);
    }), ze(s, (L) => {
      if (l.value)
        if (b = NaN, L) {
          if (Qi(l)) return _();
          v("expanding"), r("expand"), m({
            ...Ta,
            ...a.value,
            ...g.value
          }), requestAnimationFrame(() => {
            if (l.value) {
              if (l.value.scrollHeight === 0) return _();
              b = l.value.scrollHeight, u({
                ...Ji(l),
                height: `${b}px`,
                willChange: "height"
              });
            }
          });
        } else {
          if (Qi(l) || (v("collapsing"), r("collapse"), u({
            ...g.value,
            height: `${l.value.scrollHeight}px`
          }), l.value.scrollHeight === 0)) return E();
          requestAnimationFrame(() => {
            l.value && u({
              ...a.value,
              ...Ji(l),
              willChange: "height"
            });
          });
        }
    }), ze(i, (L) => {
      s.value || (L > 0 ? u({ display: void 0, height: `${L}px` }) : u({ display: "none" }));
    });
    function I(L) {
      l.value && L.target && L.target === l.value && L.propertyName === "height" && (s.value ? Math.abs(l.value.scrollHeight - Ki(l)) < 1 ? _() : b < l.value.scrollHeight && u({
        height: `${l.value.scrollHeight}px`
      }) : Math.abs(i.value - Ki(l)) < 1 && E());
    }
    return (L, C) => ($(), xe(Pt(n.as), {
      ref_key: "collapseRef",
      ref: l,
      style: Ct(f.value),
      onTransitionend: I,
      "data-collapse": h.value
    }, {
      default: Ee(() => [
        me(L.$slots, "default", _t(Dt({ state: h.value })))
      ]),
      _: 3
    }, 40, ["style", "data-collapse"]));
  }
}), Ao = /* @__PURE__ */ _e({
  __name: "InternalCollapse",
  props: {
    animated: { type: Boolean },
    as: { default: "div" },
    when: { type: Boolean }
  },
  emits: ["collapse", "collapsed", "expand", "expanded"],
  setup(e) {
    return (t, n) => e.animated ? ($(), xe(q(bc), Te({
      key: 0,
      class: "lc-collapse"
    }, { as: e.as, when: e.when }, {
      onCollapse: n[0] || (n[0] = (r) => t.$emit("collapse")),
      onCollapsed: n[1] || (n[1] = (r) => t.$emit("collapsed")),
      onExpand: n[2] || (n[2] = (r) => t.$emit("expand")),
      onExpanded: n[3] || (n[3] = (r) => t.$emit("expanded"))
    }), {
      default: Ee(() => [
        me(t.$slots, "default")
      ]),
      _: 3
    }, 16)) : ($(), xe(Pt(e.as), { key: 1 }, {
      default: Ee(() => [
        me(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), pc = /* @__PURE__ */ _e({
  __name: "InternalOptionalTeleport",
  props: {
    to: {}
  },
  setup(e) {
    return (t, n) => e.to ? ($(), xe(ba, {
      key: 0,
      to: e.to
    }, [
      me(t.$slots, "default")
    ], 8, ["to"])) : me(t.$slots, "default", {}, void 0, void 0, 1);
  }
}), yc = ["height", "width"], wc = ["r", "stroke-width"], xc = ["r", "stroke-dasharray", "stroke-dashoffset", "stroke-width"], Lo = /* @__PURE__ */ _e({
  __name: "ProgressCircle",
  props: {
    progress: { default: 0 },
    progressClass: {},
    radius: { default: 24 },
    strokeWidth: { default: 4 },
    trackClass: {}
  },
  setup(e) {
    const t = W(() => Math.min(100, Math.max(0, e.progress))), n = W(() => e.radius - e.strokeWidth), r = W(() => 2 * Math.PI * n.value), s = W(
      () => r.value - t.value / 100 * r.value
    );
    return (i, a) => ($(), j("svg", {
      class: "lc-progress-circle",
      height: e.radius * 2,
      width: e.radius * 2
    }, [
      ae("circle", {
        class: ye(["lc-progress-circle__track", e.trackClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: n.value,
        "stroke-width": e.strokeWidth
      }, null, 10, wc),
      ae("circle", {
        class: ye(["lc-progress-circle__progress", e.progressClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: n.value,
        "stroke-dasharray": `${r.value} ${r.value}`,
        "stroke-dashoffset": s.value,
        "stroke-width": e.strokeWidth
      }, null, 10, xc)
    ], 8, yc));
  }
}), kc = { class: "lc-timer-circle" }, Sc = ["aria-valuenow"], _c = { class: "lc-timer-circle__content" }, Cc = /* @__PURE__ */ _e({
  __name: "TimerCircle",
  props: {
    durationInMs: { default: 4e3 }
  },
  setup(e) {
    const t = pe(0), n = Ys(t, {
      duration: e.durationInMs,
      transition: Xs.linear
    });
    return mt(() => {
      t.value = 100;
    }), (r, s) => ($(), j("div", kc, [
      ae("div", {
        "aria-valuenow": q(n),
        class: "lc-timer-circle__visual",
        role: "progressbar"
      }, [
        Oe(q(Lo), Te({ progress: q(n) }, { class: "lc-timer-circle__progress" }), null, 16)
      ], 8, Sc),
      ae("div", _c, [
        me(r.$slots, "default")
      ])
    ]));
  }
}), Ec = (e, t) => e in t, en = (e, t) => typeof e == "string" && Object.values(t).includes(e), B1 = ["left", "right"], P1 = ["large", "medium", "small"], z1 = ["button", "reset", "submit"], V1 = ["click", "long-press"], H1 = [
  "primary",
  "primary-ghost",
  "secondary",
  "tertiary",
  "filled",
  "raised"
];
var jr = /* @__PURE__ */ ((e) => (e.Enter = "Enter", e.Space = " ", e))(jr || {});
const Tc = ["aria-valuenow"], Ac = { class: "lc-button__content" }, Lc = {
  key: 0,
  class: "lc-button__label-bubble"
}, $c = {
  key: 0,
  class: "lc-button__overlay"
}, Ic = { class: "lc-button__long-press-hint" }, Dc = {
  key: 1,
  class: "lc-button__overlay"
}, Mc = {
  key: 0,
  class: "lc-button__loading-text"
}, el = 1e3 / 25, Et = /* @__PURE__ */ _e({
  __name: "LcButton",
  props: {
    href: {},
    target: {},
    to: {},
    count: {},
    autofocus: { type: Boolean },
    disabled: { type: Boolean },
    growAnimationMaxWidth: { default: "100%" },
    icon: {},
    iconPosition: { default: "left" },
    loading: { type: Boolean },
    loadingText: {},
    longPressDelay: { default: 2500 },
    longPressHint: { default: () => je.lcButton.longPressHint },
    longPressHintDelay: { default: 1300 },
    noPadding: { type: Boolean },
    size: { default: "large" },
    title: {},
    trigger: { default: "click" },
    type: { default: "button" },
    variant: { default: "primary" }
  },
  emits: ["longpress"],
  setup(e, { emit: t }) {
    const n = t, r = An(), s = pe(!!r.default), i = pe(!1), a = pe(!1), o = pe(!1), l = pe(!1), h = pe(0), v = pe(null);
    let c, f, m;
    const u = W(() => [
      "lc-button",
      `lc-button--icon-${e.iconPosition}`,
      `lc-button--size-${e.size}`,
      `lc-button--variant-${e.variant}`,
      {
        "lc-button--disabled": p.value,
        "lc-button--icon-only": !s.value,
        "lc-button--link": k.value,
        "lc-button--loading": e.loading,
        "lc-button--long-press-active": e.trigger === "long-press" && o.value,
        "lc-button--long-press-done": i.value,
        "lc-button--no-padding": e.noPadding,
        "lc-button--overlay-visible": g.value || e.loading,
        "lc-button--pressed": b.value
      }
    ]), p = W(() => e.disabled || e.loading), k = W(() => !!(e.href || e.to) && !p.value), g = W(
      () => a.value && !e.loading && e.trigger === "long-press"
    ), b = W(() => l.value || !!v.value), _ = W(() => typeof e.to == "string" ? void 0 : e.to?.replace), E = W(() => {
      const U = {
        "--grow-animation-max-width": e.growAnimationMaxWidth
      };
      return e.trigger !== "long-press" ? U : {
        ...U,
        "--progress-transition-duration": `${e.longPressDelay}ms`
      };
    }), I = W(() => k.value ? Yn(e.to) : "button"), L = () => {
      i.value = !1, o.value = !1, K(), T();
    }, C = (U) => {
      p.value || en(U.key, jr) && (v.value || (v.value = U.key, V()));
    }, F = (U) => {
      en(U.key, jr) && U.key === v.value && (K(), !l.value && P());
    }, V = (U = !1) => {
      e.trigger !== "click" && (U && window.addEventListener("pointerup", O), clearTimeout(m), o.value = !0);
    }, J = () => {
      p.value || (l.value = !0, V(!0));
    }, O = () => {
      window.removeEventListener("pointerup", O), T(), !v.value && P();
    }, K = () => {
      v.value = null;
    }, P = () => {
      !o.value && !i.value || (i.value ? a.value = !1 : m = setTimeout(() => {
        a.value = !1;
      }, e.longPressHintDelay), i.value = !1, o.value = !1);
    }, T = () => {
      l.value = !1;
    }, A = () => {
      p.value || V();
    }, z = () => {
      T(), P();
    };
    return ro(() => {
      s.value = !!r.default;
    }), Ln(() => {
      clearInterval(c), clearTimeout(f), clearTimeout(m);
    }), ze(o, (U) => {
      if (!p.value) {
        if (!U) {
          clearInterval(c), clearTimeout(f), h.value = 0;
          return;
        }
        a.value = !0, c = setInterval(() => {
          h.value += el / e.longPressDelay * 100;
        }, el), f = setTimeout(() => {
          clearInterval(c), i.value = !0, n("longpress");
        }, e.longPressDelay);
      }
    }), (U, X) => ($(), xe(Pt(I.value), Te(U.$attrs, {
      autofocus: e.autofocus,
      href: e.href,
      target: e.target,
      title: e.title,
      to: e.to,
      type: e.type,
      style: E.value,
      replace: _.value
    }, {
      "aria-busy": e.loading,
      class: u.value,
      disabled: p.value,
      onBlur: L,
      onContextmenu: X[0] || (X[0] = sa(() => {
      }, ["prevent"])),
      onKeydown: C,
      onKeyup: F,
      onPointerdown: J,
      onPointerup: O,
      onTouchend: z,
      onTouchstartPassive: A
    }), {
      default: Ee(() => [
        e.trigger === "long-press" ? ($(), j("div", {
          key: 0,
          "aria-valuenow": h.value,
          class: "lc-button__progress",
          role: "progressbar"
        }, null, 8, Tc)) : ue("", !0),
        ae("div", Ac, [
          e.icon ? ($(), xe(q(Qe), {
            key: 0,
            class: "lc-button__icon",
            name: e.icon
          }, null, 8, ["name"])) : ue("", !0),
          Oe(wn, { name: "font-size-fade" }, {
            default: Ee(() => [
              U.$slots.default ? ($(), j("span", Lc, [
                me(U.$slots, "default"),
                Oe(q(Hr), Te({ count: e.count }, { class: "lc-button__count-text" }), null, 16)
              ])) : ue("", !0)
            ]),
            _: 3
          }),
          U.$slots.default ? ue("", !0) : ($(), xe(q(Hr), Te({ key: 1 }, { count: e.count }, { class: "lc-button__count" }), null, 16))
        ]),
        Oe(q(ua), { name: "fade" }, {
          default: Ee(() => [
            g.value ? ($(), j("div", $c, [
              ae("span", Ic, Ie(e.longPressHint), 1)
            ])) : ue("", !0),
            e.loading ? ($(), j("div", Dc, [
              Oe(q(Qe), {
                class: "lc-button__loading-spinner",
                name: "loader"
              }),
              e.loadingText ? ($(), j("span", Mc, Ie(e.loadingText), 1)) : ue("", !0)
            ])) : ue("", !0)
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 16, ["aria-busy", "class", "disabled"]));
  }
}), si = /* @__PURE__ */ _e({
  __name: "LcSeparator",
  props: {
    variant: { default: "default" }
  },
  setup(e) {
    return (t, n) => ($(), j("hr", {
      class: ye(["lc-separator", `lc-separator--variant-${e.variant}`])
    }, null, 2));
  }
}), U1 = ["dashed", "default"], Tt = (e) => {
  if (e) return `lc-${e}`;
  const t = pa(), n = crypto.randomUUID();
  return t ? `lc-${t.useId() || n}` : `lc-${n}`;
}, ui = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, s] of t)
    n[r] = s;
  return n;
}, Oc = {}, Rc = { viewBox: "0 0 752 8" }, Fc = { id: "perforation" }, Nc = ["cx"];
function Bc(e, t) {
  return $(), j("svg", Rc, [
    ae("mask", Fc, [
      t[0] || (t[0] = ae("rect", {
        fill: "white",
        height: "8",
        width: "752"
      }, null, -1)),
      ($(!0), j(Ge, null, vt(new Array(21), (n, r) => ($(), j("circle", {
        key: r,
        cx: 28 + r * 34.75,
        cy: "18",
        fill: "black",
        r: "16"
      }, null, 8, Nc))), 128))
    ]),
    t[1] || (t[1] = ae("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const Pc = /* @__PURE__ */ ui(Oc, [["render", Bc]]), zc = {}, Vc = { viewBox: "0 0 752 8" }, Hc = { id: "perforation" }, Uc = ["points"];
function qc(e, t) {
  return $(), j("svg", Vc, [
    ae("mask", Hc, [
      t[0] || (t[0] = ae("rect", {
        fill: "black",
        height: "8",
        width: "752"
      }, null, -1)),
      ($(!0), j(Ge, null, vt(new Array(150), (n, r) => ($(), j("polygon", {
        key: r,
        fill: "white",
        points: `${r * 5},0 ${4 + r * 5},6 ${8 + r * 5},0`
      }, null, 8, Uc))), 128))
    ]),
    t[1] || (t[1] = ae("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const tl = /* @__PURE__ */ ui(zc, [["render", qc]]), jc = ["id"], Zc = {
  key: 0,
  class: "lc-card__background"
}, Wc = {
  key: 1,
  class: /* @__PURE__ */ ye(["lc-card__perforation", "lc-card__perforation--top"])
}, Yc = {
  key: 0,
  class: "lc-card__toggle"
}, Xc = {
  key: 2,
  class: /* @__PURE__ */ ye(["lc-card__perforation", "lc-card__perforation--bottom"])
}, ya = /* @__PURE__ */ _e({
  __name: "LcCard",
  props: /* @__PURE__ */ Sn({
    animated: { type: Boolean },
    bodyClass: {},
    expandable: { type: Boolean },
    footerClass: {},
    headerClass: {},
    headerTo: {},
    id: {},
    modelValue: { type: Boolean },
    onHeaderClick: { type: Function },
    radius: { default: "medium" },
    shadow: { default: "large" },
    showSeparator: { type: Boolean },
    toggleAriaLabel: { default: () => je.lcCard.toggleAriaLabel },
    variant: { default: "default" },
    withWavyBody: { type: Boolean },
    withWavyHeader: { type: Boolean }
  }, {
    modelValue: { default: !1, type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Sn(["collapse", "collapsed", "expand", "expanded"], ["update:modelValue"]),
  setup(e) {
    const t = An(), n = Tt(e.id), r = pe(!!t.default), s = Wa(e, "modelValue"), i = W(() => !!e.expandable && !!e.animated), a = W(() => [
      "lc-card",
      `lc-card--radius-${e.radius}`,
      `lc-card--shadow-${e.shadow}`,
      `lc-card--variant-${e.variant}`,
      {
        "lc-card--animated": i.value,
        "lc-card--expandable": e.expandable,
        "lc-card--expanded": e.expandable && s.value,
        "lc-card--no-body": !r.value,
        "lc-card--wavy-body": e.withWavyBody,
        "lc-card--wavy-header": e.withWavyHeader
      }
    ]), o = () => {
      e.expandable && (s.value = !s.value);
    };
    return ro(() => {
      r.value = !!t.default;
    }), (l, h) => ($(), j("article", {
      id: q(n),
      class: ye(a.value)
    }, [
      l.$slots.background ? ($(), j("div", Zc, [
        me(l.$slots, "background")
      ])) : ue("", !0),
      e.variant === "transaction" ? ($(), j("div", Wc, [
        Oe(tl)
      ])) : ue("", !0),
      l.$slots.header || e.expandable ? ($(), xe(Pt(e.expandable ? "button" : "div"), {
        key: 2,
        "aria-controls": e.expandable ? `${q(n)}-region` : void 0,
        "aria-expanded": e.expandable ? s.value : void 0,
        "aria-label": e.expandable ? e.toggleAriaLabel : void 0,
        class: "lc-card__header-wrap",
        type: e.expandable ? "button" : void 0,
        onClickPassive: o
      }, {
        default: Ee(() => [
          e.headerTo && !e.expandable ? ($(), xe(q(oi), {
            key: 0,
            tabindex: "-1",
            to: e.headerTo,
            onClick: e.onHeaderClick
          }, {
            default: Ee(() => [
              ae("header", {
                class: ye(["lc-card__header", e.headerClass])
              }, [
                me(l.$slots, "header")
              ], 2)
            ]),
            _: 3
          }, 8, ["to", "onClick"])) : ($(), j("header", {
            key: 1,
            class: ye(["lc-card__header", e.headerClass])
          }, [
            me(l.$slots, "header"),
            e.expandable ? ($(), j(Ge, { key: 0 }, [
              l.$slots.toggle ? ($(), j("div", Yc, [
                me(l.$slots, "toggle")
              ])) : ($(), xe(q(Qe), {
                key: 1,
                class: "lc-card__toggle-icon",
                name: "chevron-down"
              }))
            ], 64)) : ue("", !0)
          ], 2))
        ]),
        _: 3
      }, 40, ["aria-controls", "aria-expanded", "aria-label", "type"])) : ue("", !0),
      (l.$slots.default || l.$slots.footer) && (!e.expandable || i.value || s.value) ? ($(), xe(q(Ao), Te({
        key: 3,
        id: `${q(n)}-region`
      }, { when: s.value }, {
        animated: i.value,
        class: "lc-card__body-wrap",
        onCollapse: h[0] || (h[0] = (v) => l.$emit("collapse")),
        onCollapsed: h[1] || (h[1] = (v) => l.$emit("collapsed")),
        onExpand: h[2] || (h[2] = (v) => l.$emit("expand")),
        onExpanded: h[3] || (h[3] = (v) => l.$emit("expanded"))
      }), {
        default: Ee(() => [
          l.$slots.default ? ($(), j("div", {
            key: 0,
            class: ye(["lc-card__body", e.bodyClass])
          }, [
            me(l.$slots, "default")
          ], 2)) : ue("", !0),
          l.$slots.footer ? ($(), j("footer", {
            key: 1,
            class: ye(["lc-card__footer", e.footerClass])
          }, [
            e.showSeparator ? ($(), xe(q(si), {
              key: 0,
              variant: "dashed"
            })) : ue("", !0),
            me(l.$slots, "footer")
          ], 2)) : ue("", !0),
          e.variant !== "default" ? ($(), j("div", Xc, [
            e.variant == "order" ? ($(), xe(Pc, { key: 0 })) : ($(), xe(tl, { key: 1 }))
          ])) : ue("", !0)
        ]),
        _: 3
      }, 16, ["id", "animated"])) : ue("", !0)
    ], 10, jc));
  }
}), q1 = ["large", "medium", "none"], j1 = ["large", "none", "small"], Z1 = ["default", "order", "transaction"], Gc = { class: "lc-modal__card-header-wrap" }, Kc = { class: "lc-modal__card-header-actions" }, $o = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcModal",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    backgroundClass: {},
    closeTriggers: { default: () => je.lcModal.closeTriggers },
    containerClass: {},
    fullScreen: { type: Boolean },
    fullSize: { type: Boolean },
    isVisible: { type: Boolean, default: () => je.lcModal.isVisible },
    noFocusTrap: { type: Boolean, default: () => je.lcModal.noFocusTrap },
    spacing: { default: () => je.lcModal.spacing },
    to: { default: () => je.lcModal.to },
    transition: {},
    wrapAttrs: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = t, r = pe(), s = uo(() => document.documentElement), i = W(() => h("close-button")), l = {
      allowOutsideClick: (f) => {
        const m = f.target;
        return m ? Ke(e.ignoreOutsideClickOn).some((u) => (typeof u == "string" ? document.querySelector(u) : so(u))?.contains(m) ?? !1) : !1;
      },
      fallbackFocus: (() => {
        const f = document.createElement("button");
        return f.id = "lc-modal-fallback-focus", f.hidden = !0, f;
      })(),
      immediate: !0
    }, h = (f) => e.closeTriggers.includes(f), v = (f) => {
      h(f) && n("close");
    }, c = (f) => {
      r.value = f;
    };
    return Ga(r, () => v("click-outside"), {
      ignore: e.ignoreOutsideClickOn
    }), co("Escape", () => v("escape")), ze(
      () => e.isVisible,
      (f) => {
        s.value = f;
      },
      { immediate: !0 }
    ), (f, m) => e.isVisible ? ($(), xe(ba, {
      key: 0,
      class: "lc-modal",
      to: e.to
    }, [
      Oe(q(ua), { name: "fade" }, {
        default: Ee(() => [
          ae("div", {
            class: ye([
              "lc-modal__bg",
              {
                "lc-modal__bg--full-screen": e.fullScreen,
                "lc-modal__bg--full-size": e.fullSize
              },
              e.backgroundClass
            ])
          }, [
            Oe(q(ua), Te(e.wrapAttrs, {
              class: ["lc-modal__wrap", e.containerClass],
              name: e.transition
            }), {
              default: Ee(() => [
                ($(), xe(Pt(e.noFocusTrap ? "div" : q(xo)), {
                  options: e.noFocusTrap ? null : l
                }, {
                  default: Ee(() => [
                    me(f.$slots, "modal", _t(Dt({ setRef: c })), () => [
                      Oe(q(ya), {
                        ref_key: "modalRef",
                        ref: r,
                        "body-class": "lc-modal__body",
                        class: ye([
                          "lc-modal__card",
                          `lc-modal__card--${e.spacing}`,
                          {
                            "lc-modal__card--full-size": e.fullSize
                          }
                        ]),
                        role: "dialog"
                      }, {
                        default: Ee(() => [
                          f.$slots.header || i.value ? ($(), j("header", {
                            key: 0,
                            class: ye(["lc-modal__card-header", {
                              "lc-modal__card-header--close-button": i.value || e.fullSize
                            }])
                          }, [
                            ae("div", Gc, [
                              me(f.$slots, "header")
                            ]),
                            ae("div", Kc, [
                              me(f.$slots, "actions"),
                              i.value ? ($(), xe(q(Et), {
                                key: 0,
                                class: "lc-modal__card-header-close",
                                icon: "close",
                                size: "small",
                                variant: "tertiary",
                                onClickPassive: m[0] || (m[0] = (u) => v("close-button"))
                              })) : ue("", !0)
                            ])
                          ], 2)) : ue("", !0),
                          me(f.$slots, "default")
                        ]),
                        _: 3
                      }, 8, ["class"])
                    ])
                  ]),
                  _: 3
                }, 8, ["options"]))
              ]),
              _: 3
            }, 16, ["class", "name"])
          ], 2)
        ]),
        _: 3
      })
    ], 8, ["to"])) : ue("", !0);
  }
}), W1 = ["click-outside", "close-button", "escape"], Y1 = ["large", "medium", "small"], Jc = 30, Qc = 0.3, nl = (e) => {
  const t = e.match(/^([\d.]+)(px|dvh|vh|svh|lvh)$/);
  if (t) {
    const s = parseFloat(t[1]);
    return t[2] === "px" ? s : s / 100 * window.innerHeight;
  }
  const n = document.createElement("div");
  n.style.cssText = `height:${e};position:absolute;visibility:hidden`, document.body.appendChild(n);
  const r = n.getBoundingClientRect().height;
  return n.remove(), r;
}, ed = ({
  dragAreaRef: e,
  snapHeights: t,
  onClose: n,
  canClose: r
}) => {
  const s = pe(0), i = pe(0), a = pe(!1), o = pe(0), l = pe(0), h = pe(0), v = pe(0), c = W(
    () => Ke(t)[o.value] ?? Ke(t)[0]
  ), f = W(() => o.value < Ke(t).length - 1), m = () => {
    i.value = 0, s.value = 0, a.value = !1;
  }, u = () => {
    o.value = 0;
  }, p = (_, E) => (E > 0 ? _ / E : 0) > Qc || _ > Jc, k = () => {
    if (!a.value) return;
    const _ = v.value - h.value, E = Date.now() - l.value, I = Math.abs(_), L = _ > 0 ? "down" : "up", C = Ke(t);
    if (L === "up" && f.value && p(I, E)) {
      const V = nl(C[o.value]) + I;
      let J = o.value + 1, O = 1 / 0;
      for (let K = o.value + 1; K < C.length; K++) {
        const P = Math.abs(nl(C[K]) - V);
        P < O && (O = P, J = K);
      }
      o.value = J, m();
      return;
    }
    if (L === "down" && p(I, E) && r()) {
      a.value = !1, n();
      return;
    }
    m();
  }, g = (_) => {
    if (_.target.closest('button, a, [role="button"]')) return;
    _.currentTarget.setPointerCapture(_.pointerId), h.value = _.clientY, v.value = _.clientY, l.value = Date.now(), a.value = !0;
  }, b = (_) => {
    if (!a.value) return;
    v.value = _.clientY;
    const E = v.value - h.value;
    E < 0 && f.value ? (i.value = -E, s.value = 0) : (i.value = 0, s.value = Math.max(0, E));
  };
  return on(e, "pointerdown", g), on(e, "pointermove", b), on(e, "pointerup", k), on(e, "pointercancel", k), on(e, "lostpointercapture", k), {
    currentSnapHeight: c,
    currentSnapIndex: o,
    dismissOffset: s,
    isDragging: a,
    resetDrag: m,
    resetSnapIndex: u,
    snapTransitionOffset: i
  };
}, td = { class: "lc-bottom-sheet-modal__header" }, nd = { class: "lc-bottom-sheet-modal__header-actions" }, ad = { class: "lc-bottom-sheet" }, rd = ["aria-labelledby"], id = { class: "lc-bottom-sheet__header-actions" }, Aa = 300, al = "lc-bottom-sheet__drag-area", ld = "(width < 496px)", X1 = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcBottomSheet",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    closeTriggers: { default: () => ["swipe-down", "click-outside", "escape", "close-button"] },
    modalClass: {},
    modelValue: { type: Boolean, default: !1 },
    snapHeights: { default: () => ["50dvh"] },
    to: { default: () => je.lcModal.to }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = {
      allowOutsideClick: !0,
      fallbackFocus: () => document.querySelector(`.${al}`) ?? document.body,
      immediate: !0
    }, r = ["click-outside", "escape", "close-button"], s = t;
    let i;
    const o = `${Tt()}-header`, l = it("dragArea"), h = pe(!1), v = pe(!1), c = pe(!0), f = Gs(ld), m = uo(() => document.documentElement), {
      currentSnapHeight: u,
      dismissOffset: p,
      isDragging: k,
      resetDrag: g,
      resetSnapIndex: b,
      snapTransitionOffset: _
    } = ed({
      dragAreaRef: l,
      snapHeights: W(() => e.snapHeights),
      onClose: () => L(),
      canClose: () => F("swipe-down")
    }), E = W(
      () => e.closeTriggers.filter(
        (J) => r.includes(J)
      )
    ), I = W(() => {
      if (k.value) {
        const O = _.value !== 0;
        return {
          height: O ? `calc(${u.value} + ${_.value}px)` : u.value,
          transform: O ? "translateY(0)" : `translateY(${Math.max(0, p.value)}px)`,
          transition: "none"
        };
      }
      if (h.value)
        return {
          height: u.value,
          transform: "translateY(100%)",
          transition: `transform ${Aa}ms ease`
        };
      const J = c.value;
      return {
        height: u.value,
        transform: J ? "translateY(100%)" : "translateY(0)",
        transition: c.value ? "none" : `height ${Aa}ms ease, transform ${Aa}ms ease`
      };
    }), L = () => {
      h.value || (h.value = !0, i = setTimeout(() => {
        h.value = !1, g(), b(), s("update:modelValue", !1);
      }, Aa));
    }, C = () => {
      F("click-outside") && L();
    }, F = (J) => e.closeTriggers.includes(J), V = (J) => {
      const O = J.target;
      v.value = O.scrollTop > 0;
    };
    return ze(
      () => e.modelValue,
      async (J) => {
        if (!J) return m.value = !1;
        clearTimeout(i), h.value = !1, g(), v.value = !1, c.value = !0, m.value = !0, await Ya(), requestAnimationFrame(() => {
          c.value = !1;
        });
      },
      { immediate: !0 }
    ), co("Escape", () => {
      F("escape") && L();
    }), Ln(() => {
      clearTimeout(i), m.value = !1;
    }), (J, O) => q(f) ? e.modelValue ? ($(), xe(ba, {
      key: 1,
      to: e.to
    }, [
      ae("div", ad, [
        ae("div", {
          class: ye(["lc-bottom-sheet__overlay", { "lc-bottom-sheet__overlay--closing": h.value }]),
          role: "presentation",
          onClick: C
        }, null, 2),
        Oe(q(xo), { options: n }, {
          default: Ee(() => [
            ae("div", {
              "aria-labelledby": J.$slots.title ? o : void 0,
              "aria-modal": "true",
              class: "lc-bottom-sheet__sheet",
              role: "dialog",
              style: Ct(I.value)
            }, [
              ae("div", {
                ref: "dragArea",
                class: ye([
                  al,
                  { "lc-bottom-sheet__drag-area--scrolled": v.value }
                ])
              }, [
                O[1] || (O[1] = ae("div", { class: "lc-bottom-sheet__handle" }, [
                  ae("div", { class: "lc-bottom-sheet__handle-pill" })
                ], -1)),
                J.$slots.title || F("close-button") ? ($(), j("div", {
                  key: 0,
                  id: o,
                  class: "lc-bottom-sheet__header"
                }, [
                  me(J.$slots, "title"),
                  ae("div", id, [
                    me(J.$slots, "actions"),
                    F("close-button") ? ($(), xe(q(Et), {
                      key: 0,
                      class: "lc-modal__card-header-close",
                      icon: "close",
                      size: "small",
                      variant: "tertiary",
                      onClick: L
                    })) : ue("", !0)
                  ])
                ])) : ue("", !0)
              ], 2),
              ae("div", {
                ref: "contentArea",
                class: "lc-bottom-sheet__content",
                onScroll: V
              }, [
                me(J.$slots, "default")
              ], 544)
            ], 12, rd)
          ]),
          _: 3
        })
      ])
    ], 8, ["to"])) : ue("", !0) : ($(), xe(q($o), Te({ key: 0 }, { to: e.to, ignoreOutsideClickOn: e.ignoreOutsideClickOn }, {
      "background-class": `lc-bottom-sheet-modal lc-bottom-sheet-modal--${v.value ? "scrolled" : "default"}`,
      "is-visible": e.modelValue,
      "container-class": e.modalClass,
      "close-triggers": E.value,
      spacing: "small",
      onClose: O[0] || (O[0] = (K) => s("update:modelValue", !1))
    }), Xa({
      default: Ee(() => [
        ae("div", {
          class: ye(["lc-bottom-sheet-modal__content", { "lc-bottom-sheet-modal__content--scrolled": v.value }]),
          onScroll: V
        }, [
          me(J.$slots, "default")
        ], 34)
      ]),
      _: 2
    }, [
      J.$slots.title ? {
        name: "header",
        fn: Ee(() => [
          ae("div", td, [
            me(J.$slots, "title")
          ])
        ]),
        key: "0"
      } : void 0,
      J.$slots.actions ? {
        name: "actions",
        fn: Ee(() => [
          ae("div", nd, [
            me(J.$slots, "actions")
          ])
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["background-class", "is-visible", "container-class", "close-triggers"]));
  }
}), G1 = ["swipe-down", "click-outside", "escape"];
function Io(e = {}) {
  let t, n = [];
  const r = ["select", "slideFocus"];
  function s(h) {
    t = h;
    const {
      options: {
        axis: v
      },
      slideRects: c
    } = t.internalEngine();
    v !== "y" && (n = c.map((f) => f.height), r.forEach((f) => t.on(f, o)), o());
  }
  function i() {
    r.forEach((v) => t.off(v, o));
    const h = t.containerNode();
    h.style.height = "", h.getAttribute("style") || h.removeAttribute("style");
  }
  function a() {
    const {
      slideRegistry: h
    } = t.internalEngine(), v = h[t.selectedScrollSnap()];
    return v ? v.map((c) => n[c]).reduce((c, f) => Math.max(c, f), 0) : null;
  }
  function o() {
    a() !== null && (t.containerNode().style.height = `${a()}px`);
  }
  return {
    name: "autoHeight",
    options: e,
    init: s,
    destroy: i
  };
}
Io.globalOptions = void 0;
const od = {
  active: !0,
  breakpoints: {},
  snapped: "is-snapped",
  inView: "is-in-view",
  draggable: "is-draggable",
  dragging: "is-dragging",
  loop: "is-loop"
};
function Jn(e) {
  return (Array.isArray(e) ? e : [e]).filter(Boolean);
}
function Qn(e, t) {
  !e || !t.length || e.classList.remove(...t);
}
function La(e, t) {
  !e || !t.length || e.classList.add(...t);
}
function Ja(e = {}) {
  let t, n, r, s, i = [], a = [];
  const o = ["select"], l = ["pointerDown", "pointerUp"], h = ["slidesInView"], v = {
    snapped: [],
    inView: [],
    draggable: [],
    dragging: [],
    loop: []
  };
  function c(b, _) {
    n = b;
    const {
      mergeOptions: E,
      optionsAtMedia: I
    } = _, L = E(od, Ja.globalOptions), C = E(L, e);
    t = I(C), r = n.rootNode(), s = n.slideNodes();
    const {
      watchDrag: F,
      loop: V
    } = n.internalEngine().options, J = !!F;
    t.loop && V && (v.loop = Jn(t.loop), La(r, v.loop)), t.draggable && J && (v.draggable = Jn(t.draggable), La(r, v.draggable)), t.dragging && (v.dragging = Jn(t.dragging), l.forEach((O) => n.on(O, m))), t.snapped && (v.snapped = Jn(t.snapped), o.forEach((O) => n.on(O, p)), p()), t.inView && (v.inView = Jn(t.inView), h.forEach((O) => n.on(O, k)), k());
  }
  function f() {
    l.forEach((b) => n.off(b, m)), o.forEach((b) => n.off(b, p)), h.forEach((b) => n.off(b, k)), Qn(r, v.loop), Qn(r, v.draggable), Qn(r, v.dragging), u([], i, v.snapped), u([], a, v.inView), Object.keys(v).forEach((b) => {
      const _ = b;
      v[_] = [];
    });
  }
  function m(b, _) {
    (_ === "pointerDown" ? La : Qn)(r, v.dragging);
  }
  function u(b = [], _ = [], E) {
    const I = _.map((C) => s[C]), L = b.map((C) => s[C]);
    return I.forEach((C) => Qn(C, E)), L.forEach((C) => La(C, E)), b;
  }
  function p() {
    const {
      slideRegistry: b
    } = n.internalEngine(), _ = b[n.selectedScrollSnap()];
    i = u(_, i, v.snapped);
  }
  function k() {
    const b = n.slidesInView();
    a = u(b, a, v.inView);
  }
  return {
    name: "classNames",
    options: e,
    init: c,
    destroy: f
  };
}
Ja.globalOptions = void 0;
function sd(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function rl(e) {
  return sd(e) || Array.isArray(e);
}
function ud() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function ci(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  const s = JSON.stringify(Object.keys(e.breakpoints || {})), i = JSON.stringify(Object.keys(t.breakpoints || {}));
  return s !== i ? !1 : n.every((a) => {
    const o = e[a], l = t[a];
    return typeof o == "function" ? `${o}` == `${l}` : !rl(o) || !rl(l) ? o === l : ci(o, l);
  });
}
function il(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function cd(e, t) {
  if (e.length !== t.length) return !1;
  const n = il(e), r = il(t);
  return n.every((s, i) => {
    const a = r[i];
    return ci(s, a);
  });
}
function di(e) {
  return typeof e == "number";
}
function Zr(e) {
  return typeof e == "string";
}
function Qa(e) {
  return typeof e == "boolean";
}
function ll(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function at(e) {
  return Math.abs(e);
}
function fi(e) {
  return Math.sign(e);
}
function la(e, t) {
  return at(e - t);
}
function dd(e, t) {
  if (e === 0 || t === 0 || at(e) <= at(t)) return 0;
  const n = la(at(e), at(t));
  return at(n / e);
}
function fd(e) {
  return Math.round(e * 100) / 100;
}
function ca(e) {
  return da(e).map(Number);
}
function Ut(e) {
  return e[wa(e)];
}
function wa(e) {
  return Math.max(0, e.length - 1);
}
function hi(e, t) {
  return t === wa(e);
}
function ol(e, t = 0) {
  return Array.from(Array(e), (n, r) => t + r);
}
function da(e) {
  return Object.keys(e);
}
function Do(e, t) {
  return [e, t].reduce((n, r) => (da(r).forEach((s) => {
    const i = n[s], a = r[s], o = ll(i) && ll(a);
    n[s] = o ? Do(i, a) : a;
  }), n), {});
}
function Wr(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function hd(e, t) {
  const n = {
    start: r,
    center: s,
    end: i
  };
  function r() {
    return 0;
  }
  function s(l) {
    return i(l) / 2;
  }
  function i(l) {
    return t - l;
  }
  function a(l, h) {
    return Zr(e) ? n[e](l) : e(t, l, h);
  }
  return {
    measure: a
  };
}
function fa() {
  let e = [];
  function t(s, i, a, o = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in s)
      s.addEventListener(i, a, o), l = () => s.removeEventListener(i, a, o);
    else {
      const h = s;
      h.addListener(a), l = () => h.removeListener(a);
    }
    return e.push(l), r;
  }
  function n() {
    e = e.filter((s) => s());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function vd(e, t, n, r) {
  const s = fa(), i = 1e3 / 60;
  let a = null, o = 0, l = 0;
  function h() {
    s.add(e, "visibilitychange", () => {
      e.hidden && u();
    });
  }
  function v() {
    m(), s.clear();
  }
  function c(k) {
    if (!l) return;
    a || (a = k, n(), n());
    const g = k - a;
    for (a = k, o += g; o >= i; )
      n(), o -= i;
    const b = o / i;
    r(b), l && (l = t.requestAnimationFrame(c));
  }
  function f() {
    l || (l = t.requestAnimationFrame(c));
  }
  function m() {
    t.cancelAnimationFrame(l), a = null, o = 0, l = 0;
  }
  function u() {
    a = null, o = 0;
  }
  return {
    init: h,
    destroy: v,
    start: f,
    stop: m,
    update: n,
    render: r
  };
}
function md(e, t) {
  const n = t === "rtl", r = e === "y", s = r ? "y" : "x", i = r ? "x" : "y", a = !r && n ? -1 : 1, o = v(), l = c();
  function h(u) {
    const {
      height: p,
      width: k
    } = u;
    return r ? p : k;
  }
  function v() {
    return r ? "top" : n ? "right" : "left";
  }
  function c() {
    return r ? "bottom" : n ? "left" : "right";
  }
  function f(u) {
    return u * a;
  }
  return {
    scroll: s,
    cross: i,
    startEdge: o,
    endEdge: l,
    measureSize: h,
    direction: f
  };
}
function Cn(e = 0, t = 0) {
  const n = at(e - t);
  function r(h) {
    return h < e;
  }
  function s(h) {
    return h > t;
  }
  function i(h) {
    return r(h) || s(h);
  }
  function a(h) {
    return i(h) ? r(h) ? e : t : h;
  }
  function o(h) {
    return n ? h - n * Math.ceil((h - t) / n) : h;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: a,
    reachedAny: i,
    reachedMax: s,
    reachedMin: r,
    removeOffset: o
  };
}
function Mo(e, t, n) {
  const {
    constrain: r
  } = Cn(0, e), s = e + 1;
  let i = a(t);
  function a(f) {
    return n ? at((s + f) % s) : r(f);
  }
  function o() {
    return i;
  }
  function l(f) {
    return i = a(f), c;
  }
  function h(f) {
    return v().set(o() + f);
  }
  function v() {
    return Mo(e, o(), n);
  }
  const c = {
    get: o,
    set: l,
    add: h,
    clone: v
  };
  return c;
}
function gd(e, t, n, r, s, i, a, o, l, h, v, c, f, m, u, p, k, g, b) {
  const {
    cross: _,
    direction: E
  } = e, I = ["INPUT", "SELECT", "TEXTAREA"], L = {
    passive: !1
  }, C = fa(), F = fa(), V = Cn(50, 225).constrain(m.measure(20)), J = {
    mouse: 300,
    touch: 400
  }, O = {
    mouse: 500,
    touch: 600
  }, K = u ? 43 : 25;
  let P = !1, T = 0, A = 0, z = !1, U = !1, X = !1, B = !1;
  function ie(de) {
    if (!b) return;
    function Re(Ze) {
      (Qa(b) || b(de, Ze)) && te(Ze);
    }
    const He = t;
    C.add(He, "dragstart", (Ze) => Ze.preventDefault(), L).add(He, "touchmove", () => {
    }, L).add(He, "touchend", () => {
    }).add(He, "touchstart", Re).add(He, "mousedown", Re).add(He, "touchcancel", ge).add(He, "contextmenu", ge).add(He, "click", be, !0);
  }
  function H() {
    C.clear(), F.clear();
  }
  function ee() {
    const de = B ? n : t;
    F.add(de, "touchmove", he, L).add(de, "touchend", ge).add(de, "mousemove", he, L).add(de, "mouseup", ge);
  }
  function ce(de) {
    const Re = de.nodeName || "";
    return I.includes(Re);
  }
  function we() {
    return (u ? O : J)[B ? "mouse" : "touch"];
  }
  function ke(de, Re) {
    const He = c.add(fi(de) * -1), Ze = v.byDistance(de, !u).distance;
    return u || at(de) < V ? Ze : k && Re ? Ze * 0.5 : v.byIndex(He.get(), 0).distance;
  }
  function te(de) {
    const Re = Wr(de, r);
    B = Re, X = u && Re && !de.buttons && P, P = la(s.get(), a.get()) >= 2, !(Re && de.button !== 0) && (ce(de.target) || (z = !0, i.pointerDown(de), h.useFriction(0).useDuration(0), s.set(a), ee(), T = i.readPoint(de), A = i.readPoint(de, _), f.emit("pointerDown")));
  }
  function he(de) {
    if (!Wr(de, r) && de.touches.length >= 2) return ge(de);
    const He = i.readPoint(de), Ze = i.readPoint(de, _), We = la(He, T), Be = la(Ze, A);
    if (!U && !B && (!de.cancelable || (U = We > Be, !U)))
      return ge(de);
    const Fe = i.pointerMove(de);
    We > p && (X = !0), h.useFriction(0.3).useDuration(0.75), o.start(), s.add(E(Fe)), de.preventDefault();
  }
  function ge(de) {
    const He = v.byDistance(0, !1).index !== c.get(), Ze = i.pointerUp(de) * we(), We = ke(E(Ze), He), Be = dd(Ze, We), Fe = K - 10 * Be, Xe = g + Be / 50;
    U = !1, z = !1, F.clear(), h.useDuration(Fe).useFriction(Xe), l.distance(We, !u), B = !1, f.emit("pointerUp");
  }
  function be(de) {
    X && (de.stopPropagation(), de.preventDefault(), X = !1);
  }
  function Pe() {
    return z;
  }
  return {
    init: ie,
    destroy: H,
    pointerDown: Pe
  };
}
function bd(e, t) {
  let r, s;
  function i(c) {
    return c.timeStamp;
  }
  function a(c, f) {
    const u = `client${(f || e.scroll) === "x" ? "X" : "Y"}`;
    return (Wr(c, t) ? c : c.touches[0])[u];
  }
  function o(c) {
    return r = c, s = c, a(c);
  }
  function l(c) {
    const f = a(c) - a(s), m = i(c) - i(r) > 170;
    return s = c, m && (r = c), f;
  }
  function h(c) {
    if (!r || !s) return 0;
    const f = a(s) - a(r), m = i(c) - i(r), u = i(c) - i(s) > 170, p = f / m;
    return m && !u && at(p) > 0.1 ? p : 0;
  }
  return {
    pointerDown: o,
    pointerMove: l,
    pointerUp: h,
    readPoint: a
  };
}
function pd() {
  function e(n) {
    const {
      offsetTop: r,
      offsetLeft: s,
      offsetWidth: i,
      offsetHeight: a
    } = n;
    return {
      top: r,
      right: s + i,
      bottom: r + a,
      left: s,
      width: i,
      height: a
    };
  }
  return {
    measure: e
  };
}
function yd(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function wd(e, t, n, r, s, i, a) {
  const o = [e].concat(r);
  let l, h, v = [], c = !1;
  function f(k) {
    return s.measureSize(a.measure(k));
  }
  function m(k) {
    if (!i) return;
    h = f(e), v = r.map(f);
    function g(b) {
      for (const _ of b) {
        if (c) return;
        const E = _.target === e, I = r.indexOf(_.target), L = E ? h : v[I], C = f(E ? e : r[I]);
        if (at(C - L) >= 0.5) {
          k.reInit(), t.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((b) => {
      (Qa(i) || i(k, b)) && g(b);
    }), n.requestAnimationFrame(() => {
      o.forEach((b) => l.observe(b));
    });
  }
  function u() {
    c = !0, l && l.disconnect();
  }
  return {
    init: m,
    destroy: u
  };
}
function xd(e, t, n, r, s, i) {
  let a = 0, o = 0, l = s, h = i, v = e.get(), c = 0;
  function f() {
    const L = r.get() - e.get(), C = !l;
    let F = 0;
    return C ? (a = 0, n.set(r), e.set(r), F = L) : (n.set(e), a += L / l, a *= h, v += a, e.add(a), F = v - c), o = fi(F), c = v, I;
  }
  function m() {
    const L = r.get() - t.get();
    return at(L) < 1e-3;
  }
  function u() {
    return l;
  }
  function p() {
    return o;
  }
  function k() {
    return a;
  }
  function g() {
    return _(s);
  }
  function b() {
    return E(i);
  }
  function _(L) {
    return l = L, I;
  }
  function E(L) {
    return h = L, I;
  }
  const I = {
    direction: p,
    duration: u,
    velocity: k,
    seek: f,
    settled: m,
    useBaseFriction: b,
    useBaseDuration: g,
    useFriction: E,
    useDuration: _
  };
  return I;
}
function kd(e, t, n, r, s) {
  const i = s.measure(10), a = s.measure(50), o = Cn(0.1, 0.99);
  let l = !1;
  function h() {
    return !(l || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function v(m) {
    if (!h()) return;
    const u = e.reachedMin(t.get()) ? "min" : "max", p = at(e[u] - t.get()), k = n.get() - t.get(), g = o.constrain(p / a);
    n.subtract(k * g), !m && at(k) < i && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function c(m) {
    l = !m;
  }
  return {
    shouldConstrain: h,
    constrain: v,
    toggleActive: c
  };
}
function Sd(e, t, n, r, s) {
  const i = Cn(-t + e, 0), a = c(), o = v(), l = f();
  function h(u, p) {
    return la(u, p) <= 1;
  }
  function v() {
    const u = a[0], p = Ut(a), k = a.lastIndexOf(u), g = a.indexOf(p) + 1;
    return Cn(k, g);
  }
  function c() {
    return n.map((u, p) => {
      const {
        min: k,
        max: g
      } = i, b = i.constrain(u), _ = !p, E = hi(n, p);
      return _ ? g : E || h(k, b) ? k : h(g, b) ? g : b;
    }).map((u) => parseFloat(u.toFixed(3)));
  }
  function f() {
    if (t <= e + s) return [i.max];
    if (r === "keepSnaps") return a;
    const {
      min: u,
      max: p
    } = o;
    return a.slice(u, p);
  }
  return {
    snapsContained: l,
    scrollContainLimit: o
  };
}
function _d(e, t, n) {
  const r = t[0], s = n ? r - e : Ut(t);
  return {
    limit: Cn(s, r)
  };
}
function Cd(e, t, n, r) {
  const i = t.min + 0.1, a = t.max + 0.1, {
    reachedMin: o,
    reachedMax: l
  } = Cn(i, a);
  function h(f) {
    return f === 1 ? l(n.get()) : f === -1 ? o(n.get()) : !1;
  }
  function v(f) {
    if (!h(f)) return;
    const m = e * (f * -1);
    r.forEach((u) => u.add(m));
  }
  return {
    loop: v
  };
}
function Ed(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(i) {
    const a = i - t;
    return n ? a / -n : 0;
  }
  return {
    get: r
  };
}
function Td(e, t, n, r, s) {
  const {
    startEdge: i,
    endEdge: a
  } = e, {
    groupSlides: o
  } = s, l = c().map(t.measure), h = f(), v = m();
  function c() {
    return o(r).map((p) => Ut(p)[a] - p[0][i]).map(at);
  }
  function f() {
    return r.map((p) => n[i] - p[i]).map((p) => -at(p));
  }
  function m() {
    return o(h).map((p) => p[0]).map((p, k) => p + l[k]);
  }
  return {
    snaps: h,
    snapsAligned: v
  };
}
function Ad(e, t, n, r, s, i) {
  const {
    groupSlides: a
  } = s, {
    min: o,
    max: l
  } = r, h = v();
  function v() {
    const f = a(i), m = !e || t === "keepSnaps";
    return n.length === 1 ? [i] : m ? f : f.slice(o, l).map((u, p, k) => {
      const g = !p, b = hi(k, p);
      if (g) {
        const _ = Ut(k[0]) + 1;
        return ol(_);
      }
      if (b) {
        const _ = wa(i) - Ut(k)[0] + 1;
        return ol(_, Ut(k)[0]);
      }
      return u;
    });
  }
  return {
    slideRegistry: h
  };
}
function Ld(e, t, n, r, s) {
  const {
    reachedAny: i,
    removeOffset: a,
    constrain: o
  } = r;
  function l(u) {
    return u.concat().sort((p, k) => at(p) - at(k))[0];
  }
  function h(u) {
    const p = e ? a(u) : o(u), k = t.map((b, _) => ({
      diff: v(b - p, 0),
      index: _
    })).sort((b, _) => at(b.diff) - at(_.diff)), {
      index: g
    } = k[0];
    return {
      index: g,
      distance: p
    };
  }
  function v(u, p) {
    const k = [u, u + n, u - n];
    if (!e) return u;
    if (!p) return l(k);
    const g = k.filter((b) => fi(b) === p);
    return g.length ? l(g) : Ut(k) - n;
  }
  function c(u, p) {
    const k = t[u] - s.get(), g = v(k, p);
    return {
      index: u,
      distance: g
    };
  }
  function f(u, p) {
    const k = s.get() + u, {
      index: g,
      distance: b
    } = h(k), _ = !e && i(k);
    if (!p || _) return {
      index: g,
      distance: u
    };
    const E = t[g] - b, I = u + v(E, 0);
    return {
      index: g,
      distance: I
    };
  }
  return {
    byDistance: f,
    byIndex: c,
    shortcut: v
  };
}
function $d(e, t, n, r, s, i, a) {
  function o(c) {
    const f = c.distance, m = c.index !== t.get();
    i.add(f), f && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), m && (n.set(t.get()), t.set(c.index), a.emit("select"));
  }
  function l(c, f) {
    const m = s.byDistance(c, f);
    o(m);
  }
  function h(c, f) {
    const m = t.clone().set(c), u = s.byIndex(m.get(), f);
    o(u);
  }
  return {
    distance: l,
    index: h
  };
}
function Id(e, t, n, r, s, i, a, o) {
  const l = {
    passive: !0,
    capture: !0
  };
  let h = 0;
  function v(m) {
    if (!o) return;
    function u(p) {
      if ((/* @__PURE__ */ new Date()).getTime() - h > 10) return;
      a.emit("slideFocusStart"), e.scrollLeft = 0;
      const b = n.findIndex((_) => _.includes(p));
      di(b) && (s.useDuration(0), r.index(b, 0), a.emit("slideFocus"));
    }
    i.add(document, "keydown", c, !1), t.forEach((p, k) => {
      i.add(p, "focus", (g) => {
        (Qa(o) || o(m, g)) && u(k);
      }, l);
    });
  }
  function c(m) {
    m.code === "Tab" && (h = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: v
  };
}
function na(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(l) {
    t = a(l);
  }
  function s(l) {
    t += a(l);
  }
  function i(l) {
    t -= a(l);
  }
  function a(l) {
    return di(l) ? l : l.get();
  }
  return {
    get: n,
    set: r,
    add: s,
    subtract: i
  };
}
function Oo(e, t) {
  const n = e.scroll === "x" ? a : o, r = t.style;
  let s = null, i = !1;
  function a(f) {
    return `translate3d(${f}px,0px,0px)`;
  }
  function o(f) {
    return `translate3d(0px,${f}px,0px)`;
  }
  function l(f) {
    if (i) return;
    const m = fd(e.direction(f));
    m !== s && (r.transform = n(m), s = m);
  }
  function h(f) {
    i = !f;
  }
  function v() {
    i || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: v,
    to: l,
    toggleActive: h
  };
}
function Dd(e, t, n, r, s, i, a, o, l) {
  const v = ca(s), c = ca(s).reverse(), f = g().concat(b());
  function m(C, F) {
    return C.reduce((V, J) => V - s[J], F);
  }
  function u(C, F) {
    return C.reduce((V, J) => m(V, F) > 0 ? V.concat([J]) : V, []);
  }
  function p(C) {
    return i.map((F, V) => ({
      start: F - r[V] + 0.5 + C,
      end: F + t - 0.5 + C
    }));
  }
  function k(C, F, V) {
    const J = p(F);
    return C.map((O) => {
      const K = V ? 0 : -n, P = V ? n : 0, T = V ? "end" : "start", A = J[O][T];
      return {
        index: O,
        loopPoint: A,
        slideLocation: na(-1),
        translate: Oo(e, l[O]),
        target: () => o.get() > A ? K : P
      };
    });
  }
  function g() {
    const C = a[0], F = u(c, C);
    return k(F, n, !1);
  }
  function b() {
    const C = t - a[0] - 1, F = u(v, C);
    return k(F, -n, !0);
  }
  function _() {
    return f.every(({
      index: C
    }) => {
      const F = v.filter((V) => V !== C);
      return m(F, t) <= 0.1;
    });
  }
  function E() {
    f.forEach((C) => {
      const {
        target: F,
        translate: V,
        slideLocation: J
      } = C, O = F();
      O !== J.get() && (V.to(O), J.set(O));
    });
  }
  function I() {
    f.forEach((C) => C.translate.clear());
  }
  return {
    canLoop: _,
    clear: I,
    loop: E,
    loopPoints: f
  };
}
function Md(e, t, n) {
  let r, s = !1;
  function i(l) {
    if (!n) return;
    function h(v) {
      for (const c of v)
        if (c.type === "childList") {
          l.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((v) => {
      s || (Qa(n) || n(l, v)) && h(v);
    }), r.observe(e, {
      childList: !0
    });
  }
  function a() {
    r && r.disconnect(), s = !0;
  }
  return {
    init: i,
    destroy: a
  };
}
function Od(e, t, n, r) {
  const s = {};
  let i = null, a = null, o, l = !1;
  function h() {
    o = new IntersectionObserver((u) => {
      l || (u.forEach((p) => {
        const k = t.indexOf(p.target);
        s[k] = p;
      }), i = null, a = null, n.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((u) => o.observe(u));
  }
  function v() {
    o && o.disconnect(), l = !0;
  }
  function c(u) {
    return da(s).reduce((p, k) => {
      const g = parseInt(k), {
        isIntersecting: b
      } = s[g];
      return (u && b || !u && !b) && p.push(g), p;
    }, []);
  }
  function f(u = !0) {
    if (u && i) return i;
    if (!u && a) return a;
    const p = c(u);
    return u && (i = p), u || (a = p), p;
  }
  return {
    init: h,
    destroy: v,
    get: f
  };
}
function Rd(e, t, n, r, s, i) {
  const {
    measureSize: a,
    startEdge: o,
    endEdge: l
  } = e, h = n[0] && s, v = u(), c = p(), f = n.map(a), m = k();
  function u() {
    if (!h) return 0;
    const b = n[0];
    return at(t[o] - b[o]);
  }
  function p() {
    if (!h) return 0;
    const b = i.getComputedStyle(Ut(r));
    return parseFloat(b.getPropertyValue(`margin-${l}`));
  }
  function k() {
    return n.map((b, _, E) => {
      const I = !_, L = hi(E, _);
      return I ? f[_] + v : L ? f[_] + c : E[_ + 1][o] - b[o];
    }).map(at);
  }
  return {
    slideSizes: f,
    slideSizesWithGaps: m,
    startGap: v,
    endGap: c
  };
}
function Fd(e, t, n, r, s, i, a, o, l) {
  const {
    startEdge: h,
    endEdge: v,
    direction: c
  } = e, f = di(n);
  function m(g, b) {
    return ca(g).filter((_) => _ % b === 0).map((_) => g.slice(_, _ + b));
  }
  function u(g) {
    return g.length ? ca(g).reduce((b, _, E) => {
      const I = Ut(b) || 0, L = I === 0, C = _ === wa(g), F = s[h] - i[I][h], V = s[h] - i[_][v], J = !r && L ? c(a) : 0, O = !r && C ? c(o) : 0, K = at(V - O - (F + J));
      return E && K > t + l && b.push(_), C && b.push(g.length), b;
    }, []).map((b, _, E) => {
      const I = Math.max(E[_ - 1] || 0);
      return g.slice(I, b);
    }) : [];
  }
  function p(g) {
    return f ? m(g, n) : u(g);
  }
  return {
    groupSlides: p
  };
}
function Nd(e, t, n, r, s, i, a) {
  const {
    align: o,
    axis: l,
    direction: h,
    startIndex: v,
    loop: c,
    duration: f,
    dragFree: m,
    dragThreshold: u,
    inViewThreshold: p,
    slidesToScroll: k,
    skipSnaps: g,
    containScroll: b,
    watchResize: _,
    watchSlides: E,
    watchDrag: I,
    watchFocus: L
  } = i, C = 2, F = pd(), V = F.measure(t), J = n.map(F.measure), O = md(l, h), K = O.measureSize(V), P = yd(K), T = hd(o, K), A = !c && !!b, z = c || !!b, {
    slideSizes: U,
    slideSizesWithGaps: X,
    startGap: B,
    endGap: ie
  } = Rd(O, V, J, n, z, s), H = Fd(O, K, k, c, V, J, B, ie, C), {
    snaps: ee,
    snapsAligned: ce
  } = Td(O, T, V, J, H), we = -Ut(ee) + Ut(X), {
    snapsContained: ke,
    scrollContainLimit: te
  } = Sd(K, we, ce, b, C), he = A ? ke : ce, {
    limit: ge
  } = _d(we, he, c), be = Mo(wa(he), v, c), Pe = be.clone(), Ne = ca(n), de = ({
    dragHandler: S,
    scrollBody: w,
    scrollBounds: G,
    options: {
      loop: Y
    }
  }) => {
    Y || G.constrain(S.pointerDown()), w.seek();
  }, Re = ({
    scrollBody: S,
    translate: w,
    location: G,
    offsetLocation: Y,
    previousLocation: se,
    scrollLooper: R,
    slideLooper: le,
    dragHandler: y,
    animation: fe,
    eventHandler: $e,
    scrollBounds: d,
    options: {
      loop: re
    }
  }, ne) => {
    const x = S.settled(), N = !d.shouldConstrain(), Q = re ? x : x && N, De = Q && !y.pointerDown();
    De && fe.stop();
    const Se = G.get() * ne + se.get() * (1 - ne);
    Y.set(Se), re && (R.loop(S.direction()), le.loop()), w.to(Y.get()), De && $e.emit("settle"), Q || $e.emit("scroll");
  }, He = vd(r, s, () => de(D), (S) => Re(D, S)), Ze = 0.68, We = he[be.get()], Be = na(We), Fe = na(We), Xe = na(We), ut = na(We), gt = xd(Be, Xe, Fe, ut, f, Ze), bt = Ld(c, he, we, ge, ut), Ft = $d(He, be, Pe, gt, bt, ut, a), Ot = Ed(ge), xt = fa(), qt = Od(t, n, a, p), {
    slideRegistry: $t
  } = Ad(A, b, he, te, H, Ne), ct = Id(e, n, $t, Ft, gt, xt, a, L), D = {
    ownerDocument: r,
    ownerWindow: s,
    eventHandler: a,
    containerRect: V,
    slideRects: J,
    animation: He,
    axis: O,
    dragHandler: gd(O, e, r, s, ut, bd(O, s), Be, He, Ft, gt, bt, be, a, P, m, u, g, Ze, I),
    eventStore: xt,
    percentOfView: P,
    index: be,
    indexPrevious: Pe,
    limit: ge,
    location: Be,
    offsetLocation: Xe,
    previousLocation: Fe,
    options: i,
    resizeHandler: wd(t, a, s, n, O, _, F),
    scrollBody: gt,
    scrollBounds: kd(ge, Xe, ut, gt, P),
    scrollLooper: Cd(we, ge, Xe, [Be, Xe, Fe, ut]),
    scrollProgress: Ot,
    scrollSnapList: he.map(Ot.get),
    scrollSnaps: he,
    scrollTarget: bt,
    scrollTo: Ft,
    slideLooper: Dd(O, K, we, U, X, ee, he, Xe, n),
    slideFocus: ct,
    slidesHandler: Md(t, a, E),
    slidesInView: qt,
    slideIndexes: Ne,
    slideRegistry: $t,
    slidesToScroll: H,
    target: ut,
    translate: Oo(O, t)
  };
  return D;
}
function Bd() {
  let e = {}, t;
  function n(h) {
    t = h;
  }
  function r(h) {
    return e[h] || [];
  }
  function s(h) {
    return r(h).forEach((v) => v(t, h)), l;
  }
  function i(h, v) {
    return e[h] = r(h).concat([v]), l;
  }
  function a(h, v) {
    return e[h] = r(h).filter((c) => c !== v), l;
  }
  function o() {
    e = {};
  }
  const l = {
    init: n,
    emit: s,
    off: a,
    on: i,
    clear: o
  };
  return l;
}
const Pd = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function zd(e) {
  function t(i, a) {
    return Do(i, a || {});
  }
  function n(i) {
    const a = i.breakpoints || {}, o = da(a).filter((l) => e.matchMedia(l).matches).map((l) => a[l]).reduce((l, h) => t(l, h), {});
    return t(i, o);
  }
  function r(i) {
    return i.map((a) => da(a.breakpoints || {})).reduce((a, o) => a.concat(o), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function Vd(e) {
  let t = [];
  function n(i, a) {
    return t = a.filter(({
      options: o
    }) => e.optionsAtMedia(o).active !== !1), t.forEach((o) => o.init(i, e)), a.reduce((o, l) => Object.assign(o, {
      [l.name]: l
    }), {});
  }
  function r() {
    t = t.filter((i) => i.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function Ua(e, t, n) {
  const r = e.ownerDocument, s = r.defaultView, i = zd(s), a = Vd(i), o = fa(), l = Bd(), {
    mergeOptions: h,
    optionsAtMedia: v,
    optionsMediaQueries: c
  } = i, {
    on: f,
    off: m,
    emit: u
  } = l, p = O;
  let k = !1, g, b = h(Pd, Ua.globalOptions), _ = h(b), E = [], I, L, C;
  function F() {
    const {
      container: Ne,
      slides: de
    } = _;
    L = (Zr(Ne) ? e.querySelector(Ne) : Ne) || e.children[0];
    const He = Zr(de) ? L.querySelectorAll(de) : de;
    C = [].slice.call(He || L.children);
  }
  function V(Ne) {
    const de = Nd(e, L, C, r, s, Ne, l);
    if (Ne.loop && !de.slideLooper.canLoop()) {
      const Re = Object.assign({}, Ne, {
        loop: !1
      });
      return V(Re);
    }
    return de;
  }
  function J(Ne, de) {
    k || (b = h(b, Ne), _ = v(b), E = de || E, F(), g = V(_), c([b, ...E.map(({
      options: Re
    }) => Re)]).forEach((Re) => o.add(Re, "change", O)), _.active && (g.translate.to(g.location.get()), g.animation.init(), g.slidesInView.init(), g.slideFocus.init(Pe), g.eventHandler.init(Pe), g.resizeHandler.init(Pe), g.slidesHandler.init(Pe), g.options.loop && g.slideLooper.loop(), L.offsetParent && C.length && g.dragHandler.init(Pe), I = a.init(Pe, E)));
  }
  function O(Ne, de) {
    const Re = H();
    K(), J(h({
      startIndex: Re
    }, Ne), de), l.emit("reInit");
  }
  function K() {
    g.dragHandler.destroy(), g.eventStore.clear(), g.translate.clear(), g.slideLooper.clear(), g.resizeHandler.destroy(), g.slidesHandler.destroy(), g.slidesInView.destroy(), g.animation.destroy(), a.destroy(), o.clear();
  }
  function P() {
    k || (k = !0, o.clear(), K(), l.emit("destroy"), l.clear());
  }
  function T(Ne, de, Re) {
    !_.active || k || (g.scrollBody.useBaseFriction().useDuration(de === !0 ? 0 : _.duration), g.scrollTo.index(Ne, Re || 0));
  }
  function A(Ne) {
    const de = g.index.add(1).get();
    T(de, Ne, -1);
  }
  function z(Ne) {
    const de = g.index.add(-1).get();
    T(de, Ne, 1);
  }
  function U() {
    return g.index.add(1).get() !== H();
  }
  function X() {
    return g.index.add(-1).get() !== H();
  }
  function B() {
    return g.scrollSnapList;
  }
  function ie() {
    return g.scrollProgress.get(g.offsetLocation.get());
  }
  function H() {
    return g.index.get();
  }
  function ee() {
    return g.indexPrevious.get();
  }
  function ce() {
    return g.slidesInView.get();
  }
  function we() {
    return g.slidesInView.get(!1);
  }
  function ke() {
    return I;
  }
  function te() {
    return g;
  }
  function he() {
    return e;
  }
  function ge() {
    return L;
  }
  function be() {
    return C;
  }
  const Pe = {
    canScrollNext: U,
    canScrollPrev: X,
    containerNode: ge,
    internalEngine: te,
    destroy: P,
    off: m,
    on: f,
    emit: u,
    plugins: ke,
    previousScrollSnap: ee,
    reInit: p,
    rootNode: he,
    scrollNext: A,
    scrollPrev: z,
    scrollProgress: ie,
    scrollSnapList: B,
    scrollTo: T,
    selectedScrollSnap: H,
    slideNodes: be,
    slidesInView: ce,
    slidesNotInView: we
  };
  return J(t, n), setTimeout(() => l.emit("init"), 0), Pe;
}
Ua.globalOptions = void 0;
function er(e = {}, t = []) {
  const n = Bi(e), r = Bi(t);
  let s = n ? e.value : e, i = r ? t.value : t;
  const a = kn(), o = kn();
  function l() {
    o.value && o.value.reInit(s, i);
  }
  return mt(() => {
    !ud() || !a.value || (Ua.globalOptions = er.globalOptions, o.value = Ua(a.value, s, i));
  }), io(() => {
    o.value && o.value.destroy();
  }), n && ze(e, (h) => {
    ci(s, h) || (s = h, l());
  }), r && ze(t, (h) => {
    cd(i, h) || (i = h, l());
  }), [a, o];
}
er.globalOptions = void 0;
const K1 = ["default", "highlight"], J1 = ["click", "keyboard"], Yr = /* @__PURE__ */ Symbol();
var Oa = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e))(Oa || {});
const Hd = ["tabindex"], sl = 1.08, Ud = /* @__PURE__ */ _e({
  __name: "LcCarousel",
  props: {
    duration: { default: 25 },
    loop: { type: Boolean },
    skipSnaps: { type: Boolean },
    adaptiveHeight: { type: Boolean },
    defaultIndex: { default: 0 },
    disableSwipe: { type: Boolean },
    id: {},
    keyExtractor: { type: Function },
    keyProp: {},
    moveTriggers: { default: () => [] },
    renderOnlyVisible: { type: Boolean },
    slides: {},
    variant: { default: "default" },
    visibleSlideBuffer: { default: 0 }
  },
  emits: ["ready", "changed"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = {
      align: "start",
      containScroll: "trimSnaps"
    }, i = {
      align: "center",
      containScroll: !1,
      loop: !1,
      skipSnaps: !0
    }, a = {
      duration: e.duration,
      inViewThreshold: 2 / 100,
      loop: e.loop,
      skipSnaps: e.skipSnaps,
      watchDrag: !e.disableSwipe,
      watchResize: ({ containerNode: te, emit: he, reInit: ge }, be) => {
        if (!e.adaptiveHeight) return !0;
        for (const Pe of be) {
          if (te() === Pe.target) return !0;
          requestAnimationFrame(() => {
            ge(), he("resize");
          });
          break;
        }
        return !1;
      },
      ...e.variant === "highlight" ? i : s
    }, o = [
      ...e.adaptiveHeight ? [Io()] : [],
      Ja({
        draggable: "",
        dragging: "lc-carousel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-carousel__slide--snapped"
      })
    ], [l, h] = er(
      {
        ...a,
        startIndex: e.defaultIndex
      },
      o
    ), v = Wn(Yr, () => null, !0), c = fo(), f = pe(0), m = pe(e.disableSwipe), u = pe(!1), p = pe(!1), k = pe(
      new Set(
        e.slides.slice(e.defaultIndex - e.visibleSlideBuffer, e.defaultIndex + e.visibleSlideBuffer).map((te, he) => he)
      )
    );
    let g, b, _;
    const E = W(() => [
      "lc-carousel",
      `lc-carousel--variant-${e.variant}`,
      {
        "lc-carousel--adaptive-height": e.adaptiveHeight,
        "lc-carousel--draggable": !m.value,
        "lc-carousel--keyboard-enabled": U("keyboard"),
        "lc-carousel--swipe-hint": p.value
      }
    ]), I = () => {
      e.disableSwipe || (h.value?.reInit({
        ...a,
        watchDrag: !1
      }), m.value = !0);
    }, L = () => {
      e.disableSwipe || (h.value?.reInit({
        ...a,
        watchDrag: !0
      }), m.value = !1);
    }, C = (te, he) => e.keyExtractor ? e.keyExtractor(te, he) : e.keyProp && Ec(e.keyProp, te) ? String(te[e.keyProp]) : String(he), F = (te) => {
      const he = {
        "aria-roledescription": "slide",
        role: "group"
      };
      return X(te) ? he : {
        ...he,
        "aria-hidden": "true",
        inert: "true"
      };
    }, V = ({ clientX: te }) => {
      if (!h.value || !U("click") || m.value) return;
      const ge = h.value.slideNodes().map((be) => be.getBoundingClientRect());
      for (const [be, { left: Pe, right: Ne }] of ge.entries())
        if (!(te < Pe || te > Ne)) {
          ie(be);
          break;
        }
    }, J = () => {
      u.value = !0, we(), ke(), r("ready");
    }, O = (te) => {
      if (!(!en(te.key, Oa) || !U("keyboard") || m.value))
        switch (te.preventDefault(), te.stopPropagation(), te.key) {
          case Oa.ArrowLeft:
            ee();
            break;
          case Oa.ArrowRight:
            H();
            break;
        }
    }, K = () => {
      v?.disable();
    }, P = () => {
      v?.enable();
    }, T = () => {
      we(), ke();
    }, A = () => {
      const te = h.value?.selectedScrollSnap() ?? 0;
      r("changed", te);
    }, z = () => {
      clearTimeout(b), b = setTimeout(() => h.value?.reInit(), 50);
    }, U = (te) => e.moveTriggers.includes(te), X = (te) => k.value.has(te), B = (te) => !te || c.value === "reduce", ie = (te, he = !0) => {
      h.value?.scrollTo(te, B(he));
    }, H = (te = !0) => {
      h.value?.scrollNext(B(te));
    }, ee = (te = !0) => {
      h.value?.scrollPrev(B(te));
    }, ce = async () => {
      p.value || (p.value = !0, await new Promise((te) => {
        _ = setTimeout(() => {
          p.value = !1, te();
        }, 1800);
      }));
    }, we = () => {
      if (!h.value || e.variant !== "highlight") return;
      const { rootNode: te, slideNodes: he } = h.value, ge = he(), Pe = te().getBoundingClientRect(), Ne = Pe.left + Pe.width / 2;
      let de = ge[0], Re = 1 / 0;
      ge.forEach((Be) => {
        const Fe = Be.getBoundingClientRect(), Xe = Fe.left + Fe.width / 2, ut = Math.abs(Xe - Ne);
        ut < Re && (de = Be, Re = ut);
      });
      const We = de.offsetWidth * (sl - 1) / 2;
      ge.forEach((Be, Fe) => {
        if (Be === de) {
          f.value = Fe, Be.style.transform = `scale(${sl.toString()}) translateX(0px)`, Be.style.zIndex = "1";
          return;
        }
        const Xe = Be.getBoundingClientRect(), gt = Xe.left + Xe.width / 2 < Ne ? -1 : 1;
        Be.style.transform = `scale(1) translateX(${(gt * We).toString()}px)`, Be.style.zIndex = "0";
      });
    }, ke = () => {
      if (!h.value) return;
      const te = h.value.slidesInView();
      if (!te.length) return;
      const he = e.slides.length, ge = /* @__PURE__ */ new Set();
      te.forEach((be) => {
        for (let Pe = -e.visibleSlideBuffer; Pe <= e.visibleSlideBuffer; Pe++) {
          const Ne = (be + Pe + he) % he;
          ge.add(Ne);
        }
      }), k.value = ge;
    };
    return mt(() => {
      h.value && (h.value.on("init", J).on("pointerDown", K).on("pointerUp", P).on("reInit", T).on("resize", ke).on("scroll", we).on("select", A).on("slidesChanged", we).on("slidesInView", ke), e.adaptiveHeight && (g = new ResizeObserver(z), h.value.slideNodes().forEach((te) => g?.observe(te))));
    }), Ln(() => {
      clearTimeout(_), clearTimeout(b), g?.disconnect();
    }), ze(
      [() => e.disableSwipe, () => e.loop, () => e.skipSnaps, () => e.variant],
      ([te, he, ge, be]) => {
        m.value = te, h.value?.reInit({
          ...a,
          loop: he,
          skipSnaps: ge,
          watchDrag: !te,
          ...be === "highlight" ? i : s
        });
      }
    ), t({
      disable: I,
      enable: L,
      moveToIndex: ie,
      next: H,
      prev: ee,
      showSwipeHint: ce
    }), ni(Yr, {
      disable: I,
      enable: L
    }), (te, he) => ($(), j("div", {
      class: ye(E.value),
      tabindex: U("keyboard") ? 0 : void 0,
      onClickPassive: V,
      onKeydown: O
    }, [
      ae("div", {
        ref_key: "emblaRef",
        ref: l,
        class: "lc-carousel__container"
      }, [
        ae("div", Te({ id: e.id }, { class: "lc-carousel__wrap" }), [
          ($(!0), j(Ge, null, vt(e.slides, (ge, be) => me(te.$slots, "slide", Te({ ref_for: !0 }, { slide: ge, index: be }, {
            key: C(ge, be),
            attributes: F(be),
            isHighlighted: f.value === be,
            isVisible: X(be)
          }))), 128))
        ], 16)
      ], 512)
    ], 42, Hd));
  }
}), qd = ["for"], jd = { class: "lc-checkbox__control" }, Zd = ["id", "data-click-name"], Wd = ["id"], Q1 = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcCheckbox",
  props: {
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "checkbox" },
    noFeedback: { type: Boolean },
    value: { type: Boolean }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = Tt(e.id), { vibrate: s } = ho(), i = W(() => [
      "lc-checkbox",
      {
        "lc-checkbox--checked": e.value,
        "lc-checkbox--disabled": e.disabled,
        "lc-checkbox--error": !!e.errorMessage
      }
    ]), a = W({
      get: () => e.value,
      set: (o) => {
        n("update:value", o), s();
      }
    });
    return (o, l) => ($(), j("div", {
      class: ye([i.value, o.$attrs.class])
    }, [
      ae("label", {
        class: "lc-checkbox__wrap",
        for: q(r)
      }, [
        ae("div", jd, [
          Jt(ae("input", Te({ id: q(r) }, {
            ...Qt(o.$attrs, ["class"]),
            disabled: e.disabled,
            name: e.name
          }, {
            "onUpdate:modelValue": l[0] || (l[0] = (h) => a.value = h),
            class: "lc-checkbox__input",
            "data-click-listener": "blur,focus",
            "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_checkbox`,
            type: "checkbox",
            onKeydown: l[1] || (l[1] = ai((h) => a.value = !a.value, ["enter"]))
          }), null, 16, Zd), [
            [lo, a.value]
          ]),
          Oe(q(Qe), {
            class: "lc-checkbox__icon",
            name: "checkmark"
          })
        ]),
        e.label ? ($(), j("span", {
          key: 0,
          id: `${q(r)}-label`,
          class: "lc-checkbox__label"
        }, Ie(e.label), 9, Wd)) : ue("", !0)
      ], 8, qd),
      e.noFeedback ? ue("", !0) : ($(), xe(q($n), Te({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), Yd = () => typeof window > "u";
function Ro(e, t) {
  const n = pa(), r = typeof e == "string" ? e : void 0, s = typeof e == "function" ? e : t;
  if (n)
    return r ? n.useState(r, s) : n.useState(s);
  const i = s ? Ke(s()) : void 0;
  return pe(i);
}
const vi = {
  drawingShort: {
    hour: "numeric",
    minute: "numeric",
    weekday: "short"
  }
}, Fo = (e, t) => ac({
  end: new Date(t),
  start: new Date(e)
}), No = ({ date: e, format: t, locale: n, timeZone: r }) => new Intl.DateTimeFormat(n ?? "en-US", {
  ...vi[t],
  timeZone: r
}).format(new Date(e)), yr = (e) => typeof e != "number" ? "" : e <= 0 ? "00" : e < 10 ? `0${e}` : String(e), Xd = /* @__PURE__ */ _e({
  __name: "LcCountdown",
  props: {
    expiresAt: {},
    variant: { default: "default" }
  },
  emits: ["expired", "update"],
  setup(e, { emit: t }) {
    const n = {
      hours: 0,
      minutes: 0,
      seconds: 0
    }, r = t, s = Yd(), i = Ro(() => /* @__PURE__ */ new Date()), a = pe(!1);
    let o;
    const l = W(() => {
      if (a.value) return n;
      const { hours: g, minutes: b, seconds: _ } = Fo(i.value, f.value);
      return {
        ...n,
        hours: g || 0,
        minutes: b || 0,
        seconds: _ || 0
      };
    }), h = W(() => v.value ? f.value.toISOString() : void 0), v = W(() => ii(f.value)), c = W(() => {
      const { hours: g, minutes: b, seconds: _ } = l.value, E = `${yr(b)}:${yr(_)}`;
      return e.variant === "without-hours" ? E : `${yr(g)}:${E}`;
    }), f = W(() => new Date(e.expiresAt)), m = () => {
      a.value = !0, r("expired"), clearInterval(o);
    }, u = () => {
      i.value = /* @__PURE__ */ new Date(), r("update");
    }, p = () => So(f.value), k = () => {
      o && clearInterval(o), o = setInterval(() => {
        p() ? m() : u();
      }, 1e3);
    };
    return io(() => {
      clearInterval(o);
    }), ze(
      h,
      () => {
        s || (a.value = !1, k());
      },
      {
        immediate: !0
      }
    ), (g, b) => v.value ? ($(), j("time", Te({ key: 0 }, { datetime: h.value }, { class: "lc-countdown" }), Ie(c.value), 17)) : ue("", !0);
  }
}), eg = ["default", "without-hours"], Gd = { class: "lc-data-list" }, tg = /* @__PURE__ */ _e({
  __name: "LcDataList",
  setup(e) {
    return (t, n) => ($(), j("ul", Gd, [
      me(t.$slots, "default")
    ]));
  }
}), Kd = { class: "lc-data-list-item" }, Jd = { class: "lc-data-list-item__content" }, Qd = {
  key: 0,
  class: "lc-data-list-item__headline"
}, ef = {
  key: 0,
  class: "lc-data-list-item__text"
}, tf = { key: 0 }, nf = {
  key: 0,
  class: "lc-data-list-item__underneath"
}, ng = /* @__PURE__ */ _e({
  __name: "LcDataListItem",
  props: {
    headline: {},
    text: {}
  },
  setup(e) {
    return (t, n) => ($(), j("li", Kd, [
      ae("div", Jd, [
        ae("section", null, [
          e.headline ? ($(), j("span", Qd, Ie(e.headline), 1)) : ue("", !0),
          me(t.$slots, "default", {}, () => [
            e.text ? ($(), j("p", ef, Ie(e.text), 1)) : ue("", !0)
          ])
        ]),
        t.$slots.suffix ? ($(), j("aside", tf, [
          me(t.$slots, "suffix")
        ])) : ue("", !0)
      ]),
      t.$slots.underneath ? ($(), j("div", nf, [
        me(t.$slots, "underneath")
      ])) : ue("", !0)
    ]));
  }
});
var af = Object.defineProperty, rf = (e, t, n) => t in e ? af(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, oa = (e, t, n) => rf(e, typeof t != "symbol" ? t + "" : t, n);
const ul = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, cl = (e, t, n) => e.replaceAll(t, "").replace(n, ".").replace("..", ".").replace(/[^.\d]/g, ""), dl = (e, t, n) => {
  var r;
  return new Intl.NumberFormat(((r = n.number) == null ? void 0 : r.locale) ?? "en", {
    minimumFractionDigits: e,
    maximumFractionDigits: t,
    roundingMode: "trunc"
  });
}, lf = (e, t = !0, n) => {
  var r, s, i, a;
  const o = ((r = n.number) == null ? void 0 : r.unsigned) !== !0 && e.startsWith("-") ? "-" : "", l = ((s = n.number) == null ? void 0 : s.fraction) ?? 0;
  let h = dl(0, l, n);
  const v = h.formatToParts(1000.12), c = ((i = v.find((k) => k.type === "group")) == null ? void 0 : i.value) ?? " ", f = ((a = v.find((k) => k.type === "decimal")) == null ? void 0 : a.value) ?? ".", m = cl(e, c, f);
  if (Number.isNaN(parseFloat(m))) return o;
  const u = m.split(".");
  if (u[1] != null && u[1].length >= 1) {
    const k = u[1].length <= l ? u[1].length : l;
    h = dl(k, l, n);
  }
  let p = h.format(parseFloat(m));
  return t ? l > 0 && m.endsWith(".") && !m.slice(0, -1).includes(".") && (p += f) : p = cl(p, c, f), o + p;
}, Bo = (e) => JSON.parse(e.replaceAll("'", '"')), of = (e, t = {}) => {
  const n = { ...t };
  e.dataset.maska != null && e.dataset.maska !== "" && (n.mask = sf(e.dataset.maska)), e.dataset.maskaEager != null && (n.eager = $a(e.dataset.maskaEager)), e.dataset.maskaReversed != null && (n.reversed = $a(e.dataset.maskaReversed)), e.dataset.maskaTokensReplace != null && (n.tokensReplace = $a(e.dataset.maskaTokensReplace)), e.dataset.maskaTokens != null && (n.tokens = uf(e.dataset.maskaTokens));
  const r = {};
  return e.dataset.maskaNumberLocale != null && (r.locale = e.dataset.maskaNumberLocale), e.dataset.maskaNumberFraction != null && (r.fraction = parseInt(e.dataset.maskaNumberFraction)), e.dataset.maskaNumberUnsigned != null && (r.unsigned = $a(e.dataset.maskaNumberUnsigned)), (e.dataset.maskaNumber != null || Object.values(r).length > 0) && (n.number = r), n;
}, $a = (e) => e !== "" ? !!JSON.parse(e) : !0, sf = (e) => e.startsWith("[") && e.endsWith("]") ? Bo(e) : e, uf = (e) => {
  if (e.startsWith("{") && e.endsWith("}"))
    return Bo(e);
  const t = {};
  return e.split("|").forEach((n) => {
    const r = n.split(":");
    t[r[0]] = {
      pattern: Po() ? new RegExp(r[1], "u") : new RegExp(r[1]),
      optional: r[2] === "optional",
      multiple: r[2] === "multiple",
      repeated: r[2] === "repeated"
    };
  }), t;
}, Po = () => {
  try {
    return new RegExp("\\p{L}", "u"), !0;
  } catch {
    return !1;
  }
};
class cf {
  constructor(t = {}) {
    oa(this, "opts", {}), oa(this, "memo", /* @__PURE__ */ new Map());
    const n = { ...t };
    if (n.tokens != null) {
      n.tokens = n.tokensReplace ? { ...n.tokens } : { ...ul, ...n.tokens };
      for (const r of Object.values(n.tokens))
        typeof r.pattern == "string" && (r.pattern = Po() ? new RegExp(r.pattern, "u") : new RegExp(r.pattern));
    } else
      n.tokens = ul;
    Array.isArray(n.mask) && (n.mask.length > 1 ? n.mask = [...n.mask].sort((r, s) => r.length - s.length) : n.mask = n.mask[0] ?? ""), n.mask === "" && (n.mask = null), this.opts = n;
  }
  masked(t) {
    return this.process(String(t), this.findMask(String(t)));
  }
  unmasked(t) {
    return this.process(String(t), this.findMask(String(t)), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(t) {
    const n = this.findMask(String(t));
    if (this.opts.mask == null || n == null) return !1;
    const r = this.process(String(t), n).length;
    return typeof this.opts.mask == "string" ? r >= this.opts.mask.length : r >= n.length;
  }
  findMask(t) {
    const n = this.opts.mask;
    if (n == null)
      return null;
    if (typeof n == "string")
      return n;
    if (typeof n == "function")
      return n(t);
    const r = this.process(t, n.slice(-1).pop() ?? "", !1);
    return n.find((s) => this.process(t, s, !1).length >= r.length) ?? "";
  }
  escapeMask(t) {
    const n = [], r = [];
    return t.split("").forEach((s, i) => {
      s === "!" && t[i - 1] !== "!" ? r.push(i - r.length) : n.push(s);
    }), { mask: n.join(""), escaped: r };
  }
  process(t, n, r = !0) {
    if (this.opts.number != null) return lf(t, r, this.opts);
    if (n == null) return t;
    const s = `v=${t},mr=${n},m=${r ? 1 : 0}`;
    if (this.memo.has(s)) return this.memo.get(s);
    const { mask: i, escaped: a } = this.escapeMask(n), o = [], l = this.opts.tokens != null ? this.opts.tokens : {}, h = this.isReversed() ? -1 : 1, v = this.isReversed() ? "unshift" : "push", c = this.isReversed() ? 0 : i.length - 1, f = this.isReversed() ? () => k > -1 && g > -1 : () => k < i.length && g < t.length, m = (_) => !this.isReversed() && _ <= c || this.isReversed() && _ >= c;
    let u, p = -1, k = this.isReversed() ? i.length - 1 : 0, g = this.isReversed() ? t.length - 1 : 0, b = !1;
    for (; f(); ) {
      const _ = i.charAt(k), E = l[_], I = E?.transform != null ? E.transform(t.charAt(g)) : t.charAt(g);
      if (!a.includes(k) && E != null ? (I.match(E.pattern) != null ? (o[v](I), E.repeated ? (p === -1 ? p = k : k === c && k !== p && (k = p - h), c === p && (k -= h)) : E.multiple && (b = !0, k -= h), k += h) : E.multiple ? b && (k += h, g -= h, b = !1) : I === u ? u = void 0 : E.optional && (k += h, g -= h), g += h) : (r && !this.isEager() && o[v](_), I === _ && !this.isEager() ? g += h : u = _, this.isEager() || (k += h)), this.isEager())
        for (; m(k) && (l[i.charAt(k)] == null || a.includes(k)); ) {
          if (r) {
            if (o[v](i.charAt(k)), t.charAt(g) === i.charAt(k)) {
              k += h, g += h;
              continue;
            }
          } else i.charAt(k) === t.charAt(g) && (g += h);
          k += h;
        }
    }
    return this.memo.set(s, o.join("")), this.memo.get(s);
  }
}
class df {
  constructor(t, n = {}) {
    oa(this, "items", /* @__PURE__ */ new Map()), oa(this, "eventAbortController"), oa(this, "onInput", (r) => {
      if (r instanceof CustomEvent && r.type === "input" && !r.isTrusted && !r.bubbles)
        return;
      const s = r.target, i = this.items.get(s);
      if (i === void 0) return;
      const a = "inputType" in r && r.inputType.startsWith("delete"), o = i.isEager(), l = a && o && i.unmasked(s.value) === "" ? "" : s.value;
      this.fixCursor(s, a, () => this.setValue(s, l));
    }), this.options = n, this.eventAbortController = new AbortController(), this.init(this.getInputs(t));
  }
  update(t = {}) {
    this.options = { ...t }, this.init(Array.from(this.items.keys()));
  }
  updateValue(t) {
    var n;
    t.value !== "" && t.value !== ((n = this.processInput(t)) == null ? void 0 : n.masked) && this.setValue(t, t.value);
  }
  destroy() {
    this.eventAbortController.abort(), this.items.clear();
  }
  init(t) {
    const n = this.getOptions(this.options);
    for (const r of t) {
      if (!this.items.has(r)) {
        const { signal: i } = this.eventAbortController;
        r.addEventListener("input", this.onInput, { capture: !0, signal: i });
      }
      const s = new cf(of(r, n));
      this.items.set(r, s), queueMicrotask(() => this.updateValue(r)), r.selectionStart === null && s.isEager() && console.warn("Maska: input of `%s` type is not supported", r.type);
    }
  }
  getInputs(t) {
    return typeof t == "string" ? Array.from(document.querySelectorAll(t)) : "length" in t ? Array.from(t) : [t];
  }
  getOptions(t) {
    const { onMaska: n, preProcess: r, postProcess: s, ...i } = t;
    return i;
  }
  fixCursor(t, n, r) {
    var s, i;
    const a = t.selectionStart, o = t.value;
    if (r(), a === null || a === o.length && !n) return;
    const l = t.value, h = o.slice(0, a), v = l.slice(0, a), c = (s = this.processInput(t, h)) == null ? void 0 : s.unmasked, f = (i = this.processInput(t, v)) == null ? void 0 : i.unmasked;
    if (c === void 0 || f === void 0) return;
    let m = a;
    h !== v && (m += n ? l.length - o.length : c.length - f.length), t.setSelectionRange(m, m);
  }
  setValue(t, n) {
    const r = this.processInput(t, n);
    r !== void 0 && (t.value = r.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((s) => s(r)) : this.options.onMaska(r)), t.dispatchEvent(new CustomEvent("maska", { detail: r })), t.dispatchEvent(new CustomEvent("input", { detail: r.masked })));
  }
  processInput(t, n) {
    const r = this.items.get(t);
    if (r === void 0) return;
    let s = n ?? t.value;
    this.options.preProcess != null && (s = this.options.preProcess(s));
    let i = r.masked(s);
    return this.options.postProcess != null && (i = this.options.postProcess(i)), {
      masked: i,
      unmasked: r.unmasked(s),
      completed: r.completed(s)
    };
  }
}
const wr = /* @__PURE__ */ new WeakMap(), ff = (e, t) => {
  if (e.arg == null || e.instance == null) return;
  const n = "setup" in e.instance.$.type;
  e.arg in e.instance ? e.instance[e.arg] = t : n && console.warn("Maska: please expose `%s` using defineExpose", e.arg);
}, hf = (e, t) => {
  var n;
  const r = e instanceof HTMLInputElement ? e : e.querySelector("input");
  if (r == null || r?.type === "file") return;
  let s = {};
  if (t.value != null && (s = typeof t.value == "string" ? { mask: t.value } : { ...t.value }), t.arg != null) {
    const i = (a) => {
      const o = t.modifiers.unmasked ? a.unmasked : t.modifiers.completed ? a.completed : a.masked;
      ff(t, o);
    };
    s.onMaska = s.onMaska == null ? i : Array.isArray(s.onMaska) ? [...s.onMaska, i] : [s.onMaska, i];
  }
  wr.has(r) ? (n = wr.get(r)) == null || n.update(s) : wr.set(r, new df(r, s));
}, vf = ["for"], mf = ["id"], gf = { class: "lc-input__input-wrap" }, bf = ["data-testid"], pf = ["data-testid"], tr = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: { default: "input" },
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean, default: !0 },
    suffixClass: {},
    type: { default: "text" },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = { Z: { pattern: "[1-9]" } }, s = n, i = it("input"), a = Tt(e.id), o = pe(!1), l = W(() => [
      "lc-input",
      {
        "lc-input--disabled": e.disabled,
        "lc-input--error": !!e.errorMessage,
        "lc-input--has-label": !!e.label
      }
    ]), h = W(() => ({
      "aria-labelledby": e.label ? `${a}-label` : void 0,
      autocomplete: e.autocomplete,
      class: "lc-input__input",
      "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_input`,
      disabled: e.disabled,
      id: a,
      inputmode: e.inputmode,
      name: e.name,
      onFocusin: () => o.value = !0,
      onFocusout: () => o.value = !1,
      pattern: e.pattern,
      placeholder: e.placeholder,
      spellcheck: e.spellcheck,
      type: e.type
    })), v = W(() => [
      "lc-input__label",
      {
        "lc-input__label--floating": o.value || !!e.value || typeof e.value == "number"
      }
    ]), c = W(() => e.mask ? m(e.mask) ? { ...e.mask, tokens: { ...r, ...e.mask.tokens } } : { mask: e.mask, tokens: r } : {}), f = W({
      get: () => e.value,
      set: (u) => {
        s("update:value", u);
      }
    }), m = (u) => u.mask !== void 0;
    return mt(() => {
      e.autofocus && i.value?.focus(), e.value && s("update:value", e.value);
    }), t({ ref: i }), (u, p) => ($(), j("div", {
      class: ye([l.value, u.$attrs.class])
    }, [
      ae("label", {
        class: "lc-input__wrap",
        for: q(a)
      }, [
        e.label ? ($(), j("span", {
          key: 0,
          id: `${q(a)}-label`,
          class: ye(v.value)
        }, Ie(e.label), 11, mf)) : ue("", !0),
        ae("div", gf, [
          u.$slots.prefix ? ($(), j("div", {
            key: 0,
            class: ye(["lc-input__prefix", e.prefixClass])
          }, [
            me(u.$slots, "prefix")
          ], 2)) : ue("", !0),
          e.mask ? Jt(($(), j("input", Te({
            key: 1,
            ref: "input"
          }, {
            ...Qt(u.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": p[0] || (p[0] = (k) => f.value = k),
            "data-testid": u.$attrs["data-testid"] ?? "lc-input-with-mask"
          }), null, 16, bf)), [
            [Pi, f.value],
            [q(hf), c.value]
          ]) : Jt(($(), j("input", Te({
            key: 2,
            ref: "input"
          }, {
            ...Qt(u.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": p[1] || (p[1] = (k) => f.value = k),
            "data-testid": u.$attrs["data-testid"] ?? "lc-input-without-mask"
          }), null, 16, pf)), [
            [Pi, f.value]
          ]),
          u.$slots.suffix ? ($(), j("div", {
            key: 3,
            class: ye(["lc-input__suffix", e.suffixClass])
          }, [
            me(u.$slots, "suffix")
          ], 2)) : ue("", !0)
        ])
      ], 8, vf),
      e.noFeedback ? ue("", !0) : ($(), xe(q($n), Te({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), ag = [
  "decimal",
  "email",
  "none",
  "numeric",
  "search",
  "tel",
  "text",
  "url"
], rg = [
  "email",
  "number",
  "password",
  "search",
  "tel",
  "text",
  "url"
], ig = /* @__PURE__ */ _e({
  __name: "LcDateInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null], default: "##/##/####" },
    name: {},
    noFeedback: { type: Boolean },
    placeholder: { default: "MM/DD/YYYY" },
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {}
  },
  setup(e) {
    const t = ga(e, ["mask", "placeholder"]);
    return (n, r) => ($(), xe(q(tr), Te({ ...n.$attrs, ...t, mask: e.mask, placeholder: e.placeholder }, {
      class: "lc-date-input",
      inputmode: "numeric",
      pattern: "[0-9]*"
    }), null, 16));
  }
}), yf = { class: "lc-description-list" }, lg = /* @__PURE__ */ _e({
  __name: "LcDescriptionList",
  setup(e) {
    return (t, n) => ($(), j("dl", yf, [
      me(t.$slots, "default")
    ]));
  }
}), zo = /* @__PURE__ */ Symbol();
var rn = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.Backspace = "Backspace", e.Dead = "Dead", e.Delete = "Delete", e.Eight = "8", e.Five = "5", e.Four = "4", e.Nine = "9", e.One = "1", e.Seven = "7", e.Six = "6", e.Three = "3", e.Two = "2", e.Zero = "0", e))(rn || {});
const og = /* @__PURE__ */ _e({
  __name: "LcDigitInput",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    type: {},
    index: { default: 0 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = ga(e, ["index"]), i = it("input"), a = Wn(zo, () => null, !0), o = W(() => Ke(a?.config)), l = W(() => s.disabled || !!Ke(a?.disabled)), h = W(() => l.value ? "*" : "#"), v = W({
      get: () => l.value ? "X" : f.value,
      set: (u) => {
        if (l.value || u === "X") return;
        const p = typeof u == "number" ? u : null;
        r("update:value", p), a?.updateValue(e.index, p);
      }
    }), c = W(() => a ? `${Ke(a.name)}_input_${e.index}` : s.name), f = W(() => a ? Ke(a.value)?.[e.index] : s.value), m = (u) => {
      if (en(u.key, rn))
        switch (u.key !== rn.Dead && u.preventDefault(), u.key) {
          case rn.ArrowLeft:
            a?.focusPrevious(e.index);
            break;
          case rn.ArrowRight:
            a?.focusNext(e.index);
            break;
          case rn.Backspace:
          case rn.Delete:
            v.value = null;
            break;
          case rn.Dead: {
            const p = u.target;
            p?.blur(), setTimeout(() => p?.focus(), 1);
            break;
          }
          default: {
            const p = parseInt(u.key);
            v.value = p, a?.focusNext(e.index);
          }
        }
    };
    return t({
      disabled: l,
      index: e.index,
      inputRef: i
    }), (u, p) => ($(), xe(q(tr), Te({ ref: "input" }, { ...u.$attrs, ...s, ...o.value, disabled: l.value, mask: h.value, name: c.value }, {
      autocomplete: "off",
      class: "lc-digit-input",
      inputmode: "numeric",
      pattern: "[0-9]*",
      tabindex: l.value ? -1 : 0,
      value: v.value,
      onKeydown: m
    }), null, 16, ["tabindex", "value"]));
  }
}), wf = ["id"], xf = ["id"], kf = ["aria-labelledby"], sg = /* @__PURE__ */ _e({
  __name: "LcDigitInputGroup",
  props: {
    disabled: { type: Boolean },
    errorMessage: {},
    feedbackMessageClass: {},
    helpMessage: {},
    id: {},
    legendClass: {},
    name: { default: "digit-input-group" },
    noFeedback: { type: Boolean },
    value: {},
    wrapperClass: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = pe([]), i = Tt(e.id), a = (f, m) => {
      const u = [...e.value ?? []];
      u[f] = m, r("update:value", u);
    }, o = () => {
      const f = s.value.findIndex((m) => !m.disabled);
      s.value[f]?.inputRef?.ref?.focus();
    }, l = (f) => {
      if (f < 0 || f >= s.value.length) return;
      const m = s.value[f];
      m.disabled || m.inputRef?.ref?.focus();
    }, h = (f, m) => {
      if (a(f, m), m !== null) {
        v(f);
        return;
      }
      if (f <= 0 || typeof e.value?.[f] == "number") return;
      const p = s.value.slice(0, f).reverse().find(({ disabled: k }) => !k)?.index;
      typeof p == "number" && (l(p), a(p, null));
    }, v = (f, m = !0) => {
      const u = m ? f + 1 : f - 1;
      if (u < 0 || u >= s.value.length) return;
      const p = s.value[u];
      if (p.disabled) {
        v(u, m);
        return;
      }
      p.inputRef?.ref?.focus();
    }, c = (f) => {
      const m = f;
      m?.inputRef?.ref && (s.value[m.index] = m);
    };
    return mt(o), t({ focusFirstEnabledInput: o, focusInputByIndex: l }), ni(zo, {
      config: oo(
        W(() => ({
          errorMessage: e.errorMessage,
          noFeedback: !0
        }))
      ),
      disabled: () => e.disabled,
      focusNext: (f) => v(f),
      focusPrevious: (f) => v(f, !1),
      name: () => e.name,
      updateValue: h,
      value: () => e.value
    }), (f, m) => ($(), j("fieldset", Te(f.$attrs, {
      id: q(i),
      class: "lc-digit-input-group"
    }), [
      f.$slots.legend ? ($(), j("legend", {
        key: 0,
        id: `${q(i)}-label`,
        class: ye(["lc-digit-input-group__label", e.legendClass])
      }, [
        me(f.$slots, "legend")
      ], 10, xf)) : ue("", !0),
      ae("div", {
        "aria-labelledby": f.$slots.legend ? `${q(i)}-label` : void 0,
        class: ye(["lc-digit-input-group__wrap", e.wrapperClass]),
        role: "group"
      }, [
        me(f.$slots, "default", _t(Dt({ setRef: c })))
      ], 10, kf),
      e.noFeedback ? ue("", !0) : ($(), xe(q($n), Te({ key: 1 }, { disabled: e.disabled }, {
        class: e.feedbackMessageClass,
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["class", "content", "variant"]))
    ], 16, wf));
  }
}), Sf = ["id"], _f = ["aria-expanded"], Cf = /* @__PURE__ */ _e({
  __name: "LcExpandable",
  props: /* @__PURE__ */ Sn({
    animated: { type: Boolean },
    contentClass: {},
    disabled: { type: Boolean },
    headerClass: {},
    id: {},
    modelValue: { type: Boolean }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Sn(["collapse", "collapsed", "expand", "expanded"], ["update:modelValue"]),
  setup(e) {
    const t = Tt(e.id), n = `${t}-region`, r = Wa(e, "modelValue"), s = W(() => [
      "lc-expandable",
      {
        "lc-expandable--animated": e.animated,
        "lc-expandable--disabled": e.disabled,
        "lc-expandable--expanded": r.value
      }
    ]), i = W(() => ["lc-expandable__content", e.contentClass]), a = () => {
      r.value = !r.value;
    };
    return (o, l) => ($(), j("article", Te(o.$attrs, {
      id: q(t),
      class: s.value
    }), [
      ae("button", Te({ "aria-controls": n }, { disabled: e.disabled }, {
        "aria-expanded": r.value,
        class: ["lc-expandable__header", e.headerClass],
        type: "button",
        onClickPassive: a
      }), [
        me(o.$slots, "header"),
        e.disabled ? ue("", !0) : ($(), xe(q(Qe), {
          key: 0,
          class: "lc-expandable__header-icon",
          name: "chevron-down"
        }))
      ], 16, _f),
      e.animated ? ($(), xe(q(Ao), {
        key: 0,
        animated: "",
        class: "lc-expandable__collapse",
        when: r.value,
        onCollapse: l[0] || (l[0] = (h) => o.$emit("collapse")),
        onCollapsed: l[1] || (l[1] = (h) => o.$emit("collapsed")),
        onExpand: l[2] || (l[2] = (h) => o.$emit("expand")),
        onExpanded: l[3] || (l[3] = (h) => o.$emit("expanded"))
      }, {
        default: Ee(() => [
          ae("section", {
            id: n,
            class: ye(i.value),
            role: "region"
          }, [
            me(o.$slots, "default")
          ], 2)
        ]),
        _: 3
      }, 8, ["when"])) : Jt(($(), j("section", {
        key: 1,
        id: n,
        class: ye(i.value),
        role: "region"
      }, [
        me(o.$slots, "default")
      ], 2)), [
        [ri, r.value]
      ])
    ], 16, Sf));
  }
}), Ef = { class: "lc-expandable-list" }, ug = /* @__PURE__ */ _e({
  __name: "LcExpandableList",
  setup(e) {
    return (t, n) => ($(), j("div", Ef, [
      me(t.$slots, "default")
    ]));
  }
}), Tf = () => {
  const e = pe(!1);
  return mt(() => {
    e.value = !0;
  }), Ln(() => {
    e.value = !1;
  }), e;
}, Af = {
  key: 0,
  class: "lc-fly-out__illustration"
}, Lf = { class: "lc-fly-out__message" }, cg = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcFlyOut",
  props: {
    buttonAriaLabel: { default: () => je.lcFlyOut.buttonAriaLabel },
    isVisible: { type: Boolean },
    message: {},
    to: { default: () => je.lcFlyOut.to },
    visibleInSeconds: { default: () => je.lcFlyOut.visibleInSeconds }
  },
  emits: ["update:isVisible"],
  setup(e, { emit: t }) {
    const n = t, r = Tf(), s = W(() => e.visibleInSeconds * 1e3), { start: i, stop: a } = ta(
      () => {
        n("update:isVisible", !1);
      },
      s,
      { immediate: !1 }
    );
    return Ln(a), ze(
      () => e.isVisible,
      (o) => {
        o ? i() : a();
      },
      { immediate: !0 }
    ), (o, l) => q(r) ? ($(), xe(ba, {
      key: 0,
      class: "lc-fly-out",
      to: e.to
    }, [
      Oe(q(ua), { name: "slide-down-lg" }, {
        default: Ee(() => [
          e.isVisible ? ($(), j("div", Te({ key: 0 }, o.$attrs, { class: "lc-fly-out__container" }), [
            Oe(q(Cc), {
              class: "lc-fly-out__timer",
              "duration-in-ms": s.value
            }, {
              default: Ee(() => [
                Oe(q(Et), {
                  "aria-label": e.buttonAriaLabel,
                  icon: "close",
                  variant: "tertiary",
                  onClick: l[0] || (l[0] = (h) => o.$emit("update:isVisible", !1))
                }, null, 8, ["aria-label"])
              ]),
              _: 1
            }, 8, ["duration-in-ms"]),
            o.$slots.default ? ($(), j("div", Af, [
              me(o.$slots, "default")
            ])) : ue("", !0),
            ae("p", Lf, Ie(e.message), 1)
          ], 16)) : ue("", !0)
        ]),
        _: 3
      })
    ], 8, ["to"])) : ue("", !0);
  }
});
const ha = (e) => e !== null && !!e && typeof e == "object" && !Array.isArray(e);
function fl(e) {
  return Number(e) >= 0;
}
function $f(e) {
  return typeof e == "object" && e !== null;
}
function If(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
function hl(e) {
  if (!$f(e) || If(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Vo(e, t) {
  return Object.keys(t).forEach((n) => {
    if (hl(t[n]) && hl(e[n])) {
      e[n] || (e[n] = {}), Vo(e[n], t[n]);
      return;
    }
    e[n] = t[n];
  }), e;
}
function Df(e, t = { abortEarly: !1 }) {
  return {
    __type: "VVTypedSchema",
    async parse(r) {
      var s;
      try {
        return {
          value: await e.validate(r, Object.assign({}, t)),
          errors: []
        };
      } catch (i) {
        const a = i;
        if (a.name !== "ValidationError")
          throw i;
        if (!(!((s = a.inner) === null || s === void 0) && s.length) && a.errors.length)
          return { errors: [{ path: a.path, errors: a.errors }] };
        const o = a.inner.reduce((l, h) => {
          const v = h.path || "";
          return l[v] || (l[v] = { errors: [], path: v }), l[v].errors.push(...h.errors), l;
        }, {});
        return { errors: Object.values(o) };
      }
    },
    cast(r) {
      try {
        return e.cast(r);
      } catch {
        const i = e.getDefault();
        return ha(i) && ha(r) ? Vo(i, r) : r;
      }
    },
    describe(r) {
      try {
        if (!r)
          return vl(e.spec);
        const s = Mf(r, e);
        return s ? vl(s) : {
          required: !1,
          exists: !1
        };
      } catch {
        return process.env.NODE_ENV !== "production" && console.warn(`Failed to describe path ${r} on the schema, returning a default description.`), {
          required: !1,
          exists: !1
        };
      }
    }
  };
}
function vl(e) {
  return {
    required: !e.optional,
    exists: !0
  };
}
function Mf(e, t) {
  if (!ml(t))
    return null;
  if (tu(e)) {
    const s = t.fields[nu(e)];
    return s?.spec || null;
  }
  const n = (e || "").split(/\.|\[(\d+)\]/).filter(Boolean);
  let r = t;
  for (let s = 0; s < n.length; s++) {
    const i = n[s];
    if (ml(r) && i in r.fields ? r = r.fields[i] : Of(r) && fl(i) ? r = r.spec.types[Number(i)] : fl(i) && Rf(r) && (r = r.innerType), s === n.length - 1)
      return r.spec;
  }
  return null;
}
function Of(e) {
  return ha(e) && e.type === "tuple";
}
function ml(e) {
  return ha(e) && e.type === "object";
}
function Rf(e) {
  return ha(e) && e.type === "array";
}
const dg = /* @__PURE__ */ _e({
  __name: "LcForm",
  props: {
    initialValues: {},
    onSubmit: { type: Function },
    resetOnSubmit: { type: Boolean },
    validateOnMount: { type: Boolean },
    validationSchema: {}
  },
  setup(e, { expose: t }) {
    const n = e, {
      isFieldValid: r,
      isSubmitting: s,
      meta: i,
      resetField: a,
      resetForm: o,
      setErrors: l,
      setValues: h,
      validate: v,
      values: c
    } = au({
      initialValues: n.initialValues,
      validateOnMount: n.validateOnMount,
      validationSchema: n.validationSchema ? Df(n.validationSchema) : void 0
    }), f = async (m) => {
      m.preventDefault();
      try {
        s.value = !0;
        const { valid: u, values: p } = await v();
        u && n.onSubmit && await n.onSubmit(p), u && n.resetOnSubmit && o();
      } finally {
        s.value = !1;
      }
    };
    return t({
      isFieldValid: r,
      isSubmitting: s,
      meta: i,
      resetField: a,
      resetForm: o,
      setErrors: l,
      setValues: h,
      validate: v,
      values: c
    }), (m, u) => ($(), j("form", {
      class: "lc-form",
      novalidate: "",
      onSubmit: f
    }, [
      me(m.$slots, "default", _t(Dt({ isSubmitting: q(s), meta: q(i), values: q(c) })))
    ], 32));
  }
}), fg = [
  "aggressive",
  "blur",
  "eager",
  "lazy",
  "passive"
];
var Ho = /* @__PURE__ */ ((e) => (e.InputEnd = "lottocom_form_input_end", e))(Ho || {});
const Nt = {
  Blur: "onBlur",
  Change: "onChange",
  Update: "onUpdate:value"
}, Ff = { class: "lc-form-field" }, hg = /* @__PURE__ */ _e({
  __name: "LcFormField",
  props: {
    mode: { default: "aggressive" },
    name: {}
  },
  setup(e, { expose: t }) {
    const n = {
      aggressive: () => [Nt.Blur, Nt.Update],
      blur: ({ errorMessage: f }) => f.value ? [Nt.Update] : [Nt.Blur],
      eager: ({ errorMessage: f }) => f.value ? [Nt.Update] : [Nt.Change],
      lazy: () => [Nt.Change],
      passive: () => []
    }, {
      errorMessage: r,
      handleBlur: s,
      handleChange: i,
      meta: a,
      value: o
    } = ru(() => e.name, {}, { validateOnValueUpdate: !1 }), l = {
      [Nt.Blur]: (f) => c(f, !0),
      [Nt.Change]: (f) => i(f, !0),
      [Nt.Update]: (f) => i(f, !0)
    }, h = W(() => ({
      errorMessage: r.value,
      name: e.name,
      value: o.value,
      ...v.value
    })), v = W(() => {
      const f = {
        [Nt.Blur]: (m) => c(m, !1),
        [Nt.Update]: (m) => i(m, !1)
      };
      return n[e.mode]({
        errorMessage: r,
        meta: a
      }).forEach((m) => {
        f[m] = l[m];
      }), f;
    }), c = async (f, m) => {
      if (s(f, m), await Ya(), !f) return;
      const u = new CustomEvent(Ho.InputEnd, {
        detail: {
          _value: f
        }
      });
      window.dispatchEvent(u);
    };
    return t({ field: h }), (f, m) => ($(), j("div", Ff, [
      me(f.$slots, "default", _t(Dt({ field: h.value })))
    ]));
  }
}), Nf = ["id"], Bf = { ref: "wrapper" }, Pf = { class: "lc-header__wrap" }, zf = { class: "lc-header__left-button-wrap" }, Vf = { class: "lc-header__headline-wrap" }, Hf = {
  key: 0,
  class: "lc-header__fly-out-toggle-wrap"
}, Uf = ["id", "aria-labelledby"], qf = { class: "lc-header__fly-out-content-container" }, vg = /* @__PURE__ */ _e({
  __name: "LcHeader",
  props: {
    href: {},
    target: {},
    to: {},
    ignoreOutsideClickOn: { default: () => [je.lcModal.to] },
    closeFlyOutOnOutsideClick: { type: Boolean, default: !0 },
    flyOutContentClass: {},
    flyOutToggleAriaLabel: { default: () => je.lcHeader.flyOutToggleAriaLabel },
    flyOutToggleClass: {},
    headlineClass: {},
    id: {},
    leftButtonAriaLabel: { default: () => je.lcHeader.leftButtonAriaLabel },
    leftButtonIcon: { default: "arrow-left" },
    withFlyOut: { type: Boolean }
  },
  emits: ["left-button-click"],
  setup(e) {
    const t = it("wrapper"), n = Tt(e.id), r = pe(!1), s = W(() => [
      "lc-header",
      {
        "lc-header--active": r.value,
        "lc-header--with-fly-out": e.withFlyOut
      }
    ]), i = () => {
      r.value = !r.value;
    };
    return Ga(
      t,
      () => {
        !e.closeFlyOutOnOutsideClick || !r.value || (r.value = !1);
      },
      { ignore: [...Ke(e.ignoreOutsideClickOn)] }
    ), (a, o) => ($(), j("header", {
      id: q(n),
      class: ye(s.value)
    }, [
      ae("div", Bf, [
        ae("div", Pf, [
          ae("div", zf, [
            Oe(q(Et), Te({ href: e.href, target: e.target, to: e.to }, {
              "aria-label": e.leftButtonAriaLabel,
              icon: e.leftButtonIcon,
              size: "small",
              variant: "tertiary",
              onClick: o[0] || (o[0] = (l) => a.$emit("left-button-click"))
            }), null, 16, ["aria-label", "icon"])
          ]),
          ae("div", Vf, [
            ae("h1", {
              class: ye(["lc-header__headline", e.headlineClass])
            }, [
              me(a.$slots, "headline")
            ], 2)
          ]),
          me(a.$slots, "right", {}, () => [
            e.withFlyOut ? ($(), j("div", Hf, [
              Oe(q(Et), {
                id: `${q(n)}-toggle`,
                "aria-controls": `${q(n)}-region`,
                "aria-expanded": r.value,
                "aria-label": e.flyOutToggleAriaLabel,
                class: ye(["lc-header__fly-out-toggle", e.flyOutToggleClass]),
                icon: "chevron-down",
                "icon-position": "right",
                "no-padding": "",
                size: "small",
                variant: "tertiary",
                onClickPassive: i
              }, {
                default: Ee(() => [
                  me(a.$slots, "fly-out-toggle")
                ]),
                _: 3
              }, 8, ["id", "aria-controls", "aria-expanded", "aria-label", "class"])
            ])) : ue("", !0)
          ])
        ]),
        e.withFlyOut && r.value ? ($(), j("div", {
          key: 0,
          id: `${q(n)}-region`,
          "aria-labelledby": `${q(n)}-toggle`,
          class: "lc-header__fly-out",
          role: "region"
        }, [
          ae("div", qf, [
            ae("div", {
              class: ye(["lc-header__fly-out-content", e.flyOutContentClass])
            }, [
              me(a.$slots, "fly-out-content")
            ], 2)
          ])
        ], 8, Uf)) : ue("", !0)
      ], 512),
      me(a.$slots, "default")
    ], 10, Nf));
  }
}), jf = /* @__PURE__ */ _e({
  __name: "LcHighFrequencyBall",
  props: {
    content: {},
    opacity: { default: 1 },
    size: { default: "medium" }
  },
  setup(e) {
    const t = W(() => ["lc-high-frequency-ball", `lc-high-frequency-ball--size-${e.size}`]);
    return (n, r) => ($(), j("div", {
      class: ye(t.value),
      style: Ct({
        "--ball-opacity": e.opacity
      })
    }, Ie(e.content), 7));
  }
}), Zf = { class: "lc-high-frequency-ball-background" }, Uo = /* @__PURE__ */ _e({
  __name: "LcHighFrequencyBallBackground",
  props: {
    ballConfig: {},
    gradientClass: {}
  },
  setup(e) {
    return (t, n) => ($(), j("div", Zf, [
      ($(!0), j(Ge, null, vt(e.ballConfig, (r, s) => ($(), xe(jf, {
        key: s,
        class: "lc-high-frequency-ball-background__ball",
        content: r.content,
        opacity: r.opacity,
        size: r.size,
        style: Ct({
          "--ball-position-top": r.top,
          "--ball-position-left": r.left
        })
      }, null, 8, ["content", "opacity", "size", "style"]))), 128)),
      ae("div", {
        class: ye(["lc-high-frequency-ball-background__gradient", e.gradientClass])
      }, null, 2)
    ]));
  }
}), Wf = {
  key: 0,
  class: "lc-lottery-jackpot__placeholder"
}, Yf = { class: "lc-lottery-jackpot__value" }, Xf = { class: "lc-lottery-jackpot__currency" }, Gf = {
  key: 0,
  class: "lc-lottery-jackpot__numeral"
}, gl = 10 ** 9, bl = 10 ** 6, Kf = "mil millones", Jf = "mil M", qo = /* @__PURE__ */ _e({
  __name: "LcLotteryJackpot",
  props: {
    currency: { default: () => je.general.currency },
    locale: { default: () => je.general.locale },
    noShadow: { type: Boolean },
    placeholder: {},
    size: { default: "medium" },
    value: {}
  },
  setup(e) {
    const t = gl * 100, n = bl * 100, r = W(() => {
      let a;
      const o = e.value >= t, l = e.value >= n;
      switch (!0) {
        case o:
          a = Math.floor(e.value / gl) / 100;
          break;
        case l:
          a = Math.floor(e.value / bl) / 100;
          break;
        default:
          a = e.value / 100;
          break;
      }
      const [h, v] = a.toFixed(2).split("."), c = v.replace(/0+$/, ""), f = l || o;
      let m = c;
      !f && c.length >= 1 ? m = v : f && h.length >= 3 ? m = "" : f && c.length > 1 && (m = c.slice(0, 1));
      const u = m.length > 0 ? [h, m].join(".") : h, p = m.length;
      return new Intl.NumberFormat(e.locale, {
        maximumFractionDigits: p,
        minimumFractionDigits: p
      }).format(Number(u));
    }), s = W(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: a }) => a === "currency")?.value ?? e.currency
    ), i = W(() => {
      if (e.value < n) return null;
      const a = new Intl.NumberFormat(e.locale, {
        compactDisplay: "long",
        maximumFractionDigits: 12,
        minimumFractionDigits: 2,
        notation: "compact"
      }).format(e.value / 100).split(" ").slice(1).join(" ");
      return a === Kf ? Jf : a;
    });
    return (a, o) => ($(), j("div", {
      class: ye([
        "lc-lottery-jackpot",
        `lc-lottery-jackpot--size-${e.size}`,
        { "lc-lottery-jackpot--no-shadow": e.noShadow }
      ])
    }, [
      e.placeholder ? ($(), j("span", Wf, Ie(e.placeholder), 1)) : ($(), j(Ge, { key: 1 }, [
        ae("span", Yf, [
          ae("span", Xf, Ie(s.value), 1),
          ae("span", null, Ie(r.value), 1)
        ]),
        i.value ? ($(), j("span", Gf, Ie(i.value), 1)) : ue("", !0)
      ], 64))
    ], 2));
  }
}), mg = ["large", "medium", "small"], jo = () => typeof window < "u", Qf = { class: "lc-info-button__modal" }, e0 = { class: "lc-info-button__modal-header" }, t0 = { class: "lc-info-button__modal-headline" }, n0 = { class: "lc-info-button__modal-text" }, Zo = /* @__PURE__ */ _e({
  __name: "LcInfoButton",
  props: {
    to: {},
    closeButtonAriaLabel: { default: () => je.lcInfoButton.closeButtonAriaLabel },
    disabled: { type: Boolean, default: !1 },
    headline: {},
    openButtonAriaLabel: { default: () => je.lcInfoButton.openButtonAriaLabel },
    text: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = jo(), n = pe(!1), r = () => {
      n.value = !1;
    }, s = () => {
      e.disabled || (n.value = !0);
    };
    return (i, a) => ($(), j("div", {
      class: ye(["lc-info-button", `lc-info-button--variant-${e.variant}`])
    }, [
      Oe(q(Et), Te({ disabled: e.disabled }, {
        "aria-label": e.openButtonAriaLabel,
        class: "lc-info-button__button-open",
        icon: "info",
        size: "small",
        variant: "tertiary",
        onClickPassive: s
      }), null, 16, ["aria-label"]),
      q(t) && n.value ? ($(), xe(q($o), Te({ key: 0 }, { to: e.to, isVisible: n.value }, {
        "close-triggers": ["escape", "click-outside"],
        spacing: "small",
        onClosePassive: r
      }), {
        default: Ee(() => [
          ae("div", Qf, [
            ae("header", e0, [
              ae("span", t0, Ie(e.headline), 1),
              Oe(q(Et), {
                "aria-label": e.closeButtonAriaLabel,
                icon: "close",
                size: "small",
                variant: "tertiary",
                onClick: r
              }, null, 8, ["aria-label"])
            ]),
            me(i.$slots, "default", {}, () => [
              ae("p", n0, Ie(e.text), 1)
            ])
          ])
        ]),
        _: 3
      }, 16)) : ue("", !0)
    ], 2));
  }
}), gg = ["default", "prominent"], a0 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='11.9999'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M19.4149%2015.1688C18.8733%2019.0325%2016.1778%2021.4239%2011.7967%2021.4239C7.80659%2021.4239%204.34435%2017.7274%205.29956%2014.3591C6.14178%2011.3891%208.79864%2011.1375%209.58553%207.65315C11.2998%209.28806%2010.8823%2010.6768%2010.5907%2012.0319C10.34%2013.1974%2010.7651%2014.5391%2011.7967%2014.5391C13.0342%2014.5391%2013.5051%2013.1541%2013.0342%2011.7364C12.2699%209.43549%2010.4881%206.2479%2012.2267%203.90869C13.3913%206.00993%2014.7039%206.89025%2016.4607%208.40282C18.7036%2010.3339%2019.7843%2012.5328%2019.4149%2015.1688Z'%20fill='%23000860'/%3e%3cpath%20d='M7.99905%203.70487C9.59553%207.89517%205.86485%209.98417%205.86485%209.98417C5.07622%206.82574%206.57056%206.64536%207.99905%203.70487Z'%20fill='%23000860'/%3e%3c/svg%3e", r0 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='56'%20height='55'%20fill='none'%3e%3cg%20filter='url(%23a)'%3e%3cpath%20fill='%2300C572'%20d='M24.064%204.19A1%201%200%200%201%2025.427%204L27.1%205.192a1%201%200%200%200%201.185-.016l1.638-1.24a1%201%200%200%201%201.368.153l1.323%201.572a1%201%200%200%200%201.151.279l1.895-.794a1%201%200%200%201%201.288.49l.89%201.85a1%201%200%200%200%201.046.557l2.033-.297a1%201%200%200%201%201.125.794l.402%202.014a1%201%200%200%200%20.875.799l2.042.218a1%201%200%200%201%20.893%201.048l-.112%202.052a1%201%200%200%200%20.649.99l1.924.72a1%201%200%200%201%20.604%201.237l-.618%201.96a1%201%200%200%200%20.381%201.12l1.685%201.176a1%201%200%200%201%20.277%201.349l-1.086%201.744a1%201%200%200%200%20.091%201.18l1.34%201.558a1%201%200%200%201-.067%201.375l-1.485%201.419a1%201%200%200%200-.206%201.166l.91%201.842a1%201%200%200%201-.407%201.315l-1.791%201.005a1%201%200%200%200-.49%201.079l.424%202.01a1%201%200%200%201-.721%201.173l-1.986.528a1%201%200%200%200-.742.923l-.089%202.052a1%201%200%200%201-.99.957l-2.055.017a1%201%200%200%200-.948.71l-.597%201.965a1%201%200%200%201-1.197.68l-1.994-.493a1%201%200%200%200-1.095.45l-1.067%201.756a1%201%200%200%201-1.33.361l-1.808-.974a1%201%200%200%200-1.172.165l-1.47%201.435a1%201%200%200%201-1.377.02l-1.51-1.394a1%201%200%200%200-1.177-.132l-1.78%201.024a1%201%200%200%201-1.339-.324l-1.115-1.725a1%201%200%200%200-1.108-.42l-1.98.55a1%201%200%200%201-1.215-.647l-.651-1.949a1%201%200%200%200-.968-.682l-2.054.04a1%201%200%200%201-1.017-.929l-.146-2.05a1%201%200%200%200-.768-.901l-2-.472a1%201%200%200%201-.753-1.153l.367-2.02a1%201%200%200%200-.519-1.065l-1.819-.955a1%201%200%200%201-.444-1.303l.86-1.866a1%201%200%200%200-.239-1.16L4.738%2029.73a1%201%200%200%201-.105-1.373l1.296-1.593a1%201%200%200%200%20.058-1.183l-1.135-1.713a1%201%200%200%201%20.24-1.356l1.651-1.222a1%201%200%200%200%20.35-1.131l-.672-1.942a1%201%200%200%201%20.569-1.254l1.903-.772a1%201%200%200%200%20.62-1.009l-.168-2.047a1%201%200%200%201%20.863-1.073l2.036-.275a1%201%200%200%200%20.852-.823l.345-2.025a1%201%200%200%201%201.103-.825l2.04.24a1%201%200%200%200%201.03-.585l.838-1.875a1%201%200%200%201%201.274-.525l1.916.74a1%201%200%200%200%201.143-.31z'/%3e%3cpath%20fill='%23fff'%20d='M12.886%2035.433a.42.42%200%200%201-.32-.075.41.41%200%200%201-.16-.286l-1.538-10.943a.41.41%200%200%201%20.075-.32.41.41%200%200%201%20.286-.16l1.532-.215q.254-.036.387.066.135.101.178.163l5.481%206.389-.97-6.902a.41.41%200%200%201%20.075-.32.4.4%200%200%201%20.27-.158l1.717-.242a.41.41%200%200%201%20.32.076q.135.101.16.286l1.538%2010.943a.45.45%200%200%201-.075.32.41.41%200%200%201-.287.16l-1.549.217q-.252.036-.386-.065-.12-.12-.178-.164l-5.434-6.172.94%206.683a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.176-1.57a.42.42%200%200%201-.32-.076.41.41%200%200%201-.16-.286l-1.538-10.943a.42.42%200%200%201%20.076-.32.41.41%200%200%201%20.286-.16l7.626-1.072a.41.41%200%200%201%20.32.076q.135.101.16.286l.19%201.347a.4.4%200%200%201-.078.303.42.42%200%200%201-.287.16l-5.454.767.372%202.643%205.084-.715a.42.42%200%200%201%20.32.075q.133.102.16.287l.175%201.246a.4.4%200%200%201-.078.302.42.42%200%200%201-.287.16l-5.084.715.384%202.727%205.589-.785a.42.42%200%200%201%20.32.075q.133.102.16.287l.187%201.33a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.278-1.586a.64.64%200%200%201-.459-.09.66.66%200%200%201-.237-.344l-3.436-10.521a.15.15%200%200%201-.026-.065l-.007-.05a.33.33%200%200%201%20.067-.25.32.32%200%200%201%20.236-.154l1.768-.248q.438-.061.538.285l2.263%206.943.742-4.619q.03-.142.128-.31.096-.167.366-.206l1.06-.149q.27-.038.409.097a.8.8%200%200%201%20.192.265l2%204.217.247-7.28q0-.36.456-.424l1.767-.248a.32.32%200%200%201%20.27.082.33.33%200%200%201%20.133.222l.008.05a.15.15%200%200%201-.008.07l-.403%2011.06a.62.62%200%200%201-.15.4q-.13.172-.399.21l-1.364.192q-.27.038-.44-.076a.9.9%200%200%201-.227-.277l-2.535-4.966-1.05%205.47a.8.8%200%200%201-.16.331q-.117.154-.402.194z'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='a'%20width='54.296'%20height='56.295'%20x='.852'%20y='.102'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='2'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20values='0%200%200%200%200%200%200%200%200%200.0313726%200%200%200%200%200.376471%200%200%200%200.06%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_11660_18282'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_11660_18282'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e", i0 = "data:image/svg+xml,%3csvg%20width='24'%20height='25'%20viewBox='0%200%2024%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12.0001'%20cy='12.9417'%20r='11'%20fill='white'/%3e%3ccircle%20cx='12'%20cy='12.9417'%20r='9.21486'%20transform='rotate(-11.3509%2012%2012.9417)'%20fill='%23000860'/%3e%3cpath%20d='M10.5288%205.61047C9.30234%205.85667%208.15728%206.40664%207.19846%207.21001C6.23963%208.01338%205.49769%209.04448%205.04059%2010.2089L12.0003%2012.941L10.5288%205.61047Z'%20fill='white'/%3e%3c/svg%3e", l0 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M11.7802%2013.8032L14.3303%2012.5401L14.5266%2012.7531C16.3077%2014.6859%2017.2575%2017.2414%2017.1712%2019.8683C17.1679%2019.9693%2017.1041%2020.0585%2017.0095%2020.0942L13.4144%2021.4522C13.2796%2021.5031%2013.1355%2021.4035%2013.1355%2021.2594L13.1356%2020.3255C13.1356%2018.0815%2012.6742%2015.8615%2011.7802%2013.8032Z'%20fill='%23000860'/%3e%3cpath%20d='M11.0112%209.27934C11.0323%209.19513%2011.1291%209.15558%2011.2031%209.20086L17.6251%2012.5888C17.715%2012.6438%2017.7043%2012.7778%2017.6066%2012.8177L9.86212%2016.2293C9.76448%2016.2693%209.66293%2016.1812%209.6886%2016.0789L11.0112%209.27934Z'%20fill='%23000860'/%3e%3cpath%20d='M5.25467%200.422462C5.25301%200.280381%205.41499%200.19807%205.52878%200.283175L8.27821%202.33962C8.3234%202.37342%208.38232%202.38282%208.43577%202.36475L11.6885%201.26567C11.8231%201.22018%2011.9515%201.3488%2011.9057%201.48331L10.7995%204.73366C10.7813%204.78707%2010.7906%204.84601%2010.8243%204.89127L12.8748%207.64518C12.9596%207.75915%2012.8769%207.92095%2012.7349%207.91898L9.30178%207.87136C9.24536%207.87057%209.19217%207.8976%209.15954%207.94364L7.17404%2010.7447C7.09187%2010.8607%206.91245%2010.832%206.87042%2010.6963L5.85482%207.41653C5.83813%207.36263%205.79599%207.32039%205.74213%207.30359L2.46457%206.28085C2.32893%206.23852%202.3007%206.05904%202.41681%205.97712L5.22222%203.99773C5.26833%203.9652%205.29547%203.91207%205.29481%203.85565L5.25467%200.422462Z'%20fill='%23000860'/%3e%3c/svg%3e", o0 = {
  key: 0,
  fill: "none",
  height: "32",
  viewBox: "0 0 21 32",
  width: "21",
  xmlns: "http://www.w3.org/2000/svg"
}, s0 = ["src"], u0 = {
  key: 2,
  class: "lc-teaser-badge__text"
}, c0 = ["src"], d0 = 8, an = 10, f0 = 20, h0 = /* @__PURE__ */ _e({
  __name: "LcTeaserBadge",
  props: {
    infoHeadline: {},
    infoText: {},
    title: {},
    variant: {}
  },
  setup(e) {
    const t = W(() => [
      "lc-teaser-badge",
      `lc-teaser-badge--variant-${e.variant}`,
      {
        "lc-teaser-badge--multiple-lines": n.value
      }
    ]), n = W(() => s.value.length > 1), r = W(() => {
      switch (e.variant) {
        case "fire":
          return a0;
        case "pie":
          return i0;
        case "star":
          return l0;
        default:
          return null;
      }
    }), s = W(() => {
      if (!e.title) return [];
      const i = e.title.substring(0, f0);
      if (i.length <= d0) return [i];
      const o = i.split(" ").filter(Boolean);
      if (o.length === 1)
        return [
          i.slice(0, an),
          i.slice(an)
        ];
      let l = "";
      const h = [];
      return o.forEach((v) => {
        if (l.length + v.length + (l.length ? 1 : 0) <= an) {
          l.length > 0 && (l += " "), l += v;
          return;
        }
        if (v.length > an) {
          if (l.length > 0) {
            let c = 0;
            l.length < an && (l += " ", c = an - l.length, l += v.slice(0, c)), h.push(l), h.push(v.slice(c)), l = "";
            return;
          }
          h.push(v.slice(0, an)), l = v.slice(an);
          return;
        }
        h.push(l), l = v;
      }), l.length > 0 && h.push(l), h.length > 2 ? [h[0], h.slice(1).join(" ")] : h;
    });
    return (i, a) => ($(), j("div", {
      class: ye(t.value)
    }, [
      e.variant === "price-tag" ? ($(), j("svg", o0, [...a[0] || (a[0] = [
        ae("path", {
          d: "M20.4593 2C20.4593 0.895431 19.5638 0 18.4593 0H16.9403C16.602 0 16.2693 0.0858105 15.9732 0.249404L1.49209 8.24989C0.854856 8.60195 0.459259 9.27247 0.459259 10.0005V21.9995C0.459259 22.7275 0.854856 23.398 1.49209 23.7501L15.9732 31.7506C16.2693 31.9142 16.602 32 16.9403 32H18.4593C19.5638 32 20.4593 31.1046 20.4593 30V2Z",
          fill: "currentColor"
        }, null, -1)
      ])])) : ue("", !0),
      r.value ? ($(), j("img", {
        key: 1,
        alt: "",
        height: "24",
        src: r.value,
        width: "24"
      }, null, 8, s0)) : ue("", !0),
      e.variant !== "new" ? ($(), j("span", u0, Ie(s.value.join(`
`)), 1)) : ($(), j("img", {
        key: 3,
        alt: "New",
        height: "48",
        src: q(r0),
        width: "48"
      }, null, 8, c0)),
      e.variant !== "new" && e.variant !== "floating" && e.infoHeadline && e.infoText ? ($(), xe(q(Zo), {
        key: 4,
        headline: e.infoHeadline,
        "open-button-aria-label": `${q(je).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : ue("", !0)
    ], 2));
  }
}), bg = ["fire", "lightning", "money", "star"], pg = [
  "fire",
  "floating",
  "new",
  "pie",
  "price-tag",
  "star",
  "text"
], yg = ["bottom-m", "bottom-xl", "top-m", "top-xl"], Wo = ["badge", "default", "hero"];
var Yo = /* @__PURE__ */ ((e) => (e.Blue = "#a8e2ff", e.Green = "#84f9c1", e.YellowBright = "#ffec8d", e.YellowDark = "#f2c219", e))(Yo || {});
const v0 = { class: "lc-teaser-hero-badge__text-wrap" }, m0 = /* @__PURE__ */ _e({
  __name: "LcTeaserHeroBadge",
  props: {
    color: { default: () => Yo.YellowBright },
    infoHeadline: {},
    infoText: {},
    subtitle: {},
    title: {},
    variant: {}
  },
  setup(e) {
    return (t, n) => ($(), j("div", {
      class: ye(["lc-teaser-hero-badge", `lc-teaser-hero-badge--variant-${e.variant}`]),
      style: Ct({
        "--teaser-badge-color": e.color
      })
    }, [
      ae("div", v0, [
        ae("span", null, Ie(e.title), 1),
        ae("span", null, Ie(e.subtitle), 1)
      ]),
      e.infoHeadline && e.infoText ? ($(), xe(q(Zo), {
        key: 0,
        headline: e.infoHeadline,
        "open-button-aria-label": `${q(je).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : ue("", !0)
    ], 6));
  }
}), g0 = (e) => !!e.title && !!e.subtitle, b0 = { class: "lc-teaser__background" }, nr = /* @__PURE__ */ _e({
  __name: "LcTeaser",
  props: {
    bodyClass: {},
    footerClass: {},
    headerClass: {},
    headerTo: {},
    onHeaderClick: { type: Function },
    backgroundPattern: {},
    badge: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = An(), n = W(() => [
      ["lc-teaser", `lc-teaser--variant-${e.variant}`],
      {
        [`lc-teaser--background-pattern-${String(e.backgroundPattern)}`]: e.variant === "hero" && !!e.backgroundPattern,
        [`lc-teaser--variant-badge-${String(e.badge?.variant)}`]: !!e.badge,
        "lc-teaser--has-background": !!t.background
      }
    ]);
    return (r, s) => ($(), xe(q(ya), Te({ headerTo: e.headerTo }, {
      "body-class": ["lc-teaser__body", e.bodyClass],
      class: n.value,
      "footer-class": ["lc-teaser__footer", e.footerClass],
      "header-class": ["lc-teaser__header", e.headerClass],
      radius: "large",
      onHeaderClick: e.onHeaderClick
    }), Xa({
      default: Ee(() => [
        me(r.$slots, "default"),
        e.badge ? ($(), j(Ge, { key: 0 }, [
          q(g0)(e.badge) ? ($(), xe(m0, _t(Te({ key: 0 }, e.badge)), null, 16)) : ($(), xe(h0, _t(Te({ key: 1 }, e.badge)), null, 16))
        ], 64)) : ue("", !0)
      ]),
      _: 2
    }, [
      r.$slots.background ? {
        name: "background",
        fn: Ee(() => [
          ae("div", b0, [
            me(r.$slots, "background")
          ])
        ]),
        key: "0"
      } : void 0,
      r.$slots.header ? {
        name: "header",
        fn: Ee(() => [
          me(r.$slots, "header")
        ]),
        key: "1"
      } : void 0,
      r.$slots.footer ? {
        name: "footer",
        fn: Ee(() => [
          me(r.$slots, "footer")
        ]),
        key: "2"
      } : void 0
    ]), 1040, ["body-class", "class", "footer-class", "header-class", "onHeaderClick"]));
  }
}), p0 = { class: "lc-high-frequency-teaser__background" }, y0 = { class: "lc-high-frequency-teaser__jackpot-section" }, w0 = {
  key: 0,
  class: "lc-high-frequency-teaser__jackpot-headline"
}, x0 = { class: "lc-high-frequency-teaser__button-container" }, k0 = { class: "lc-high-frequency-teaser__button-wrap" }, S0 = { class: "lc-high-frequency-teaser__hint-container" }, _0 = {
  key: 0,
  class: "lc-high-frequency-teaser__hint-text"
}, wg = /* @__PURE__ */ _e({
  __name: "LcHighFrequencyTeaser",
  props: {
    backgroundPattern: {},
    badge: {},
    headline: {},
    jackpot: {},
    locale: {},
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" },
    ballConfig: {},
    hint: {}
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    An();
    const t = W(() => [
      "lc-high-frequency-teaser",
      `lc-high-frequency-teaser--variant-${e.variant}`
    ]), n = W(
      () => e.primaryButtonProps.to ? Yn(e.primaryButtonProps.to) : "div"
    );
    return (r, s) => ($(), xe(q(nr), Te({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-high-frequency-teaser__body",
      class: t.value,
      "footer-class": "lc-high-frequency-teaser__footer",
      "header-to": e.primaryButtonProps.to,
      onHeaderClick: e.onTeaserClick
    }), {
      background: Ee(() => [
        ae("div", p0, [
          Oe(q(Uo), _t(Dt({ ballConfig: e.ballConfig })), null, 16)
        ])
      ]),
      header: Ee(() => [
        me(r.$slots, "lottery-logo")
      ]),
      default: Ee(() => [
        ae("section", y0, [
          ($(), xe(Pt(n.value), {
            class: "lc-high-frequency-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: Ee(() => [
              e.headline ? ($(), j("strong", w0, Ie(e.headline), 1)) : ue("", !0),
              Oe(q(qo), Te(e.jackpot, {
                "no-shadow": "",
                size: "small"
              }), null, 16)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        ae("section", x0, [
          ae("div", k0, [
            me(r.$slots, "primary-button", {}, () => [
              Oe(q(Et), Te(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-high-frequency-teaser__button",
                "no-padding": "",
                onClick: s[0] || (s[0] = (i) => r.$emit("primary-button-click"))
              }), {
                default: Ee(() => [
                  wt(Ie(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])
            ])
          ])
        ]),
        ae("section", S0, [
          e.hint ? ($(), j("p", _0, [
            me(r.$slots, "hint", {}, () => [
              wt(Ie(e.hint), 1)
            ])
          ])) : ue("", !0)
        ])
      ]),
      _: 3
    }, 16, ["class", "header-to", "onHeaderClick"]));
  }
}), C0 = {
  width: "47",
  height: "47",
  viewBox: "0 0 47 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, E0 = ["stroke"], T0 = ["stroke"], pl = "lc-high-frequency-teaser-watch-arrows-gradient-1", yl = "lc-high-frequency-teaser-watch-arrows-gradient-2", A0 = /* @__PURE__ */ _e({
  __name: "ArrowsIcon",
  setup(e) {
    return (t, n) => ($(), j("svg", C0, [
      ae("path", {
        d: "M6.29812 18.431C7.41552 14.3207 9.97378 10.7492 13.5059 8.36858C17.0381 5.98793 21.3086 4.95686 25.5378 5.46358C29.7671 5.9703 33.6731 7.98101 36.5429 11.1287C39.4127 14.2764 41.0549 18.3511 41.1696 22.6091",
        stroke: `url(#${pl})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, E0),
      n[2] || (n[2] = ae("path", {
        d: "M38.1073 20.6755L41.1265 22.9697C41.2144 23.0366 41.3399 23.0195 41.4067 22.9315L43.7009 19.9123",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      ae("path", {
        d: "M40.5545 28.3175C39.3918 32.4153 36.7942 35.9583 33.236 38.2998C29.6778 40.6413 25.3962 41.6251 21.1727 41.0717C16.9493 40.5183 13.0657 38.4646 10.2309 35.2854C7.39604 32.1062 5.79899 28.0136 5.73126 23.7546",
        stroke: `url(#${yl})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, T0),
      n[3] || (n[3] = ae("path", {
        d: "M8.73274 25.8842L5.71355 23.5899C5.6256 23.5231 5.50013 23.5402 5.4333 23.6282L3.1391 26.6474",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      ae("defs", null, [
        ae("linearGradient", {
          id: pl,
          x1: "35.7167",
          y1: "6.28729",
          x2: "7.80661",
          y2: "13.8312",
          gradientUnits: "userSpaceOnUse"
        }, [...n[0] || (n[0] = [
          ae("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          ae("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])]),
        ae("linearGradient", {
          id: yl,
          x1: "11.0036",
          y1: "40.1356",
          x2: "38.9953",
          y2: "32.9005",
          gradientUnits: "userSpaceOnUse"
        }, [...n[1] || (n[1] = [
          ae("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          ae("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), L0 = {}, $0 = {
  viewBox: "0 0 45 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function I0(e, t) {
  return $(), j("svg", $0, [...t[0] || (t[0] = [
    Fs('<path class="star star-1" fill-rule="evenodd" clip-rule="evenodd" d="M5.25845 10.7151C4.91385 10.5772 4.91385 10.0894 5.25845 9.95156C6.48681 9.46014 7.46014 8.48681 7.95157 7.25845C8.08943 6.91385 8.57723 6.91385 8.7151 7.25845C9.20653 8.48681 10.1799 9.46014 11.4082 9.95156C11.7528 10.0894 11.7528 10.5772 11.4082 10.7151C10.1799 11.2065 9.20653 12.1798 8.7151 13.4082C8.57723 13.7528 8.08943 13.7528 7.95157 13.4082C7.46014 12.1798 6.48681 11.2065 5.25845 10.7151Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-2" fill-rule="evenodd" clip-rule="evenodd" d="M0.155071 19.2291C-0.0516903 19.1463 -0.0516903 18.8537 0.155071 18.7709C0.892087 18.4761 1.47608 17.8921 1.77094 17.1551C1.85366 16.9483 2.14634 16.9483 2.22906 17.1551C2.52392 17.8921 3.10791 18.4761 3.84493 18.7709C4.05169 18.8537 4.05169 19.1463 3.84493 19.2291C3.10791 19.5239 2.52392 20.1079 2.22906 20.8449C2.14634 21.0517 1.85366 21.0517 1.77094 20.8449C1.47608 20.1079 0.892087 19.5239 0.155071 19.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-3" fill-rule="evenodd" clip-rule="evenodd" d="M41.1551 18.2291C40.9483 18.1463 40.9483 17.8537 41.1551 17.7709C41.8921 17.4761 42.4761 16.8921 42.7709 16.1551C42.8537 15.9483 43.1463 15.9483 43.2291 16.1551C43.5239 16.8921 44.1079 17.4761 44.8449 17.7709C45.0517 17.8537 45.0517 18.1463 44.8449 18.2291C44.1079 18.5239 43.5239 19.1079 43.2291 19.8449C43.1463 20.0517 42.8537 20.0517 42.7709 19.8449C42.4761 19.1079 41.8921 18.5239 41.1551 18.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-4" fill-rule="evenodd" clip-rule="evenodd" d="M32.2068 21.9721C31.9311 21.8618 31.9311 21.4715 32.2068 21.3613C33.1894 20.9681 33.9681 20.1894 34.3613 19.2068C34.4715 18.9311 34.8618 18.9311 34.9721 19.2068C35.3652 20.1894 36.1439 20.9681 37.1266 21.3613C37.4023 21.4715 37.4023 21.8618 37.1266 21.9721C36.1439 22.3652 35.3652 23.1439 34.9721 24.1266C34.8618 24.4022 34.4715 24.4022 34.3613 24.1266C33.9681 23.1439 33.1894 22.3652 32.2068 21.9721Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-5" fill-rule="evenodd" clip-rule="evenodd" d="M31.2068 2.97208C30.9311 2.86179 30.9311 2.47154 31.2068 2.36125C32.1894 1.96811 32.9681 1.18945 33.3613 0.206761C33.4715 -0.0689204 33.8618 -0.0689204 33.9721 0.206761C34.3652 1.18945 35.1439 1.96811 36.1266 2.36125C36.4023 2.47154 36.4023 2.86179 36.1266 2.97208C35.1439 3.36522 34.3652 4.14388 33.9721 5.12657C33.8618 5.40225 33.4715 5.40225 33.3613 5.12657C32.9681 4.14388 32.1894 3.36522 31.2068 2.97208Z" fill="currentColor" data-v-0c679bcf></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.2651 4.74748C19.6333 4.10999 20.4491 3.89126 21.0867 4.2592L32.6479 10.935C33.2856 11.3032 33.5044 12.1189 33.1362 12.7566C32.7679 13.3941 31.9522 13.6129 31.3146 13.2449L31.144 13.1459L30.5047 14.2553C29.6757 15.6906 28.226 16.6584 26.5828 16.8751L24.0815 17.2045L25.0464 19.5352C25.6807 21.067 25.5666 22.8078 24.7378 24.2436L24.101 25.3464L24.2469 25.4311C24.8843 25.7994 25.102 26.6151 24.7339 27.2527C24.3657 27.89 23.5511 28.1087 22.9135 27.741L11.351 21.0652C10.7137 20.6969 10.496 19.8811 10.8641 19.2436C11.2324 18.6065 12.0469 18.3886 12.6844 18.7566L12.8354 18.8438L13.4734 17.7397C14.3024 16.3041 15.7518 15.3352 17.3953 15.1186L19.8966 14.7878L18.9318 12.4571C18.2977 10.9256 18.4117 9.18694 19.2404 7.75138L19.8797 6.64201L19.7534 6.56909C19.1157 6.20089 18.8969 5.38518 19.2651 4.74748ZM17.7443 17.7618C16.9225 17.87 16.1965 18.3552 15.782 19.073L15.1492 20.1694L21.7951 24.0066L22.4292 22.9102C22.8434 22.1925 22.901 21.3218 22.5841 20.5561L21.2365 17.3009L17.7443 17.7618ZM21.549 9.08472C21.135 9.80227 21.0773 10.6721 21.394 11.4376L22.7417 14.6928L26.2339 14.2319C27.0556 14.1236 27.7816 13.6396 28.1961 12.922L28.8289 11.8243L22.1831 7.98706L21.549 9.08472Z" fill="currentColor" data-v-0c679bcf></path>', 6)
  ])]);
}
const D0 = /* @__PURE__ */ ui(L0, [["render", I0], ["__scopeId", "data-v-0c679bcf"]]), M0 = {
  width: "48",
  height: "54",
  viewBox: "16 6 48 54",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, O0 = ["fill"], wl = "lc-high-frequency-teaser-watch-play-button-gradient", R0 = /* @__PURE__ */ _e({
  __name: "PlayButtonIcon",
  setup(e) {
    return (t, n) => ($(), j("svg", M0, [
      n[1] || (n[1] = ae("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        transform: "translate(2.4, 2.4)",
        fill: "var(--play-button-icon-shadow-color, #D3A700)"
      }, null, -1)),
      ae("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        fill: `url(#${wl})`
      }, null, 8, O0),
      ae("defs", null, [
        ae("radialGradient", {
          id: wl,
          cx: "0",
          cy: "0",
          r: "1",
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "translate(30.339 18.8727) rotate(103.105) scale(31.1141 42.8816)"
        }, [...n[0] || (n[0] = [
          ae("stop", { "stop-color": "var(--play-button-icon-color-start, #FFF5C9)" }, null, -1),
          ae("stop", {
            offset: "1",
            "stop-color": "var(--play-button-icon-color-end, #FBCD0C)"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), ea = {
  SPIN_DELAY: 50,
  PAUSE_DELAY: 2550,
  LABEL_DELAY: 3350,
  IDLE_DELAY: 13350,
  IDLE_SPIN_INTERVAL: 1e4
}, F0 = { class: "lc-high-frequency-teaser-watch__background-wrapper" }, N0 = { class: "lc-high-frequency-teaser-watch__header-wrapper" }, B0 = { class: "lc-high-frequency-teaser-watch__game-badge" }, P0 = { class: "lc-high-frequency-teaser-watch__game-label" }, z0 = { class: "lc-high-frequency-teaser-watch__game-number" }, V0 = { class: "lc-high-frequency-teaser-watch__game-icon" }, H0 = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__pause-icon"
}, U0 = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__icon-area"
}, q0 = { class: "lc-high-frequency-teaser-watch__timer-value" }, j0 = { class: "lc-high-frequency-teaser-watch__timer-unit" }, Z0 = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__new-game-label"
}, W0 = { class: "lc-high-frequency-teaser-watch__main" }, Y0 = { class: "lc-high-frequency-teaser-watch__title" }, xg = /* @__PURE__ */ _e({
  __name: "LcHighFrequencyTeaserWatch",
  props: {
    ballConfig: {},
    gameLabel: {},
    gameNumber: {},
    timerValueLabel: {},
    timerUnitLabel: {},
    isOperational: { type: Boolean, default: !0 },
    title: {},
    to: {}
  },
  setup(e) {
    const t = pe("idle"), n = pe(e.gameNumber), r = pe(!1), s = pe(0), i = W(() => e.to ? Yn(e.to) : "div"), a = W(() => String(n.value).split("")), o = W(() => t.value === "spinning"), l = W(() => t.value === "idle" || o.value), h = W(() => ({
      "lc-high-frequency-teaser-watch__timer-icon--spinning": o.value
    })), v = W(() => ({
      "lc-high-frequency-teaser-watch__timer-text--hidden": o.value
    })), c = W(() => ({
      "lc-high-frequency-teaser-watch__arrows--spinning": o.value,
      "lc-high-frequency-teaser-watch__arrows--idle-spin": s.value > 0 && t.value === "idle"
    })), f = W(() => ({
      "lc-high-frequency-teaser-watch__play-button--heartbeat": r.value
    })), { pause: m, resume: u } = Ks(
      () => {
        t.value === "idle" && e.isOperational && s.value++;
      },
      ea.IDLE_SPIN_INTERVAL,
      { immediate: e.isOperational }
    ), { start: p, stop: k } = ta(
      () => {
        t.value = "spinning";
      },
      ea.SPIN_DELAY,
      { immediate: !1 }
    ), { start: g, stop: b } = ta(
      () => t.value = "paused",
      ea.PAUSE_DELAY,
      { immediate: !1 }
    ), _ = pe(e.gameNumber), { start: E, stop: I } = ta(
      () => {
        t.value = "label", n.value = _.value, r.value = !1, requestAnimationFrame(() => {
          r.value = !0;
        });
      },
      ea.LABEL_DELAY,
      { immediate: !1 }
    ), { start: L, stop: C } = ta(
      () => {
        t.value = "idle", r.value = !1, u();
      },
      ea.IDLE_DELAY,
      { immediate: !1 }
    ), F = () => {
      k(), b(), I(), C();
    };
    return ze(
      () => e.isOperational,
      (V) => {
        V ? u() : (F(), m(), t.value = "idle", r.value = !1);
      }
    ), ze(
      () => e.gameNumber,
      (V, J) => {
        if (V === J || !e.isOperational) {
          n.value = V;
          return;
        }
        F(), m(), _.value = V, t.value = "idle", p(), g(), E(), L();
      }
    ), (V, J) => ($(), xe(Pt(i.value), _t(Dt({ to: e.to })), {
      default: Ee(() => [
        Oe(q(nr), {
          class: "lc-high-frequency-teaser-watch",
          "body-class": "lc-high-frequency-teaser-watch__body",
          "footer-class": "lc-high-frequency-teaser-watch__footer"
        }, {
          background: Ee(() => [
            ae("div", F0, [
              Oe(q(Uo), Te({
                class: "lc-high-frequency-teaser-watch__background",
                "gradient-class": "lc-high-frequency-teaser-watch__gradient"
              }, { ballConfig: e.ballConfig }), null, 16)
            ])
          ]),
          header: Ee(() => [
            ae("div", N0, [
              ae("div", B0, [
                ae("span", P0, Ie(e.gameLabel), 1),
                ae("span", z0, [
                  ($(!0), j(Ge, null, vt(a.value, (O, K) => ($(), j("span", {
                    key: `pos-${K}`,
                    class: "lc-high-frequency-teaser-watch__digit-slot"
                  }, [
                    Oe(Ns, { name: "lc-high-frequency-teaser-watch-digit" }, {
                      default: Ee(() => [
                        ($(), j("span", {
                          key: O,
                          class: "lc-high-frequency-teaser-watch__digit",
                          style: Ct({ transitionDelay: `${K * 35}ms` })
                        }, Ie(O), 5))
                      ]),
                      _: 2
                    }, 1024)
                  ]))), 128))
                ])
              ]),
              ae("div", V0, [
                Oe(wn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                  default: Ee(() => [
                    e.isOperational ? ue("", !0) : ($(), j("div", H0, [
                      Oe(D0)
                    ]))
                  ]),
                  _: 1
                }),
                e.isOperational ? ($(), j("div", U0, [
                  Oe(wn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                    default: Ee(() => [
                      l.value ? ($(), j("div", {
                        key: 0,
                        class: ye(["lc-high-frequency-teaser-watch__timer-icon", h.value])
                      }, [
                        ae("span", {
                          class: ye(["lc-high-frequency-teaser-watch__timer-text", v.value])
                        }, [
                          ae("span", q0, Ie(e.timerValueLabel), 1),
                          ae("span", j0, Ie(e.timerUnitLabel), 1)
                        ], 2),
                        ($(), j("div", {
                          key: `arrows-${s.value}`,
                          class: ye(["lc-high-frequency-teaser-watch__arrows", c.value])
                        }, [
                          Oe(A0)
                        ], 2))
                      ], 2)) : ue("", !0)
                    ]),
                    _: 1
                  }),
                  Oe(wn, { name: "lc-high-frequency-teaser-watch-label" }, {
                    default: Ee(() => [
                      t.value === "label" ? ($(), j("div", Z0, [
                        me(V.$slots, "new-game-label")
                      ])) : ue("", !0)
                    ]),
                    _: 3
                  })
                ])) : ue("", !0)
              ])
            ])
          ]),
          footer: Ee(() => [
            me(V.$slots, "message")
          ]),
          default: Ee(() => [
            ae("div", W0, [
              ae("div", {
                class: ye(["lc-high-frequency-teaser-watch__play-button", f.value])
              }, [
                Oe(R0)
              ], 2),
              ae("span", Y0, Ie(e.title), 1)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16));
  }
});
var Bn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", X0 = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Ia = 0; Ia < Bn.length; Ia++)
  X0[Bn.charCodeAt(Ia)] = Ia;
var G0 = function(e) {
  var t = new Uint8Array(e), n, r = t.length, s = "";
  for (n = 0; n < r; n += 3)
    s += Bn[t[n] >> 2], s += Bn[(t[n] & 3) << 4 | t[n + 1] >> 4], s += Bn[(t[n + 1] & 15) << 2 | t[n + 2] >> 6], s += Bn[t[n + 2] & 63];
  return r % 3 === 2 ? s = s.substring(0, s.length - 1) + "=" : r % 3 === 1 && (s = s.substring(0, s.length - 2) + "=="), s;
}, K0 = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "#", "$", "%", "*", "+", ",", "-", ".", ":", ";", "=", "?", "@", "[", "]", "^", "_", "{", "|", "}", "~"], aa = (e) => {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    let r = e[n], s = K0.indexOf(r);
    t = t * 83 + s;
  }
  return t;
}, xr = (e) => {
  let t = e / 255;
  return t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}, kr = (e) => {
  let t = Math.max(0, Math.min(1, e));
  return t <= 31308e-7 ? Math.trunc(t * 12.92 * 255 + 0.5) : Math.trunc((1.055 * Math.pow(t, 0.4166666666666667) - 0.055) * 255 + 0.5);
}, J0 = (e) => e < 0 ? -1 : 1, Sr = (e, t) => J0(e) * Math.pow(Math.abs(e), t), xl = class extends Error {
  constructor(t) {
    super(t), this.name = "ValidationError", this.message = t;
  }
}, Q0 = (e) => {
  if (!e || e.length < 6) throw new xl("The blurhash string must be at least 6 characters");
  let t = aa(e[0]), n = Math.floor(t / 9) + 1, r = t % 9 + 1;
  if (e.length !== 4 + 2 * r * n) throw new xl(`blurhash length mismatch: length is ${e.length} but it should be ${4 + 2 * r * n}`);
}, eh = (e) => {
  let t = e >> 16, n = e >> 8 & 255, r = e & 255;
  return [xr(t), xr(n), xr(r)];
}, th = (e, t) => {
  let n = Math.floor(e / 361), r = Math.floor(e / 19) % 19, s = e % 19;
  return [Sr((n - 9) / 9, 2) * t, Sr((r - 9) / 9, 2) * t, Sr((s - 9) / 9, 2) * t];
}, nh = (e, t, n, r) => {
  Q0(e), r = r | 1;
  let s = aa(e[0]), i = Math.floor(s / 9) + 1, a = s % 9 + 1, o = (aa(e[1]) + 1) / 166, l = new Array(a * i);
  for (let c = 0; c < l.length; c++) if (c === 0) {
    let f = aa(e.substring(2, 6));
    l[c] = eh(f);
  } else {
    let f = aa(e.substring(4 + c * 2, 6 + c * 2));
    l[c] = th(f, o * r);
  }
  let h = t * 4, v = new Uint8ClampedArray(h * n);
  for (let c = 0; c < n; c++) for (let f = 0; f < t; f++) {
    let m = 0, u = 0, p = 0;
    for (let _ = 0; _ < i; _++) for (let E = 0; E < a; E++) {
      let I = Math.cos(Math.PI * f * E / t) * Math.cos(Math.PI * c * _ / n), L = l[E + _ * a];
      m += L[0] * I, u += L[1] * I, p += L[2] * I;
    }
    let k = kr(m), g = kr(u), b = kr(p);
    v[4 * f + 0 + c * h] = k, v[4 * f + 1 + c * h] = g, v[4 * f + 2 + c * h] = b, v[4 * f + 3 + c * h] = 255;
  }
  return v;
}, ah = nh;
function rh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function ih(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var _r = { exports: {} }, Cr = {}, kl;
function cn() {
  return kl || (kl = 1, (function(e) {
    var t = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
    function n(i, a) {
      return Object.prototype.hasOwnProperty.call(i, a);
    }
    e.assign = function(i) {
      for (var a = Array.prototype.slice.call(arguments, 1); a.length; ) {
        var o = a.shift();
        if (o) {
          if (typeof o != "object")
            throw new TypeError(o + "must be non-object");
          for (var l in o)
            n(o, l) && (i[l] = o[l]);
        }
      }
      return i;
    }, e.shrinkBuf = function(i, a) {
      return i.length === a ? i : i.subarray ? i.subarray(0, a) : (i.length = a, i);
    };
    var r = {
      arraySet: function(i, a, o, l, h) {
        if (a.subarray && i.subarray) {
          i.set(a.subarray(o, o + l), h);
          return;
        }
        for (var v = 0; v < l; v++)
          i[h + v] = a[o + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        var a, o, l, h, v, c;
        for (l = 0, a = 0, o = i.length; a < o; a++)
          l += i[a].length;
        for (c = new Uint8Array(l), h = 0, a = 0, o = i.length; a < o; a++)
          v = i[a], c.set(v, h), h += v.length;
        return c;
      }
    }, s = {
      arraySet: function(i, a, o, l, h) {
        for (var v = 0; v < l; v++)
          i[h + v] = a[o + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        return [].concat.apply([], i);
      }
    };
    e.setTyped = function(i) {
      i ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, r)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, s));
    }, e.setTyped(t);
  })(Cr)), Cr;
}
var Rn = {}, Vt = {}, mn = {}, Sl;
function lh() {
  if (Sl) return mn;
  Sl = 1;
  var e = cn(), t = 4, n = 0, r = 1, s = 2;
  function i(w) {
    for (var G = w.length; --G >= 0; )
      w[G] = 0;
  }
  var a = 0, o = 1, l = 2, h = 3, v = 258, c = 29, f = 256, m = f + 1 + c, u = 30, p = 19, k = 2 * m + 1, g = 15, b = 16, _ = 7, E = 256, I = 16, L = 17, C = 18, F = (
    /* extra bits for each length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
  ), V = (
    /* extra bits for each distance code */
    [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
  ), J = (
    /* extra bits for each bit length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
  ), O = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], K = 512, P = new Array((m + 2) * 2);
  i(P);
  var T = new Array(u * 2);
  i(T);
  var A = new Array(K);
  i(A);
  var z = new Array(v - h + 1);
  i(z);
  var U = new Array(c);
  i(U);
  var X = new Array(u);
  i(X);
  function B(w, G, Y, se, R) {
    this.static_tree = w, this.extra_bits = G, this.extra_base = Y, this.elems = se, this.max_length = R, this.has_stree = w && w.length;
  }
  var ie, H, ee;
  function ce(w, G) {
    this.dyn_tree = w, this.max_code = 0, this.stat_desc = G;
  }
  function we(w) {
    return w < 256 ? A[w] : A[256 + (w >>> 7)];
  }
  function ke(w, G) {
    w.pending_buf[w.pending++] = G & 255, w.pending_buf[w.pending++] = G >>> 8 & 255;
  }
  function te(w, G, Y) {
    w.bi_valid > b - Y ? (w.bi_buf |= G << w.bi_valid & 65535, ke(w, w.bi_buf), w.bi_buf = G >> b - w.bi_valid, w.bi_valid += Y - b) : (w.bi_buf |= G << w.bi_valid & 65535, w.bi_valid += Y);
  }
  function he(w, G, Y) {
    te(
      w,
      Y[G * 2],
      Y[G * 2 + 1]
      /*.Len*/
    );
  }
  function ge(w, G) {
    var Y = 0;
    do
      Y |= w & 1, w >>>= 1, Y <<= 1;
    while (--G > 0);
    return Y >>> 1;
  }
  function be(w) {
    w.bi_valid === 16 ? (ke(w, w.bi_buf), w.bi_buf = 0, w.bi_valid = 0) : w.bi_valid >= 8 && (w.pending_buf[w.pending++] = w.bi_buf & 255, w.bi_buf >>= 8, w.bi_valid -= 8);
  }
  function Pe(w, G) {
    var Y = G.dyn_tree, se = G.max_code, R = G.stat_desc.static_tree, le = G.stat_desc.has_stree, y = G.stat_desc.extra_bits, fe = G.stat_desc.extra_base, $e = G.stat_desc.max_length, d, re, ne, x, N, Q, De = 0;
    for (x = 0; x <= g; x++)
      w.bl_count[x] = 0;
    for (Y[w.heap[w.heap_max] * 2 + 1] = 0, d = w.heap_max + 1; d < k; d++)
      re = w.heap[d], x = Y[Y[re * 2 + 1] * 2 + 1] + 1, x > $e && (x = $e, De++), Y[re * 2 + 1] = x, !(re > se) && (w.bl_count[x]++, N = 0, re >= fe && (N = y[re - fe]), Q = Y[re * 2], w.opt_len += Q * (x + N), le && (w.static_len += Q * (R[re * 2 + 1] + N)));
    if (De !== 0) {
      do {
        for (x = $e - 1; w.bl_count[x] === 0; )
          x--;
        w.bl_count[x]--, w.bl_count[x + 1] += 2, w.bl_count[$e]--, De -= 2;
      } while (De > 0);
      for (x = $e; x !== 0; x--)
        for (re = w.bl_count[x]; re !== 0; )
          ne = w.heap[--d], !(ne > se) && (Y[ne * 2 + 1] !== x && (w.opt_len += (x - Y[ne * 2 + 1]) * Y[ne * 2], Y[ne * 2 + 1] = x), re--);
    }
  }
  function Ne(w, G, Y) {
    var se = new Array(g + 1), R = 0, le, y;
    for (le = 1; le <= g; le++)
      se[le] = R = R + Y[le - 1] << 1;
    for (y = 0; y <= G; y++) {
      var fe = w[y * 2 + 1];
      fe !== 0 && (w[y * 2] = ge(se[fe]++, fe));
    }
  }
  function de() {
    var w, G, Y, se, R, le = new Array(g + 1);
    for (Y = 0, se = 0; se < c - 1; se++)
      for (U[se] = Y, w = 0; w < 1 << F[se]; w++)
        z[Y++] = se;
    for (z[Y - 1] = se, R = 0, se = 0; se < 16; se++)
      for (X[se] = R, w = 0; w < 1 << V[se]; w++)
        A[R++] = se;
    for (R >>= 7; se < u; se++)
      for (X[se] = R << 7, w = 0; w < 1 << V[se] - 7; w++)
        A[256 + R++] = se;
    for (G = 0; G <= g; G++)
      le[G] = 0;
    for (w = 0; w <= 143; )
      P[w * 2 + 1] = 8, w++, le[8]++;
    for (; w <= 255; )
      P[w * 2 + 1] = 9, w++, le[9]++;
    for (; w <= 279; )
      P[w * 2 + 1] = 7, w++, le[7]++;
    for (; w <= 287; )
      P[w * 2 + 1] = 8, w++, le[8]++;
    for (Ne(P, m + 1, le), w = 0; w < u; w++)
      T[w * 2 + 1] = 5, T[w * 2] = ge(w, 5);
    ie = new B(P, F, f + 1, m, g), H = new B(T, V, 0, u, g), ee = new B(new Array(0), J, 0, p, _);
  }
  function Re(w) {
    var G;
    for (G = 0; G < m; G++)
      w.dyn_ltree[G * 2] = 0;
    for (G = 0; G < u; G++)
      w.dyn_dtree[G * 2] = 0;
    for (G = 0; G < p; G++)
      w.bl_tree[G * 2] = 0;
    w.dyn_ltree[E * 2] = 1, w.opt_len = w.static_len = 0, w.last_lit = w.matches = 0;
  }
  function He(w) {
    w.bi_valid > 8 ? ke(w, w.bi_buf) : w.bi_valid > 0 && (w.pending_buf[w.pending++] = w.bi_buf), w.bi_buf = 0, w.bi_valid = 0;
  }
  function Ze(w, G, Y, se) {
    He(w), ke(w, Y), ke(w, ~Y), e.arraySet(w.pending_buf, w.window, G, Y, w.pending), w.pending += Y;
  }
  function We(w, G, Y, se) {
    var R = G * 2, le = Y * 2;
    return w[R] < w[le] || w[R] === w[le] && se[G] <= se[Y];
  }
  function Be(w, G, Y) {
    for (var se = w.heap[Y], R = Y << 1; R <= w.heap_len && (R < w.heap_len && We(G, w.heap[R + 1], w.heap[R], w.depth) && R++, !We(G, se, w.heap[R], w.depth)); )
      w.heap[Y] = w.heap[R], Y = R, R <<= 1;
    w.heap[Y] = se;
  }
  function Fe(w, G, Y) {
    var se, R, le = 0, y, fe;
    if (w.last_lit !== 0)
      do
        se = w.pending_buf[w.d_buf + le * 2] << 8 | w.pending_buf[w.d_buf + le * 2 + 1], R = w.pending_buf[w.l_buf + le], le++, se === 0 ? he(w, R, G) : (y = z[R], he(w, y + f + 1, G), fe = F[y], fe !== 0 && (R -= U[y], te(w, R, fe)), se--, y = we(se), he(w, y, Y), fe = V[y], fe !== 0 && (se -= X[y], te(w, se, fe)));
      while (le < w.last_lit);
    he(w, E, G);
  }
  function Xe(w, G) {
    var Y = G.dyn_tree, se = G.stat_desc.static_tree, R = G.stat_desc.has_stree, le = G.stat_desc.elems, y, fe, $e = -1, d;
    for (w.heap_len = 0, w.heap_max = k, y = 0; y < le; y++)
      Y[y * 2] !== 0 ? (w.heap[++w.heap_len] = $e = y, w.depth[y] = 0) : Y[y * 2 + 1] = 0;
    for (; w.heap_len < 2; )
      d = w.heap[++w.heap_len] = $e < 2 ? ++$e : 0, Y[d * 2] = 1, w.depth[d] = 0, w.opt_len--, R && (w.static_len -= se[d * 2 + 1]);
    for (G.max_code = $e, y = w.heap_len >> 1; y >= 1; y--)
      Be(w, Y, y);
    d = le;
    do
      y = w.heap[
        1
        /*SMALLEST*/
      ], w.heap[
        1
        /*SMALLEST*/
      ] = w.heap[w.heap_len--], Be(
        w,
        Y,
        1
        /*SMALLEST*/
      ), fe = w.heap[
        1
        /*SMALLEST*/
      ], w.heap[--w.heap_max] = y, w.heap[--w.heap_max] = fe, Y[d * 2] = Y[y * 2] + Y[fe * 2], w.depth[d] = (w.depth[y] >= w.depth[fe] ? w.depth[y] : w.depth[fe]) + 1, Y[y * 2 + 1] = Y[fe * 2 + 1] = d, w.heap[
        1
        /*SMALLEST*/
      ] = d++, Be(
        w,
        Y,
        1
        /*SMALLEST*/
      );
    while (w.heap_len >= 2);
    w.heap[--w.heap_max] = w.heap[
      1
      /*SMALLEST*/
    ], Pe(w, G), Ne(Y, $e, w.bl_count);
  }
  function ut(w, G, Y) {
    var se, R = -1, le, y = G[1], fe = 0, $e = 7, d = 4;
    for (y === 0 && ($e = 138, d = 3), G[(Y + 1) * 2 + 1] = 65535, se = 0; se <= Y; se++)
      le = y, y = G[(se + 1) * 2 + 1], !(++fe < $e && le === y) && (fe < d ? w.bl_tree[le * 2] += fe : le !== 0 ? (le !== R && w.bl_tree[le * 2]++, w.bl_tree[I * 2]++) : fe <= 10 ? w.bl_tree[L * 2]++ : w.bl_tree[C * 2]++, fe = 0, R = le, y === 0 ? ($e = 138, d = 3) : le === y ? ($e = 6, d = 3) : ($e = 7, d = 4));
  }
  function gt(w, G, Y) {
    var se, R = -1, le, y = G[1], fe = 0, $e = 7, d = 4;
    for (y === 0 && ($e = 138, d = 3), se = 0; se <= Y; se++)
      if (le = y, y = G[(se + 1) * 2 + 1], !(++fe < $e && le === y)) {
        if (fe < d)
          do
            he(w, le, w.bl_tree);
          while (--fe !== 0);
        else le !== 0 ? (le !== R && (he(w, le, w.bl_tree), fe--), he(w, I, w.bl_tree), te(w, fe - 3, 2)) : fe <= 10 ? (he(w, L, w.bl_tree), te(w, fe - 3, 3)) : (he(w, C, w.bl_tree), te(w, fe - 11, 7));
        fe = 0, R = le, y === 0 ? ($e = 138, d = 3) : le === y ? ($e = 6, d = 3) : ($e = 7, d = 4);
      }
  }
  function bt(w) {
    var G;
    for (ut(w, w.dyn_ltree, w.l_desc.max_code), ut(w, w.dyn_dtree, w.d_desc.max_code), Xe(w, w.bl_desc), G = p - 1; G >= 3 && w.bl_tree[O[G] * 2 + 1] === 0; G--)
      ;
    return w.opt_len += 3 * (G + 1) + 5 + 5 + 4, G;
  }
  function Ft(w, G, Y, se) {
    var R;
    for (te(w, G - 257, 5), te(w, Y - 1, 5), te(w, se - 4, 4), R = 0; R < se; R++)
      te(w, w.bl_tree[O[R] * 2 + 1], 3);
    gt(w, w.dyn_ltree, G - 1), gt(w, w.dyn_dtree, Y - 1);
  }
  function Ot(w) {
    var G = 4093624447, Y;
    for (Y = 0; Y <= 31; Y++, G >>>= 1)
      if (G & 1 && w.dyn_ltree[Y * 2] !== 0)
        return n;
    if (w.dyn_ltree[18] !== 0 || w.dyn_ltree[20] !== 0 || w.dyn_ltree[26] !== 0)
      return r;
    for (Y = 32; Y < f; Y++)
      if (w.dyn_ltree[Y * 2] !== 0)
        return r;
    return n;
  }
  var xt = !1;
  function qt(w) {
    xt || (de(), xt = !0), w.l_desc = new ce(w.dyn_ltree, ie), w.d_desc = new ce(w.dyn_dtree, H), w.bl_desc = new ce(w.bl_tree, ee), w.bi_buf = 0, w.bi_valid = 0, Re(w);
  }
  function $t(w, G, Y, se) {
    te(w, (a << 1) + (se ? 1 : 0), 3), Ze(w, G, Y);
  }
  function ct(w) {
    te(w, o << 1, 3), he(w, E, P), be(w);
  }
  function D(w, G, Y, se) {
    var R, le, y = 0;
    w.level > 0 ? (w.strm.data_type === s && (w.strm.data_type = Ot(w)), Xe(w, w.l_desc), Xe(w, w.d_desc), y = bt(w), R = w.opt_len + 3 + 7 >>> 3, le = w.static_len + 3 + 7 >>> 3, le <= R && (R = le)) : R = le = Y + 5, Y + 4 <= R && G !== -1 ? $t(w, G, Y, se) : w.strategy === t || le === R ? (te(w, (o << 1) + (se ? 1 : 0), 3), Fe(w, P, T)) : (te(w, (l << 1) + (se ? 1 : 0), 3), Ft(w, w.l_desc.max_code + 1, w.d_desc.max_code + 1, y + 1), Fe(w, w.dyn_ltree, w.dyn_dtree)), Re(w), se && He(w);
  }
  function S(w, G, Y) {
    return w.pending_buf[w.d_buf + w.last_lit * 2] = G >>> 8 & 255, w.pending_buf[w.d_buf + w.last_lit * 2 + 1] = G & 255, w.pending_buf[w.l_buf + w.last_lit] = Y & 255, w.last_lit++, G === 0 ? w.dyn_ltree[Y * 2]++ : (w.matches++, G--, w.dyn_ltree[(z[Y] + f + 1) * 2]++, w.dyn_dtree[we(G) * 2]++), w.last_lit === w.lit_bufsize - 1;
  }
  return mn._tr_init = qt, mn._tr_stored_block = $t, mn._tr_flush_block = D, mn._tr_tally = S, mn._tr_align = ct, mn;
}
var Er, _l;
function Xo() {
  if (_l) return Er;
  _l = 1;
  function e(t, n, r, s) {
    for (var i = t & 65535 | 0, a = t >>> 16 & 65535 | 0, o = 0; r !== 0; ) {
      o = r > 2e3 ? 2e3 : r, r -= o;
      do
        i = i + n[s++] | 0, a = a + i | 0;
      while (--o);
      i %= 65521, a %= 65521;
    }
    return i | a << 16 | 0;
  }
  return Er = e, Er;
}
var Tr, Cl;
function Go() {
  if (Cl) return Tr;
  Cl = 1;
  function e() {
    for (var r, s = [], i = 0; i < 256; i++) {
      r = i;
      for (var a = 0; a < 8; a++)
        r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
      s[i] = r;
    }
    return s;
  }
  var t = e();
  function n(r, s, i, a) {
    var o = t, l = a + i;
    r ^= -1;
    for (var h = a; h < l; h++)
      r = r >>> 8 ^ o[(r ^ s[h]) & 255];
    return r ^ -1;
  }
  return Tr = n, Tr;
}
var Ar, El;
function mi() {
  return El || (El = 1, Ar = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */
    1: "stream end",
    /* Z_STREAM_END      1  */
    0: "",
    /* Z_OK              0  */
    "-1": "file error",
    /* Z_ERRNO         (-1) */
    "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */
    "-3": "data error",
    /* Z_DATA_ERROR    (-3) */
    "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */
    "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */
    "-6": "incompatible version"
    /* Z_VERSION_ERROR (-6) */
  }), Ar;
}
var Tl;
function oh() {
  if (Tl) return Vt;
  Tl = 1;
  var e = cn(), t = lh(), n = Xo(), r = Go(), s = mi(), i = 0, a = 1, o = 3, l = 4, h = 5, v = 0, c = 1, f = -2, m = -3, u = -5, p = -1, k = 1, g = 2, b = 3, _ = 4, E = 0, I = 2, L = 8, C = 9, F = 15, V = 8, J = 29, O = 256, K = O + 1 + J, P = 30, T = 19, A = 2 * K + 1, z = 15, U = 3, X = 258, B = X + U + 1, ie = 32, H = 42, ee = 69, ce = 73, we = 91, ke = 103, te = 113, he = 666, ge = 1, be = 2, Pe = 3, Ne = 4, de = 3;
  function Re(d, re) {
    return d.msg = s[re], re;
  }
  function He(d) {
    return (d << 1) - (d > 4 ? 9 : 0);
  }
  function Ze(d) {
    for (var re = d.length; --re >= 0; )
      d[re] = 0;
  }
  function We(d) {
    var re = d.state, ne = re.pending;
    ne > d.avail_out && (ne = d.avail_out), ne !== 0 && (e.arraySet(d.output, re.pending_buf, re.pending_out, ne, d.next_out), d.next_out += ne, re.pending_out += ne, d.total_out += ne, d.avail_out -= ne, re.pending -= ne, re.pending === 0 && (re.pending_out = 0));
  }
  function Be(d, re) {
    t._tr_flush_block(d, d.block_start >= 0 ? d.block_start : -1, d.strstart - d.block_start, re), d.block_start = d.strstart, We(d.strm);
  }
  function Fe(d, re) {
    d.pending_buf[d.pending++] = re;
  }
  function Xe(d, re) {
    d.pending_buf[d.pending++] = re >>> 8 & 255, d.pending_buf[d.pending++] = re & 255;
  }
  function ut(d, re, ne, x) {
    var N = d.avail_in;
    return N > x && (N = x), N === 0 ? 0 : (d.avail_in -= N, e.arraySet(re, d.input, d.next_in, N, ne), d.state.wrap === 1 ? d.adler = n(d.adler, re, N, ne) : d.state.wrap === 2 && (d.adler = r(d.adler, re, N, ne)), d.next_in += N, d.total_in += N, N);
  }
  function gt(d, re) {
    var ne = d.max_chain_length, x = d.strstart, N, Q, De = d.prev_length, Se = d.nice_match, Ae = d.strstart > d.w_size - B ? d.strstart - (d.w_size - B) : 0, Ue = d.window, ft = d.w_mask, et = d.prev, qe = d.strstart + X, lt = Ue[x + De - 1], pt = Ue[x + De];
    d.prev_length >= d.good_match && (ne >>= 2), Se > d.lookahead && (Se = d.lookahead);
    do
      if (N = re, !(Ue[N + De] !== pt || Ue[N + De - 1] !== lt || Ue[N] !== Ue[x] || Ue[++N] !== Ue[x + 1])) {
        x += 2, N++;
        do
          ;
        while (Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && x < qe);
        if (Q = X - (qe - x), x = qe - X, Q > De) {
          if (d.match_start = re, De = Q, Q >= Se)
            break;
          lt = Ue[x + De - 1], pt = Ue[x + De];
        }
      }
    while ((re = et[re & ft]) > Ae && --ne !== 0);
    return De <= d.lookahead ? De : d.lookahead;
  }
  function bt(d) {
    var re = d.w_size, ne, x, N, Q, De;
    do {
      if (Q = d.window_size - d.lookahead - d.strstart, d.strstart >= re + (re - B)) {
        e.arraySet(d.window, d.window, re, re, 0), d.match_start -= re, d.strstart -= re, d.block_start -= re, x = d.hash_size, ne = x;
        do
          N = d.head[--ne], d.head[ne] = N >= re ? N - re : 0;
        while (--x);
        x = re, ne = x;
        do
          N = d.prev[--ne], d.prev[ne] = N >= re ? N - re : 0;
        while (--x);
        Q += re;
      }
      if (d.strm.avail_in === 0)
        break;
      if (x = ut(d.strm, d.window, d.strstart + d.lookahead, Q), d.lookahead += x, d.lookahead + d.insert >= U)
        for (De = d.strstart - d.insert, d.ins_h = d.window[De], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[De + 1]) & d.hash_mask; d.insert && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[De + U - 1]) & d.hash_mask, d.prev[De & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = De, De++, d.insert--, !(d.lookahead + d.insert < U)); )
          ;
    } while (d.lookahead < B && d.strm.avail_in !== 0);
  }
  function Ft(d, re) {
    var ne = 65535;
    for (ne > d.pending_buf_size - 5 && (ne = d.pending_buf_size - 5); ; ) {
      if (d.lookahead <= 1) {
        if (bt(d), d.lookahead === 0 && re === i)
          return ge;
        if (d.lookahead === 0)
          break;
      }
      d.strstart += d.lookahead, d.lookahead = 0;
      var x = d.block_start + ne;
      if ((d.strstart === 0 || d.strstart >= x) && (d.lookahead = d.strstart - x, d.strstart = x, Be(d, !1), d.strm.avail_out === 0) || d.strstart - d.block_start >= d.w_size - B && (Be(d, !1), d.strm.avail_out === 0))
        return ge;
    }
    return d.insert = 0, re === l ? (Be(d, !0), d.strm.avail_out === 0 ? Pe : Ne) : (d.strstart > d.block_start && (Be(d, !1), d.strm.avail_out === 0), ge);
  }
  function Ot(d, re) {
    for (var ne, x; ; ) {
      if (d.lookahead < B) {
        if (bt(d), d.lookahead < B && re === i)
          return ge;
        if (d.lookahead === 0)
          break;
      }
      if (ne = 0, d.lookahead >= U && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + U - 1]) & d.hash_mask, ne = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), ne !== 0 && d.strstart - ne <= d.w_size - B && (d.match_length = gt(d, ne)), d.match_length >= U)
        if (x = t._tr_tally(d, d.strstart - d.match_start, d.match_length - U), d.lookahead -= d.match_length, d.match_length <= d.max_lazy_match && d.lookahead >= U) {
          d.match_length--;
          do
            d.strstart++, d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + U - 1]) & d.hash_mask, ne = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart;
          while (--d.match_length !== 0);
          d.strstart++;
        } else
          d.strstart += d.match_length, d.match_length = 0, d.ins_h = d.window[d.strstart], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + 1]) & d.hash_mask;
      else
        x = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++;
      if (x && (Be(d, !1), d.strm.avail_out === 0))
        return ge;
    }
    return d.insert = d.strstart < U - 1 ? d.strstart : U - 1, re === l ? (Be(d, !0), d.strm.avail_out === 0 ? Pe : Ne) : d.last_lit && (Be(d, !1), d.strm.avail_out === 0) ? ge : be;
  }
  function xt(d, re) {
    for (var ne, x, N; ; ) {
      if (d.lookahead < B) {
        if (bt(d), d.lookahead < B && re === i)
          return ge;
        if (d.lookahead === 0)
          break;
      }
      if (ne = 0, d.lookahead >= U && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + U - 1]) & d.hash_mask, ne = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), d.prev_length = d.match_length, d.prev_match = d.match_start, d.match_length = U - 1, ne !== 0 && d.prev_length < d.max_lazy_match && d.strstart - ne <= d.w_size - B && (d.match_length = gt(d, ne), d.match_length <= 5 && (d.strategy === k || d.match_length === U && d.strstart - d.match_start > 4096) && (d.match_length = U - 1)), d.prev_length >= U && d.match_length <= d.prev_length) {
        N = d.strstart + d.lookahead - U, x = t._tr_tally(d, d.strstart - 1 - d.prev_match, d.prev_length - U), d.lookahead -= d.prev_length - 1, d.prev_length -= 2;
        do
          ++d.strstart <= N && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + U - 1]) & d.hash_mask, ne = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart);
        while (--d.prev_length !== 0);
        if (d.match_available = 0, d.match_length = U - 1, d.strstart++, x && (Be(d, !1), d.strm.avail_out === 0))
          return ge;
      } else if (d.match_available) {
        if (x = t._tr_tally(d, 0, d.window[d.strstart - 1]), x && Be(d, !1), d.strstart++, d.lookahead--, d.strm.avail_out === 0)
          return ge;
      } else
        d.match_available = 1, d.strstart++, d.lookahead--;
    }
    return d.match_available && (x = t._tr_tally(d, 0, d.window[d.strstart - 1]), d.match_available = 0), d.insert = d.strstart < U - 1 ? d.strstart : U - 1, re === l ? (Be(d, !0), d.strm.avail_out === 0 ? Pe : Ne) : d.last_lit && (Be(d, !1), d.strm.avail_out === 0) ? ge : be;
  }
  function qt(d, re) {
    for (var ne, x, N, Q, De = d.window; ; ) {
      if (d.lookahead <= X) {
        if (bt(d), d.lookahead <= X && re === i)
          return ge;
        if (d.lookahead === 0)
          break;
      }
      if (d.match_length = 0, d.lookahead >= U && d.strstart > 0 && (N = d.strstart - 1, x = De[N], x === De[++N] && x === De[++N] && x === De[++N])) {
        Q = d.strstart + X;
        do
          ;
        while (x === De[++N] && x === De[++N] && x === De[++N] && x === De[++N] && x === De[++N] && x === De[++N] && x === De[++N] && x === De[++N] && N < Q);
        d.match_length = X - (Q - N), d.match_length > d.lookahead && (d.match_length = d.lookahead);
      }
      if (d.match_length >= U ? (ne = t._tr_tally(d, 1, d.match_length - U), d.lookahead -= d.match_length, d.strstart += d.match_length, d.match_length = 0) : (ne = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++), ne && (Be(d, !1), d.strm.avail_out === 0))
        return ge;
    }
    return d.insert = 0, re === l ? (Be(d, !0), d.strm.avail_out === 0 ? Pe : Ne) : d.last_lit && (Be(d, !1), d.strm.avail_out === 0) ? ge : be;
  }
  function $t(d, re) {
    for (var ne; ; ) {
      if (d.lookahead === 0 && (bt(d), d.lookahead === 0)) {
        if (re === i)
          return ge;
        break;
      }
      if (d.match_length = 0, ne = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++, ne && (Be(d, !1), d.strm.avail_out === 0))
        return ge;
    }
    return d.insert = 0, re === l ? (Be(d, !0), d.strm.avail_out === 0 ? Pe : Ne) : d.last_lit && (Be(d, !1), d.strm.avail_out === 0) ? ge : be;
  }
  function ct(d, re, ne, x, N) {
    this.good_length = d, this.max_lazy = re, this.nice_length = ne, this.max_chain = x, this.func = N;
  }
  var D;
  D = [
    /*      good lazy nice chain */
    new ct(0, 0, 0, 0, Ft),
    /* 0 store only */
    new ct(4, 4, 8, 4, Ot),
    /* 1 max speed, no lazy matches */
    new ct(4, 5, 16, 8, Ot),
    /* 2 */
    new ct(4, 6, 32, 32, Ot),
    /* 3 */
    new ct(4, 4, 16, 16, xt),
    /* 4 lazy matches */
    new ct(8, 16, 32, 32, xt),
    /* 5 */
    new ct(8, 16, 128, 128, xt),
    /* 6 */
    new ct(8, 32, 128, 256, xt),
    /* 7 */
    new ct(32, 128, 258, 1024, xt),
    /* 8 */
    new ct(32, 258, 258, 4096, xt)
    /* 9 max compression */
  ];
  function S(d) {
    d.window_size = 2 * d.w_size, Ze(d.head), d.max_lazy_match = D[d.level].max_lazy, d.good_match = D[d.level].good_length, d.nice_match = D[d.level].nice_length, d.max_chain_length = D[d.level].max_chain, d.strstart = 0, d.block_start = 0, d.lookahead = 0, d.insert = 0, d.match_length = d.prev_length = U - 1, d.match_available = 0, d.ins_h = 0;
  }
  function w() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = L, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new e.Buf16(A * 2), this.dyn_dtree = new e.Buf16((2 * P + 1) * 2), this.bl_tree = new e.Buf16((2 * T + 1) * 2), Ze(this.dyn_ltree), Ze(this.dyn_dtree), Ze(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new e.Buf16(z + 1), this.heap = new e.Buf16(2 * K + 1), Ze(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new e.Buf16(2 * K + 1), Ze(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  function G(d) {
    var re;
    return !d || !d.state ? Re(d, f) : (d.total_in = d.total_out = 0, d.data_type = I, re = d.state, re.pending = 0, re.pending_out = 0, re.wrap < 0 && (re.wrap = -re.wrap), re.status = re.wrap ? H : te, d.adler = re.wrap === 2 ? 0 : 1, re.last_flush = i, t._tr_init(re), v);
  }
  function Y(d) {
    var re = G(d);
    return re === v && S(d.state), re;
  }
  function se(d, re) {
    return !d || !d.state || d.state.wrap !== 2 ? f : (d.state.gzhead = re, v);
  }
  function R(d, re, ne, x, N, Q) {
    if (!d)
      return f;
    var De = 1;
    if (re === p && (re = 6), x < 0 ? (De = 0, x = -x) : x > 15 && (De = 2, x -= 16), N < 1 || N > C || ne !== L || x < 8 || x > 15 || re < 0 || re > 9 || Q < 0 || Q > _)
      return Re(d, f);
    x === 8 && (x = 9);
    var Se = new w();
    return d.state = Se, Se.strm = d, Se.wrap = De, Se.gzhead = null, Se.w_bits = x, Se.w_size = 1 << Se.w_bits, Se.w_mask = Se.w_size - 1, Se.hash_bits = N + 7, Se.hash_size = 1 << Se.hash_bits, Se.hash_mask = Se.hash_size - 1, Se.hash_shift = ~~((Se.hash_bits + U - 1) / U), Se.window = new e.Buf8(Se.w_size * 2), Se.head = new e.Buf16(Se.hash_size), Se.prev = new e.Buf16(Se.w_size), Se.lit_bufsize = 1 << N + 6, Se.pending_buf_size = Se.lit_bufsize * 4, Se.pending_buf = new e.Buf8(Se.pending_buf_size), Se.d_buf = 1 * Se.lit_bufsize, Se.l_buf = 3 * Se.lit_bufsize, Se.level = re, Se.strategy = Q, Se.method = ne, Y(d);
  }
  function le(d, re) {
    return R(d, re, L, F, V, E);
  }
  function y(d, re) {
    var ne, x, N, Q;
    if (!d || !d.state || re > h || re < 0)
      return d ? Re(d, f) : f;
    if (x = d.state, !d.output || !d.input && d.avail_in !== 0 || x.status === he && re !== l)
      return Re(d, d.avail_out === 0 ? u : f);
    if (x.strm = d, ne = x.last_flush, x.last_flush = re, x.status === H)
      if (x.wrap === 2)
        d.adler = 0, Fe(x, 31), Fe(x, 139), Fe(x, 8), x.gzhead ? (Fe(
          x,
          (x.gzhead.text ? 1 : 0) + (x.gzhead.hcrc ? 2 : 0) + (x.gzhead.extra ? 4 : 0) + (x.gzhead.name ? 8 : 0) + (x.gzhead.comment ? 16 : 0)
        ), Fe(x, x.gzhead.time & 255), Fe(x, x.gzhead.time >> 8 & 255), Fe(x, x.gzhead.time >> 16 & 255), Fe(x, x.gzhead.time >> 24 & 255), Fe(x, x.level === 9 ? 2 : x.strategy >= g || x.level < 2 ? 4 : 0), Fe(x, x.gzhead.os & 255), x.gzhead.extra && x.gzhead.extra.length && (Fe(x, x.gzhead.extra.length & 255), Fe(x, x.gzhead.extra.length >> 8 & 255)), x.gzhead.hcrc && (d.adler = r(d.adler, x.pending_buf, x.pending, 0)), x.gzindex = 0, x.status = ee) : (Fe(x, 0), Fe(x, 0), Fe(x, 0), Fe(x, 0), Fe(x, 0), Fe(x, x.level === 9 ? 2 : x.strategy >= g || x.level < 2 ? 4 : 0), Fe(x, de), x.status = te);
      else {
        var De = L + (x.w_bits - 8 << 4) << 8, Se = -1;
        x.strategy >= g || x.level < 2 ? Se = 0 : x.level < 6 ? Se = 1 : x.level === 6 ? Se = 2 : Se = 3, De |= Se << 6, x.strstart !== 0 && (De |= ie), De += 31 - De % 31, x.status = te, Xe(x, De), x.strstart !== 0 && (Xe(x, d.adler >>> 16), Xe(x, d.adler & 65535)), d.adler = 1;
      }
    if (x.status === ee)
      if (x.gzhead.extra) {
        for (N = x.pending; x.gzindex < (x.gzhead.extra.length & 65535) && !(x.pending === x.pending_buf_size && (x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), We(d), N = x.pending, x.pending === x.pending_buf_size)); )
          Fe(x, x.gzhead.extra[x.gzindex] & 255), x.gzindex++;
        x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), x.gzindex === x.gzhead.extra.length && (x.gzindex = 0, x.status = ce);
      } else
        x.status = ce;
    if (x.status === ce)
      if (x.gzhead.name) {
        N = x.pending;
        do {
          if (x.pending === x.pending_buf_size && (x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), We(d), N = x.pending, x.pending === x.pending_buf_size)) {
            Q = 1;
            break;
          }
          x.gzindex < x.gzhead.name.length ? Q = x.gzhead.name.charCodeAt(x.gzindex++) & 255 : Q = 0, Fe(x, Q);
        } while (Q !== 0);
        x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), Q === 0 && (x.gzindex = 0, x.status = we);
      } else
        x.status = we;
    if (x.status === we)
      if (x.gzhead.comment) {
        N = x.pending;
        do {
          if (x.pending === x.pending_buf_size && (x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), We(d), N = x.pending, x.pending === x.pending_buf_size)) {
            Q = 1;
            break;
          }
          x.gzindex < x.gzhead.comment.length ? Q = x.gzhead.comment.charCodeAt(x.gzindex++) & 255 : Q = 0, Fe(x, Q);
        } while (Q !== 0);
        x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), Q === 0 && (x.status = ke);
      } else
        x.status = ke;
    if (x.status === ke && (x.gzhead.hcrc ? (x.pending + 2 > x.pending_buf_size && We(d), x.pending + 2 <= x.pending_buf_size && (Fe(x, d.adler & 255), Fe(x, d.adler >> 8 & 255), d.adler = 0, x.status = te)) : x.status = te), x.pending !== 0) {
      if (We(d), d.avail_out === 0)
        return x.last_flush = -1, v;
    } else if (d.avail_in === 0 && He(re) <= He(ne) && re !== l)
      return Re(d, u);
    if (x.status === he && d.avail_in !== 0)
      return Re(d, u);
    if (d.avail_in !== 0 || x.lookahead !== 0 || re !== i && x.status !== he) {
      var Ae = x.strategy === g ? $t(x, re) : x.strategy === b ? qt(x, re) : D[x.level].func(x, re);
      if ((Ae === Pe || Ae === Ne) && (x.status = he), Ae === ge || Ae === Pe)
        return d.avail_out === 0 && (x.last_flush = -1), v;
      if (Ae === be && (re === a ? t._tr_align(x) : re !== h && (t._tr_stored_block(x, 0, 0, !1), re === o && (Ze(x.head), x.lookahead === 0 && (x.strstart = 0, x.block_start = 0, x.insert = 0))), We(d), d.avail_out === 0))
        return x.last_flush = -1, v;
    }
    return re !== l ? v : x.wrap <= 0 ? c : (x.wrap === 2 ? (Fe(x, d.adler & 255), Fe(x, d.adler >> 8 & 255), Fe(x, d.adler >> 16 & 255), Fe(x, d.adler >> 24 & 255), Fe(x, d.total_in & 255), Fe(x, d.total_in >> 8 & 255), Fe(x, d.total_in >> 16 & 255), Fe(x, d.total_in >> 24 & 255)) : (Xe(x, d.adler >>> 16), Xe(x, d.adler & 65535)), We(d), x.wrap > 0 && (x.wrap = -x.wrap), x.pending !== 0 ? v : c);
  }
  function fe(d) {
    var re;
    return !d || !d.state ? f : (re = d.state.status, re !== H && re !== ee && re !== ce && re !== we && re !== ke && re !== te && re !== he ? Re(d, f) : (d.state = null, re === te ? Re(d, m) : v));
  }
  function $e(d, re) {
    var ne = re.length, x, N, Q, De, Se, Ae, Ue, ft;
    if (!d || !d.state || (x = d.state, De = x.wrap, De === 2 || De === 1 && x.status !== H || x.lookahead))
      return f;
    for (De === 1 && (d.adler = n(d.adler, re, ne, 0)), x.wrap = 0, ne >= x.w_size && (De === 0 && (Ze(x.head), x.strstart = 0, x.block_start = 0, x.insert = 0), ft = new e.Buf8(x.w_size), e.arraySet(ft, re, ne - x.w_size, x.w_size, 0), re = ft, ne = x.w_size), Se = d.avail_in, Ae = d.next_in, Ue = d.input, d.avail_in = ne, d.next_in = 0, d.input = re, bt(x); x.lookahead >= U; ) {
      N = x.strstart, Q = x.lookahead - (U - 1);
      do
        x.ins_h = (x.ins_h << x.hash_shift ^ x.window[N + U - 1]) & x.hash_mask, x.prev[N & x.w_mask] = x.head[x.ins_h], x.head[x.ins_h] = N, N++;
      while (--Q);
      x.strstart = N, x.lookahead = U - 1, bt(x);
    }
    return x.strstart += x.lookahead, x.block_start = x.strstart, x.insert = x.lookahead, x.lookahead = 0, x.match_length = x.prev_length = U - 1, x.match_available = 0, d.next_in = Ae, d.input = Ue, d.avail_in = Se, x.wrap = De, v;
  }
  return Vt.deflateInit = le, Vt.deflateInit2 = R, Vt.deflateReset = Y, Vt.deflateResetKeep = G, Vt.deflateSetHeader = se, Vt.deflate = y, Vt.deflateEnd = fe, Vt.deflateSetDictionary = $e, Vt.deflateInfo = "pako deflate (from Nodeca project)", Vt;
}
var gn = {}, Al;
function Ko() {
  if (Al) return gn;
  Al = 1;
  var e = cn(), t = !0, n = !0;
  try {
    String.fromCharCode.apply(null, [0]);
  } catch {
    t = !1;
  }
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch {
    n = !1;
  }
  for (var r = new e.Buf8(256), s = 0; s < 256; s++)
    r[s] = s >= 252 ? 6 : s >= 248 ? 5 : s >= 240 ? 4 : s >= 224 ? 3 : s >= 192 ? 2 : 1;
  r[254] = r[254] = 1, gn.string2buf = function(a) {
    var o, l, h, v, c, f = a.length, m = 0;
    for (v = 0; v < f; v++)
      l = a.charCodeAt(v), (l & 64512) === 55296 && v + 1 < f && (h = a.charCodeAt(v + 1), (h & 64512) === 56320 && (l = 65536 + (l - 55296 << 10) + (h - 56320), v++)), m += l < 128 ? 1 : l < 2048 ? 2 : l < 65536 ? 3 : 4;
    for (o = new e.Buf8(m), c = 0, v = 0; c < m; v++)
      l = a.charCodeAt(v), (l & 64512) === 55296 && v + 1 < f && (h = a.charCodeAt(v + 1), (h & 64512) === 56320 && (l = 65536 + (l - 55296 << 10) + (h - 56320), v++)), l < 128 ? o[c++] = l : l < 2048 ? (o[c++] = 192 | l >>> 6, o[c++] = 128 | l & 63) : l < 65536 ? (o[c++] = 224 | l >>> 12, o[c++] = 128 | l >>> 6 & 63, o[c++] = 128 | l & 63) : (o[c++] = 240 | l >>> 18, o[c++] = 128 | l >>> 12 & 63, o[c++] = 128 | l >>> 6 & 63, o[c++] = 128 | l & 63);
    return o;
  };
  function i(a, o) {
    if (o < 65534 && (a.subarray && n || !a.subarray && t))
      return String.fromCharCode.apply(null, e.shrinkBuf(a, o));
    for (var l = "", h = 0; h < o; h++)
      l += String.fromCharCode(a[h]);
    return l;
  }
  return gn.buf2binstring = function(a) {
    return i(a, a.length);
  }, gn.binstring2buf = function(a) {
    for (var o = new e.Buf8(a.length), l = 0, h = o.length; l < h; l++)
      o[l] = a.charCodeAt(l);
    return o;
  }, gn.buf2string = function(a, o) {
    var l, h, v, c, f = o || a.length, m = new Array(f * 2);
    for (h = 0, l = 0; l < f; ) {
      if (v = a[l++], v < 128) {
        m[h++] = v;
        continue;
      }
      if (c = r[v], c > 4) {
        m[h++] = 65533, l += c - 1;
        continue;
      }
      for (v &= c === 2 ? 31 : c === 3 ? 15 : 7; c > 1 && l < f; )
        v = v << 6 | a[l++] & 63, c--;
      if (c > 1) {
        m[h++] = 65533;
        continue;
      }
      v < 65536 ? m[h++] = v : (v -= 65536, m[h++] = 55296 | v >> 10 & 1023, m[h++] = 56320 | v & 1023);
    }
    return i(m, h);
  }, gn.utf8border = function(a, o) {
    var l;
    for (o = o || a.length, o > a.length && (o = a.length), l = o - 1; l >= 0 && (a[l] & 192) === 128; )
      l--;
    return l < 0 || l === 0 ? o : l + r[a[l]] > o ? l : o;
  }, gn;
}
var Lr, Ll;
function Jo() {
  if (Ll) return Lr;
  Ll = 1;
  function e() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  }
  return Lr = e, Lr;
}
var $l;
function sh() {
  if ($l) return Rn;
  $l = 1;
  var e = oh(), t = cn(), n = Ko(), r = mi(), s = Jo(), i = Object.prototype.toString, a = 0, o = 4, l = 0, h = 1, v = 2, c = -1, f = 0, m = 8;
  function u(b) {
    if (!(this instanceof u)) return new u(b);
    this.options = t.assign({
      level: c,
      method: m,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: f,
      to: ""
    }, b || {});
    var _ = this.options;
    _.raw && _.windowBits > 0 ? _.windowBits = -_.windowBits : _.gzip && _.windowBits > 0 && _.windowBits < 16 && (_.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s(), this.strm.avail_out = 0;
    var E = e.deflateInit2(
      this.strm,
      _.level,
      _.method,
      _.windowBits,
      _.memLevel,
      _.strategy
    );
    if (E !== l)
      throw new Error(r[E]);
    if (_.header && e.deflateSetHeader(this.strm, _.header), _.dictionary) {
      var I;
      if (typeof _.dictionary == "string" ? I = n.string2buf(_.dictionary) : i.call(_.dictionary) === "[object ArrayBuffer]" ? I = new Uint8Array(_.dictionary) : I = _.dictionary, E = e.deflateSetDictionary(this.strm, I), E !== l)
        throw new Error(r[E]);
      this._dict_set = !0;
    }
  }
  u.prototype.push = function(b, _) {
    var E = this.strm, I = this.options.chunkSize, L, C;
    if (this.ended)
      return !1;
    C = _ === ~~_ ? _ : _ === !0 ? o : a, typeof b == "string" ? E.input = n.string2buf(b) : i.call(b) === "[object ArrayBuffer]" ? E.input = new Uint8Array(b) : E.input = b, E.next_in = 0, E.avail_in = E.input.length;
    do {
      if (E.avail_out === 0 && (E.output = new t.Buf8(I), E.next_out = 0, E.avail_out = I), L = e.deflate(E, C), L !== h && L !== l)
        return this.onEnd(L), this.ended = !0, !1;
      (E.avail_out === 0 || E.avail_in === 0 && (C === o || C === v)) && (this.options.to === "string" ? this.onData(n.buf2binstring(t.shrinkBuf(E.output, E.next_out))) : this.onData(t.shrinkBuf(E.output, E.next_out)));
    } while ((E.avail_in > 0 || E.avail_out === 0) && L !== h);
    return C === o ? (L = e.deflateEnd(this.strm), this.onEnd(L), this.ended = !0, L === l) : (C === v && (this.onEnd(l), E.avail_out = 0), !0);
  }, u.prototype.onData = function(b) {
    this.chunks.push(b);
  }, u.prototype.onEnd = function(b) {
    b === l && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = b, this.msg = this.strm.msg;
  };
  function p(b, _) {
    var E = new u(_);
    if (E.push(b, !0), E.err)
      throw E.msg || r[E.err];
    return E.result;
  }
  function k(b, _) {
    return _ = _ || {}, _.raw = !0, p(b, _);
  }
  function g(b, _) {
    return _ = _ || {}, _.gzip = !0, p(b, _);
  }
  return Rn.Deflate = u, Rn.deflate = p, Rn.deflateRaw = k, Rn.gzip = g, Rn;
}
var Fn = {}, Bt = {}, $r, Il;
function uh() {
  if (Il) return $r;
  Il = 1;
  var e = 30, t = 12;
  return $r = function(r, s) {
    var i, a, o, l, h, v, c, f, m, u, p, k, g, b, _, E, I, L, C, F, V, J, O, K, P;
    i = r.state, a = r.next_in, K = r.input, o = a + (r.avail_in - 5), l = r.next_out, P = r.output, h = l - (s - r.avail_out), v = l + (r.avail_out - 257), c = i.dmax, f = i.wsize, m = i.whave, u = i.wnext, p = i.window, k = i.hold, g = i.bits, b = i.lencode, _ = i.distcode, E = (1 << i.lenbits) - 1, I = (1 << i.distbits) - 1;
    e:
      do {
        g < 15 && (k += K[a++] << g, g += 8, k += K[a++] << g, g += 8), L = b[k & E];
        t:
          for (; ; ) {
            if (C = L >>> 24, k >>>= C, g -= C, C = L >>> 16 & 255, C === 0)
              P[l++] = L & 65535;
            else if (C & 16) {
              F = L & 65535, C &= 15, C && (g < C && (k += K[a++] << g, g += 8), F += k & (1 << C) - 1, k >>>= C, g -= C), g < 15 && (k += K[a++] << g, g += 8, k += K[a++] << g, g += 8), L = _[k & I];
              n:
                for (; ; ) {
                  if (C = L >>> 24, k >>>= C, g -= C, C = L >>> 16 & 255, C & 16) {
                    if (V = L & 65535, C &= 15, g < C && (k += K[a++] << g, g += 8, g < C && (k += K[a++] << g, g += 8)), V += k & (1 << C) - 1, V > c) {
                      r.msg = "invalid distance too far back", i.mode = e;
                      break e;
                    }
                    if (k >>>= C, g -= C, C = l - h, V > C) {
                      if (C = V - C, C > m && i.sane) {
                        r.msg = "invalid distance too far back", i.mode = e;
                        break e;
                      }
                      if (J = 0, O = p, u === 0) {
                        if (J += f - C, C < F) {
                          F -= C;
                          do
                            P[l++] = p[J++];
                          while (--C);
                          J = l - V, O = P;
                        }
                      } else if (u < C) {
                        if (J += f + u - C, C -= u, C < F) {
                          F -= C;
                          do
                            P[l++] = p[J++];
                          while (--C);
                          if (J = 0, u < F) {
                            C = u, F -= C;
                            do
                              P[l++] = p[J++];
                            while (--C);
                            J = l - V, O = P;
                          }
                        }
                      } else if (J += u - C, C < F) {
                        F -= C;
                        do
                          P[l++] = p[J++];
                        while (--C);
                        J = l - V, O = P;
                      }
                      for (; F > 2; )
                        P[l++] = O[J++], P[l++] = O[J++], P[l++] = O[J++], F -= 3;
                      F && (P[l++] = O[J++], F > 1 && (P[l++] = O[J++]));
                    } else {
                      J = l - V;
                      do
                        P[l++] = P[J++], P[l++] = P[J++], P[l++] = P[J++], F -= 3;
                      while (F > 2);
                      F && (P[l++] = P[J++], F > 1 && (P[l++] = P[J++]));
                    }
                  } else if ((C & 64) === 0) {
                    L = _[(L & 65535) + (k & (1 << C) - 1)];
                    continue n;
                  } else {
                    r.msg = "invalid distance code", i.mode = e;
                    break e;
                  }
                  break;
                }
            } else if ((C & 64) === 0) {
              L = b[(L & 65535) + (k & (1 << C) - 1)];
              continue t;
            } else if (C & 32) {
              i.mode = t;
              break e;
            } else {
              r.msg = "invalid literal/length code", i.mode = e;
              break e;
            }
            break;
          }
      } while (a < o && l < v);
    F = g >> 3, a -= F, g -= F << 3, k &= (1 << g) - 1, r.next_in = a, r.next_out = l, r.avail_in = a < o ? 5 + (o - a) : 5 - (a - o), r.avail_out = l < v ? 257 + (v - l) : 257 - (l - v), i.hold = k, i.bits = g;
  }, $r;
}
var Ir, Dl;
function ch() {
  if (Dl) return Ir;
  Dl = 1;
  var e = cn(), t = 15, n = 852, r = 592, s = 0, i = 1, a = 2, o = [
    /* Length codes 257..285 base */
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
  ], l = [
    /* Length codes 257..285 extra */
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
  ], h = [
    /* Distance codes 0..29 base */
    1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
  ], v = [
    /* Distance codes 0..29 extra */
    16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
  ];
  return Ir = function(f, m, u, p, k, g, b, _) {
    var E = _.bits, I = 0, L = 0, C = 0, F = 0, V = 0, J = 0, O = 0, K = 0, P = 0, T = 0, A, z, U, X, B, ie = null, H = 0, ee, ce = new e.Buf16(t + 1), we = new e.Buf16(t + 1), ke = null, te = 0, he, ge, be;
    for (I = 0; I <= t; I++)
      ce[I] = 0;
    for (L = 0; L < p; L++)
      ce[m[u + L]]++;
    for (V = E, F = t; F >= 1 && ce[F] === 0; F--)
      ;
    if (V > F && (V = F), F === 0)
      return k[g++] = 1 << 24 | 64 << 16 | 0, k[g++] = 1 << 24 | 64 << 16 | 0, _.bits = 1, 0;
    for (C = 1; C < F && ce[C] === 0; C++)
      ;
    for (V < C && (V = C), K = 1, I = 1; I <= t; I++)
      if (K <<= 1, K -= ce[I], K < 0)
        return -1;
    if (K > 0 && (f === s || F !== 1))
      return -1;
    for (we[1] = 0, I = 1; I < t; I++)
      we[I + 1] = we[I] + ce[I];
    for (L = 0; L < p; L++)
      m[u + L] !== 0 && (b[we[m[u + L]]++] = L);
    if (f === s ? (ie = ke = b, ee = 19) : f === i ? (ie = o, H -= 257, ke = l, te -= 257, ee = 256) : (ie = h, ke = v, ee = -1), T = 0, L = 0, I = C, B = g, J = V, O = 0, U = -1, P = 1 << V, X = P - 1, f === i && P > n || f === a && P > r)
      return 1;
    for (; ; ) {
      he = I - O, b[L] < ee ? (ge = 0, be = b[L]) : b[L] > ee ? (ge = ke[te + b[L]], be = ie[H + b[L]]) : (ge = 96, be = 0), A = 1 << I - O, z = 1 << J, C = z;
      do
        z -= A, k[B + (T >> O) + z] = he << 24 | ge << 16 | be | 0;
      while (z !== 0);
      for (A = 1 << I - 1; T & A; )
        A >>= 1;
      if (A !== 0 ? (T &= A - 1, T += A) : T = 0, L++, --ce[I] === 0) {
        if (I === F)
          break;
        I = m[u + b[L]];
      }
      if (I > V && (T & X) !== U) {
        for (O === 0 && (O = V), B += C, J = I - O, K = 1 << J; J + O < F && (K -= ce[J + O], !(K <= 0)); )
          J++, K <<= 1;
        if (P += 1 << J, f === i && P > n || f === a && P > r)
          return 1;
        U = T & X, k[U] = V << 24 | J << 16 | B - g | 0;
      }
    }
    return T !== 0 && (k[B + T] = I - O << 24 | 64 << 16 | 0), _.bits = V, 0;
  }, Ir;
}
var Ml;
function dh() {
  if (Ml) return Bt;
  Ml = 1;
  var e = cn(), t = Xo(), n = Go(), r = uh(), s = ch(), i = 0, a = 1, o = 2, l = 4, h = 5, v = 6, c = 0, f = 1, m = 2, u = -2, p = -3, k = -4, g = -5, b = 8, _ = 1, E = 2, I = 3, L = 4, C = 5, F = 6, V = 7, J = 8, O = 9, K = 10, P = 11, T = 12, A = 13, z = 14, U = 15, X = 16, B = 17, ie = 18, H = 19, ee = 20, ce = 21, we = 22, ke = 23, te = 24, he = 25, ge = 26, be = 27, Pe = 28, Ne = 29, de = 30, Re = 31, He = 32, Ze = 852, We = 592, Be = 15, Fe = Be;
  function Xe(R) {
    return (R >>> 24 & 255) + (R >>> 8 & 65280) + ((R & 65280) << 8) + ((R & 255) << 24);
  }
  function ut() {
    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new e.Buf16(320), this.work = new e.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  function gt(R) {
    var le;
    return !R || !R.state ? u : (le = R.state, R.total_in = R.total_out = le.total = 0, R.msg = "", le.wrap && (R.adler = le.wrap & 1), le.mode = _, le.last = 0, le.havedict = 0, le.dmax = 32768, le.head = null, le.hold = 0, le.bits = 0, le.lencode = le.lendyn = new e.Buf32(Ze), le.distcode = le.distdyn = new e.Buf32(We), le.sane = 1, le.back = -1, c);
  }
  function bt(R) {
    var le;
    return !R || !R.state ? u : (le = R.state, le.wsize = 0, le.whave = 0, le.wnext = 0, gt(R));
  }
  function Ft(R, le) {
    var y, fe;
    return !R || !R.state || (fe = R.state, le < 0 ? (y = 0, le = -le) : (y = (le >> 4) + 1, le < 48 && (le &= 15)), le && (le < 8 || le > 15)) ? u : (fe.window !== null && fe.wbits !== le && (fe.window = null), fe.wrap = y, fe.wbits = le, bt(R));
  }
  function Ot(R, le) {
    var y, fe;
    return R ? (fe = new ut(), R.state = fe, fe.window = null, y = Ft(R, le), y !== c && (R.state = null), y) : u;
  }
  function xt(R) {
    return Ot(R, Fe);
  }
  var qt = !0, $t, ct;
  function D(R) {
    if (qt) {
      var le;
      for ($t = new e.Buf32(512), ct = new e.Buf32(32), le = 0; le < 144; )
        R.lens[le++] = 8;
      for (; le < 256; )
        R.lens[le++] = 9;
      for (; le < 280; )
        R.lens[le++] = 7;
      for (; le < 288; )
        R.lens[le++] = 8;
      for (s(a, R.lens, 0, 288, $t, 0, R.work, { bits: 9 }), le = 0; le < 32; )
        R.lens[le++] = 5;
      s(o, R.lens, 0, 32, ct, 0, R.work, { bits: 5 }), qt = !1;
    }
    R.lencode = $t, R.lenbits = 9, R.distcode = ct, R.distbits = 5;
  }
  function S(R, le, y, fe) {
    var $e, d = R.state;
    return d.window === null && (d.wsize = 1 << d.wbits, d.wnext = 0, d.whave = 0, d.window = new e.Buf8(d.wsize)), fe >= d.wsize ? (e.arraySet(d.window, le, y - d.wsize, d.wsize, 0), d.wnext = 0, d.whave = d.wsize) : ($e = d.wsize - d.wnext, $e > fe && ($e = fe), e.arraySet(d.window, le, y - fe, $e, d.wnext), fe -= $e, fe ? (e.arraySet(d.window, le, y - fe, fe, 0), d.wnext = fe, d.whave = d.wsize) : (d.wnext += $e, d.wnext === d.wsize && (d.wnext = 0), d.whave < d.wsize && (d.whave += $e))), 0;
  }
  function w(R, le) {
    var y, fe, $e, d, re, ne, x, N, Q, De, Se, Ae, Ue, ft, et = 0, qe, lt, pt, kt, fn, nn, tt, At, ht = new e.Buf8(4), zt, Rt, xa = (
      /* permutation of code lengths */
      [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
    );
    if (!R || !R.state || !R.output || !R.input && R.avail_in !== 0)
      return u;
    y = R.state, y.mode === T && (y.mode = A), re = R.next_out, $e = R.output, x = R.avail_out, d = R.next_in, fe = R.input, ne = R.avail_in, N = y.hold, Q = y.bits, De = ne, Se = x, At = c;
    e:
      for (; ; )
        switch (y.mode) {
          case _:
            if (y.wrap === 0) {
              y.mode = A;
              break;
            }
            for (; Q < 16; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            if (y.wrap & 2 && N === 35615) {
              y.check = 0, ht[0] = N & 255, ht[1] = N >>> 8 & 255, y.check = n(y.check, ht, 2, 0), N = 0, Q = 0, y.mode = E;
              break;
            }
            if (y.flags = 0, y.head && (y.head.done = !1), !(y.wrap & 1) || /* check if zlib header allowed */
            (((N & 255) << 8) + (N >> 8)) % 31) {
              R.msg = "incorrect header check", y.mode = de;
              break;
            }
            if ((N & 15) !== b) {
              R.msg = "unknown compression method", y.mode = de;
              break;
            }
            if (N >>>= 4, Q -= 4, tt = (N & 15) + 8, y.wbits === 0)
              y.wbits = tt;
            else if (tt > y.wbits) {
              R.msg = "invalid window size", y.mode = de;
              break;
            }
            y.dmax = 1 << tt, R.adler = y.check = 1, y.mode = N & 512 ? K : T, N = 0, Q = 0;
            break;
          case E:
            for (; Q < 16; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            if (y.flags = N, (y.flags & 255) !== b) {
              R.msg = "unknown compression method", y.mode = de;
              break;
            }
            if (y.flags & 57344) {
              R.msg = "unknown header flags set", y.mode = de;
              break;
            }
            y.head && (y.head.text = N >> 8 & 1), y.flags & 512 && (ht[0] = N & 255, ht[1] = N >>> 8 & 255, y.check = n(y.check, ht, 2, 0)), N = 0, Q = 0, y.mode = I;
          /* falls through */
          case I:
            for (; Q < 32; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            y.head && (y.head.time = N), y.flags & 512 && (ht[0] = N & 255, ht[1] = N >>> 8 & 255, ht[2] = N >>> 16 & 255, ht[3] = N >>> 24 & 255, y.check = n(y.check, ht, 4, 0)), N = 0, Q = 0, y.mode = L;
          /* falls through */
          case L:
            for (; Q < 16; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            y.head && (y.head.xflags = N & 255, y.head.os = N >> 8), y.flags & 512 && (ht[0] = N & 255, ht[1] = N >>> 8 & 255, y.check = n(y.check, ht, 2, 0)), N = 0, Q = 0, y.mode = C;
          /* falls through */
          case C:
            if (y.flags & 1024) {
              for (; Q < 16; ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              y.length = N, y.head && (y.head.extra_len = N), y.flags & 512 && (ht[0] = N & 255, ht[1] = N >>> 8 & 255, y.check = n(y.check, ht, 2, 0)), N = 0, Q = 0;
            } else y.head && (y.head.extra = null);
            y.mode = F;
          /* falls through */
          case F:
            if (y.flags & 1024 && (Ae = y.length, Ae > ne && (Ae = ne), Ae && (y.head && (tt = y.head.extra_len - y.length, y.head.extra || (y.head.extra = new Array(y.head.extra_len)), e.arraySet(
              y.head.extra,
              fe,
              d,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              Ae,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              tt
            )), y.flags & 512 && (y.check = n(y.check, fe, Ae, d)), ne -= Ae, d += Ae, y.length -= Ae), y.length))
              break e;
            y.length = 0, y.mode = V;
          /* falls through */
          case V:
            if (y.flags & 2048) {
              if (ne === 0)
                break e;
              Ae = 0;
              do
                tt = fe[d + Ae++], y.head && tt && y.length < 65536 && (y.head.name += String.fromCharCode(tt));
              while (tt && Ae < ne);
              if (y.flags & 512 && (y.check = n(y.check, fe, Ae, d)), ne -= Ae, d += Ae, tt)
                break e;
            } else y.head && (y.head.name = null);
            y.length = 0, y.mode = J;
          /* falls through */
          case J:
            if (y.flags & 4096) {
              if (ne === 0)
                break e;
              Ae = 0;
              do
                tt = fe[d + Ae++], y.head && tt && y.length < 65536 && (y.head.comment += String.fromCharCode(tt));
              while (tt && Ae < ne);
              if (y.flags & 512 && (y.check = n(y.check, fe, Ae, d)), ne -= Ae, d += Ae, tt)
                break e;
            } else y.head && (y.head.comment = null);
            y.mode = O;
          /* falls through */
          case O:
            if (y.flags & 512) {
              for (; Q < 16; ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              if (N !== (y.check & 65535)) {
                R.msg = "header crc mismatch", y.mode = de;
                break;
              }
              N = 0, Q = 0;
            }
            y.head && (y.head.hcrc = y.flags >> 9 & 1, y.head.done = !0), R.adler = y.check = 0, y.mode = T;
            break;
          case K:
            for (; Q < 32; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            R.adler = y.check = Xe(N), N = 0, Q = 0, y.mode = P;
          /* falls through */
          case P:
            if (y.havedict === 0)
              return R.next_out = re, R.avail_out = x, R.next_in = d, R.avail_in = ne, y.hold = N, y.bits = Q, m;
            R.adler = y.check = 1, y.mode = T;
          /* falls through */
          case T:
            if (le === h || le === v)
              break e;
          /* falls through */
          case A:
            if (y.last) {
              N >>>= Q & 7, Q -= Q & 7, y.mode = be;
              break;
            }
            for (; Q < 3; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            switch (y.last = N & 1, N >>>= 1, Q -= 1, N & 3) {
              case 0:
                y.mode = z;
                break;
              case 1:
                if (D(y), y.mode = ee, le === v) {
                  N >>>= 2, Q -= 2;
                  break e;
                }
                break;
              case 2:
                y.mode = B;
                break;
              case 3:
                R.msg = "invalid block type", y.mode = de;
            }
            N >>>= 2, Q -= 2;
            break;
          case z:
            for (N >>>= Q & 7, Q -= Q & 7; Q < 32; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            if ((N & 65535) !== (N >>> 16 ^ 65535)) {
              R.msg = "invalid stored block lengths", y.mode = de;
              break;
            }
            if (y.length = N & 65535, N = 0, Q = 0, y.mode = U, le === v)
              break e;
          /* falls through */
          case U:
            y.mode = X;
          /* falls through */
          case X:
            if (Ae = y.length, Ae) {
              if (Ae > ne && (Ae = ne), Ae > x && (Ae = x), Ae === 0)
                break e;
              e.arraySet($e, fe, d, Ae, re), ne -= Ae, d += Ae, x -= Ae, re += Ae, y.length -= Ae;
              break;
            }
            y.mode = T;
            break;
          case B:
            for (; Q < 14; ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            if (y.nlen = (N & 31) + 257, N >>>= 5, Q -= 5, y.ndist = (N & 31) + 1, N >>>= 5, Q -= 5, y.ncode = (N & 15) + 4, N >>>= 4, Q -= 4, y.nlen > 286 || y.ndist > 30) {
              R.msg = "too many length or distance symbols", y.mode = de;
              break;
            }
            y.have = 0, y.mode = ie;
          /* falls through */
          case ie:
            for (; y.have < y.ncode; ) {
              for (; Q < 3; ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              y.lens[xa[y.have++]] = N & 7, N >>>= 3, Q -= 3;
            }
            for (; y.have < 19; )
              y.lens[xa[y.have++]] = 0;
            if (y.lencode = y.lendyn, y.lenbits = 7, zt = { bits: y.lenbits }, At = s(i, y.lens, 0, 19, y.lencode, 0, y.work, zt), y.lenbits = zt.bits, At) {
              R.msg = "invalid code lengths set", y.mode = de;
              break;
            }
            y.have = 0, y.mode = H;
          /* falls through */
          case H:
            for (; y.have < y.nlen + y.ndist; ) {
              for (; et = y.lencode[N & (1 << y.lenbits) - 1], qe = et >>> 24, lt = et >>> 16 & 255, pt = et & 65535, !(qe <= Q); ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              if (pt < 16)
                N >>>= qe, Q -= qe, y.lens[y.have++] = pt;
              else {
                if (pt === 16) {
                  for (Rt = qe + 2; Q < Rt; ) {
                    if (ne === 0)
                      break e;
                    ne--, N += fe[d++] << Q, Q += 8;
                  }
                  if (N >>>= qe, Q -= qe, y.have === 0) {
                    R.msg = "invalid bit length repeat", y.mode = de;
                    break;
                  }
                  tt = y.lens[y.have - 1], Ae = 3 + (N & 3), N >>>= 2, Q -= 2;
                } else if (pt === 17) {
                  for (Rt = qe + 3; Q < Rt; ) {
                    if (ne === 0)
                      break e;
                    ne--, N += fe[d++] << Q, Q += 8;
                  }
                  N >>>= qe, Q -= qe, tt = 0, Ae = 3 + (N & 7), N >>>= 3, Q -= 3;
                } else {
                  for (Rt = qe + 7; Q < Rt; ) {
                    if (ne === 0)
                      break e;
                    ne--, N += fe[d++] << Q, Q += 8;
                  }
                  N >>>= qe, Q -= qe, tt = 0, Ae = 11 + (N & 127), N >>>= 7, Q -= 7;
                }
                if (y.have + Ae > y.nlen + y.ndist) {
                  R.msg = "invalid bit length repeat", y.mode = de;
                  break;
                }
                for (; Ae--; )
                  y.lens[y.have++] = tt;
              }
            }
            if (y.mode === de)
              break;
            if (y.lens[256] === 0) {
              R.msg = "invalid code -- missing end-of-block", y.mode = de;
              break;
            }
            if (y.lenbits = 9, zt = { bits: y.lenbits }, At = s(a, y.lens, 0, y.nlen, y.lencode, 0, y.work, zt), y.lenbits = zt.bits, At) {
              R.msg = "invalid literal/lengths set", y.mode = de;
              break;
            }
            if (y.distbits = 6, y.distcode = y.distdyn, zt = { bits: y.distbits }, At = s(o, y.lens, y.nlen, y.ndist, y.distcode, 0, y.work, zt), y.distbits = zt.bits, At) {
              R.msg = "invalid distances set", y.mode = de;
              break;
            }
            if (y.mode = ee, le === v)
              break e;
          /* falls through */
          case ee:
            y.mode = ce;
          /* falls through */
          case ce:
            if (ne >= 6 && x >= 258) {
              R.next_out = re, R.avail_out = x, R.next_in = d, R.avail_in = ne, y.hold = N, y.bits = Q, r(R, Se), re = R.next_out, $e = R.output, x = R.avail_out, d = R.next_in, fe = R.input, ne = R.avail_in, N = y.hold, Q = y.bits, y.mode === T && (y.back = -1);
              break;
            }
            for (y.back = 0; et = y.lencode[N & (1 << y.lenbits) - 1], qe = et >>> 24, lt = et >>> 16 & 255, pt = et & 65535, !(qe <= Q); ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            if (lt && (lt & 240) === 0) {
              for (kt = qe, fn = lt, nn = pt; et = y.lencode[nn + ((N & (1 << kt + fn) - 1) >> kt)], qe = et >>> 24, lt = et >>> 16 & 255, pt = et & 65535, !(kt + qe <= Q); ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              N >>>= kt, Q -= kt, y.back += kt;
            }
            if (N >>>= qe, Q -= qe, y.back += qe, y.length = pt, lt === 0) {
              y.mode = ge;
              break;
            }
            if (lt & 32) {
              y.back = -1, y.mode = T;
              break;
            }
            if (lt & 64) {
              R.msg = "invalid literal/length code", y.mode = de;
              break;
            }
            y.extra = lt & 15, y.mode = we;
          /* falls through */
          case we:
            if (y.extra) {
              for (Rt = y.extra; Q < Rt; ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              y.length += N & (1 << y.extra) - 1, N >>>= y.extra, Q -= y.extra, y.back += y.extra;
            }
            y.was = y.length, y.mode = ke;
          /* falls through */
          case ke:
            for (; et = y.distcode[N & (1 << y.distbits) - 1], qe = et >>> 24, lt = et >>> 16 & 255, pt = et & 65535, !(qe <= Q); ) {
              if (ne === 0)
                break e;
              ne--, N += fe[d++] << Q, Q += 8;
            }
            if ((lt & 240) === 0) {
              for (kt = qe, fn = lt, nn = pt; et = y.distcode[nn + ((N & (1 << kt + fn) - 1) >> kt)], qe = et >>> 24, lt = et >>> 16 & 255, pt = et & 65535, !(kt + qe <= Q); ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              N >>>= kt, Q -= kt, y.back += kt;
            }
            if (N >>>= qe, Q -= qe, y.back += qe, lt & 64) {
              R.msg = "invalid distance code", y.mode = de;
              break;
            }
            y.offset = pt, y.extra = lt & 15, y.mode = te;
          /* falls through */
          case te:
            if (y.extra) {
              for (Rt = y.extra; Q < Rt; ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              y.offset += N & (1 << y.extra) - 1, N >>>= y.extra, Q -= y.extra, y.back += y.extra;
            }
            if (y.offset > y.dmax) {
              R.msg = "invalid distance too far back", y.mode = de;
              break;
            }
            y.mode = he;
          /* falls through */
          case he:
            if (x === 0)
              break e;
            if (Ae = Se - x, y.offset > Ae) {
              if (Ae = y.offset - Ae, Ae > y.whave && y.sane) {
                R.msg = "invalid distance too far back", y.mode = de;
                break;
              }
              Ae > y.wnext ? (Ae -= y.wnext, Ue = y.wsize - Ae) : Ue = y.wnext - Ae, Ae > y.length && (Ae = y.length), ft = y.window;
            } else
              ft = $e, Ue = re - y.offset, Ae = y.length;
            Ae > x && (Ae = x), x -= Ae, y.length -= Ae;
            do
              $e[re++] = ft[Ue++];
            while (--Ae);
            y.length === 0 && (y.mode = ce);
            break;
          case ge:
            if (x === 0)
              break e;
            $e[re++] = y.length, x--, y.mode = ce;
            break;
          case be:
            if (y.wrap) {
              for (; Q < 32; ) {
                if (ne === 0)
                  break e;
                ne--, N |= fe[d++] << Q, Q += 8;
              }
              if (Se -= x, R.total_out += Se, y.total += Se, Se && (R.adler = y.check = /*UPDATE(state.check, put - _out, _out);*/
              y.flags ? n(y.check, $e, Se, re - Se) : t(y.check, $e, Se, re - Se)), Se = x, (y.flags ? N : Xe(N)) !== y.check) {
                R.msg = "incorrect data check", y.mode = de;
                break;
              }
              N = 0, Q = 0;
            }
            y.mode = Pe;
          /* falls through */
          case Pe:
            if (y.wrap && y.flags) {
              for (; Q < 32; ) {
                if (ne === 0)
                  break e;
                ne--, N += fe[d++] << Q, Q += 8;
              }
              if (N !== (y.total & 4294967295)) {
                R.msg = "incorrect length check", y.mode = de;
                break;
              }
              N = 0, Q = 0;
            }
            y.mode = Ne;
          /* falls through */
          case Ne:
            At = f;
            break e;
          case de:
            At = p;
            break e;
          case Re:
            return k;
          case He:
          /* falls through */
          default:
            return u;
        }
    return R.next_out = re, R.avail_out = x, R.next_in = d, R.avail_in = ne, y.hold = N, y.bits = Q, (y.wsize || Se !== R.avail_out && y.mode < de && (y.mode < be || le !== l)) && S(R, R.output, R.next_out, Se - R.avail_out), De -= R.avail_in, Se -= R.avail_out, R.total_in += De, R.total_out += Se, y.total += Se, y.wrap && Se && (R.adler = y.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
    y.flags ? n(y.check, $e, Se, R.next_out - Se) : t(y.check, $e, Se, R.next_out - Se)), R.data_type = y.bits + (y.last ? 64 : 0) + (y.mode === T ? 128 : 0) + (y.mode === ee || y.mode === U ? 256 : 0), (De === 0 && Se === 0 || le === l) && At === c && (At = g), At;
  }
  function G(R) {
    if (!R || !R.state)
      return u;
    var le = R.state;
    return le.window && (le.window = null), R.state = null, c;
  }
  function Y(R, le) {
    var y;
    return !R || !R.state || (y = R.state, (y.wrap & 2) === 0) ? u : (y.head = le, le.done = !1, c);
  }
  function se(R, le) {
    var y = le.length, fe, $e, d;
    return !R || !R.state || (fe = R.state, fe.wrap !== 0 && fe.mode !== P) ? u : fe.mode === P && ($e = 1, $e = t($e, le, y, 0), $e !== fe.check) ? p : (d = S(R, le, y, y), d ? (fe.mode = Re, k) : (fe.havedict = 1, c));
  }
  return Bt.inflateReset = bt, Bt.inflateReset2 = Ft, Bt.inflateResetKeep = gt, Bt.inflateInit = xt, Bt.inflateInit2 = Ot, Bt.inflate = w, Bt.inflateEnd = G, Bt.inflateGetHeader = Y, Bt.inflateSetDictionary = se, Bt.inflateInfo = "pako inflate (from Nodeca project)", Bt;
}
var Dr, Ol;
function Qo() {
  return Ol || (Ol = 1, Dr = {
    /* Allowed flush values; see deflate() and inflate() below for details */
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
    * are errors, positive values are used for special but normal events.
    */
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */
    Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */
    Z_DEFLATED: 8
    //Z_NULL:                 null // Use -1 or null inline, depending on var type
  }), Dr;
}
var Mr, Rl;
function fh() {
  if (Rl) return Mr;
  Rl = 1;
  function e() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  }
  return Mr = e, Mr;
}
var Fl;
function hh() {
  if (Fl) return Fn;
  Fl = 1;
  var e = dh(), t = cn(), n = Ko(), r = Qo(), s = mi(), i = Jo(), a = fh(), o = Object.prototype.toString;
  function l(c) {
    if (!(this instanceof l)) return new l(c);
    this.options = t.assign({
      chunkSize: 16384,
      windowBits: 0,
      to: ""
    }, c || {});
    var f = this.options;
    f.raw && f.windowBits >= 0 && f.windowBits < 16 && (f.windowBits = -f.windowBits, f.windowBits === 0 && (f.windowBits = -15)), f.windowBits >= 0 && f.windowBits < 16 && !(c && c.windowBits) && (f.windowBits += 32), f.windowBits > 15 && f.windowBits < 48 && (f.windowBits & 15) === 0 && (f.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i(), this.strm.avail_out = 0;
    var m = e.inflateInit2(
      this.strm,
      f.windowBits
    );
    if (m !== r.Z_OK)
      throw new Error(s[m]);
    if (this.header = new a(), e.inflateGetHeader(this.strm, this.header), f.dictionary && (typeof f.dictionary == "string" ? f.dictionary = n.string2buf(f.dictionary) : o.call(f.dictionary) === "[object ArrayBuffer]" && (f.dictionary = new Uint8Array(f.dictionary)), f.raw && (m = e.inflateSetDictionary(this.strm, f.dictionary), m !== r.Z_OK)))
      throw new Error(s[m]);
  }
  l.prototype.push = function(c, f) {
    var m = this.strm, u = this.options.chunkSize, p = this.options.dictionary, k, g, b, _, E, I = !1;
    if (this.ended)
      return !1;
    g = f === ~~f ? f : f === !0 ? r.Z_FINISH : r.Z_NO_FLUSH, typeof c == "string" ? m.input = n.binstring2buf(c) : o.call(c) === "[object ArrayBuffer]" ? m.input = new Uint8Array(c) : m.input = c, m.next_in = 0, m.avail_in = m.input.length;
    do {
      if (m.avail_out === 0 && (m.output = new t.Buf8(u), m.next_out = 0, m.avail_out = u), k = e.inflate(m, r.Z_NO_FLUSH), k === r.Z_NEED_DICT && p && (k = e.inflateSetDictionary(this.strm, p)), k === r.Z_BUF_ERROR && I === !0 && (k = r.Z_OK, I = !1), k !== r.Z_STREAM_END && k !== r.Z_OK)
        return this.onEnd(k), this.ended = !0, !1;
      m.next_out && (m.avail_out === 0 || k === r.Z_STREAM_END || m.avail_in === 0 && (g === r.Z_FINISH || g === r.Z_SYNC_FLUSH)) && (this.options.to === "string" ? (b = n.utf8border(m.output, m.next_out), _ = m.next_out - b, E = n.buf2string(m.output, b), m.next_out = _, m.avail_out = u - _, _ && t.arraySet(m.output, m.output, b, _, 0), this.onData(E)) : this.onData(t.shrinkBuf(m.output, m.next_out))), m.avail_in === 0 && m.avail_out === 0 && (I = !0);
    } while ((m.avail_in > 0 || m.avail_out === 0) && k !== r.Z_STREAM_END);
    return k === r.Z_STREAM_END && (g = r.Z_FINISH), g === r.Z_FINISH ? (k = e.inflateEnd(this.strm), this.onEnd(k), this.ended = !0, k === r.Z_OK) : (g === r.Z_SYNC_FLUSH && (this.onEnd(r.Z_OK), m.avail_out = 0), !0);
  }, l.prototype.onData = function(c) {
    this.chunks.push(c);
  }, l.prototype.onEnd = function(c) {
    c === r.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = c, this.msg = this.strm.msg;
  };
  function h(c, f) {
    var m = new l(f);
    if (m.push(c, !0), m.err)
      throw m.msg || s[m.err];
    return m.result;
  }
  function v(c, f) {
    return f = f || {}, f.raw = !0, h(c, f);
  }
  return Fn.Inflate = l, Fn.inflate = h, Fn.inflateRaw = v, Fn.ungzip = h, Fn;
}
var Or, Nl;
function vh() {
  if (Nl) return Or;
  Nl = 1;
  var e = cn().assign, t = sh(), n = hh(), r = Qo(), s = {};
  return e(s, t, n, r), Or = s, Or;
}
var Bl;
function mh() {
  return Bl || (Bl = 1, (function(e) {
    (function() {
      var t = {}, n;
      e.exports = t, typeof ih == "function" ? n = vh() : n = window.pako, (function(r, s) {
        r.toRGBA8 = function(i) {
          var a = i.width, o = i.height;
          if (i.tabs.acTL == null) return [r.toRGBA8.decodeImage(i.data, a, o, i).buffer];
          var l = [];
          i.frames[0].data == null && (i.frames[0].data = i.data);
          for (var h, v = new Uint8Array(a * o * 4), c = 0; c < i.frames.length; c++) {
            var f = i.frames[c], m = f.rect.x, u = f.rect.y, p = f.rect.width, k = f.rect.height, g = r.toRGBA8.decodeImage(f.data, p, k, i);
            if (c == 0 ? h = g : f.blend == 0 ? r._copyTile(g, p, k, h, a, o, m, u, 0) : f.blend == 1 && r._copyTile(g, p, k, h, a, o, m, u, 1), l.push(h.buffer), h = h.slice(0), f.dispose != 0) {
              if (f.dispose == 1) r._copyTile(v, p, k, h, a, o, m, u, 0);
              else if (f.dispose == 2) {
                for (var b = c - 1; i.frames[b].dispose == 2; ) b--;
                h = new Uint8Array(l[b]).slice(0);
              }
            }
          }
          return l;
        }, r.toRGBA8.decodeImage = function(i, a, o, l) {
          var h = a * o, v = r.decode._getBPP(l), c = Math.ceil(a * v / 8), f = new Uint8Array(h * 4), m = new Uint32Array(f.buffer), u = l.ctype, p = l.depth, k = r._bin.readUshort;
          if (u == 6) {
            var g = h << 2;
            if (p == 8) for (var b = 0; b < g; b++)
              f[b] = i[b];
            if (p == 16) for (var b = 0; b < g; b++)
              f[b] = i[b << 1];
          } else if (u == 2) {
            var _ = l.tabs.tRNS, E = -1, I = -1, L = -1;
            if (_ && (E = _[0], I = _[1], L = _[2]), p == 8) for (var b = 0; b < h; b++) {
              var C = b << 2, F = b * 3;
              f[C] = i[F], f[C + 1] = i[F + 1], f[C + 2] = i[F + 2], f[C + 3] = 255, E != -1 && i[F] == E && i[F + 1] == I && i[F + 2] == L && (f[C + 3] = 0);
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var C = b << 2, F = b * 6;
              f[C] = i[F], f[C + 1] = i[F + 2], f[C + 2] = i[F + 4], f[C + 3] = 255, E != -1 && k(i, F) == E && k(i, F + 2) == I && k(i, F + 4) == L && (f[C + 3] = 0);
            }
          } else if (u == 3) {
            var V = l.tabs.PLTE, J = l.tabs.tRNS, O = J ? J.length : 0;
            if (p == 1) for (var K = 0; K < o; K++)
              for (var P = K * c, T = K * a, b = 0; b < a; b++) {
                var C = T + b << 2, A = i[P + (b >> 3)] >> 7 - ((b & 7) << 0) & 1, z = 3 * A;
                f[C] = V[z], f[C + 1] = V[z + 1], f[C + 2] = V[z + 2], f[C + 3] = A < O ? J[A] : 255;
              }
            if (p == 2) for (var K = 0; K < o; K++)
              for (var P = K * c, T = K * a, b = 0; b < a; b++) {
                var C = T + b << 2, A = i[P + (b >> 2)] >> 6 - ((b & 3) << 1) & 3, z = 3 * A;
                f[C] = V[z], f[C + 1] = V[z + 1], f[C + 2] = V[z + 2], f[C + 3] = A < O ? J[A] : 255;
              }
            if (p == 4) for (var K = 0; K < o; K++)
              for (var P = K * c, T = K * a, b = 0; b < a; b++) {
                var C = T + b << 2, A = i[P + (b >> 1)] >> 4 - ((b & 1) << 2) & 15, z = 3 * A;
                f[C] = V[z], f[C + 1] = V[z + 1], f[C + 2] = V[z + 2], f[C + 3] = A < O ? J[A] : 255;
              }
            if (p == 8) for (var b = 0; b < h; b++) {
              var C = b << 2, A = i[b], z = 3 * A;
              f[C] = V[z], f[C + 1] = V[z + 1], f[C + 2] = V[z + 2], f[C + 3] = A < O ? J[A] : 255;
            }
          } else if (u == 4) {
            if (p == 8) for (var b = 0; b < h; b++) {
              var C = b << 2, U = b << 1, X = i[U];
              f[C] = X, f[C + 1] = X, f[C + 2] = X, f[C + 3] = i[U + 1];
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var C = b << 2, U = b << 2, X = i[U];
              f[C] = X, f[C + 1] = X, f[C + 2] = X, f[C + 3] = i[U + 2];
            }
          } else if (u == 0) {
            var E = l.tabs.tRNS ? l.tabs.tRNS : -1;
            if (p == 1) for (var b = 0; b < h; b++) {
              var X = 255 * (i[b >> 3] >> 7 - (b & 7) & 1), B = X == E * 255 ? 0 : 255;
              m[b] = B << 24 | X << 16 | X << 8 | X;
            }
            if (p == 2) for (var b = 0; b < h; b++) {
              var X = 85 * (i[b >> 2] >> 6 - ((b & 3) << 1) & 3), B = X == E * 85 ? 0 : 255;
              m[b] = B << 24 | X << 16 | X << 8 | X;
            }
            if (p == 4) for (var b = 0; b < h; b++) {
              var X = 17 * (i[b >> 1] >> 4 - ((b & 1) << 2) & 15), B = X == E * 17 ? 0 : 255;
              m[b] = B << 24 | X << 16 | X << 8 | X;
            }
            if (p == 8) for (var b = 0; b < h; b++) {
              var X = i[b], B = X == E ? 0 : 255;
              m[b] = B << 24 | X << 16 | X << 8 | X;
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var X = i[b << 1], B = k(i, b << 1) == E ? 0 : 255;
              m[b] = B << 24 | X << 16 | X << 8 | X;
            }
          }
          return f;
        }, r.decode = function(i) {
          for (var a = new Uint8Array(i), o = 8, l = r._bin, h = l.readUshort, v = l.readUint, c = { tabs: {}, frames: [] }, f = new Uint8Array(a.length), m = 0, u, p = 0, k = [137, 80, 78, 71, 13, 10, 26, 10], g = 0; g < 8; g++) if (a[g] != k[g]) throw "The input is not a PNG file!";
          for (; o < a.length; ) {
            var b = l.readUint(a, o);
            o += 4;
            var _ = l.readASCII(a, o, 4);
            if (o += 4, _ == "IHDR")
              r.decode._IHDR(a, o, c);
            else if (_ == "IDAT") {
              for (var g = 0; g < b; g++) f[m + g] = a[o + g];
              m += b;
            } else if (_ == "acTL")
              c.tabs[_] = { num_frames: v(a, o), num_plays: v(a, o + 4) }, u = new Uint8Array(a.length);
            else if (_ == "fcTL") {
              if (p != 0) {
                var E = c.frames[c.frames.length - 1];
                E.data = r.decode._decompress(c, u.slice(0, p), E.rect.width, E.rect.height), p = 0;
              }
              var I = { x: v(a, o + 12), y: v(a, o + 16), width: v(a, o + 4), height: v(a, o + 8) }, L = h(a, o + 22);
              L = h(a, o + 20) / (L == 0 ? 100 : L);
              var C = { rect: I, delay: Math.round(L * 1e3), dispose: a[o + 24], blend: a[o + 25] };
              c.frames.push(C);
            } else if (_ == "fdAT") {
              for (var g = 0; g < b - 4; g++) u[p + g] = a[o + g + 4];
              p += b - 4;
            } else if (_ == "pHYs")
              c.tabs[_] = [l.readUint(a, o), l.readUint(a, o + 4), a[o + 8]];
            else if (_ == "cHRM") {
              c.tabs[_] = [];
              for (var g = 0; g < 8; g++) c.tabs[_].push(l.readUint(a, o + g * 4));
            } else if (_ == "tEXt") {
              c.tabs[_] == null && (c.tabs[_] = {});
              var F = l.nextZero(a, o), V = l.readASCII(a, o, F - o), J = l.readASCII(a, F + 1, o + b - F - 1);
              c.tabs[_][V] = J;
            } else if (_ == "iTXt") {
              c.tabs[_] == null && (c.tabs[_] = {});
              var F = 0, O = o;
              F = l.nextZero(a, O);
              var V = l.readASCII(a, O, F - O);
              O = F + 1, a[O], a[O + 1], O += 2, F = l.nextZero(a, O), l.readASCII(a, O, F - O), O = F + 1, F = l.nextZero(a, O), l.readUTF8(a, O, F - O), O = F + 1;
              var J = l.readUTF8(a, O, b - (O - o));
              c.tabs[_][V] = J;
            } else if (_ == "PLTE")
              c.tabs[_] = l.readBytes(a, o, b);
            else if (_ == "hIST") {
              var K = c.tabs.PLTE.length / 3;
              c.tabs[_] = [];
              for (var g = 0; g < K; g++) c.tabs[_].push(h(a, o + g * 2));
            } else if (_ == "tRNS")
              c.ctype == 3 ? c.tabs[_] = l.readBytes(a, o, b) : c.ctype == 0 ? c.tabs[_] = h(a, o) : c.ctype == 2 && (c.tabs[_] = [h(a, o), h(a, o + 2), h(a, o + 4)]);
            else if (_ == "gAMA") c.tabs[_] = l.readUint(a, o) / 1e5;
            else if (_ == "sRGB") c.tabs[_] = a[o];
            else if (_ == "bKGD")
              c.ctype == 0 || c.ctype == 4 ? c.tabs[_] = [h(a, o)] : c.ctype == 2 || c.ctype == 6 ? c.tabs[_] = [h(a, o), h(a, o + 2), h(a, o + 4)] : c.ctype == 3 && (c.tabs[_] = a[o]);
            else if (_ == "IEND") {
              if (p != 0) {
                var E = c.frames[c.frames.length - 1];
                E.data = r.decode._decompress(c, u.slice(0, p), E.rect.width, E.rect.height), p = 0;
              }
              c.data = r.decode._decompress(c, f, c.width, c.height);
              break;
            }
            o += b, l.readUint(a, o), o += 4;
          }
          return delete c.compress, delete c.interlace, delete c.filter, c;
        }, r.decode._decompress = function(i, a, o, l) {
          return i.compress == 0 && (a = r.decode._inflate(a)), i.interlace == 0 ? a = r.decode._filterZero(a, i, 0, o, l) : i.interlace == 1 && (a = r.decode._readInterlace(a, i)), a;
        }, r.decode._inflate = function(i) {
          return s.inflate(i);
        }, r.decode._readInterlace = function(i, a) {
          for (var o = a.width, l = a.height, h = r.decode._getBPP(a), v = h >> 3, c = Math.ceil(o * h / 8), f = new Uint8Array(l * c), m = 0, u = [0, 0, 4, 0, 2, 0, 1], p = [0, 4, 0, 2, 0, 1, 0], k = [8, 8, 8, 4, 4, 2, 2], g = [8, 8, 4, 4, 2, 2, 1], b = 0; b < 7; ) {
            for (var _ = k[b], E = g[b], I = 0, L = 0, C = u[b]; C < l; )
              C += _, L++;
            for (var F = p[b]; F < o; )
              F += E, I++;
            var V = Math.ceil(I * h / 8);
            r.decode._filterZero(i, a, m, I, L);
            for (var J = 0, O = u[b]; O < l; ) {
              for (var K = p[b], P = m + J * V << 3; K < o; ) {
                if (h == 1) {
                  var T = i[P >> 3];
                  T = T >> 7 - (P & 7) & 1, f[O * c + (K >> 3)] |= T << 7 - ((K & 3) << 0);
                }
                if (h == 2) {
                  var T = i[P >> 3];
                  T = T >> 6 - (P & 7) & 3, f[O * c + (K >> 2)] |= T << 6 - ((K & 3) << 1);
                }
                if (h == 4) {
                  var T = i[P >> 3];
                  T = T >> 4 - (P & 7) & 15, f[O * c + (K >> 1)] |= T << 4 - ((K & 1) << 2);
                }
                if (h >= 8)
                  for (var A = O * c + K * v, z = 0; z < v; z++) f[A + z] = i[(P >> 3) + z];
                P += h, K += E;
              }
              J++, O += _;
            }
            I * L != 0 && (m += L * (1 + V)), b = b + 1;
          }
          return f;
        }, r.decode._getBPP = function(i) {
          var a = [1, null, 3, 1, 2, null, 4][i.ctype];
          return a * i.depth;
        }, r.decode._filterZero = function(i, a, o, l, h) {
          var v = r.decode._getBPP(a), c = Math.ceil(l * v / 8), f = r.decode._paeth;
          v = Math.ceil(v / 8);
          for (var m = 0; m < h; m++) {
            var u = o + m * c, p = u + m + 1, k = i[p - 1];
            if (k == 0) for (var g = 0; g < c; g++) i[u + g] = i[p + g];
            else if (k == 1) {
              for (var g = 0; g < v; g++) i[u + g] = i[p + g];
              for (var g = v; g < c; g++) i[u + g] = i[p + g] + i[u + g - v] & 255;
            } else if (m == 0) {
              for (var g = 0; g < v; g++) i[u + g] = i[p + g];
              if (k == 2) for (var g = v; g < c; g++) i[u + g] = i[p + g] & 255;
              if (k == 3) for (var g = v; g < c; g++) i[u + g] = i[p + g] + (i[u + g - v] >> 1) & 255;
              if (k == 4) for (var g = v; g < c; g++) i[u + g] = i[p + g] + f(i[u + g - v], 0, 0) & 255;
            } else {
              if (k == 2)
                for (var g = 0; g < c; g++) i[u + g] = i[p + g] + i[u + g - c] & 255;
              if (k == 3) {
                for (var g = 0; g < v; g++) i[u + g] = i[p + g] + (i[u + g - c] >> 1) & 255;
                for (var g = v; g < c; g++) i[u + g] = i[p + g] + (i[u + g - c] + i[u + g - v] >> 1) & 255;
              }
              if (k == 4) {
                for (var g = 0; g < v; g++) i[u + g] = i[p + g] + f(0, i[u + g - c], 0) & 255;
                for (var g = v; g < c; g++) i[u + g] = i[p + g] + f(i[u + g - v], i[u + g - c], i[u + g - v - c]) & 255;
              }
            }
          }
          return i;
        }, r.decode._paeth = function(i, a, o) {
          var l = i + a - o, h = Math.abs(l - i), v = Math.abs(l - a), c = Math.abs(l - o);
          return h <= v && h <= c ? i : v <= c ? a : o;
        }, r.decode._IHDR = function(i, a, o) {
          var l = r._bin;
          o.width = l.readUint(i, a), a += 4, o.height = l.readUint(i, a), a += 4, o.depth = i[a], a++, o.ctype = i[a], a++, o.compress = i[a], a++, o.filter = i[a], a++, o.interlace = i[a], a++;
        }, r._bin = {
          nextZero: function(i, a) {
            for (; i[a] != 0; ) a++;
            return a;
          },
          readUshort: function(i, a) {
            return i[a] << 8 | i[a + 1];
          },
          writeUshort: function(i, a, o) {
            i[a] = o >> 8 & 255, i[a + 1] = o & 255;
          },
          readUint: function(i, a) {
            return i[a] * (256 * 256 * 256) + (i[a + 1] << 16 | i[a + 2] << 8 | i[a + 3]);
          },
          writeUint: function(i, a, o) {
            i[a] = o >> 24 & 255, i[a + 1] = o >> 16 & 255, i[a + 2] = o >> 8 & 255, i[a + 3] = o & 255;
          },
          readASCII: function(i, a, o) {
            for (var l = "", h = 0; h < o; h++) l += String.fromCharCode(i[a + h]);
            return l;
          },
          writeASCII: function(i, a, o) {
            for (var l = 0; l < o.length; l++) i[a + l] = o.charCodeAt(l);
          },
          readBytes: function(i, a, o) {
            for (var l = [], h = 0; h < o; h++) l.push(i[a + h]);
            return l;
          },
          pad: function(i) {
            return i.length < 2 ? "0" + i : i;
          },
          readUTF8: function(i, a, o) {
            for (var l = "", h, v = 0; v < o; v++) l += "%" + r._bin.pad(i[a + v].toString(16));
            try {
              h = decodeURIComponent(l);
            } catch {
              return r._bin.readASCII(i, a, o);
            }
            return h;
          }
        }, r._copyTile = function(i, a, o, l, h, v, c, f, m) {
          for (var u = Math.min(a, h), p = Math.min(o, v), k = 0, g = 0, b = 0; b < p; b++)
            for (var _ = 0; _ < u; _++)
              if (c >= 0 && f >= 0 ? (k = b * a + _ << 2, g = (f + b) * h + c + _ << 2) : (k = (-f + b) * a - c + _ << 2, g = b * h + _ << 2), m == 0)
                l[g] = i[k], l[g + 1] = i[k + 1], l[g + 2] = i[k + 2], l[g + 3] = i[k + 3];
              else if (m == 1) {
                var E = i[k + 3] * 0.00392156862745098, I = i[k] * E, L = i[k + 1] * E, C = i[k + 2] * E, F = l[g + 3] * (1 / 255), V = l[g] * F, J = l[g + 1] * F, O = l[g + 2] * F, K = 1 - E, P = E + F * K, T = P == 0 ? 0 : 1 / P;
                l[g + 3] = 255 * P, l[g + 0] = (I + V * K) * T, l[g + 1] = (L + J * K) * T, l[g + 2] = (C + O * K) * T;
              } else if (m == 2) {
                var E = i[k + 3], I = i[k], L = i[k + 1], C = i[k + 2], F = l[g + 3], V = l[g], J = l[g + 1], O = l[g + 2];
                E == F && I == V && L == J && C == O ? (l[g] = 0, l[g + 1] = 0, l[g + 2] = 0, l[g + 3] = 0) : (l[g] = I, l[g + 1] = L, l[g + 2] = C, l[g + 3] = E);
              } else if (m == 3) {
                var E = i[k + 3], I = i[k], L = i[k + 1], C = i[k + 2], F = l[g + 3], V = l[g], J = l[g + 1], O = l[g + 2];
                if (E == F && I == V && L == J && C == O) continue;
                if (E < 220 && F > 20) return !1;
              }
          return !0;
        }, r.encode = function(i, a, o, l, h, v) {
          l == null && (l = 0), v == null && (v = !1);
          for (var c = new Uint8Array(i[0].byteLength * i.length + 100), f = [137, 80, 78, 71, 13, 10, 26, 10], m = 0; m < 8; m++) c[m] = f[m];
          var u = 8, p = r._bin, k = r.crc.crc, g = p.writeUint, b = p.writeUshort, _ = p.writeASCII, E = r.encode.compressPNG(i, a, o, l, v);
          g(c, u, 13), u += 4, _(c, u, "IHDR"), u += 4, g(c, u, a), u += 4, g(c, u, o), u += 4, c[u] = E.depth, u++, c[u] = E.ctype, u++, c[u] = 0, u++, c[u] = 0, u++, c[u] = 0, u++, g(c, u, k(c, u - 17, 17)), u += 4, g(c, u, 1), u += 4, _(c, u, "sRGB"), u += 4, c[u] = 1, u++, g(c, u, k(c, u - 5, 5)), u += 4;
          var I = i.length > 1;
          if (I && (g(c, u, 8), u += 4, _(c, u, "acTL"), u += 4, g(c, u, i.length), u += 4, g(c, u, 0), u += 4, g(c, u, k(c, u - 12, 12)), u += 4), E.ctype == 3) {
            var L = E.plte.length;
            g(c, u, L * 3), u += 4, _(c, u, "PLTE"), u += 4;
            for (var m = 0; m < L; m++) {
              var C = m * 3, F = E.plte[m], V = F & 255, J = F >> 8 & 255, O = F >> 16 & 255;
              c[u + C + 0] = V, c[u + C + 1] = J, c[u + C + 2] = O;
            }
            if (u += L * 3, g(c, u, k(c, u - L * 3 - 4, L * 3 + 4)), u += 4, E.gotAlpha) {
              g(c, u, L), u += 4, _(c, u, "tRNS"), u += 4;
              for (var m = 0; m < L; m++) c[u + m] = E.plte[m] >> 24 & 255;
              u += L, g(c, u, k(c, u - L - 4, L + 4)), u += 4;
            }
          }
          for (var K = 0, P = 0; P < E.frames.length; P++) {
            var T = E.frames[P];
            I && (g(c, u, 26), u += 4, _(c, u, "fcTL"), u += 4, g(c, u, K++), u += 4, g(c, u, T.rect.width), u += 4, g(c, u, T.rect.height), u += 4, g(c, u, T.rect.x), u += 4, g(c, u, T.rect.y), u += 4, b(c, u, h[P]), u += 2, b(c, u, 1e3), u += 2, c[u] = T.dispose, u++, c[u] = T.blend, u++, g(c, u, k(c, u - 30, 30)), u += 4);
            var A = T.cimg, L = A.length;
            g(c, u, L + (P == 0 ? 0 : 4)), u += 4;
            var z = u;
            _(c, u, P == 0 ? "IDAT" : "fdAT"), u += 4, P != 0 && (g(c, u, K++), u += 4);
            for (var m = 0; m < L; m++) c[u + m] = A[m];
            u += L, g(c, u, k(c, z, u - z)), u += 4;
          }
          return g(c, u, 0), u += 4, _(c, u, "IEND"), u += 4, g(c, u, k(c, u - 4, 4)), u += 4, c.buffer.slice(0, u);
        }, r.encode.compressPNG = function(i, a, o, l, h) {
          for (var v = r.encode.compress(i, a, o, l, !1, h), c = 0; c < i.length; c++) {
            var f = v.frames[c];
            f.rect.width;
            var m = f.rect.height, u = f.bpl, p = f.bpp, k = new Uint8Array(m * u + m);
            f.cimg = r.encode._filterZero(f.img, m, p, u, k);
          }
          return v;
        }, r.encode.compress = function(i, a, o, l, h, v) {
          v == null && (v = !1);
          for (var c = 6, f = 8, m = 4, u = 255, p = 0; p < i.length; p++)
            for (var k = new Uint8Array(i[p]), g = k.length, b = 0; b < g; b += 4) u &= k[b + 3];
          var _ = u != 255, E = {}, I = [];
          if (i.length != 0 && (E[0] = 0, I.push(0), l != 0 && l--), l != 0) {
            var L = r.quantize(i, l, h);
            i = L.bufs;
            for (var b = 0; b < L.plte.length; b++) {
              var C = L.plte[b].est.rgba;
              E[C] == null && (E[C] = I.length, I.push(C));
            }
          } else
            for (var p = 0; p < i.length; p++)
              for (var F = new Uint32Array(i[p]), g = F.length, b = 0; b < g; b++) {
                var C = F[b];
                if ((b < a || C != F[b - 1] && C != F[b - a]) && E[C] == null && (E[C] = I.length, I.push(C), I.length >= 300))
                  break;
              }
          var V = _ ? h : !1, J = I.length;
          J <= 256 && v == !1 && (J <= 2 ? f = 1 : J <= 4 ? f = 2 : J <= 16 ? f = 4 : f = 8, h && (f = 8), _ = !0);
          for (var O = [], p = 0; p < i.length; p++) {
            var K = new Uint8Array(i[p]), P = new Uint32Array(K.buffer), T = 0, A = 0, z = a, U = o, X = 0;
            if (p != 0 && !V) {
              for (var B = h || p == 1 || O[O.length - 2].dispose == 2 ? 1 : 2, ie = 0, H = 1e9, ee = 0; ee < B; ee++) {
                for (var Ne = new Uint8Array(i[p - 1 - ee]), ce = new Uint32Array(i[p - 1 - ee]), we = a, ke = o, te = -1, he = -1, ge = 0; ge < o; ge++) for (var be = 0; be < a; be++) {
                  var b = ge * a + be;
                  P[b] != ce[b] && (be < we && (we = be), be > te && (te = be), ge < ke && (ke = ge), ge > he && (he = ge));
                }
                var Pe = te == -1 ? 1 : (te - we + 1) * (he - ke + 1);
                Pe < H && (H = Pe, ie = ee, te == -1 ? (T = A = 0, z = U = 1) : (T = we, A = ke, z = te - we + 1, U = he - ke + 1));
              }
              var Ne = new Uint8Array(i[p - 1 - ie]);
              ie == 1 && (O[O.length - 1].dispose = 2);
              var de = new Uint8Array(z * U * 4);
              new Uint32Array(de.buffer), r._copyTile(Ne, a, o, de, z, U, -T, -A, 0), r._copyTile(K, a, o, de, z, U, -T, -A, 3) ? (r._copyTile(K, a, o, de, z, U, -T, -A, 2), X = 1) : (r._copyTile(K, a, o, de, z, U, -T, -A, 0), X = 0), K = de, P = new Uint32Array(K.buffer);
            }
            var Re = 4 * z;
            if (J <= 256 && v == !1) {
              Re = Math.ceil(f * z / 8);
              for (var de = new Uint8Array(Re * U), ge = 0; ge < U; ge++) {
                var b = ge * Re, He = ge * z;
                if (f == 8) for (var be = 0; be < z; be++) de[b + be] = E[P[He + be]];
                else if (f == 4) for (var be = 0; be < z; be++) de[b + (be >> 1)] |= E[P[He + be]] << 4 - (be & 1) * 4;
                else if (f == 2) for (var be = 0; be < z; be++) de[b + (be >> 2)] |= E[P[He + be]] << 6 - (be & 3) * 2;
                else if (f == 1) for (var be = 0; be < z; be++) de[b + (be >> 3)] |= E[P[He + be]] << 7 - (be & 7) * 1;
              }
              K = de, c = 3, m = 1;
            } else if (_ == !1 && i.length == 1) {
              for (var de = new Uint8Array(z * U * 3), Ze = z * U, b = 0; b < Ze; b++) {
                var We = b * 3, Be = b * 4;
                de[We] = K[Be], de[We + 1] = K[Be + 1], de[We + 2] = K[Be + 2];
              }
              K = de, c = 2, m = 3, Re = 3 * z;
            }
            O.push({ rect: { x: T, y: A, width: z, height: U }, img: K, bpl: Re, bpp: m, blend: X, dispose: V ? 1 : 0 });
          }
          return { ctype: c, depth: f, plte: I, gotAlpha: _, frames: O };
        }, r.encode._filterZero = function(i, a, o, l, h) {
          for (var v = [], c = 0; c < 5; c++)
            if (!(a * l > 5e5 && (c == 2 || c == 3 || c == 4))) {
              for (var f = 0; f < a; f++) r.encode._filterLine(h, i, f, l, o, c);
              if (v.push(s.deflate(h)), o == 1) break;
            }
          for (var m, u = 1e9, p = 0; p < v.length; p++) v[p].length < u && (m = p, u = v[p].length);
          return v[m];
        }, r.encode._filterLine = function(i, a, o, l, h, v) {
          var c = o * l, f = c + o, m = r.decode._paeth;
          if (i[f] = v, f++, v == 0) for (var u = 0; u < l; u++) i[f + u] = a[c + u];
          else if (v == 1) {
            for (var u = 0; u < h; u++) i[f + u] = a[c + u];
            for (var u = h; u < l; u++) i[f + u] = a[c + u] - a[c + u - h] + 256 & 255;
          } else if (o == 0) {
            for (var u = 0; u < h; u++) i[f + u] = a[c + u];
            if (v == 2) for (var u = h; u < l; u++) i[f + u] = a[c + u];
            if (v == 3) for (var u = h; u < l; u++) i[f + u] = a[c + u] - (a[c + u - h] >> 1) + 256 & 255;
            if (v == 4) for (var u = h; u < l; u++) i[f + u] = a[c + u] - m(a[c + u - h], 0, 0) + 256 & 255;
          } else {
            if (v == 2)
              for (var u = 0; u < l; u++) i[f + u] = a[c + u] + 256 - a[c + u - l] & 255;
            if (v == 3) {
              for (var u = 0; u < h; u++) i[f + u] = a[c + u] + 256 - (a[c + u - l] >> 1) & 255;
              for (var u = h; u < l; u++) i[f + u] = a[c + u] + 256 - (a[c + u - l] + a[c + u - h] >> 1) & 255;
            }
            if (v == 4) {
              for (var u = 0; u < h; u++) i[f + u] = a[c + u] + 256 - m(0, a[c + u - l], 0) & 255;
              for (var u = h; u < l; u++) i[f + u] = a[c + u] + 256 - m(a[c + u - h], a[c + u - l], a[c + u - h - l]) & 255;
            }
          }
        }, r.crc = {
          table: (function() {
            for (var i = new Uint32Array(256), a = 0; a < 256; a++) {
              for (var o = a, l = 0; l < 8; l++)
                o & 1 ? o = 3988292384 ^ o >>> 1 : o = o >>> 1;
              i[a] = o;
            }
            return i;
          })(),
          update: function(i, a, o, l) {
            for (var h = 0; h < l; h++) i = r.crc.table[(i ^ a[o + h]) & 255] ^ i >>> 8;
            return i;
          },
          crc: function(i, a, o) {
            return r.crc.update(4294967295, i, a, o) ^ 4294967295;
          }
        }, r.quantize = function(i, a, o) {
          for (var l = [], h = 0, v = 0; v < i.length; v++)
            l.push(r.encode.alphaMul(new Uint8Array(i[v]), o)), h += i[v].byteLength;
          for (var c = new Uint8Array(h), f = new Uint32Array(c.buffer), m = 0, v = 0; v < l.length; v++) {
            for (var u = l[v], p = u.length, k = 0; k < p; k++) c[m + k] = u[k];
            m += p;
          }
          var g = { i0: 0, i1: c.length, bst: null, est: null, tdst: 0, left: null, right: null };
          g.bst = r.quantize.stats(c, g.i0, g.i1), g.est = r.quantize.estats(g.bst);
          for (var b = [g]; b.length < a; ) {
            for (var _ = 0, E = 0, v = 0; v < b.length; v++) b[v].est.L > _ && (_ = b[v].est.L, E = v);
            if (_ < 1e-3) break;
            var I = b[E], L = r.quantize.splitPixels(c, f, I.i0, I.i1, I.est.e, I.est.eMq255), C = { i0: I.i0, i1: L, bst: null, est: null, tdst: 0, left: null, right: null };
            C.bst = r.quantize.stats(c, C.i0, C.i1), C.est = r.quantize.estats(C.bst);
            var F = { i0: L, i1: I.i1, bst: null, est: null, tdst: 0, left: null, right: null };
            F.bst = { R: [], m: [], N: I.bst.N - C.bst.N };
            for (var v = 0; v < 16; v++) F.bst.R[v] = I.bst.R[v] - C.bst.R[v];
            for (var v = 0; v < 4; v++) F.bst.m[v] = I.bst.m[v] - C.bst.m[v];
            F.est = r.quantize.estats(F.bst), I.left = C, I.right = F, b[E] = C, b.push(F);
          }
          b.sort(function(B, ie) {
            return ie.bst.N - B.bst.N;
          });
          for (var V = 0; V < l.length; V++) {
            for (var J = r.quantize.planeDst, O = new Uint8Array(l[V].buffer), K = new Uint32Array(l[V].buffer), P = O.length, v = 0; v < P; v += 4) {
              for (var T = O[v] * 0.00392156862745098, A = O[v + 1] * (1 / 255), z = O[v + 2] * (1 / 255), U = O[v + 3] * (1 / 255), X = g; X.left; ) X = J(X.est, T, A, z, U) <= 0 ? X.left : X.right;
              K[v >> 2] = X.est.rgba;
            }
            l[V] = K.buffer;
          }
          return { bufs: l, plte: b };
        }, r.quantize.getNearest = function(i, a, o, l, h) {
          if (i.left == null)
            return i.tdst = r.quantize.dist(i.est.q, a, o, l, h), i;
          var v = r.quantize.planeDst(i.est, a, o, l, h), c = i.left, f = i.right;
          v > 0 && (c = i.right, f = i.left);
          var m = r.quantize.getNearest(c, a, o, l, h);
          if (m.tdst <= v * v) return m;
          var u = r.quantize.getNearest(f, a, o, l, h);
          return u.tdst < m.tdst ? u : m;
        }, r.quantize.planeDst = function(i, a, o, l, h) {
          var v = i.e;
          return v[0] * a + v[1] * o + v[2] * l + v[3] * h - i.eMq;
        }, r.quantize.dist = function(i, a, o, l, h) {
          var v = a - i[0], c = o - i[1], f = l - i[2], m = h - i[3];
          return v * v + c * c + f * f + m * m;
        }, r.quantize.splitPixels = function(i, a, o, l, h, v) {
          var c = r.quantize.vecDot;
          for (l -= 4; o < l; ) {
            for (; c(i, o, h) <= v; ) o += 4;
            for (; c(i, l, h) > v; ) l -= 4;
            if (o >= l) break;
            var f = a[o >> 2];
            a[o >> 2] = a[l >> 2], a[l >> 2] = f, o += 4, l -= 4;
          }
          for (; c(i, o, h) > v; ) o -= 4;
          return o + 4;
        }, r.quantize.vecDot = function(i, a, o) {
          return i[a] * o[0] + i[a + 1] * o[1] + i[a + 2] * o[2] + i[a + 3] * o[3];
        }, r.quantize.stats = function(i, a, o) {
          for (var l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], h = [0, 0, 0, 0], v = o - a >> 2, c = a; c < o; c += 4) {
            var f = i[c] * 0.00392156862745098, m = i[c + 1] * (1 / 255), u = i[c + 2] * (1 / 255), p = i[c + 3] * (1 / 255);
            h[0] += f, h[1] += m, h[2] += u, h[3] += p, l[0] += f * f, l[1] += f * m, l[2] += f * u, l[3] += f * p, l[5] += m * m, l[6] += m * u, l[7] += m * p, l[10] += u * u, l[11] += u * p, l[15] += p * p;
          }
          return l[4] = l[1], l[8] = l[2], l[12] = l[3], l[9] = l[6], l[13] = l[7], l[14] = l[11], { R: l, m: h, N: v };
        }, r.quantize.estats = function(i) {
          var a = i.R, o = i.m, l = i.N, h = o[0], v = o[1], c = o[2], f = o[3], m = l == 0 ? 0 : 1 / l, u = [
            a[0] - h * h * m,
            a[1] - h * v * m,
            a[2] - h * c * m,
            a[3] - h * f * m,
            a[4] - v * h * m,
            a[5] - v * v * m,
            a[6] - v * c * m,
            a[7] - v * f * m,
            a[8] - c * h * m,
            a[9] - c * v * m,
            a[10] - c * c * m,
            a[11] - c * f * m,
            a[12] - f * h * m,
            a[13] - f * v * m,
            a[14] - f * c * m,
            a[15] - f * f * m
          ], p = u, k = r.M4, g = [0.5, 0.5, 0.5, 0.5], b = 0, _ = 0;
          if (l != 0)
            for (var E = 0; E < 10 && (g = k.multVec(p, g), _ = Math.sqrt(k.dot(g, g)), g = k.sml(1 / _, g), !(Math.abs(_ - b) < 1e-9)); E++)
              b = _;
          var I = [h * m, v * m, c * m, f * m], L = k.dot(k.sml(255, I), g), C = I[3] < 1e-3 ? 0 : 1 / I[3];
          return {
            Cov: u,
            q: I,
            e: g,
            L: b,
            eMq255: L,
            eMq: k.dot(g, I),
            rgba: (Math.round(255 * I[3]) << 24 | Math.round(255 * I[2] * C) << 16 | Math.round(255 * I[1] * C) << 8 | Math.round(255 * I[0] * C) << 0) >>> 0
          };
        }, r.M4 = {
          multVec: function(i, a) {
            return [
              i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] * a[3],
              i[4] * a[0] + i[5] * a[1] + i[6] * a[2] + i[7] * a[3],
              i[8] * a[0] + i[9] * a[1] + i[10] * a[2] + i[11] * a[3],
              i[12] * a[0] + i[13] * a[1] + i[14] * a[2] + i[15] * a[3]
            ];
          },
          dot: function(i, a) {
            return i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] * a[3];
          },
          sml: function(i, a) {
            return [i * a[0], i * a[1], i * a[2], i * a[3]];
          }
        }, r.encode.alphaMul = function(i, a) {
          for (var o = new Uint8Array(i.length), l = i.length >> 2, h = 0; h < l; h++) {
            var v = h << 2, c = i[v + 3];
            a && (c = c < 128 ? 0 : 255);
            var f = c * (1 / 255);
            o[v + 0] = i[v + 0] * f, o[v + 1] = i[v + 1] * f, o[v + 2] = i[v + 2] * f, o[v + 3] = c;
          }
          return o;
        };
      })(t, n);
    })();
  })(_r)), _r.exports;
}
var gh = mh();
const bh = /* @__PURE__ */ rh(gh), ph = () => pa() ? Na("NuxtImg") : "img", yh = ["alt", "src"], Sg = /* @__PURE__ */ _e({
  __name: "LcImage",
  props: {
    alt: {},
    aspectRatio: {},
    blurHash: {},
    densities: {},
    fetchpriority: { default: "low" },
    height: {},
    loading: { type: Boolean },
    preload: { type: Boolean },
    src: {},
    width: {}
  },
  emits: ["error", "load"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = it("wrapper"), i = ph(), a = pe(!0), o = W(
      () => typeof e.aspectRatio == "number" ? e.aspectRatio : (Math.round(e.width) / Math.round(e.height)).toFixed(2)
    ), l = W(() => s.value?.clientHeight ?? 0), h = W(() => s.value?.clientWidth ?? 0), v = W(() => e.loading || a.value), c = W(() => {
      if (!e.blurHash) return;
      const m = ah(e.blurHash, 32, 32), u = new Uint8Array(m), p = bh.encode([u.buffer], 32, 32, 256);
      return "data:image/png;base64," + G0(p);
    }), f = () => {
      a.value = !1, r("load");
    };
    return t({
      clientHeight: l,
      clientWidth: h
    }), (m, u) => ($(), j("div", {
      ref: "wrapper",
      class: "lc-image",
      style: Ct({ "--image-aspect-ratio": o.value })
    }, [
      ($(), xe(Pt(q(i)), Te({ key: "image" }, {
        alt: e.alt,
        densities: e.densities,
        fetchpriority: e.fetchpriority,
        height: e.height,
        preload: e.preload,
        src: e.src,
        width: e.width
      }, {
        class: "lc-image__image",
        loading: e.fetchpriority === "high" ? void 0 : "lazy",
        onError: u[0] || (u[0] = (p) => m.$emit("error")),
        onLoad: f
      }), null, 16, ["loading"])),
      c.value ? ($(), xe(wn, {
        key: 0,
        name: "lc-image__transition"
      }, {
        default: Ee(() => [
          Jt(ae("img", Te({ key: "placeholder" }, { height: e.height, width: e.width }, {
            alt: e.alt,
            class: "lc-image__placeholder",
            src: c.value
          }), null, 16, yh), [
            [ri, v.value]
          ])
        ]),
        _: 1
      })) : ue("", !0)
    ], 4));
  }
}), wh = {
  key: 1,
  class: "lc-info-text__content"
}, xh = {
  key: 0,
  class: "lc-info-text__text"
}, _g = /* @__PURE__ */ _e({
  __name: "LcInfoText",
  props: {
    headline: {},
    icon: { default: "info" },
    iconAlignment: { default: "top" },
    iconSize: { default: "medium" },
    size: { default: "medium" },
    text: {}
  },
  setup(e) {
    const t = An(), n = W(() => [
      "lc-info-text",
      {
        [`lc-info-text--icon-align-${e.iconAlignment}`]: !0,
        [`lc-info-text--size-${e.size}`]: !0
      }
    ]), r = W(() => [
      "lc-info-text__headline",
      {
        "lc-info-text__headline--with-margin": !!e.text || !!t.default
      }
    ]);
    return (s, i) => ($(), j("article", {
      class: ye(n.value)
    }, [
      Oe(q(Qe), {
        name: e.icon,
        size: e.iconSize
      }, null, 8, ["name", "size"]),
      ae("section", null, [
        e.headline ? ($(), j("span", {
          key: 0,
          class: ye(r.value)
        }, Ie(e.headline), 3)) : ue("", !0),
        e.text || s.$slots.default ? ($(), j("div", wh, [
          me(s.$slots, "default", {}, () => [
            e.text ? ($(), j("p", xh, Ie(e.text), 1)) : ue("", !0)
          ])
        ])) : ue("", !0)
      ])
    ], 2));
  }
}), Cg = ["center", "top"], Eg = ["medium", "small"], kh = { class: "lc-link-list" }, Tg = /* @__PURE__ */ _e({
  __name: "LcLinkList",
  setup(e) {
    return (t, n) => ($(), j("ul", kh, [
      me(t.$slots, "default")
    ]));
  }
}), Sh = { key: 0 }, _h = { class: "lc-link-list-item__headline" }, Ch = {
  key: 0,
  class: "lc-link-list-item__text"
}, Ag = /* @__PURE__ */ _e({
  __name: "LcLinkListItem",
  props: {
    href: {},
    target: {},
    to: {},
    headline: {},
    icon: {},
    text: {}
  },
  setup(e) {
    const t = W(() => [
      "lc-link-list-item",
      {
        "lc-link-list-item--headline-only": !e.text
      }
    ]);
    return (n, r) => ($(), j("li", {
      class: ye(t.value)
    }, [
      Oe(q(oi), Te({ href: e.href, target: e.target, to: e.to }, { class: "lc-link-list-item__link" }), {
        default: Ee(() => [
          n.$slots.default ? ($(), j("div", Sh, [
            me(n.$slots, "default")
          ])) : ($(), j(Ge, { key: 1 }, [
            e.icon ? ($(), xe(q(Qe), {
              key: 0,
              name: e.icon
            }, null, 8, ["name"])) : ue("", !0),
            ae("div", null, [
              ae("span", _h, Ie(e.headline), 1),
              e.text ? ($(), j("p", Ch, Ie(e.text), 1)) : ue("", !0)
            ])
          ], 64))
        ]),
        _: 3
      }, 16)
    ], 2));
  }
}), Eh = "data:image/svg+xml,%3csvg%20id='eSvZIJXzBLn1'%20width='16'%20height='16'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20viewBox='0%200%2016%2016'%20shape-rendering='geometricPrecision'%20text-rendering='geometricPrecision'%3e%3cstyle%3e%3c![CDATA[%23eSvZIJXzBLn2_to%20{animation:%20eSvZIJXzBLn2_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_to__to%20{%200%25%20{transform:%20translate(7.980026px,1.350002px)}%2024%25%20{transform:%20translate(7.980026px,1.350002px)}%2025%25%20{transform:%20translate(7.980026px,2.07px)}%2028%25%20{transform:%20translate(7.980026px,1px)}%2032%25%20{transform:%20translate(9.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20translate(5.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20translate(8.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20translate(6.980026px,1px)}%2044%25%20{transform:%20translate(7.999896px,1.175001px)}%2048%25%20{transform:%20translate(7.980026px,1.350002px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2052%25%20{transform:%20translate(7.980026px,1.35px)}%20100%25%20{transform:%20translate(7.980026px,1.35px)}}%20%23eSvZIJXzBLn2_tr%20{animation:%20eSvZIJXzBLn2_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2028%25%20{transform:%20rotate(0deg)}%2032%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20rotate(-8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20rotate(-8deg)}%2044%25%20{transform:%20rotate(0deg)}%20100%25%20{transform:%20rotate(0deg)}}%20%23eSvZIJXzBLn3_to%20{animation:%20eSvZIJXzBLn3_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn3_tr%20{animation:%20eSvZIJXzBLn3_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn6_to%20{animation:%20eSvZIJXzBLn6_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn6_tr%20{animation:%20eSvZIJXzBLn6_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%206%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn9_to%20{animation:%20eSvZIJXzBLn9_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn9_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000025px,9.6px);animation-timing-function:%20cubic-bezier(0.42,0,1,1)}%2044%25%20{transform:%20translate(8.000025px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}]]%3e%3c/style%3e%3cg%20id='eSvZIJXzBLn2_to'%20transform='translate(7.980026,1.350002)'%3e%3cg%20id='eSvZIJXzBLn2_tr'%20transform='rotate(0)'%3e%3cpath%20d='M6.06888,2.13247c.8-.2,1.4-.26667,1.93333-.26667s1.13333.06667,1.86667.26667c.33332.13333.73332-.13333.80002-.46667.1333-.33333-.1334-.733329-.4667-.799996-.77705-.253981-1.07173-.333333-2.19999-.333333-.73333,0-1.40328.079352-2.26667.333333-.33333.066667-.53333.399996-.46666.799996.06666.33334.46666.53334.8.46667Z'%20transform='translate(-7.980026,-1.350002)'%20fill='%23394e8e'/%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn3_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn3_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='4.09313'%20rx='0.638'%20ry='0.638'%20transform='translate(7.36206%205.73901)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn6_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn6_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='3.48663'%20rx='0.638'%20ry='0.638'%20transform='matrix(0-1%201%200%205.14111%209.83799)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn9_to'%20transform='translate(8.000025,9.2)'%3e%3cpath%20d='M8.00005,14.2C10.7615,14.2,13,11.9614,13,9.2s-2.2385-5-4.99995-5-5,2.23858-5,5s2.23858,5,5,5Zm0,1.2C11.4242,15.4,14.2,12.6242,14.2,9.2s-2.7758-6.2-6.19995-6.2-6.2,2.77583-6.2,6.2s2.77583,6.2,6.2,6.2Z'%20transform='translate(-8.000025,-9.2)'%20clip-rule='evenodd'%20fill='%23394e8e'%20fill-rule='evenodd'/%3e%3c/g%3e%3c/svg%3e", Th = { class: "lc-lottery-cutoff-time__headline" }, Ah = ["src"], Lh = { class: "lc-lottery-cutoff-time__time-to-cutoff" }, $h = { class: "lc-lottery-cutoff-time__time-is-almost-up" }, Ih = {
  key: 0,
  class: "lc-lottery-cutoff-time__divider"
}, Dh = { class: "lc-lottery-cutoff-time__countdown-wrapper" }, Pl = /* @__PURE__ */ _e({
  __name: "LcLotteryCutoffTime",
  props: {
    countdownVariant: { default: "default" },
    cutoffTime: {},
    locale: { default: () => je.general.locale },
    nextCutoffTime: {},
    singleLine: { type: Boolean },
    startAnimationTime: { default: 90 },
    textCutoffTime: { default: () => je.lcLotteryCutoffTime.textCutoffTime },
    textTimeIsAlmostUp: { default: () => je.lcLotteryCutoffTime.textTimeIsAlmostUp },
    textTimeToCutoff: { default: () => je.lcLotteryCutoffTime.textTimeToCutoff },
    variant: { default: "default" }
  },
  emits: ["cutoff-time-reached"],
  setup(e, { emit: t }) {
    const n = t, r = pe(), s = Ro(() => /* @__PURE__ */ new Date()), i = W(() => [
      "lc-lottery-cutoff-time",
      `lc-lottery-cutoff-time--variant-${e.variant}`,
      {
        "lc-lottery-cutoff-time--animated": h.value,
        "lc-lottery-cutoff-time--single-line": e.singleLine
      }
    ]), a = W(() => new Date(e.cutoffTime)), o = W(
      () => No({
        date: v.value,
        format: "drawingShort",
        locale: e.locale
      })
    ), l = W(() => c("days") === 0), h = W(() => {
      const m = c("minutes");
      return l.value && m ? m < e.startAnimationTime : !1;
    }), v = W({
      get: () => r.value ?? new Date(e.cutoffTime),
      set: (m) => {
        r.value = m;
      }
    }), c = (m) => {
      if (!ii(a.value)) return null;
      const { days: u = 0, hours: p = 0, minutes: k = 0 } = Fo(s.value, a.value);
      switch (m) {
        case "days":
          return u;
        case "minutes":
          return u * 24 + p * 60 + k;
      }
    }, f = () => {
      n("cutoff-time-reached"), So(a.value) && e.nextCutoffTime && (v.value = new Date(e.nextCutoffTime));
    };
    return (m, u) => ($(), j("div", {
      class: ye(i.value)
    }, [
      ae("span", Th, [
        h.value ? ($(), j("img", {
          key: 0,
          alt: "",
          height: "16",
          src: q(Eh),
          width: "16"
        }, null, 8, Ah)) : ($(), xe(q(Qe), {
          key: 1,
          name: l.value ? "alarm" : "time",
          size: "small"
        }, null, 8, ["name"])),
        me(m.$slots, "title", {}, () => [
          ae("span", Lh, Ie(l.value ? e.textTimeToCutoff : e.textCutoffTime), 1),
          ae("span", $h, Ie(e.textTimeIsAlmostUp), 1)
        ])
      ]),
      e.variant === "default" && e.singleLine ? ($(), j("span", Ih, " : ")) : ue("", !0),
      ae("div", Dh, [
        l.value ? ($(), xe(q(Xd), {
          key: 0,
          class: "lc-lottery-cutoff-time__countdown",
          "expires-at": v.value,
          variant: e.countdownVariant,
          onExpired: f,
          onUpdate: u[0] || (u[0] = (p) => s.value = /* @__PURE__ */ new Date())
        }, null, 8, ["expires-at", "variant"])) : ($(), xe(q(Eo), Te({
          key: 1,
          class: "lc-lottery-cutoff-time__date-time"
        }, { locale: e.locale, ...q(vi).drawingShort }, { datetime: v.value }), {
          default: Ee(() => [
            wt(Ie(o.value), 1)
          ]),
          _: 1
        }, 16, ["datetime"]))
      ])
    ], 2));
  }
}), Lg = ["default", "expressive"], Mh = {
  key: 0,
  class: "lc-lottery-numbers__icon-wrap"
}, Oh = {
  key: 0,
  class: "lc-lottery-numbers__field-divider"
}, Rh = "extra", Fh = /* @__PURE__ */ _e({
  __name: "LcLotteryNumbers",
  props: {
    fields: {},
    listClass: {},
    numberClass: { type: Function },
    rows: {},
    size: { default: "medium" },
    spacing: { default: "medium" }
  },
  setup(e) {
    const t = W(() => [
      "lc-lottery-numbers",
      `lc-lottery-numbers--size-${e.size}`,
      `lc-lottery-numbers--spacing-${e.spacing}`,
      {
        "lc-lottery-numbers--multiple-rows": e.rows
      }
    ]), n = W(() => s.value.flat().length), r = W(() => e.rows ? Math.ceil(n.value / e.rows) : n.value), s = W(
      () => e.fields.map(
        ({ name: i, numbers: a }) => a.map(({ icon: o, ignored: l, matching: h, value: v }) => ({
          empty: !o && !l && (v === void 0 || v === ""),
          icon: o,
          ignored: l,
          matching: h,
          name: i.toLowerCase().replace("_", "-"),
          number: v
        }))
      ).filter((i) => !!i.length)
    );
    return (i, a) => ($(), j("article", {
      class: ye(t.value),
      style: Ct({ "--items-per-row": r.value })
    }, [
      ae("ol", {
        class: ye(["lc-lottery-numbers__list", e.listClass])
      }, [
        ($(!0), j(Ge, null, vt(s.value, (o, l) => ($(), j(Ge, { key: l }, [
          ($(!0), j(Ge, null, vt(o, ({ empty: h, icon: v, ignored: c, matching: f, name: m, number: u }, p) => ($(), j(Ge, {
            key: `${l}-${p}`
          }, [
            ae("li", {
              class: "lc-lottery-numbers__list-item",
              style: Ct({
                "--number-bg": `var(--lottery-numbers-${m}-bg)`,
                "--number-border": `var(--lottery-numbers-${m}-border)`,
                "--number-color": `var(--lottery-numbers-${m}-color)`,
                "--number-font-size": `var(--lottery-numbers-${m}-font-size)`,
                "--number-font-weight": `var(--lottery-numbers-${m}-font-weight)`
              })
            }, [
              me(i.$slots, `highlight-${m}`),
              ae("div", {
                class: ye(["lc-lottery-numbers__number", [
                  {
                    "lc-lottery-numbers__number--empty": h,
                    "lc-lottery-numbers__number--empty-extra": h && m === Rh,
                    "lc-lottery-numbers__number--ignored": c
                  },
                  e.numberClass ? e.numberClass(u, m) : ""
                ]])
              }, [
                f ? ($(), j("div", Mh, [
                  Oe(q(Qe), {
                    class: "lc-lottery-numbers__icon",
                    name: "checkmark-small"
                  })
                ])) : ue("", !0),
                me(i.$slots, `number-${m}`, Te({ ref_for: !0 }, { icon: v, number: u }), () => [
                  v ? ($(), xe(q(Qe), {
                    key: 0,
                    name: v
                  }, null, 8, ["name"])) : ($(), j(Ge, { key: 1 }, [
                    wt(Ie(c ? "X" : u), 1)
                  ], 64))
                ])
              ], 2)
            ], 4),
            l < s.value.length - 1 && p === o.length - 1 && i.$slots["field-divider"] ? ($(), j("li", Oh, [
              me(i.$slots, "field-divider")
            ])) : ue("", !0)
          ], 64))), 128))
        ], 64))), 128))
      ], 2)
    ], 6));
  }
}), $g = ["large", "medium", "small"], Ig = ["medium", "small"], Dg = [
  "custom-cell",
  "default",
  "high-frequency",
  "round"
];
var jt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Home = "Home", e))(jt || {});
const Nh = ["id"], Bh = { class: "lc-lottery-number-selector__label" }, Ph = ["for"], zh = ["id", "checked", "disabled", "tabindex", "onChange", "onFocusin", "onKeydown"], Mg = /* @__PURE__ */ _e({
  __name: "LcLotteryNumberSelector",
  props: {
    allNumbersToggled: { type: Boolean },
    disabled: { type: Boolean },
    fixedColumns: {},
    id: {},
    label: {},
    max: {},
    min: { default: 1 },
    selectableNumbers: {},
    selectableMax: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["complete", "update:value"],
  setup(e, { emit: t }) {
    const n = t, r = jo(), s = it("numberInputs"), i = Tt(e.id), a = pe(e.fixedColumns ?? 0), o = pe(0), l = W(() => E(o.value)), h = W(
      () => c.value ? u.value : f.value
    ), v = W(() => L(o.value)), c = W(() => e.value.length >= e.selectableMax), f = W(() => {
      const B = Array.from({ length: b.value }, () => []);
      return m.value.map((ie, H) => {
        B[L(H)].push(H);
      }), T(B);
    }), m = W(() => {
      if (e.selectableNumbers?.length)
        return [...e.selectableNumbers];
      if (e.max === void 0)
        throw Error('LcLotteryNumberSelector: provide "max" or "selectableNumbers".');
      if (e.min < 0)
        throw Error('LcLotteryNumberSelector: "min" must be >= 0.');
      if (e.min >= e.max)
        throw Error('LcLotteryNumberSelector: "max" must be greater than "min".');
      return Array.from({ length: e.max - e.min + 1 }, (B, ie) => e.min + ie);
    }), u = W(
      () => f.value.map(
        (B) => B.map(
          (ie) => p.value.includes(ie) ? ie : -1
        )
      )
    ), p = W(() => e.value.map((B) => m.value.indexOf(B))), k = W(() => Math.min(g.value, a.value)), g = W(() => m.value.length), b = W(() => Math.ceil(g.value / k.value)), _ = (B) => {
      const ie = h.value.length, H = h.value[0].length;
      let ee = v.value, ce = l.value;
      do
        switch (B) {
          case "down":
            ee = (ee + 1) % ie, ee === 0 && (ce = (ce + 1) % H);
            break;
          case "left":
            ce = (ce - 1 + H) % H, ce === H - 1 && (ee = (ee - 1 + ie) % ie);
            break;
          case "right":
            ce = (ce + 1) % H, ce === 0 && (ee = (ee + 1) % ie);
            break;
          case "up":
            ee = (ee - 1 + ie) % ie, ee === ie - 1 && (ce = (ce - 1 + H) % H);
            break;
        }
      while (h.value[ee][ce] === -1);
      return h.value[ee][ce];
    }, E = (B) => B % k.value, I = (B) => ({
      "lc-lottery-number-selector__number": !0,
      "lc-lottery-number-selector__number--all-checked": e.allNumbersToggled,
      "lc-lottery-number-selector__number--checked": A(B),
      "lc-lottery-number-selector__number--disabled": z(B)
    }), L = (B) => Math.floor(B / k.value), C = () => {
      if (c.value) {
        const H = f.value[v.value].filter(
          (ee) => ee > o.value && p.value.includes(ee)
        ).reverse();
        if (!H.length) return;
        o.value = H[0];
        return;
      }
      const B = f.value[v.value];
      o.value = B.at(-1) ?? 0;
    }, F = () => {
      if (c.value) {
        const H = f.value[v.value].filter(
          (ee) => ee < o.value && p.value.includes(ee)
        );
        if (!H.length) return;
        o.value = H[0];
        return;
      }
      const B = f.value[v.value];
      o.value = B[0];
    }, V = () => {
      o.value = c.value ? p.value[0] : 0;
    }, J = () => {
      const B = p.value.at(-1) ?? 0;
      o.value = c.value ? B : g.value - 1;
    }, O = (B) => {
      en(B.key, jt) && (B.preventDefault(), B.stopPropagation(), B.ctrlKey ? K(B.key) : P(B.key));
    }, K = (B) => {
      switch (B) {
        case jt.End:
          J();
          break;
        case jt.Home:
          V();
          break;
      }
    }, P = (B) => {
      switch (B) {
        case jt.ArrowDown:
          o.value = _("down");
          break;
        case jt.ArrowLeft:
          o.value = _("left");
          break;
        case jt.ArrowRight:
          o.value = _("right");
          break;
        case jt.ArrowUp:
          o.value = _("up");
          break;
        case jt.End:
          C();
          break;
        case jt.Home:
          F();
          break;
      }
    }, T = (B) => {
      const ie = Math.max(...B.map((H) => H.length));
      return B.map((H) => {
        const ee = [...H];
        for (; ee.length < ie; )
          ee.push(-1);
        return ee;
      });
    }, A = (B) => e.value.includes(B), z = (B) => e.disabled || !A(B) && c.value || e.allNumbersToggled, U = (B) => {
      const ie = [...e.value], H = ie.indexOf(B);
      H > -1 ? ie.splice(H, 1) : c.value || (ie.push(B), ie.sort((ee, ce) => ee - ce)), n("update:value", ie);
    };
    ze(
      () => e.allNumbersToggled,
      () => {
        const B = e.allNumbersToggled ? m.value : [];
        n("update:value", B);
      }
    ), ze(o, (B) => {
      s.value?.[B].focus();
    }), ze(c, (B) => {
      B && n("complete");
    });
    const X = Js(() => {
      if (e.fixedColumns && e.fixedColumns >= 0) {
        a.value = e.fixedColumns;
        return;
      }
      const B = s.value;
      if (!r || !B?.length) return;
      const ie = B[0].getBoundingClientRect().top;
      let H = 0;
      for (const ee of B) {
        if (ee.getBoundingClientRect().top !== ie) break;
        H++;
      }
      a.value = H;
    }, 100);
    return ze(() => e.fixedColumns, X), mt(X), on(window, "resize", X), (B, ie) => ($(), j("fieldset", Te(B.$attrs, {
      id: q(i),
      class: [
        "lc-lottery-number-selector",
        `lc-lottery-number-selector--${e.variant}`,
        {
          "lc-lottery-number-selector--fixed-columns": e.fixedColumns && e.fixedColumns >= 0
        }
      ],
      style: {
        "--fixed-columns": e.fixedColumns,
        "--hfg-number-background": "var(--lottery-numbers-extra-bg)",
        "--number-bg": "var(--lottery-numbers-extra-bg)",
        "--round-number-bg": `var(--lottery-number-rounded-${e.id}-bg)`,
        "--round-number-color": `var(--lottery-number-rounded-${e.id}-color)`
      }
    }), [
      ae("legend", Bh, Ie(e.label), 1),
      ($(!0), j(Ge, null, vt(m.value, (H, ee) => ($(), j("label", {
        key: H,
        class: ye(I(H)),
        for: `gridcell-${E(ee)}-${L(ee)}-${q(i)}`
      }, [
        ae("input", {
          id: `gridcell-${E(ee)}-${L(ee)}-${q(i)}`,
          ref_for: !0,
          ref: "numberInputs",
          checked: A(H),
          class: "lc-lottery-number-selector__input",
          disabled: z(H),
          tabindex: o.value === ee || A(H) ? 0 : -1,
          type: "checkbox",
          onChange: () => U(H),
          onFocusin: (ce) => o.value = ee,
          onKeydown: [
            O,
            ai(() => U(H), ["enter"])
          ]
        }, null, 40, zh),
        me(B.$slots, "cell", Te({ ref_for: !0 }, {
          checked: A(H),
          disabled: z(H),
          number: H
        }), () => [
          wt(Ie(H), 1)
        ])
      ], 10, Ph))), 128))
    ], 16, Nh));
  }
}), Vh = { class: "w-full" }, Hh = {
  key: 0,
  class: "lc-lottery-teaser__jackpot-text"
}, Uh = {
  key: 1,
  class: "lc-lottery-teaser__jackpot-text"
}, qh = { class: "lc-lottery-teaser__button-container" }, jh = { class: "lc-lottery-teaser__button-wrap" }, Zh = {
  key: 0,
  class: "lc-lottery-teaser__button-wrap"
}, Wh = {
  key: 0,
  class: "lc-lottery-teaser__draw-date"
}, Yh = { class: "lc-lottery-teaser__draw-date-headline" }, Og = /* @__PURE__ */ _e({
  __name: "LcLotteryTeaser",
  props: {
    cutoffTime: {},
    nextCutoffTime: {},
    backgroundPattern: {},
    badge: {},
    comingSoon: { type: Boolean },
    drawDate: {},
    drawDateHeadline: {},
    headline: {},
    jackpot: {},
    locale: { default: () => je.general.locale },
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" }
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    const t = An(), n = W(() => [
      "lc-lottery-teaser",
      `lc-lottery-teaser--variant-${e.variant}`,
      {
        "lc-lottery-teaser--two-buttons": s.value
      }
    ]), r = W(
      () => No({
        date: e.drawDate,
        format: "drawingShort",
        locale: e.locale
      })
    ), s = W(
      () => e.variant !== "expressive" && !!(e.secondaryButtonProps?.text || t["secondary-button"])
    ), i = W(
      () => e.primaryButtonProps.to ? Yn(e.primaryButtonProps.to) : "div"
    );
    return (a, o) => ($(), xe(q(nr), Te({ badge: e.badge, backgroundPattern: e.backgroundPattern }, {
      "body-class": "lc-lottery-teaser__body",
      class: n.value,
      "footer-class": "lc-lottery-teaser__footer",
      "header-class": "lc-lottery-teaser__header",
      "header-to": e.primaryButtonProps.to,
      style: {
        "--teaser-frame-color": "var(--lottery-teaser-frame-color)"
      },
      variant: e.variant === "expressive" ? "default" : e.variant,
      onHeaderClick: e.onTeaserClick
    }), Xa({
      header: Ee(() => [
        me(a.$slots, "lottery-logo")
      ]),
      default: Ee(() => [
        e.variant === "expressive" ? ($(), xe(q(Pl), Te({ key: 0 }, { cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
          class: "lc-lottery-teaser__cutoff-time",
          variant: "expressive",
          onCutoffTimeReached: o[0] || (o[0] = (l) => a.$emit("outdated"))
        }), null, 16)) : ue("", !0),
        ae("section", Vh, [
          ($(), xe(Pt(i.value), {
            class: "lc-lottery-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: Ee(() => [
              e.headline ? ($(), j("strong", Hh, Ie(e.headline), 1)) : ue("", !0),
              Oe(q(qo), Te(e.jackpot, { size: "small" }), null, 16),
              e.subline ? ($(), j("strong", Uh, Ie(e.subline), 1)) : ue("", !0)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        ae("section", qh, [
          ae("div", jh, [
            me(a.$slots, "primary-button", {}, () => [
              Oe(q(Et), Te(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                variant: s.value ? "primary-ghost" : "primary",
                onClick: o[1] || (o[1] = (l) => a.$emit("primary-button-click"))
              }), {
                default: Ee(() => [
                  wt(Ie(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label", "variant"])
            ])
          ]),
          s.value ? ($(), j("div", Zh, [
            me(a.$slots, "secondary-button", {}, () => [
              e.secondaryButtonProps ? ($(), xe(q(Et), Te({ key: 0 }, e.secondaryButtonProps, {
                "aria-label": e.secondaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                onClick: o[2] || (o[2] = (l) => a.$emit("secondary-button-click"))
              }), {
                default: Ee(() => [
                  wt(Ie(e.secondaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])) : ue("", !0)
            ])
          ])) : ue("", !0)
        ])
      ]),
      _: 2
    }, [
      e.variant !== "expressive" ? {
        name: "footer",
        fn: Ee(() => [
          ["default", "badge"].includes(e.variant) ? ($(), j("div", Wh, [
            ae("div", Yh, [
              Oe(q(Qe), {
                name: "calendar",
                size: "small"
              }),
              ae("span", null, Ie(e.drawDateHeadline), 1)
            ]),
            Oe(q(Eo), Te({ locale: e.locale, ...q(vi).drawingShort }, { datetime: e.drawDate }), {
              default: Ee(() => [
                wt(Ie(r.value), 1)
              ]),
              _: 1
            }, 16, ["datetime"])
          ])) : ue("", !0),
          Oe(q(Pl), Te({ cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
            "single-line": e.variant === "hero",
            variant: e.variant === "hero" ? "expressive" : "default",
            onCutoffTimeReached: o[3] || (o[3] = (l) => a.$emit("outdated"))
          }), null, 16, ["single-line", "variant"])
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["class", "header-to", "variant", "onHeaderClick"]));
  }
}), Rg = [...Wo, "expressive"], Xh = { class: "lc-masked-value-display" }, Fg = /* @__PURE__ */ _e({
  __name: "LcMaskedValueDisplay",
  props: {
    masksPerPart: { default: 4 },
    parts: { default: 1 }
  },
  setup(e) {
    return (t, n) => ($(), j("span", Xh, [
      ($(!0), j(Ge, null, vt(e.parts, (r) => ($(), j("span", {
        key: r,
        class: "lc-masked-value-display__part"
      }, [
        ($(!0), j(Ge, null, vt(e.masksPerPart, (s) => ($(), j("span", {
          key: s,
          class: "lc-masked-value-display__mask"
        }))), 128))
      ]))), 128)),
      me(t.$slots, "default")
    ]));
  }
}), Xr = Math.min, Pn = Math.max, qa = Math.round, Da = Math.floor, Kt = (e) => ({
  x: e,
  y: e
}), Gh = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function gi(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function jn(e) {
  return e.split("-")[0];
}
function ar(e) {
  return e.split("-")[1];
}
function Kh(e) {
  return e === "x" ? "y" : "x";
}
function es(e) {
  return e === "y" ? "height" : "width";
}
function yn(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function ts(e) {
  return Kh(yn(e));
}
function Jh(e, t, n) {
  n === void 0 && (n = !1);
  const r = ar(e), s = ts(e), i = es(s);
  let a = s === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = ja(a)), [a, ja(a)];
}
function Qh(e) {
  const t = ja(e);
  return [Gr(e), t, Gr(t)];
}
function Gr(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const zl = ["left", "right"], Vl = ["right", "left"], ev = ["top", "bottom"], tv = ["bottom", "top"];
function nv(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Vl : zl : t ? zl : Vl;
    case "left":
    case "right":
      return t ? ev : tv;
    default:
      return [];
  }
}
function av(e, t, n, r) {
  const s = ar(e);
  let i = nv(jn(e), n === "start", r);
  return s && (i = i.map((a) => a + "-" + s), t && (i = i.concat(i.map(Gr)))), i;
}
function ja(e) {
  const t = jn(e);
  return Gh[t] + e.slice(t.length);
}
function rv(e) {
  var t, n, r, s;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (n = e.right) != null ? n : 0,
    bottom: (r = e.bottom) != null ? r : 0,
    left: (s = e.left) != null ? s : 0
  };
}
function iv(e) {
  return typeof e != "number" ? rv(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Za(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: s
  } = e;
  return {
    width: r,
    height: s,
    top: n,
    left: t,
    right: t + r,
    bottom: n + s,
    x: t,
    y: n
  };
}
function Hl(e, t, n) {
  let {
    reference: r,
    floating: s
  } = e;
  const i = yn(t), a = ts(t), o = es(a), l = jn(t), h = i === "y", v = r.x + r.width / 2 - s.width / 2, c = r.y + r.height / 2 - s.height / 2, f = r[o] / 2 - s[o] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: v,
        y: r.y - s.height
      };
      break;
    case "bottom":
      m = {
        x: v,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: c
      };
      break;
    case "left":
      m = {
        x: r.x - s.width,
        y: c
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  const u = ar(t);
  return u && (m[a] += f * (u === "end" ? 1 : -1) * (n && h ? -1 : 1)), m;
}
async function lv(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: s,
    platform: i,
    rects: a,
    elements: o,
    strategy: l
  } = e, {
    boundary: h = "clippingAncestors",
    rootBoundary: v = "viewport",
    elementContext: c = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = gi(t, e), u = iv(m), k = o[f ? c === "floating" ? "reference" : "floating" : c], g = Za(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(k))) == null || n ? k : k.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
    boundary: h,
    rootBoundary: v,
    strategy: l
  })), b = c === "floating" ? {
    x: r,
    y: s,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), E = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
    x: 1,
    y: 1
  }, I = Za(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: b,
    offsetParent: _,
    strategy: l
  }) : b);
  return {
    top: (g.top - I.top + u.top) / E.y,
    bottom: (I.bottom - g.bottom + u.bottom) / E.y,
    left: (g.left - I.left + u.left) / E.x,
    right: (I.right - g.right + u.right) / E.x
  };
}
const ov = 50, sv = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: s = "absolute",
    middleware: i = [],
    platform: a
  } = n, o = a.detectOverflow ? a : {
    ...a,
    detectOverflow: lv
  }, l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let h = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: s
  }), {
    x: v,
    y: c
  } = Hl(h, r, l), f = r, m = 0;
  const u = {};
  for (let p = 0; p < i.length; p++) {
    const k = i[p];
    if (!k)
      continue;
    const {
      name: g,
      fn: b
    } = k, {
      x: _,
      y: E,
      data: I,
      reset: L
    } = await b({
      x: v,
      y: c,
      initialPlacement: r,
      placement: f,
      strategy: s,
      middlewareData: u,
      rects: h,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    v = _ ?? v, c = E ?? c, u[g] = {
      ...u[g],
      ...I
    }, L && m < ov && (m++, typeof L == "object" && (L.placement && (f = L.placement), L.rects && (h = L.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: s
    }) : L.rects), {
      x: v,
      y: c
    } = Hl(h, f, l)), p = -1);
  }
  return {
    x: v,
    y: c,
    placement: f,
    strategy: s,
    middlewareData: u
  };
}, uv = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: s,
        middlewareData: i,
        rects: a,
        initialPlacement: o,
        platform: l,
        elements: h
      } = t, {
        mainAxis: v = !0,
        crossAxis: c = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: u = "none",
        flipAlignment: p = !0,
        ...k
      } = gi(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const g = jn(s), b = yn(o), _ = jn(o) === o, E = await (l.isRTL == null ? void 0 : l.isRTL(h.floating)), I = f || (_ || !p ? [ja(o)] : Qh(o)), L = u !== "none";
      !f && L && I.push(...av(o, p, u, E));
      const C = [o, ...I], F = await l.detectOverflow(t, k), V = [];
      let J = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (v && V.push(F[g]), c) {
        const T = Jh(s, a, E);
        V.push(F[T[0]], F[T[1]]);
      }
      if (J = [...J, {
        placement: s,
        overflows: V
      }], !V.every((T) => T <= 0)) {
        var O, K;
        const T = (((O = i.flip) == null ? void 0 : O.index) || 0) + 1, A = C[T];
        if (A && (!(c === "alignment" ? b !== yn(A) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        J.every((X) => yn(X.placement) === b ? X.overflows[0] > 0 : !0)))
          return {
            data: {
              index: T,
              overflows: J
            },
            reset: {
              placement: A
            }
          };
        let z = (K = J.filter((U) => U.overflows[0] <= 0).sort((U, X) => U.overflows[1] - X.overflows[1])[0]) == null ? void 0 : K.placement;
        if (!z)
          switch (m) {
            case "bestFit": {
              var P;
              const U = (P = J.filter((X) => {
                if (L) {
                  const B = yn(X.placement);
                  return B === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  B === "y";
                }
                return !0;
              }).map((X) => [X.placement, X.overflows.filter((B) => B > 0).reduce((B, ie) => B + ie, 0)]).sort((X, B) => X[1] - B[1])[0]) == null ? void 0 : P[0];
              U && (z = U);
              break;
            }
            case "initialPlacement":
              z = o;
              break;
          }
        if (s !== z)
          return {
            reset: {
              placement: z
            }
          };
      }
      return {};
    }
  };
}, cv = /* @__PURE__ */ new Set(["left", "top"]);
async function dv(e, t) {
  const {
    placement: n,
    platform: r,
    elements: s
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(s.floating)), a = jn(n), o = ar(n), l = yn(n) === "y", h = cv.has(a) ? -1 : 1, v = i && l ? -1 : 1, c = gi(t, e);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: u
  } = typeof c == "number" ? {
    mainAxis: c,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: c.mainAxis || 0,
    crossAxis: c.crossAxis || 0,
    alignmentAxis: c.alignmentAxis
  };
  return o && typeof u == "number" && (m = o === "end" ? u * -1 : u), l ? {
    x: m * v,
    y: f * h
  } : {
    x: f * h,
    y: m * v
  };
}
const fv = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: s,
        y: i,
        placement: a,
        middlewareData: o
      } = t, l = await dv(t, e);
      return a === ((n = o.offset) == null ? void 0 : n.placement) && (r = o.arrow) != null && r.alignmentOffset ? {} : {
        x: s + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
};
function rr() {
  return typeof window < "u";
}
function In(e) {
  return bi(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function It(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function tn(e) {
  var t;
  return (t = (bi(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function bi(e) {
  return rr() ? e instanceof Node || e instanceof It(e).Node : !1;
}
function Wt(e) {
  return rr() ? e instanceof Element || e instanceof It(e).Element : !1;
}
function dn(e) {
  return rr() ? e instanceof HTMLElement || e instanceof It(e).HTMLElement : !1;
}
function Ul(e) {
  return !rr() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof It(e).ShadowRoot;
}
function ir(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: s
  } = Yt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && s !== "inline" && s !== "contents";
}
function hv(e) {
  return /^(table|td|th)$/.test(In(e));
}
function lr(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const vv = /transform|translate|scale|rotate|perspective|filter/, mv = /paint|layout|strict|content/, bn = (e) => !!e && e !== "none";
let Rr;
function pi(e) {
  const t = Wt(e) ? Yt(e) : e;
  return bn(t.transform) || bn(t.translate) || bn(t.scale) || bn(t.rotate) || bn(t.perspective) || !yi() && (bn(t.backdropFilter) || bn(t.filter)) || vv.test(t.willChange || "") || mv.test(t.contain || "");
}
function gv(e) {
  let t = En(e);
  for (; dn(t) && !va(t); ) {
    if (pi(t))
      return t;
    if (lr(t))
      return null;
    t = En(t);
  }
  return null;
}
function yi() {
  return Rr == null && (Rr = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Rr;
}
function va(e) {
  return /^(html|body|#document)$/.test(In(e));
}
function Yt(e) {
  return It(e).getComputedStyle(e);
}
function or(e) {
  return Wt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function En(e) {
  if (In(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ul(e) && e.host || // Fallback.
    tn(e)
  );
  return Ul(t) ? t.host : t;
}
function ns(e) {
  const t = En(e);
  return va(t) ? (e.ownerDocument || e).body : dn(t) && ir(t) ? t : ns(t);
}
function ma(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const s = ns(e), i = s === ((r = e.ownerDocument) == null ? void 0 : r.body), a = It(s);
  if (i) {
    const o = Kr(a);
    return t.concat(a, a.visualViewport || [], ir(s) ? s : [], o && n ? ma(o) : []);
  } else
    return t.concat(s, ma(s, [], n));
}
function Kr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function as(e) {
  const t = Yt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const s = dn(e), i = s ? e.offsetWidth : n, a = s ? e.offsetHeight : r, o = qa(n) !== i || qa(r) !== a;
  return o && (n = i, r = a), {
    width: n,
    height: r,
    $: o
  };
}
function wi(e) {
  return Wt(e) ? e : e.contextElement;
}
function zn(e) {
  const t = wi(e);
  if (!dn(t))
    return Kt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: s,
    $: i
  } = as(t);
  let a = (i ? qa(n.width) : n.width) / r, o = (i ? qa(n.height) : n.height) / s;
  return (!a || !Number.isFinite(a)) && (a = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: a,
    y: o
  };
}
const bv = /* @__PURE__ */ Kt(0);
function rs(e) {
  const t = It(e);
  return !yi() || !t.visualViewport ? bv : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function pv(e, t, n) {
  return t === void 0 && (t = !1), !!n && t && n === It(e);
}
function Tn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const s = e.getBoundingClientRect(), i = wi(e);
  let a = Kt(1);
  t && (r ? Wt(r) && (a = zn(r)) : a = zn(e));
  const o = pv(i, n, r) ? rs(i) : Kt(0);
  let l = (s.left + o.x) / a.x, h = (s.top + o.y) / a.y, v = s.width / a.x, c = s.height / a.y;
  if (i && r) {
    const f = It(i), m = Wt(r) ? It(r) : r;
    let u = f, p = Kr(u);
    for (; p && m !== u; ) {
      const k = zn(p), g = p.getBoundingClientRect(), b = Yt(p), _ = g.left + (p.clientLeft + parseFloat(b.paddingLeft)) * k.x, E = g.top + (p.clientTop + parseFloat(b.paddingTop)) * k.y;
      l *= k.x, h *= k.y, v *= k.x, c *= k.y, l += _, h += E, u = It(p), p = Kr(u);
    }
  }
  return Za({
    width: v,
    height: c,
    x: l,
    y: h
  });
}
function sr(e, t) {
  const n = or(e).scrollLeft;
  return t ? t.left + n : Tn(tn(e)).left + n;
}
function is(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - sr(e, n), s = n.top + t.scrollTop;
  return {
    x: r,
    y: s
  };
}
function yv(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: s
  } = e;
  const i = s === "fixed", a = tn(r), o = t ? lr(t.floating) : !1;
  if (r === a || o && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, h = Kt(1);
  const v = Kt(0), c = dn(r);
  if ((c || !i) && ((In(r) !== "body" || ir(a)) && (l = or(r)), c)) {
    const m = Tn(r);
    h = zn(r), v.x = m.x + r.clientLeft, v.y = m.y + r.clientTop;
  }
  const f = a && !c && !i ? is(a, l) : Kt(0);
  return {
    width: n.width * h.x,
    height: n.height * h.y,
    x: n.x * h.x - l.scrollLeft * h.x + v.x + f.x,
    y: n.y * h.y - l.scrollTop * h.y + v.y + f.y
  };
}
function wv(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function xv(e) {
  const t = or(e), n = e.ownerDocument.body, r = Pn(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), s = Pn(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -t.scrollLeft + sr(e);
  const a = -t.scrollTop;
  return Yt(n).direction === "rtl" && (i += Pn(e.clientWidth, n.clientWidth) - r), {
    width: r,
    height: s,
    x: i,
    y: a
  };
}
const kv = 25;
function Sv(e, t, n) {
  n === void 0 && (n = "viewport");
  const r = n === "layoutViewport", s = It(e), i = tn(e), a = s.visualViewport;
  let o = i.clientWidth, l = i.clientHeight, h = 0, v = 0;
  if (a) {
    const f = !yi() || t === "fixed";
    r ? f || (h = -a.offsetLeft, v = -a.offsetTop) : (o = a.width, l = a.height, f && (h = a.offsetLeft, v = a.offsetTop));
  }
  if (sr(i) <= 0) {
    const f = i.ownerDocument, m = f.body, u = getComputedStyle(m), p = f.compatMode === "CSS1Compat" && parseFloat(u.marginLeft) + parseFloat(u.marginRight) || 0, k = Math.abs(i.clientWidth - m.clientWidth - p), g = getComputedStyle(i).scrollbarGutter === "stable both-edges" ? k / 2 : k;
    g <= kv && (o -= g);
  }
  return {
    width: o,
    height: l,
    x: h,
    y: v
  };
}
function _v(e, t) {
  const n = Tn(e, !0, t === "fixed"), r = n.top + e.clientTop, s = n.left + e.clientLeft, i = zn(e), a = e.clientWidth * i.x, o = e.clientHeight * i.y, l = s * i.x, h = r * i.y;
  return {
    width: a,
    height: o,
    x: l,
    y: h
  };
}
function ql(e, t, n) {
  let r;
  if (t === "viewport" || t === "layoutViewport")
    r = Sv(e, n, t);
  else if (t === "document")
    r = xv(tn(e));
  else if (Wt(t))
    r = _v(t, n);
  else {
    const s = rs(e);
    r = {
      x: t.x - s.x,
      y: t.y - s.y,
      width: t.width,
      height: t.height
    };
  }
  return Za(r);
}
function Cv(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ma(e, [], !1).filter((o) => Wt(o) && In(o) !== "body"), s = null;
  const i = Yt(e).position === "fixed";
  let a = i ? En(e) : e;
  for (; Wt(a) && !va(a); ) {
    const o = Yt(a), l = pi(a), h = s ? s.position : i ? "fixed" : "";
    !l && (h === "fixed" || h === "absolute" && o.position === "static") ? r = r.filter((c) => c !== a) : s = o, a = En(a);
  }
  return t.set(e, r), r;
}
function Ev(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: s
  } = e;
  const a = [...n === "clippingAncestors" ? lr(t) ? [] : Cv(t, this._c) : [].concat(n), r], o = ql(t, a[0], s);
  let l = o.top, h = o.right, v = o.bottom, c = o.left;
  for (let f = 1; f < a.length; f++) {
    const m = ql(t, a[f], s);
    l = Pn(m.top, l), h = Xr(m.right, h), v = Xr(m.bottom, v), c = Pn(m.left, c);
  }
  return {
    width: h - c,
    height: v - l,
    x: c,
    y: l
  };
}
function Tv(e) {
  const {
    width: t,
    height: n
  } = as(e);
  return {
    width: t,
    height: n
  };
}
function Av(e, t, n) {
  const r = dn(t), s = tn(t), i = n === "fixed", a = Tn(e, !0, i, t);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Kt(0);
  if ((r || !i) && ((In(t) !== "body" || ir(s)) && (o = or(t)), r)) {
    const f = Tn(t, !0, i, t);
    l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
  }
  !r && s && (l.x = sr(s));
  const h = s && !r && !i ? is(s, o) : Kt(0), v = a.left + o.scrollLeft - l.x - h.x, c = a.top + o.scrollTop - l.y - h.y;
  return {
    x: v,
    y: c,
    width: a.width,
    height: a.height
  };
}
function Fr(e) {
  return Yt(e).position === "static";
}
function jl(e, t) {
  if (!dn(e) || Yt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return tn(e) === n && (n = n.ownerDocument.body), n;
}
function ls(e, t) {
  const n = It(e);
  if (lr(e))
    return n;
  if (!dn(e)) {
    let s = En(e);
    for (; s && !va(s); ) {
      if (Wt(s) && !Fr(s))
        return s;
      s = En(s);
    }
    return n;
  }
  let r = jl(e, t);
  for (; r && hv(r) && Fr(r); )
    r = jl(r, t);
  return r && va(r) && Fr(r) && !pi(r) ? n : r || gv(e) || n;
}
const Lv = async function(e) {
  const t = this.getOffsetParent || ls, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Av(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function $v(e) {
  return Yt(e).direction === "rtl";
}
const Iv = {
  convertOffsetParentRelativeRectToViewportRelativeRect: yv,
  getDocumentElement: tn,
  getClippingRect: Ev,
  getOffsetParent: ls,
  getElementRects: Lv,
  getClientRects: wv,
  getDimensions: Tv,
  getScale: zn,
  isElement: Wt,
  isRTL: $v
};
function os(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Dv(e, t, n) {
  let r = null, s;
  const i = tn(e);
  function a() {
    var v;
    clearTimeout(s), (v = r) == null || v.disconnect(), r = null;
  }
  function o(v, c) {
    v === void 0 && (v = !1), c === void 0 && (c = 1), a();
    const f = e.getBoundingClientRect(), {
      left: m,
      top: u,
      width: p,
      height: k
    } = f;
    if (v || t(), !p || !k)
      return;
    const g = Da(u), b = Da(i.clientWidth - (m + p)), _ = Da(i.clientHeight - (u + k)), E = Da(m), L = {
      rootMargin: -g + "px " + -b + "px " + -_ + "px " + -E + "px",
      threshold: Pn(0, Xr(1, c)) || 1
    };
    let C = !0;
    function F(V) {
      const J = V[0].intersectionRatio;
      if (!os(f, e.getBoundingClientRect()))
        return o();
      if (J !== c) {
        if (!C)
          return o();
        J ? o(!1, J) : s = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      C = !1;
    }
    try {
      r = new IntersectionObserver(F, {
        ...L,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(F, L);
    }
    r.observe(e);
  }
  const l = It(e), h = () => o(n);
  return l.addEventListener("resize", h), o(!0), () => {
    l.removeEventListener("resize", h), a();
  };
}
function ss(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, h = wi(e), v = s || i ? [...h ? ma(h) : [], ...t ? ma(t) : []] : [];
  v.forEach((g) => {
    s && g.addEventListener("scroll", n), i && g.addEventListener("resize", n);
  });
  const c = h && o ? Dv(h, n, i) : null;
  let f = -1, m = null;
  a && (m = new ResizeObserver((g) => {
    let [b] = g;
    b && b.target === h && m && t && (m.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var _;
      (_ = m) == null || _.observe(t);
    })), n();
  }), h && !l && m.observe(h), t && m.observe(t));
  let u, p = l ? Tn(e) : null;
  l && k();
  function k() {
    const g = Tn(e);
    p && !os(p, g) && n(), p = g, u = requestAnimationFrame(k);
  }
  return n(), () => {
    var g;
    v.forEach((b) => {
      s && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), c?.(), (g = m) == null || g.disconnect(), m = null, l && cancelAnimationFrame(u);
  };
}
const us = fv, cs = uv, Mv = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), s = n ?? {}, i = {
    ...Iv,
    ...s.platform,
    _c: r
  };
  return sv(e, t, {
    ...s,
    platform: i
  });
};
function Ov(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Zl(e) {
  if (Ov(e)) {
    const t = e.$el;
    return bi(t) && In(t) === "#comment" ? null : t;
  }
  return e;
}
function ds(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Wl(e, t) {
  const n = ds(e);
  return Math.round(t * n) / n;
}
function fs(e, t, n) {
  n === void 0 && (n = {});
  const r = n.whileElementsMounted, s = W(() => {
    var C;
    return (C = Ke(n.open)) != null ? C : !0;
  }), i = W(() => Ke(n.middleware)), a = W(() => {
    var C;
    return (C = Ke(n.placement)) != null ? C : "bottom";
  }), o = W(() => {
    var C;
    return (C = Ke(n.strategy)) != null ? C : "absolute";
  }), l = W(() => {
    var C;
    return (C = Ke(n.transform)) != null ? C : !0;
  }), h = W(() => Zl(e.value)), v = W(() => Zl(t.value)), c = pe(0), f = pe(0), m = pe(o.value), u = pe(a.value), p = kn({}), k = pe(!1), g = W(() => {
    const C = {
      position: m.value,
      left: "0",
      top: "0"
    };
    if (!v.value)
      return C;
    const F = Wl(v.value, c.value), V = Wl(v.value, f.value);
    return l.value ? {
      ...C,
      transform: "translate(" + F + "px, " + V + "px)",
      ...ds(v.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: m.value,
      left: F + "px",
      top: V + "px"
    };
  });
  let b;
  function _() {
    if (h.value == null || v.value == null)
      return;
    const C = s.value;
    Mv(h.value, v.value, {
      middleware: i.value,
      placement: a.value,
      strategy: o.value
    }).then((F) => {
      c.value = F.x, f.value = F.y, m.value = F.strategy, u.value = F.placement, p.value = F.middlewareData, k.value = C !== !1;
    });
  }
  function E() {
    typeof b == "function" && (b(), b = void 0);
  }
  function I() {
    if (E(), r === void 0) {
      _();
      return;
    }
    if (h.value != null && v.value != null) {
      b = r(h.value, v.value, _);
      return;
    }
  }
  function L() {
    s.value || (k.value = !1);
  }
  return ze([i, a, o, s], _, {
    flush: "sync"
  }), ze([h, v], I, {
    flush: "sync"
  }), ze(s, L, {
    flush: "sync"
  }), Bs() && Ps(E), {
    x: Mn(c),
    y: Mn(f),
    strategy: Mn(m),
    placement: Mn(u),
    middlewareData: Mn(p),
    isPositioned: Mn(k),
    floatingStyles: g,
    update: _
  };
}
const Ra = pe(!1);
let Vn, Hn, Un, Jr = 0;
const xi = () => (mt(() => {
  Jr += 1, Rv();
}), Ln(() => {
  Jr -= 1, Fv();
}), Ra), Rv = () => {
  typeof window > "u" || (Vn || (Vn = () => Ra.value = !0, window.addEventListener("keydown", Vn, !0)), Hn || (Hn = () => Ra.value = !1, window.addEventListener("mousedown", Hn, !0)), Un || (Un = () => Ra.value = !1, window.addEventListener("pointerdown", Un, !0)));
}, Fv = () => {
  typeof window > "u" || Jr || (Vn && (window.removeEventListener("keydown", Vn, !0), Vn = null), Hn && (window.removeEventListener("mousedown", Hn, !0), Hn = null), Un && (window.removeEventListener("pointerdown", Un, !0), Un = null));
}, hs = {
  fn: (e) => ({ x: e.x < 0 ? e.rects.reference.x : e.x }),
  name: "positionHelper"
}, Ng = [
  "top-start",
  "top-end",
  "bottom-start",
  "bottom-end"
];
var Ht = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Escape = "Escape", e.Home = "Home", e.Space = " ", e.Tab = "Tab", e))(Ht || {});
const Nv = {
  ref: "container",
  class: "lc-menu-button"
}, Bv = ["id", "aria-activedescendant"], Pv = ["id", "aria-selected", "onClick"], Bg = /* @__PURE__ */ _e({
  __name: "LcMenuButton",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    icon: { default: "more-horizontal" },
    id: {},
    options: {},
    placement: { default: "bottom-end" },
    value: {},
    zIndex: { default: 99 }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = it("button"), i = it("menu"), a = pe(null), o = pe(!1), { floatingStyles: l } = fs(s, i, {
      middleware: [
        us({
          alignmentAxis: 4
        }),
        cs(),
        hs
      ],
      placement: () => e.placement,
      whileElementsMounted: ss
    }), h = Tt(e.id), v = xi(), c = W(() => {
      if (!(!o.value || !St(a.value)))
        return `${h}-menuitem-${a.value}`;
    }), f = W(
      () => e.options.findIndex((b) => "value" in b && b.value === e.value)
    ), m = () => {
      o.value && (a.value = null, o.value = !1);
    }, u = () => {
      if (o.value) {
        m();
        return;
      }
      g();
    }, p = (b) => {
      if (m(), b?.onClick) {
        b.onClick();
        return;
      }
      r("update:value", b.value);
    }, k = (b) => {
      if (!en(b.key, Ht)) return;
      b.key !== Ht.Tab && (b.preventDefault(), b.stopPropagation());
      const _ = e.options.length - 1;
      switch (b.key) {
        case Ht.ArrowDown:
          if (o.value && St(a.value)) {
            a.value = Math.min(_, a.value + 1);
            break;
          }
          a.value = 0, g();
          break;
        case Ht.ArrowUp:
          if (o.value && St(a.value)) {
            a.value = Math.max(0, a.value - 1);
            break;
          }
          a.value = _, g();
          break;
        case Ht.End:
          if (!o.value) return;
          a.value = _;
          break;
        case Ht.Enter:
        case Ht.Space:
          if (o.value && St(a.value)) {
            p(e.options[a.value]);
            break;
          }
          a.value = 0, g();
          break;
        case Ht.Escape:
        case Ht.Tab:
          m();
          break;
        case Ht.Home:
          if (!o.value) return;
          a.value = 0;
          break;
      }
    }, g = () => {
      o.value || (o.value = !0, e.value && (a.value = f.value));
    };
    return Ga(i, m, {
      ignore: [s, ...Ke(e.ignoreOutsideClickOn)]
    }), t({ menuRef: i }), mt(() => {
      e.value && (a.value = f.value);
    }), (b, _) => ($(), j("div", Nv, [
      Oe(q(Et), Te({
        id: q(h),
        ref: "button"
      }, { icon: e.icon }, {
        "aria-controls": `${q(h)}-menu`,
        "aria-expanded": o.value,
        "aria-haspopup": "menu",
        size: "small",
        variant: "tertiary",
        onClickPassive: u,
        onKeydown: k
      }), null, 16, ["id", "aria-controls", "aria-expanded"]),
      ($(), xe(ba, { to: "body" }, [
        o.value ? ($(), xe(q(ya), {
          key: 0,
          ref: "menu",
          "body-class": "lc-menu-button__menu-wrap-body",
          class: "lc-menu-button__menu-wrap",
          style: Ct({ ...q(l), zIndex: e.zIndex })
        }, {
          default: Ee(() => [
            ae("ul", {
              id: `${q(h)}-menu`,
              "aria-activedescendant": c.value,
              class: "lc-menu-button__menu",
              role: "menu"
            }, [
              ($(!0), j(Ge, null, vt(e.options, (E, I) => ($(), j("li", {
                key: `${E.label}-${"value" in E ? E.value : "action"}`,
                class: ye(["lc-menu-button__menu-item", {
                  "lc-menu-button__menu-item--focused": a.value === I && q(v),
                  "lc-menu-button__menu-item--selected": "value" in E && E.value === e.value
                }])
              }, [
                ae("button", {
                  id: `${q(h)}-menuitem-${I}`,
                  "aria-selected": "value" in E && E.value === e.value,
                  class: "lc-menu-button__menu-item-button",
                  role: "menuitem",
                  tabindex: "-1",
                  type: "button",
                  onClick: (L) => p(E)
                }, [
                  Oe(q(Qe), {
                    name: E.icon
                  }, null, 8, ["name"]),
                  ae("span", null, Ie(E.label), 1),
                  "value" in E && E.value === e.value ? ($(), xe(q(Qe), {
                    key: 0,
                    class: "lc-menu-button__menu-item-checkmark",
                    name: "checkmark"
                  })) : ue("", !0)
                ], 8, Pv)
              ], 2))), 128))
            ], 8, Bv)
          ]),
          _: 1
        }, 8, ["style"])) : ue("", !0)
      ]))
    ], 512));
  }
}), zv = { class: "lc-message-box__headline" }, Vv = {
  key: 0,
  class: "lc-message-box__text"
}, Pg = /* @__PURE__ */ _e({
  __name: "LcMessageBox",
  props: /* @__PURE__ */ Sn({
    id: {},
    modelValue: { type: Boolean },
    headline: {},
    size: { default: "medium" },
    text: {},
    variant: { default: "default" }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = {
      default: "info",
      info: "info",
      warning: "alert-circle"
    }, n = Wa(e, "modelValue"), r = W(() => [
      "lc-message-box",
      `lc-message-box--size-${e.size}`,
      `lc-message-box--variant-${e.variant}`
    ]);
    return (s, i) => ($(), xe(q(Cf), {
      modelValue: n.value,
      "onUpdate:modelValue": i[0] || (i[0] = (a) => n.value = a),
      class: ye(r.value),
      "content-class": "lc-message-box__content",
      "header-class": "lc-message-box__header"
    }, {
      header: Ee(() => [
        ae("span", zv, [
          Oe(q(Qe), {
            name: t[e.variant]
          }, null, 8, ["name"]),
          ae("span", null, Ie(e.headline), 1)
        ])
      ]),
      default: Ee(() => [
        me(s.$slots, "default", {}, () => [
          e.text ? ($(), j("p", Vv, Ie(e.text), 1)) : ue("", !0)
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "class"]));
  }
}), zg = ["medium", "small"], Vg = ["default", "info", "warning"];
var sn;
(function(e) {
  e.symbol = "symbol", e.narrowSymbol = "narrowSymbol", e.code = "code", e.name = "name", e.hidden = "hidden";
})(sn || (sn = {}));
var ln;
(function(e) {
  e.precision = "precision", e.thousands = "thousands", e.tenThousands = "tenThousands", e.millions = "millions", e.billions = "billions";
})(ln || (ln = {}));
const Fa = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), vs = (e) => e.replace(/^0+(0$|[^0])/, "$1"), Nr = (e, t) => (e.match(new RegExp(Fa(t), "g")) || []).length, Hv = (e, t) => e.substring(0, e.indexOf(t)), ms = [
  ",",
  ".",
  "٫",
  "。"
], Yl = "(0|[1-9]\\d*)";
class Uv {
  constructor(t) {
    var n, r, s, i, a, o;
    const { currency: l, currencyDisplay: h, locale: v, precision: c, accountingSign: f, useGrouping: m } = t;
    this.locale = v, this.options = {
      currency: l,
      useGrouping: m,
      style: "currency",
      currencySign: f ? "accounting" : void 0,
      currencyDisplay: h !== sn.hidden ? h : void 0
    };
    const u = new Intl.NumberFormat(v, this.options), p = u.formatToParts(123456);
    this.currency = (n = p.find(({ type: b }) => b === "currency")) === null || n === void 0 ? void 0 : n.value, this.digits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((b) => b.toLocaleString(v)), this.decimalSymbol = (r = p.find(({ type: b }) => b === "decimal")) === null || r === void 0 ? void 0 : r.value, this.groupingSymbol = (s = p.find(({ type: b }) => b === "group")) === null || s === void 0 ? void 0 : s.value, this.minusSign = (i = u.formatToParts(-1).find(({ type: b }) => b === "minusSign")) === null || i === void 0 ? void 0 : i.value, this.decimalSymbol === void 0 ? this.minimumFractionDigits = this.maximumFractionDigits = 0 : typeof c == "number" ? this.minimumFractionDigits = this.maximumFractionDigits = c : (this.minimumFractionDigits = (a = c?.min) !== null && a !== void 0 ? a : u.resolvedOptions().minimumFractionDigits, this.maximumFractionDigits = (o = c?.max) !== null && o !== void 0 ? o : u.resolvedOptions().maximumFractionDigits);
    const k = (b) => Hv(b, this.digits[1]), g = (b) => b.substring(b.lastIndexOf(this.decimalSymbol ? this.digits[0] : this.digits[1]) + 1);
    this.prefix = k(u.format(1)), this.suffix = g(u.format(1)), this.negativePrefix = k(u.format(-1)), this.negativeSuffix = g(u.format(-1));
  }
  parse(t) {
    if (t) {
      const n = this.isNegative(t);
      t = this.normalizeDigits(t), t = this.stripCurrency(t, n), t = this.stripSignLiterals(t);
      const r = this.decimalSymbol ? `(?:${Fa(this.decimalSymbol)}(\\d*))?` : "", s = this.stripGroupingSeparator(t).match(new RegExp(`^${Yl}${r}$`));
      if (s && this.isValidIntegerFormat(this.decimalSymbol ? t.split(this.decimalSymbol)[0] : t, Number(s[1])))
        return +`${n ? "-" : ""}${this.onlyDigits(s[1])}.${this.onlyDigits(s[2] || "")}`;
    }
    return null;
  }
  isValidIntegerFormat(t, n) {
    const r = { ...this.options, minimumFractionDigits: 0 };
    return [
      this.stripCurrency(this.normalizeDigits(n.toLocaleString(this.locale, { ...r, useGrouping: !0 })), !1),
      this.stripCurrency(this.normalizeDigits(n.toLocaleString(this.locale, { ...r, useGrouping: !1 })), !1)
    ].includes(t);
  }
  format(t, n = {
    minimumFractionDigits: this.minimumFractionDigits,
    maximumFractionDigits: this.maximumFractionDigits
  }) {
    return t != null ? t.toLocaleString(this.locale, { ...this.options, ...n }) : "";
  }
  toFraction(t) {
    return `${this.digits[0]}${this.decimalSymbol}${this.onlyLocaleDigits(t.substring(1)).substring(0, this.maximumFractionDigits)}`;
  }
  isFractionIncomplete(t) {
    return !!this.normalizeDigits(this.stripGroupingSeparator(t)).match(new RegExp(`^${Yl}${Fa(this.decimalSymbol)}$`));
  }
  isNegative(t) {
    return t.startsWith(this.negativePrefix) || this.minusSign === void 0 && (t.startsWith("(") || t.startsWith("-")) || this.minusSign !== void 0 && t.replace("-", this.minusSign).startsWith(this.minusSign);
  }
  insertCurrency(t, n) {
    return `${n ? this.negativePrefix : this.prefix}${t}${n ? this.negativeSuffix : this.suffix}`;
  }
  stripGroupingSeparator(t) {
    return this.groupingSymbol !== void 0 ? t.replace(new RegExp(Fa(this.groupingSymbol), "g"), "") : t;
  }
  stripSignLiterals(t) {
    return this.minusSign !== void 0 ? t.replace("-", this.minusSign).replace(this.minusSign, "") : t.replace(/[-()]/g, "");
  }
  stripCurrency(t, n) {
    return t.replace(n ? this.negativePrefix : this.prefix, "").replace(n ? this.negativeSuffix : this.suffix, "");
  }
  normalizeDecimalSeparator(t, n) {
    return ms.forEach((r) => {
      t = t.substring(0, n) + t.substring(n).replace(r, this.decimalSymbol);
    }), t;
  }
  normalizeDigits(t) {
    return this.digits[0] !== "0" && this.digits.forEach((n, r) => {
      t = t.replace(new RegExp(n, "g"), String(r));
    }), t;
  }
  onlyDigits(t) {
    return this.normalizeDigits(t).replace(/\D+/g, "");
  }
  onlyLocaleDigits(t) {
    return t.replace(new RegExp(`[^${this.digits.join("")}]*`, "g"), "");
  }
}
class gs {
  constructor(t) {
    this.currencyFormat = t;
  }
}
class qv extends gs {
  conformToMask(t, n = "") {
    const r = this.currencyFormat.isNegative(t), s = (u) => u === "" && r && !(this.currencyFormat.minusSign === void 0 ? n === this.currencyFormat.negativePrefix + this.currencyFormat.negativeSuffix : n === this.currencyFormat.negativePrefix), i = (u) => {
      if (s(u))
        return "";
      if (this.currencyFormat.maximumFractionDigits > 0) {
        if (this.currencyFormat.isFractionIncomplete(u))
          return u;
        if (u.startsWith(this.currencyFormat.decimalSymbol))
          return this.currencyFormat.toFraction(u);
      }
      return null;
    };
    let a = t;
    a = this.currencyFormat.stripCurrency(a, r), a = this.currencyFormat.stripSignLiterals(a);
    const o = i(a);
    if (o != null)
      return this.currencyFormat.insertCurrency(o, r);
    const [l, ...h] = a.split(this.currencyFormat.decimalSymbol), v = vs(this.currencyFormat.onlyDigits(l)), c = this.currencyFormat.onlyDigits(h.join("")).substring(0, this.currencyFormat.maximumFractionDigits), f = h.length > 0 && c.length === 0, m = v === "" && r && (this.currencyFormat.minusSign === void 0 ? n === t.slice(0, -2) + this.currencyFormat.negativeSuffix : n === t.slice(0, -1));
    return f || m || s(v) ? n : v.match(/\d+/) ? {
      numberValue: +`${r ? "-" : ""}${v}.${c}`,
      fractionDigits: c
    } : "";
  }
}
class jv extends gs {
  conformToMask(t, n = "") {
    if (t === "" || t === this.currencyFormat.decimalSymbol || this.currencyFormat.parse(n) === 0 && this.currencyFormat.stripCurrency(n, !0).slice(0, -1) === this.currencyFormat.stripCurrency(t, !0))
      return "";
    const r = this.currencyFormat.isNegative(t), s = this.currencyFormat.stripSignLiterals(t) === "" ? -0 : +`${r ? "-" : ""}${vs(this.currencyFormat.onlyDigits(t))}` / Math.pow(10, this.currencyFormat.maximumFractionDigits);
    return {
      numberValue: s,
      fractionDigits: s.toFixed(this.currencyFormat.maximumFractionDigits).slice(-this.currencyFormat.maximumFractionDigits)
    };
  }
}
const Zv = {
  locale: void 0,
  currency: void 0,
  currencyDisplay: void 0,
  hideGroupingSeparatorOnFocus: !0,
  hideCurrencySymbolOnFocus: !0,
  hideNegligibleDecimalDigitsOnFocus: !0,
  precision: void 0,
  autoDecimalDigits: !1,
  valueRange: void 0,
  useGrouping: void 0,
  valueScaling: void 0
};
class Wv {
  constructor(t) {
    this.el = t.el, this.onInput = t.onInput, this.onChange = t.onChange, this.addEventListener(), this.init(t.options);
  }
  setOptions(t) {
    this.init(t), this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.onChange(this.getValue());
  }
  getValue() {
    return { number: this.valueScaling && this.numberValue != null ? this.toInteger(this.numberValue, this.valueScaling) : this.numberValue, formatted: this.formattedValue };
  }
  setValue(t) {
    const n = this.valueScaling !== void 0 && t != null ? this.toFloat(t, this.valueScaling) : t;
    n !== this.numberValue && (this.format(this.currencyFormat.format(this.validateValueRange(n))), this.onChange(this.getValue()));
  }
  init(t) {
    this.options = {
      ...Zv,
      ...t
    }, this.options.autoDecimalDigits && (this.options.hideNegligibleDecimalDigitsOnFocus = !1), this.el.getAttribute("inputmode") || this.el.setAttribute("inputmode", this.options.autoDecimalDigits ? "numeric" : "decimal"), this.currencyFormat = new Uv(this.options), this.numberMask = this.options.autoDecimalDigits ? new jv(this.currencyFormat) : new qv(this.currencyFormat);
    const n = {
      [ln.precision]: this.currencyFormat.maximumFractionDigits,
      [ln.thousands]: 3,
      [ln.tenThousands]: 4,
      [ln.millions]: 6,
      [ln.billions]: 9
    };
    this.valueScaling = this.options.valueScaling ? n[this.options.valueScaling] : void 0, this.valueScalingFractionDigits = this.valueScaling !== void 0 && this.options.valueScaling !== ln.precision ? this.valueScaling + this.currencyFormat.maximumFractionDigits : this.currencyFormat.maximumFractionDigits, this.minValue = this.getMinValue(), this.maxValue = this.getMaxValue();
  }
  getMinValue() {
    var t, n;
    let r = this.toFloat(-Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.min) !== void 0 && (r = Math.max((n = this.options.valueRange) === null || n === void 0 ? void 0 : n.min, this.toFloat(-Number.MAX_SAFE_INTEGER))), r;
  }
  getMaxValue() {
    var t, n;
    let r = this.toFloat(Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.max) !== void 0 && (r = Math.min((n = this.options.valueRange) === null || n === void 0 ? void 0 : n.max, this.toFloat(Number.MAX_SAFE_INTEGER))), r;
  }
  toFloat(t, n) {
    return t / Math.pow(10, n ?? this.valueScalingFractionDigits);
  }
  toInteger(t, n) {
    return Number(t.toFixed(n ?? this.valueScalingFractionDigits).split(".").join(""));
  }
  validateValueRange(t) {
    return t != null ? Math.min(Math.max(t, this.minValue), this.maxValue) : t;
  }
  format(t, n = !1) {
    if (t != null) {
      this.decimalSymbolInsertedAt !== void 0 && (t = this.currencyFormat.normalizeDecimalSeparator(t, this.decimalSymbolInsertedAt), this.decimalSymbolInsertedAt = void 0);
      const r = this.numberMask.conformToMask(t, this.formattedValue);
      let s;
      if (typeof r == "object") {
        const { numberValue: i, fractionDigits: a } = r;
        let { maximumFractionDigits: o, minimumFractionDigits: l } = this.currencyFormat;
        this.focus ? l = n ? a.replace(/0+$/, "").length : Math.min(o, a.length) : Number.isInteger(i) && !this.options.autoDecimalDigits && (this.options.precision === void 0 || l === 0) && (l = o = 0), s = this.toInteger(Math.abs(i)) > Number.MAX_SAFE_INTEGER ? this.formattedValue : this.currencyFormat.format(i, {
          useGrouping: this.options.useGrouping !== !1 && !(this.focus && this.options.hideGroupingSeparatorOnFocus),
          minimumFractionDigits: l,
          maximumFractionDigits: o
        });
      } else
        s = r;
      this.maxValue <= 0 && !this.currencyFormat.isNegative(s) && this.currencyFormat.parse(s) !== 0 && (s = s.replace(this.currencyFormat.prefix, this.currencyFormat.negativePrefix)), this.minValue >= 0 && (s = s.replace(this.currencyFormat.negativePrefix, this.currencyFormat.prefix)), (this.options.currencyDisplay === sn.hidden || this.focus && this.options.hideCurrencySymbolOnFocus) && (s = s.replace(this.currencyFormat.negativePrefix, this.currencyFormat.minusSign !== void 0 ? this.currencyFormat.minusSign : "(").replace(this.currencyFormat.negativeSuffix, this.currencyFormat.minusSign !== void 0 ? "" : ")").replace(this.currencyFormat.prefix, "").replace(this.currencyFormat.suffix, "")), this.el.value = s, this.numberValue = this.currencyFormat.parse(s);
    } else
      this.el.value = "", this.numberValue = null;
    this.formattedValue = this.el.value, this.onInput(this.getValue());
  }
  addEventListener() {
    this.el.addEventListener("input", (t) => {
      const { value: n, selectionStart: r } = this.el, s = t;
      if (r && s.data && ms.includes(s.data) && (this.decimalSymbolInsertedAt = r - 1), this.format(n), this.focus && r != null) {
        const i = () => {
          const { prefix: a, suffix: o, decimalSymbol: l, maximumFractionDigits: h, groupingSymbol: v } = this.currencyFormat;
          let c = n.length - r;
          const f = this.formattedValue.length;
          if (this.currencyFormat.minusSign === void 0 && (n.startsWith("(") || n.startsWith("-")) && !n.endsWith(")"))
            return f - this.currencyFormat.negativeSuffix.length > 1 ? this.formattedValue.substring(r).length : 1;
          if (this.formattedValue.substring(r, 1) === v && Nr(this.formattedValue, v) === Nr(n, v) + 1)
            return f - c - 1;
          if (f < c)
            return r;
          if (l !== void 0 && n.indexOf(l) !== -1) {
            const m = n.indexOf(l) + 1;
            if (Math.abs(f - n.length) > 1 && r <= m)
              return this.formattedValue.indexOf(l) + 1;
            !this.options.autoDecimalDigits && r > m && this.currencyFormat.onlyDigits(n.substring(m)).length - 1 === h && (c -= 1);
          }
          return this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden ? f - c : Math.max(f - Math.max(c, o.length), a.length);
        };
        this.setCaretPosition(i());
      }
    }), this.el.addEventListener("focus", () => {
      this.focus = !0, this.numberValueOnFocus = this.numberValue, setTimeout(() => {
        const { value: t, selectionStart: n, selectionEnd: r } = this.el;
        if (this.format(t, this.options.hideNegligibleDecimalDigitsOnFocus), n != null && r != null && Math.abs(n - r) > 0)
          this.setCaretPosition(0, this.el.value.length);
        else if (n != null) {
          const s = this.getCaretPositionOnFocus(t, n);
          this.setCaretPosition(s);
        }
      });
    }), this.el.addEventListener("blur", () => {
      this.focus = !1, this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.numberValueOnFocus !== this.numberValue && this.onChange(this.getValue());
    });
  }
  getCaretPositionOnFocus(t, n) {
    if (this.numberValue == null)
      return n;
    const { prefix: r, negativePrefix: s, suffix: i, negativeSuffix: a, groupingSymbol: o, currency: l } = this.currencyFormat, h = this.numberValue < 0, v = h ? s : r, c = v.length;
    if (this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden) {
      if (h) {
        if (n <= 1)
          return 1;
        if (t.endsWith(")") && n > t.indexOf(")"))
          return this.formattedValue.length - 1;
      }
    } else {
      const m = h ? a.length : i.length;
      if (n >= t.length - m)
        return this.formattedValue.length - m;
      if (n < c)
        return c;
    }
    let f = n;
    return this.options.hideCurrencySymbolOnFocus && this.options.currencyDisplay !== sn.hidden && n >= c && l !== void 0 && v.includes(l) && (f -= c, h && (f += 1)), this.options.hideGroupingSeparatorOnFocus && o !== void 0 && (f -= Nr(t.substring(0, n), o)), f;
  }
  setCaretPosition(t, n = t) {
    this.el.setSelectionRange(t, n);
  }
}
const Yv = (e) => e?.matches("input") ? e : e?.querySelector("input");
function Xv(e, t) {
  var n, r, s, i;
  let a;
  const o = pe(null), l = pe(null), h = pe(null), v = ti();
  v?.emit || ((r = (n = v?.proxy) === null || n === void 0 ? void 0 : n.$emit) === null || r === void 0 || r.bind(v?.proxy));
  const c = v?.props || ((s = v?.proxy) === null || s === void 0 ? void 0 : s.$props), f = zs.startsWith("3");
  f && ((i = v?.attrs.modelModifiers) === null || i === void 0 || i.lazy);
  const m = W(() => c?.[f ? "modelValue" : "value"]);
  return ze(o, (u) => {
    var p;
    if (u) {
      const k = Yv((p = u?.$el) !== null && p !== void 0 ? p : u);
      k ? (a = new Wv({
        el: k,
        options: e,
        onInput: (g) => {
          h.value = g.number, l.value = g.formatted;
        },
        onChange: (g) => {
        }
      }), a.setValue(m.value)) : console.error('No input element found. Please make sure that the "inputRef" template ref is properly assigned.');
    } else
      a = null;
  }), {
    inputRef: o,
    numberValue: h,
    formattedValue: l,
    setValue: (u) => a?.setValue(u),
    setOptions: (u) => a?.setOptions(u)
  };
}
const Xl = 2, Hg = /* @__PURE__ */ _e({
  __name: "LcMoneyInput",
  props: {
    autocomplete: { default: "off" },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: { default: "0.00" },
    prefixClass: {},
    suffixClass: {},
    valueRange: { default: () => ({
      max: 1e6,
      min: 0
    }) },
    currency: { default: () => je.general.currency },
    locale: { default: () => je.general.locale },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ga(e, ["autocomplete", "currency", "locale", "placeholder", "value", "valueRange"]), { formattedValue: s, inputRef: i, numberValue: a, setValue: o } = Xv(
      {
        currency: e.currency,
        currencyDisplay: sn.hidden,
        locale: e.locale,
        precision: Xl,
        valueRange: e.valueRange
      }
    ), l = W(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: c }) => c === "currency")?.value ?? e.currency
    ), h = W(
      () => St(a.value) ? parseFloat((a.value * 100).toFixed()) : null
    ), v = (c) => {
      o(St(c) ? parseFloat((c / 100).toFixed(Xl)) : null);
    };
    return mt(async () => {
      St(e.value) && (await Ya(), v(e.value));
    }), ze(h, (c) => {
      n("update:value", c);
    }), ze(
      () => e.value,
      (c) => {
        c !== h.value && v(c);
      }
    ), (c, f) => ($(), xe(q(tr), Te({
      ref_key: "inputRef",
      ref: i
    }, { ...c.$attrs, ...r, autocomplete: e.autocomplete, placeholder: e.placeholder, value: e.value }, {
      class: "lc-money-input",
      spellcheck: !1,
      value: q(s)
    }), Xa({
      prefix: Ee(() => [
        wt(Ie(l.value), 1)
      ]),
      _: 2
    }, [
      c.$slots.suffix ? {
        name: "suffix",
        fn: Ee(() => [
          me(c.$slots, "suffix")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["value"]));
  }
}), Gv = ["aria-checked", "aria-label"], Ug = /* @__PURE__ */ _e({
  __name: "LcPasswordInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {},
    toggleAriaLabel: { default: () => je.lcPasswordInput.toggleAriaLabel }
  },
  setup(e) {
    const t = ga(e, ["toggleAriaLabel"]), n = pe("password"), r = W(() => s.value ? "eye-off" : "eye"), s = W(() => n.value === "text"), i = () => {
      n.value = s.value ? "password" : "text";
    };
    return (a, o) => ($(), xe(q(tr), Te({ ...a.$attrs, ...t }, {
      class: "lc-password-input",
      spellcheck: !1,
      type: n.value
    }), {
      suffix: Ee(() => [
        ae("button", {
          "aria-checked": s.value,
          "aria-label": e.toggleAriaLabel,
          class: "lc-password-input__toggle",
          role: "switch",
          type: "button",
          onClickPassive: i
        }, [
          Oe(q(Qe), { name: r.value }, null, 8, ["name"])
        ], 40, Gv),
        me(a.$slots, "suffix")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), qg = ["password", "text"], Kv = ["aria-valuenow"], jg = /* @__PURE__ */ _e({
  __name: "LcProgressIndicator",
  props: {
    icon: {},
    progress: { default: 0 },
    size: { default: "medium" },
    variant: { default: "info" }
  },
  setup(e) {
    const t = W(() => e.size === "medium" ? 36 : 24);
    return (n, r) => ($(), j("div", {
      "aria-live": "polite",
      "aria-valuenow": e.progress,
      class: ye([
        "lc-progress-indicator",
        `lc-progress-indicator--size-${e.size}`,
        `lc-progress-indicator--variant-${e.variant}`
      ]),
      role: "progressbar"
    }, [
      Oe(q(Lo), Te({ progress: e.progress, radius: t.value }, { "progress-class": "lc-progress-indicator__progress" }), null, 16),
      Oe(wn, {
        mode: "out-in",
        name: "lc-progress-indicator__transition"
      }, {
        default: Ee(() => [
          ($(), xe(q(Qe), {
            key: e.icon,
            class: "lc-progress-indicator__icon",
            name: e.icon,
            size: e.size === "medium" ? "large" : "medium"
          }, null, 8, ["name", "size"]))
        ]),
        _: 1
      })
    ], 10, Kv));
  }
}), Zg = ["medium", "small"], Wg = ["info", "success"], ki = /* @__PURE__ */ Symbol(), Jv = ["for"], Qv = { class: "lc-radio__control" }, em = ["id", "aria-labelledby", "data-click-name", "name"], tm = ["id"], nm = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcRadio",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] }
  },
  emits: ["change"],
  setup(e, { emit: t }) {
    const n = t, r = Wn(ki), s = Tt(e.id), i = W(() => [
      "lc-radio",
      {
        "lc-radio--checked": a.value,
        "lc-radio--disabled": !!Ke(r?.disabled) || e.disabled,
        "lc-radio--error": !!Ke(r?.hasError)
      }
    ]), a = W(() => e.value === Ke(r?.value) || e.checked), o = W({
      get: () => a.value,
      set: () => {
        if (r) {
          r.updateValue(e.value);
          return;
        }
        n("change");
      }
    }), l = W(() => {
      if (Ke(r?.value))
        return a.value ? 0 : -1;
    }), h = W(() => Ke(r?.name) ?? e.name);
    return (v, c) => ($(), j("label", {
      class: ye([i.value, v.$attrs.class]),
      for: q(s)
    }, [
      ae("div", Qv, [
        Jt(ae("input", Te({ id: q(s) }, {
          ...Qt(v.$attrs, ["class"]),
          disabled: e.disabled,
          tabindex: l.value
        }, {
          "onUpdate:modelValue": c[0] || (c[0] = (f) => o.value = f),
          "aria-labelledby": e.label ? `${q(s)}-label` : void 0,
          class: "lc-radio__input",
          "data-click-name": e.dataClickName || `${h.value?.toLowerCase()}_radio`,
          name: h.value,
          type: "radio"
        }), null, 16, em), [
          [Vs, o.value]
        ])
      ]),
      e.label ? ($(), j("span", {
        key: 0,
        id: `${q(s)}-label`,
        class: ye(["lc-radio__label", e.labelClass])
      }, Ie(e.label), 11, tm)) : ue("", !0)
    ], 10, Jv));
  }
}), am = { class: "lc-radio-card__main" }, Yg = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcRadioCard",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] },
    bodyClass: {}
  },
  setup(e) {
    const t = it("radio"), n = Wn(ki), r = W(() => [
      "lc-radio-card",
      {
        "lc-radio-card--disabled": i.value
      }
    ]), s = W(() => e.value === Ke(n?.value) || e.checked), i = W(() => e.disabled || Ke(n?.disabled)), a = () => {
      if (i.value) return;
      n?.updateValue(e.value);
      const o = t.value?.$el?.querySelector("input");
      if (!o) return;
      const l = new Event("focusin", { bubbles: !0 }), h = new Event("focusout", { bubbles: !0 });
      o.dispatchEvent(l), o.dispatchEvent(h);
    };
    return (o, l) => ($(), xe(q(ya), {
      "body-class": ["lc-radio-card__body", e.bodyClass],
      class: ye([r.value, o.$attrs.class]),
      onClick: a
    }, {
      default: Ee(() => [
        ae("div", am, [
          Oe(q(nm), Te({ ref: "radio" }, {
            ...Qt(o.$attrs, ["class"]),
            ...o.$props
          }), null, 16),
          me(o.$slots, "default", {
            checked: s.value,
            disabled: i.value
          })
        ]),
        Jt(ae("div", {
          class: "lc-radio-card__underneath",
          onClick: l[0] || (l[0] = sa(() => {
          }, ["stop"]))
        }, [
          me(o.$slots, "underneath", { disabled: i.value })
        ], 512), [
          [ri, s.value && o.$slots.underneath]
        ]),
        me(o.$slots, "bottom")
      ]),
      _: 3
    }, 8, ["body-class", "class"]));
  }
}), rm = ["id", "aria-labelledby"], im = ["id"], Xg = /* @__PURE__ */ _e({
  __name: "LcRadioGroup",
  props: {
    contentWrapClass: {},
    defaultValue: { type: [Boolean, Number, String] },
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    layout: { default: "horizontal" },
    name: { default: "radio-group" },
    noFeedback: { type: Boolean },
    value: { type: [Boolean, null, Number, String], default: null }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = Tt(e.id), s = W(() => [
      "lc-radio-group",
      `lc-radio-group--${e.layout}`,
      {
        "lc-radio-group--disabled": e.disabled,
        "lc-radio-group--error": i.value
      }
    ]), i = W(() => !!e.errorMessage);
    return mt(() => {
      e.defaultValue && n("update:value", e.defaultValue);
    }), ni(ki, {
      disabled: () => e.disabled,
      hasError: oo(i),
      name: () => e.name,
      updateValue: (a) => {
        n("update:value", a);
      },
      value: () => e.value
    }), (a, o) => ($(), j("fieldset", Te({
      ...a.$attrs,
      disabled: e.disabled,
      name: e.name
    }, {
      id: q(r),
      "aria-labelledby": e.label ? `${q(r)}-label` : void 0,
      class: s.value,
      role: "radiogroup"
    }), [
      e.label ? ($(), j("legend", {
        key: 0,
        id: `${q(r)}-label`,
        class: "lc-radio-group__label"
      }, Ie(e.label), 9, im)) : ue("", !0),
      ae("div", {
        class: ye(["lc-radio-group__wrap", e.contentWrapClass])
      }, [
        me(a.$slots, "default")
      ], 2),
      e.noFeedback ? ue("", !0) : ($(), xe(q($n), Te({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 16, rm));
  }
}), Gg = ["horizontal", "vertical"], lm = { class: "lc-rating" }, Kg = /* @__PURE__ */ _e({
  __name: "LcRating",
  props: {
    max: { default: 5 },
    rating: { default: 0 }
  },
  setup(e) {
    return (t, n) => ($(), j("div", lm, [
      ($(!0), j(Ge, null, vt(new Array(e.max), (r, s) => ($(), j("svg", {
        key: s,
        class: ye(["lc-rating__star", s < e.rating ? "lc-rating__star--active" : "lc-rating__star--inactive"]),
        fill: "none",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
      }, [...n[0] || (n[0] = [
        ae("path", { d: "M7.639.68c.148-.299.574-.299.722 0l2.16 4.377c.059.119.172.201.303.22l4.831.702c.33.048.462.454.223.686l-3.496 3.407c-.095.092-.138.226-.116.356l.825 4.811c.056.329-.289.579-.584.424l-4.321-2.271c-.117-.062-.257-.062-.374 0l-4.321 2.271c-.295.155-.64-.095-.584-.424l.825-4.811c.022-.131-.021-.264-.116-.356L.122 6.665c-.239-.233-.107-.638.223-.686l4.831-.702c.131-.019.244-.101.303-.22L7.639.68z" }, null, -1),
        ae("path", {
          d: "M.262 6.522l-.14.143.14-.143c-.12-.117-.054-.321.112-.345l4.831-.702a.6.6 0 0 0 .454-.33L7.819.768c.074-.15.289-.15.363 0l2.16 4.377c.088.178.257.301.454.33l4.831.702c.166.024.232.228.112.345l-3.496 3.407c-.142.138-.207.338-.173.533l.825 4.811c.028.165-.145.291-.294.213l-4.321-2.271a.6.6 0 0 0-.561 0l-4.321 2.271.093.177-.093-.177c-.148.078-.322-.048-.294-.213l.825-4.811a.6.6 0 0 0-.173-.533L.262 6.522z",
          "stroke-width": ".4"
        }, null, -1)
      ])], 2))), 128))
    ]));
  }
}), om = /* @__PURE__ */ _e({
  __name: "LcSkeleton",
  props: {
    height: { default: "1rem" },
    opacity: { default: 0.4 },
    radius: { default: "large" },
    width: { default: "100%" }
  },
  setup(e) {
    return (t, n) => ($(), j("div", {
      "aria-hidden": "true",
      class: ye(["lc-skeleton", `lc-skeleton--radius-${e.radius}`]),
      style: Ct({
        "--skeleton-height": e.height,
        "--skeleton-radius": e.radius,
        "--skeleton-width": e.width,
        "--skeleton-opacity": e.opacity
      })
    }, null, 6));
  }
}), Jg = ["full", "half", "large", "medium", "none", "small"], sm = { class: "lc-remote-list__content" }, um = {
  key: 0,
  class: "lc-remote-list__cta-wrap"
}, Qg = /* @__PURE__ */ _e({
  __name: "LcRemoteList",
  props: {
    buttonText: {},
    count: {},
    hideSeparator: { type: Boolean },
    loading: { type: Boolean },
    numberOfSkeletons: { default: 3 },
    skeletonHeight: { default: "10.75rem" },
    total: {}
  },
  emits: ["fetch-more"],
  setup(e, { emit: t }) {
    const n = t, r = W(() => [
      "lc-remote-list",
      {
        "lc-remote-list--separator": !e.hideSeparator
      }
    ]), s = W(() => e.count < e.total), i = () => {
      s.value && n("fetch-more");
    };
    return (a, o) => ($(), j("section", {
      class: ye(r.value)
    }, [
      ae("ul", sm, [
        me(a.$slots, "default"),
        e.loading ? me(a.$slots, "loading", {}, () => [
          ($(!0), j(Ge, null, vt(e.numberOfSkeletons, (l) => ($(), xe(q(om), {
            key: l,
            height: e.skeletonHeight,
            radius: "medium"
          }, null, 8, ["height"]))), 128))
        ], void 0, 0) : ue("", !0)
      ]),
      !e.loading && s.value ? ($(), j("div", um, [
        me(a.$slots, "load-more", _t(Dt({ fetchMore: i })), () => [
          Oe(q(Et), {
            class: "lc-remote-list__cta",
            size: "medium",
            variant: "secondary",
            onClickPassive: i
          }, {
            default: Ee(() => [
              wt(Ie(e.buttonText), 1)
            ]),
            _: 1
          })
        ]),
        e.hideSeparator ? ue("", !0) : ($(), xe(q(si), { key: 0 }))
      ])) : ue("", !0)
    ], 2));
  }
}), cm = { class: "lc-scratchcard-teaser__button-wrap" }, e2 = /* @__PURE__ */ _e({
  __name: "LcScratchcardTeaser",
  props: {
    href: {},
    target: {},
    to: {},
    backgroundPattern: {},
    badge: {},
    buttonAriaLabel: {},
    buttonText: {},
    variant: { default: "default" }
  },
  emits: ["primary-button-click"],
  setup(e) {
    return (t, n) => ($(), xe(q(nr), Te({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-scratchcard-teaser__body",
      class: ["lc-scratchcard-teaser", `lc-scratchcard-teaser--variant-${e.variant}`],
      style: {
        "--teaser-frame-color": "var(--scratchcard-teaser-frame-color)"
      }
    }), {
      default: Ee(() => [
        Oe(q(oi), Te({ href: e.href, target: e.target, to: e.to }, {
          class: "lc-scratchcard-teaser__link",
          tabindex: "-1"
        }), {
          default: Ee(() => [
            me(t.$slots, "image")
          ]),
          _: 3
        }, 16),
        ae("div", cm, [
          Oe(q(Et), Te({ "aria-label": e.buttonAriaLabel }, { href: e.href, target: e.target, to: e.to }, {
            class: "lc-scratchcard-teaser__button",
            "no-padding": "",
            onClick: n[0] || (n[0] = (r) => t.$emit("primary-button-click"))
          }), {
            default: Ee(() => [
              wt(Ie(e.buttonText), 1)
            ]),
            _: 1
          }, 16, ["aria-label"])
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), t2 = [...Wo];
var Xt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.Enter = "Enter", e.Escape = "Escape", e.Space = " ", e.Tab = "Tab", e))(Xt || {});
const dm = ["id", "aria-controls", "aria-expanded", "aria-haspopup", "aria-labelledby", "data-click-name", "disabled", "role"], fm = ["id"], hm = { class: "lc-select__input" }, vm = ["id", "aria-activedescendant", "aria-labelledby"], mm = ["id", "aria-selected", "onClickPassive"], n2 = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcSelect",
  props: {
    ignoreOutsideClickOn: { default: () => [je.lcModal.to] },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "select" },
    noFeedback: { type: Boolean },
    noTeleport: { type: Boolean },
    notNullable: { type: Boolean },
    onBlur: {},
    options: {},
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = it("button"), s = it("container"), i = it("menu"), a = it("options"), o = pe(null), l = pe(!1), h = ei({
      focusin: !1,
      focusout: !1
    }), { floatingStyles: v } = fs(r, i, {
      middleware: [cs(), hs, us(2)],
      whileElementsMounted: ss
    }), { width: c } = Vr(s), f = Tt(e.id), m = xi(), u = W(() => {
      if (!(!l.value || !St(o.value)))
        return `${f}-option-${o.value}`;
    }), p = W(() => [
      "lc-select",
      {
        "lc-select--disabled": e.disabled,
        "lc-select--fixed-value": b.value,
        "lc-select--error": !!e.errorMessage,
        "lc-select--expanded": l.value,
        "lc-select--has-label": !b.value && !!e.label
      }
    ]), k = W(
      () => b.value || e.value ? e.options[g.value].label : ""
    ), g = W(() => e.options.findIndex((A) => A.value === e.value)), b = W(() => e.notNullable && e.options.length === 1 && !!e.value), _ = W(() => [
      "lc-select__label",
      {
        "lc-select__label--floating": !!e.value
      }
    ]), E = W(() => [
      "lc-select__menu",
      {
        "lc-select__menu--scrollable": e.options.length > 6
      }
    ]), I = W(() => ({
      ...v.value,
      minWidth: `${c.value}px`
    })), L = () => {
      l.value && (o.value = null, l.value = !1, e.onBlur?.(), C("focusout"));
    }, C = (A) => {
      const z = r.value;
      if (!z) return;
      h[A] = !0;
      const U = new Event(A, { bubbles: !0 });
      z.dispatchEvent(U);
    }, F = async () => {
      l.value || await P();
    }, V = (A) => {
      const z = A.type;
      if (!K(z)) return;
      h[z] ? h[z] = !1 : A.stopPropagation();
    }, J = async (A) => {
      if (!en(A.key, Xt)) return;
      A.key !== Xt.Tab && (A.preventDefault(), A.stopPropagation());
      const z = e.options.length - 1;
      switch (A.key) {
        case Xt.ArrowDown:
          if (l.value && St(o.value)) {
            o.value = Math.min(z, o.value + 1), T();
            break;
          }
          o.value = 0, await P();
          break;
        case Xt.ArrowUp:
          if (l.value && St(o.value)) {
            o.value = Math.max(0, o.value - 1), T();
            break;
          }
          o.value = z, await P();
          break;
        case Xt.Enter:
        case Xt.Space:
          if (l.value && St(o.value)) {
            O(e.options[o.value].value);
            break;
          }
          await P();
          break;
        case Xt.Escape:
          L();
          break;
        case Xt.Tab:
          if (!l.value || !St(o.value)) break;
          O(e.options[o.value].value);
          break;
      }
    }, O = (A) => {
      const z = e.value === A ? null : A;
      e.notNullable && z === null || (n("update:value", z), L());
    }, K = (A) => A === "focusin" || A === "focusout", P = async () => {
      l.value || (l.value = !0, e.value && (o.value = g.value), C("focusin"), await Ya(), T());
    }, T = () => {
      if (!St(o.value)) return;
      a.value?.[o.value]?.scrollIntoView({ block: "center" });
    };
    return Ga(i, L, {
      ignore: [r, ...Ke(e.ignoreOutsideClickOn)]
    }), mt(() => {
      e.autofocus && r.value?.focus(), e.value && (o.value = g.value);
    }), (A, z) => ($(), j("div", {
      ref: "container",
      class: ye([p.value, A.$attrs.class])
    }, [
      ae("button", Te({
        id: q(f),
        ref: "button"
      }, Qt(A.$attrs, ["class"]), {
        "aria-controls": b.value ? void 0 : `${q(f)}-listbox`,
        "aria-expanded": b.value ? void 0 : l.value,
        "aria-haspopup": b.value ? void 0 : "listbox",
        "aria-labelledby": e.label ? `${q(f)}-label` : void 0,
        class: "lc-select__wrap",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_select`,
        disabled: b.value || e.disabled,
        role: b.value ? void 0 : "combobox",
        type: "button",
        onClickPassive: F,
        onFocusin: V,
        onFocusout: V,
        onKeydown: J
      }), [
        !b.value && e.label ? ($(), j("span", {
          key: 0,
          id: `${q(f)}-label`,
          class: ye(_.value)
        }, Ie(e.label), 11, fm)) : ue("", !0),
        ae("div", hm, Ie(k.value), 1),
        b.value ? ue("", !0) : ($(), xe(q(Qe), {
          key: 1,
          class: "lc-select__icon",
          name: "chevron-down"
        }))
      ], 16, dm),
      b.value ? ue("", !0) : ($(), xe(q(pc), {
        key: 0,
        to: e.noTeleport ? void 0 : "body"
      }, {
        default: Ee(() => [
          l.value ? ($(), j("div", {
            key: 0,
            ref: "menu",
            class: ye(E.value),
            style: Ct(I.value)
          }, [
            ae("ul", {
              id: `${q(f)}-listbox`,
              "aria-activedescendant": u.value,
              "aria-labelledby": e.label ? `${q(f)}-label` : void 0,
              class: "lc-select__menu-list",
              role: "listbox"
            }, [
              ($(!0), j(Ge, null, vt(e.options, (U, X) => ($(), j("li", {
                key: `${U.label}-${U.value}`,
                class: ye(["lc-select__menu-item", {
                  "lc-select__menu-item--focused": o.value === X && q(m),
                  "lc-select__menu-item--selected": U.value === e.value
                }])
              }, [
                ae("button", {
                  id: `${q(f)}-option-${X}`,
                  ref_for: !0,
                  ref: "options",
                  "aria-selected": U.value === e.value,
                  class: "lc-select__menu-item-button",
                  role: "option",
                  tabindex: "-1",
                  type: "button",
                  onClickPassive: (B) => O(U.value)
                }, [
                  ae("span", null, Ie(U.label), 1),
                  U.value === e.value ? ($(), xe(q(Qe), {
                    key: 0,
                    class: "lc-select__menu-item-checkmark",
                    name: "checkmark"
                  })) : ue("", !0)
                ], 40, mm)
              ], 2))), 128))
            ], 8, vm)
          ], 6)) : ue("", !0)
        ]),
        _: 1
      }, 8, ["to"])),
      e.noFeedback ? ue("", !0) : ($(), xe(q($n), Te({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), a2 = ["default", "discreet"];
var Zt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Home = "Home", e.Space = " ", e))(Zt || {});
const gm = ["id", "aria-activedescendant"], r2 = /* @__PURE__ */ _e({
  __name: "LcSelectList",
  props: {
    horizontal: { type: Boolean },
    id: {},
    multiple: { type: Boolean },
    optionComponent: {},
    options: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = it("list"), s = pe(null), i = Tt(e.id), a = xi(), o = W(() => {
      if (St(s.value))
        return `${i}-option-${s.value}`;
    }), l = W(() => !r.value || !St(s.value) ? null : r.value.querySelectorAll('[role="option"]')[s.value]), h = W(() => [
      "lc-select-list",
      `lc-select-list--variant-${e.variant}`,
      {
        "lc-select-list--focus-hidden": e.options.length <= 1,
        "lc-select-list--horizontal": e.horizontal
      }
    ]), v = W(
      () => e.options.findIndex((E) => E.value === (Array.isArray(e.value) ? e.value[0] : e.value))
    ), c = (E) => e.optionComponent ? g(E) ? "span" : e.optionComponent : k(E) ? g(E) ? "span" : Yn(E.to) : "button", f = () => {
      a.value && (s.value = Math.max(0, v.value));
    }, m = () => {
      a.value && (s.value = null);
    }, u = (E) => {
      if (!en(E.key, Zt) || !St(s.value))
        return;
      E.preventDefault(), E.stopPropagation();
      const I = e.options.length - 1;
      switch (E.key) {
        case Zt.ArrowDown:
        case Zt.ArrowRight:
          s.value = Math.min(I, s.value + 1);
          break;
        case Zt.ArrowLeft:
        case Zt.ArrowUp:
          s.value = Math.max(0, s.value - 1);
          break;
        case Zt.End:
          s.value = I;
          break;
        case Zt.Enter:
        case Zt.Space:
          l.value?.dispatchEvent(new MouseEvent("click"));
          break;
        case Zt.Home:
          s.value = 0;
          break;
      }
    }, p = (E) => {
      let I;
      if (e.multiple) {
        const L = Array.isArray(e.value) ? e.value : [];
        I = L.includes(E) ? L.filter((C) => C !== E) : _([...L, E]);
      } else
        I = e.value === E ? void 0 : E;
      n("update:value", I);
    }, k = ({ href: E, to: I }) => !!(E || I), g = (E) => Array.isArray(e.value) ? e.value.includes(E.value) : e.value === E.value, b = () => {
      l.value?.scrollIntoView(
        e.horizontal ? { block: "nearest", inline: "center" } : { block: "center", inline: "nearest" }
      );
    }, _ = (E) => {
      const I = new Map(e.options.map((L, C) => [L.value, C]));
      return [...E].sort(
        (L, C) => (I.get(L) ?? 1 / 0) - (I.get(C) ?? 1 / 0)
      );
    };
    return mt(() => {
      if (e.value) {
        if (e.multiple && !Array.isArray(e.value))
          throw Error('LcSelectList: "value" must be an array when "multiple" is true.');
        if (!e.multiple && Array.isArray(e.value))
          throw Error('LcSelectList: "value" must not be an array when "multiple" is false.');
      }
    }), ze(s, (E) => {
      E !== null && b();
    }), (E, I) => ($(), j("div", {
      class: ye(h.value)
    }, [
      ae("ul", {
        id: q(i),
        ref: "list",
        "aria-activedescendant": o.value,
        class: "lc-select-list__list",
        role: "listbox",
        tabindex: "0",
        onFocusin: f,
        onFocusout: m,
        onKeydown: u
      }, [
        ($(!0), j(Ge, null, vt(e.options, (L, C) => ($(), j("li", {
          key: `${L.label}-${L.value}`,
          class: ye(["lc-select-list__item", {
            "lc-select-list__item--focused": s.value === C && q(a),
            "lc-select-list__item--selected": g(L)
          }])
        }, [
          ($(), xe(Pt(c(L)), Te({
            id: `${q(i)}-option-${C}`
          }, { ref_for: !0 }, {
            ...sc(L, ["href", "target", "to"]),
            ...L?.additionalProps ?? {}
          }, {
            "aria-label": L.ariaLabelText,
            "aria-selected": g(L),
            class: "lc-select-list__item-button",
            role: "option",
            tabindex: "-1",
            type: k(L) && !g(L) ? void 0 : "button",
            onClickPassive: (F) => p(L.value)
          }), {
            default: Ee(() => [
              ae("span", null, Ie(L.label), 1),
              g(L) ? ($(), xe(q(Qe), {
                key: 0,
                class: "lc-select-list__item-checkmark",
                name: e.variant === "discreet" ? "checkmark-small" : "checkmark"
              }, null, 8, ["name"])) : ue("", !0)
            ]),
            _: 2
          }, 1040, ["id", "aria-label", "aria-selected", "type", "onClickPassive"]))
        ], 2))), 128))
      ], 40, gm)
    ], 2));
  }
});
function Ma(e) {
  return [null, void 0, !1].indexOf(e) !== -1;
}
function bm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function bs(e) {
  var t = { exports: {} };
  return e(t, t.exports), t.exports;
}
var Gl = bs((function(e, t) {
  e.exports = /* @__PURE__ */ (function() {
    var n = ["decimals", "thousand", "mark", "prefix", "suffix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];
    function r(u) {
      return u.split("").reverse().join("");
    }
    function s(u, p) {
      return u.substring(0, p.length) === p;
    }
    function i(u, p) {
      return u.slice(-1 * p.length) === p;
    }
    function a(u, p, k) {
      if ((u[p] || u[k]) && u[p] === u[k]) throw new Error(p);
    }
    function o(u) {
      return typeof u == "number" && isFinite(u);
    }
    function l(u, p) {
      return u = u.toString().split("e"), (+((u = (u = Math.round(+(u[0] + "e" + (u[1] ? +u[1] + p : p)))).toString().split("e"))[0] + "e" + (u[1] ? +u[1] - p : -p))).toFixed(p);
    }
    function h(u, p, k, g, b, _, E, I, L, C, F, V) {
      var J, O, K, P = V, T = "", A = "";
      return _ && (V = _(V)), !!o(V) && (u !== !1 && parseFloat(V.toFixed(u)) === 0 && (V = 0), V < 0 && (J = !0, V = Math.abs(V)), u !== !1 && (V = l(V, u)), (V = V.toString()).indexOf(".") !== -1 ? (K = (O = V.split("."))[0], k && (T = k + O[1])) : K = V, p && (K = r(K).match(/.{1,3}/g), K = r(K.join(r(p)))), J && I && (A += I), g && (A += g), J && L && (A += L), A += K, A += T, b && (A += b), C && (A = C(A, P)), A);
    }
    function v(u, p, k, g, b, _, E, I, L, C, F, V) {
      var J, O = "";
      return F && (V = F(V)), !(!V || typeof V != "string") && (I && s(V, I) && (V = V.replace(I, ""), J = !0), g && s(V, g) && (V = V.replace(g, "")), L && s(V, L) && (V = V.replace(L, ""), J = !0), b && i(V, b) && (V = V.slice(0, -1 * b.length)), p && (V = V.split(p).join("")), k && (V = V.replace(k, ".")), J && (O += "-"), (O = (O += V).replace(/[^0-9\.\-.]/g, "")) !== "" && (O = Number(O), E && (O = E(O)), !!o(O) && O));
    }
    function c(u) {
      var p, k, g, b = {};
      for (u.suffix === void 0 && (u.suffix = u.postfix), p = 0; p < n.length; p += 1) if ((g = u[k = n[p]]) === void 0) k !== "negative" || b.negativeBefore ? k === "mark" && b.thousand !== "." ? b[k] = "." : b[k] = !1 : b[k] = "-";
      else if (k === "decimals") {
        if (!(g >= 0 && g < 8)) throw new Error(k);
        b[k] = g;
      } else if (k === "encoder" || k === "decoder" || k === "edit" || k === "undo") {
        if (typeof g != "function") throw new Error(k);
        b[k] = g;
      } else {
        if (typeof g != "string") throw new Error(k);
        b[k] = g;
      }
      return a(b, "mark", "thousand"), a(b, "prefix", "negative"), a(b, "prefix", "negativeBefore"), b;
    }
    function f(u, p, k) {
      var g, b = [];
      for (g = 0; g < n.length; g += 1) b.push(u[n[g]]);
      return b.push(k), p.apply("", b);
    }
    function m(u) {
      if (!(this instanceof m)) return new m(u);
      typeof u == "object" && (u = c(u), this.to = function(p) {
        return f(u, h, p);
      }, this.from = function(p) {
        return f(u, v, p);
      });
    }
    return m;
  })();
})), pm = bm(bs((function(e, t) {
  (function(n) {
    function r(D) {
      return s(D) && typeof D.from == "function";
    }
    function s(D) {
      return typeof D == "object" && typeof D.to == "function";
    }
    function i(D) {
      D.parentElement.removeChild(D);
    }
    function a(D) {
      return D != null;
    }
    function o(D) {
      D.preventDefault();
    }
    function l(D) {
      return D.filter((function(S) {
        return !this[S] && (this[S] = !0);
      }), {});
    }
    function h(D, S) {
      return Math.round(D / S) * S;
    }
    function v(D, S) {
      var w = D.getBoundingClientRect(), G = D.ownerDocument, Y = G.documentElement, se = _(G);
      return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (se.x = 0), S ? w.top + se.y - Y.clientTop : w.left + se.x - Y.clientLeft;
    }
    function c(D) {
      return typeof D == "number" && !isNaN(D) && isFinite(D);
    }
    function f(D, S, w) {
      w > 0 && (k(D, S), setTimeout((function() {
        g(D, S);
      }), w));
    }
    function m(D) {
      return Math.max(Math.min(D, 100), 0);
    }
    function u(D) {
      return Array.isArray(D) ? D : [D];
    }
    function p(D) {
      var S = (D = String(D)).split(".");
      return S.length > 1 ? S[1].length : 0;
    }
    function k(D, S) {
      D.classList && !/\s/.test(S) ? D.classList.add(S) : D.className += " " + S;
    }
    function g(D, S) {
      D.classList && !/\s/.test(S) ? D.classList.remove(S) : D.className = D.className.replace(new RegExp("(^|\\b)" + S.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
    function b(D, S) {
      return D.classList ? D.classList.contains(S) : new RegExp("\\b" + S + "\\b").test(D.className);
    }
    function _(D) {
      var S = window.pageXOffset !== void 0, w = (D.compatMode || "") === "CSS1Compat";
      return { x: S ? window.pageXOffset : w ? D.documentElement.scrollLeft : D.body.scrollLeft, y: S ? window.pageYOffset : w ? D.documentElement.scrollTop : D.body.scrollTop };
    }
    function E() {
      return window.navigator.pointerEnabled ? { start: "pointerdown", move: "pointermove", end: "pointerup" } : window.navigator.msPointerEnabled ? { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" } : { start: "mousedown touchstart", move: "mousemove touchmove", end: "mouseup touchend" };
    }
    function I() {
      var D = !1;
      try {
        var S = Object.defineProperty({}, "passive", { get: function() {
          D = !0;
        } });
        window.addEventListener("test", null, S);
      } catch {
      }
      return D;
    }
    function L() {
      return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
    }
    function C(D, S) {
      return 100 / (S - D);
    }
    function F(D, S, w) {
      return 100 * S / (D[w + 1] - D[w]);
    }
    function V(D, S) {
      return F(D, D[0] < 0 ? S + Math.abs(D[0]) : S - D[0], 0);
    }
    function J(D, S) {
      return S * (D[1] - D[0]) / 100 + D[0];
    }
    function O(D, S) {
      for (var w = 1; D >= S[w]; ) w += 1;
      return w;
    }
    function K(D, S, w) {
      if (w >= D.slice(-1)[0]) return 100;
      var G = O(w, D), Y = D[G - 1], se = D[G], R = S[G - 1], le = S[G];
      return R + V([Y, se], w) / C(R, le);
    }
    function P(D, S, w) {
      if (w >= 100) return D.slice(-1)[0];
      var G = O(w, S), Y = D[G - 1], se = D[G], R = S[G - 1];
      return J([Y, se], (w - R) * C(R, S[G]));
    }
    function T(D, S, w, G) {
      if (G === 100) return G;
      var Y = O(G, D), se = D[Y - 1], R = D[Y];
      return w ? G - se > (R - se) / 2 ? R : se : S[Y - 1] ? D[Y - 1] + h(G - D[Y - 1], S[Y - 1]) : G;
    }
    var A, z;
    n.PipsMode = void 0, (z = n.PipsMode || (n.PipsMode = {})).Range = "range", z.Steps = "steps", z.Positions = "positions", z.Count = "count", z.Values = "values", n.PipsType = void 0, (A = n.PipsType || (n.PipsType = {}))[A.None = -1] = "None", A[A.NoValue = 0] = "NoValue", A[A.LargeValue = 1] = "LargeValue", A[A.SmallValue = 2] = "SmallValue";
    var U = (function() {
      function D(S, w, G) {
        var Y;
        this.xPct = [], this.xVal = [], this.xSteps = [], this.xNumSteps = [], this.xHighestCompleteStep = [], this.xSteps = [G || !1], this.xNumSteps = [!1], this.snap = w;
        var se = [];
        for (Object.keys(S).forEach((function(R) {
          se.push([u(S[R]), R]);
        })), se.sort((function(R, le) {
          return R[0][0] - le[0][0];
        })), Y = 0; Y < se.length; Y++) this.handleEntryPoint(se[Y][1], se[Y][0]);
        for (this.xNumSteps = this.xSteps.slice(0), Y = 0; Y < this.xNumSteps.length; Y++) this.handleStepPoint(Y, this.xNumSteps[Y]);
      }
      return D.prototype.getDistance = function(S) {
        for (var w = [], G = 0; G < this.xNumSteps.length - 1; G++) w[G] = F(this.xVal, S, G);
        return w;
      }, D.prototype.getAbsoluteDistance = function(S, w, G) {
        var Y, se = 0;
        if (S < this.xPct[this.xPct.length - 1]) for (; S > this.xPct[se + 1]; ) se++;
        else S === this.xPct[this.xPct.length - 1] && (se = this.xPct.length - 2);
        G || S !== this.xPct[se + 1] || se++, w === null && (w = []);
        var R = 1, le = w[se], y = 0, fe = 0, $e = 0, d = 0;
        for (Y = G ? (S - this.xPct[se]) / (this.xPct[se + 1] - this.xPct[se]) : (this.xPct[se + 1] - S) / (this.xPct[se + 1] - this.xPct[se]); le > 0; ) y = this.xPct[se + 1 + d] - this.xPct[se + d], w[se + d] * R + 100 - 100 * Y > 100 ? (fe = y * Y, R = (le - 100 * Y) / w[se + d], Y = 1) : (fe = w[se + d] * y / 100 * R, R = 0), G ? ($e -= fe, this.xPct.length + d >= 1 && d--) : ($e += fe, this.xPct.length - d >= 1 && d++), le = w[se + d] * R;
        return S + $e;
      }, D.prototype.toStepping = function(S) {
        return S = K(this.xVal, this.xPct, S);
      }, D.prototype.fromStepping = function(S) {
        return P(this.xVal, this.xPct, S);
      }, D.prototype.getStep = function(S) {
        return S = T(this.xPct, this.xSteps, this.snap, S);
      }, D.prototype.getDefaultStep = function(S, w, G) {
        var Y = O(S, this.xPct);
        return (S === 100 || w && S === this.xPct[Y - 1]) && (Y = Math.max(Y - 1, 1)), (this.xVal[Y] - this.xVal[Y - 1]) / G;
      }, D.prototype.getNearbySteps = function(S) {
        var w = O(S, this.xPct);
        return { stepBefore: { startValue: this.xVal[w - 2], step: this.xNumSteps[w - 2], highestStep: this.xHighestCompleteStep[w - 2] }, thisStep: { startValue: this.xVal[w - 1], step: this.xNumSteps[w - 1], highestStep: this.xHighestCompleteStep[w - 1] }, stepAfter: { startValue: this.xVal[w], step: this.xNumSteps[w], highestStep: this.xHighestCompleteStep[w] } };
      }, D.prototype.countStepDecimals = function() {
        var S = this.xNumSteps.map(p);
        return Math.max.apply(null, S);
      }, D.prototype.hasNoSize = function() {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
      }, D.prototype.convert = function(S) {
        return this.getStep(this.toStepping(S));
      }, D.prototype.handleEntryPoint = function(S, w) {
        var G;
        if (!c(G = S === "min" ? 0 : S === "max" ? 100 : parseFloat(S)) || !c(w[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
        this.xPct.push(G), this.xVal.push(w[0]);
        var Y = Number(w[1]);
        G ? this.xSteps.push(!isNaN(Y) && Y) : isNaN(Y) || (this.xSteps[0] = Y), this.xHighestCompleteStep.push(0);
      }, D.prototype.handleStepPoint = function(S, w) {
        if (w) if (this.xVal[S] !== this.xVal[S + 1]) {
          this.xSteps[S] = F([this.xVal[S], this.xVal[S + 1]], w, 0) / C(this.xPct[S], this.xPct[S + 1]);
          var G = (this.xVal[S + 1] - this.xVal[S]) / this.xNumSteps[S], Y = Math.ceil(Number(G.toFixed(3)) - 1), se = this.xVal[S] + this.xNumSteps[S] * Y;
          this.xHighestCompleteStep[S] = se;
        } else this.xSteps[S] = this.xHighestCompleteStep[S] = this.xVal[S];
      }, D;
    })(), X = { to: function(D) {
      return D === void 0 ? "" : D.toFixed(2);
    }, from: Number }, B = { target: "target", base: "base", origin: "origin", handle: "handle", handleLower: "handle-lower", handleUpper: "handle-upper", touchArea: "touch-area", horizontal: "horizontal", vertical: "vertical", background: "background", connect: "connect", connects: "connects", ltr: "ltr", rtl: "rtl", textDirectionLtr: "txt-dir-ltr", textDirectionRtl: "txt-dir-rtl", draggable: "draggable", drag: "state-drag", tap: "state-tap", active: "active", tooltip: "tooltip", pips: "pips", pipsHorizontal: "pips-horizontal", pipsVertical: "pips-vertical", marker: "marker", markerHorizontal: "marker-horizontal", markerVertical: "marker-vertical", markerNormal: "marker-normal", markerLarge: "marker-large", markerSub: "marker-sub", value: "value", valueHorizontal: "value-horizontal", valueVertical: "value-vertical", valueNormal: "value-normal", valueLarge: "value-large", valueSub: "value-sub" }, ie = { tooltips: ".__tooltips", aria: ".__aria" };
    function H(D, S) {
      if (!c(S)) throw new Error("noUiSlider: 'step' is not numeric.");
      D.singleStep = S;
    }
    function ee(D, S) {
      if (!c(S)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
      D.keyboardPageMultiplier = S;
    }
    function ce(D, S) {
      if (!c(S)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
      D.keyboardMultiplier = S;
    }
    function we(D, S) {
      if (!c(S)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
      D.keyboardDefaultStep = S;
    }
    function ke(D, S) {
      if (typeof S != "object" || Array.isArray(S)) throw new Error("noUiSlider: 'range' is not an object.");
      if (S.min === void 0 || S.max === void 0) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
      D.spectrum = new U(S, D.snap || !1, D.singleStep);
    }
    function te(D, S) {
      if (S = u(S), !Array.isArray(S) || !S.length) throw new Error("noUiSlider: 'start' option is incorrect.");
      D.handles = S.length, D.start = S;
    }
    function he(D, S) {
      if (typeof S != "boolean") throw new Error("noUiSlider: 'snap' option must be a boolean.");
      D.snap = S;
    }
    function ge(D, S) {
      if (typeof S != "boolean") throw new Error("noUiSlider: 'animate' option must be a boolean.");
      D.animate = S;
    }
    function be(D, S) {
      if (typeof S != "number") throw new Error("noUiSlider: 'animationDuration' option must be a number.");
      D.animationDuration = S;
    }
    function Pe(D, S) {
      var w, G = [!1];
      if (S === "lower" ? S = [!0, !1] : S === "upper" && (S = [!1, !0]), S === !0 || S === !1) {
        for (w = 1; w < D.handles; w++) G.push(S);
        G.push(!1);
      } else {
        if (!Array.isArray(S) || !S.length || S.length !== D.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
        G = S;
      }
      D.connect = G;
    }
    function Ne(D, S) {
      switch (S) {
        case "horizontal":
          D.ort = 0;
          break;
        case "vertical":
          D.ort = 1;
          break;
        default:
          throw new Error("noUiSlider: 'orientation' option is invalid.");
      }
    }
    function de(D, S) {
      if (!c(S)) throw new Error("noUiSlider: 'margin' option must be numeric.");
      S !== 0 && (D.margin = D.spectrum.getDistance(S));
    }
    function Re(D, S) {
      if (!c(S)) throw new Error("noUiSlider: 'limit' option must be numeric.");
      if (D.limit = D.spectrum.getDistance(S), !D.limit || D.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
    }
    function He(D, S) {
      var w;
      if (!c(S) && !Array.isArray(S)) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (Array.isArray(S) && S.length !== 2 && !c(S[0]) && !c(S[1])) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (S !== 0) {
        for (Array.isArray(S) || (S = [S, S]), D.padding = [D.spectrum.getDistance(S[0]), D.spectrum.getDistance(S[1])], w = 0; w < D.spectrum.xNumSteps.length - 1; w++) if (D.padding[0][w] < 0 || D.padding[1][w] < 0) throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
        var G = S[0] + S[1], Y = D.spectrum.xVal[0];
        if (G / (D.spectrum.xVal[D.spectrum.xVal.length - 1] - Y) > 1) throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
      }
    }
    function Ze(D, S) {
      switch (S) {
        case "ltr":
          D.dir = 0;
          break;
        case "rtl":
          D.dir = 1;
          break;
        default:
          throw new Error("noUiSlider: 'direction' option was not recognized.");
      }
    }
    function We(D, S) {
      if (typeof S != "string") throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
      var w = S.indexOf("tap") >= 0, G = S.indexOf("drag") >= 0, Y = S.indexOf("fixed") >= 0, se = S.indexOf("snap") >= 0, R = S.indexOf("hover") >= 0, le = S.indexOf("unconstrained") >= 0, y = S.indexOf("drag-all") >= 0, fe = S.indexOf("smooth-steps") >= 0;
      if (Y) {
        if (D.handles !== 2) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        de(D, D.start[1] - D.start[0]);
      }
      if (le && (D.margin || D.limit)) throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
      D.events = { tap: w || se, drag: G, dragAll: y, smoothSteps: fe, fixed: Y, snap: se, hover: R, unconstrained: le };
    }
    function Be(D, S) {
      if (S !== !1) if (S === !0 || s(S)) {
        D.tooltips = [];
        for (var w = 0; w < D.handles; w++) D.tooltips.push(S);
      } else {
        if ((S = u(S)).length !== D.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
        S.forEach((function(G) {
          if (typeof G != "boolean" && !s(G)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
        })), D.tooltips = S;
      }
    }
    function Fe(D, S) {
      if (S.length !== D.handles) throw new Error("noUiSlider: must pass a attributes for all handles.");
      D.handleAttributes = S;
    }
    function Xe(D, S) {
      if (!s(S)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
      D.ariaFormat = S;
    }
    function ut(D, S) {
      if (!r(S)) throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
      D.format = S;
    }
    function gt(D, S) {
      if (typeof S != "boolean") throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
      D.keyboardSupport = S;
    }
    function bt(D, S) {
      D.documentElement = S;
    }
    function Ft(D, S) {
      if (typeof S != "string" && S !== !1) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
      D.cssPrefix = S;
    }
    function Ot(D, S) {
      if (typeof S != "object") throw new Error("noUiSlider: 'cssClasses' must be an object.");
      typeof D.cssPrefix == "string" ? (D.cssClasses = {}, Object.keys(S).forEach((function(w) {
        D.cssClasses[w] = D.cssPrefix + S[w];
      }))) : D.cssClasses = S;
    }
    function xt(D) {
      var S = { margin: null, limit: null, padding: null, animate: !0, animationDuration: 300, ariaFormat: X, format: X }, w = { step: { r: !1, t: H }, keyboardPageMultiplier: { r: !1, t: ee }, keyboardMultiplier: { r: !1, t: ce }, keyboardDefaultStep: { r: !1, t: we }, start: { r: !0, t: te }, connect: { r: !0, t: Pe }, direction: { r: !0, t: Ze }, snap: { r: !1, t: he }, animate: { r: !1, t: ge }, animationDuration: { r: !1, t: be }, range: { r: !0, t: ke }, orientation: { r: !1, t: Ne }, margin: { r: !1, t: de }, limit: { r: !1, t: Re }, padding: { r: !1, t: He }, behaviour: { r: !0, t: We }, ariaFormat: { r: !1, t: Xe }, format: { r: !1, t: ut }, tooltips: { r: !1, t: Be }, keyboardSupport: { r: !0, t: gt }, documentElement: { r: !1, t: bt }, cssPrefix: { r: !0, t: Ft }, cssClasses: { r: !0, t: Ot }, handleAttributes: { r: !1, t: Fe } }, G = { connect: !1, direction: "ltr", behaviour: "tap", orientation: "horizontal", keyboardSupport: !0, cssPrefix: "noUi-", cssClasses: B, keyboardPageMultiplier: 5, keyboardMultiplier: 1, keyboardDefaultStep: 10 };
      D.format && !D.ariaFormat && (D.ariaFormat = D.format), Object.keys(w).forEach((function(y) {
        if (a(D[y]) || G[y] !== void 0) w[y].t(S, a(D[y]) ? D[y] : G[y]);
        else if (w[y].r) throw new Error("noUiSlider: '" + y + "' is required.");
      })), S.pips = D.pips;
      var Y = document.createElement("div"), se = Y.style.msTransform !== void 0, R = Y.style.transform !== void 0;
      S.transformRule = R ? "transform" : se ? "msTransform" : "webkitTransform";
      var le = [["left", "top"], ["right", "bottom"]];
      return S.style = le[S.dir][S.ort], S;
    }
    function qt(D, S, w) {
      var G, Y, se, R, le, y = E(), fe = L() && I(), $e = D, d = S.spectrum, re = [], ne = [], x = [], N = 0, Q = {}, De = D.ownerDocument, Se = S.documentElement || De.documentElement, Ae = De.body, Ue = De.dir === "rtl" || S.ort === 1 ? 0 : 100;
      function ft(M, Z) {
        var oe = De.createElement("div");
        return Z && k(oe, Z), M.appendChild(oe), oe;
      }
      function et(M, Z) {
        var oe = ft(M, S.cssClasses.origin), ve = ft(oe, S.cssClasses.handle);
        if (ft(ve, S.cssClasses.touchArea), ve.setAttribute("data-handle", String(Z)), S.keyboardSupport && (ve.setAttribute("tabindex", "0"), ve.addEventListener("keydown", (function(Ce) {
          return Cs(Ce, Z);
        }))), S.handleAttributes !== void 0) {
          var Le = S.handleAttributes[Z];
          Object.keys(Le).forEach((function(Ce) {
            ve.setAttribute(Ce, Le[Ce]);
          }));
        }
        return ve.setAttribute("role", "slider"), ve.setAttribute("aria-orientation", S.ort ? "vertical" : "horizontal"), Z === 0 ? k(ve, S.cssClasses.handleLower) : Z === S.handles - 1 && k(ve, S.cssClasses.handleUpper), oe;
      }
      function qe(M, Z) {
        return !!Z && ft(M, S.cssClasses.connect);
      }
      function lt(M, Z) {
        var oe = ft(Z, S.cssClasses.connects);
        Y = [], (se = []).push(qe(oe, M[0]));
        for (var ve = 0; ve < S.handles; ve++) Y.push(et(Z, ve)), x[ve] = ve, se.push(qe(oe, M[ve + 1]));
      }
      function pt(M) {
        return k(M, S.cssClasses.target), S.dir === 0 ? k(M, S.cssClasses.ltr) : k(M, S.cssClasses.rtl), S.ort === 0 ? k(M, S.cssClasses.horizontal) : k(M, S.cssClasses.vertical), k(M, getComputedStyle(M).direction === "rtl" ? S.cssClasses.textDirectionRtl : S.cssClasses.textDirectionLtr), ft(M, S.cssClasses.base);
      }
      function kt(M, Z) {
        return !(!S.tooltips || !S.tooltips[Z]) && ft(M.firstChild, S.cssClasses.tooltip);
      }
      function fn() {
        return $e.hasAttribute("disabled");
      }
      function nn(M) {
        return Y[M].hasAttribute("disabled");
      }
      function tt() {
        le && (Xn("update" + ie.tooltips), le.forEach((function(M) {
          M && i(M);
        })), le = null);
      }
      function At() {
        tt(), le = Y.map(kt), hr("update" + ie.tooltips, (function(M, Z, oe) {
          if (le && S.tooltips && le[Z] !== !1) {
            var ve = M[Z];
            S.tooltips[Z] !== !0 && (ve = S.tooltips[Z].to(oe[Z])), le[Z].innerHTML = ve;
          }
        }));
      }
      function ht() {
        Xn("update" + ie.aria), hr("update" + ie.aria, (function(M, Z, oe, ve, Le) {
          x.forEach((function(Ce) {
            var Ve = Y[Ce], Me = ka(ne, Ce, 0, !0, !0, !0), st = ka(ne, Ce, 100, !0, !0, !0), rt = Le[Ce], Je = String(S.ariaFormat.to(oe[Ce]));
            Me = d.fromStepping(Me).toFixed(1), st = d.fromStepping(st).toFixed(1), rt = d.fromStepping(rt).toFixed(1), Ve.children[0].setAttribute("aria-valuemin", Me), Ve.children[0].setAttribute("aria-valuemax", st), Ve.children[0].setAttribute("aria-valuenow", rt), Ve.children[0].setAttribute("aria-valuetext", Je);
          }));
        }));
      }
      function zt(M) {
        if (M.mode === n.PipsMode.Range || M.mode === n.PipsMode.Steps) return d.xVal;
        if (M.mode === n.PipsMode.Count) {
          if (M.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
          for (var Z = M.values - 1, oe = 100 / Z, ve = []; Z--; ) ve[Z] = Z * oe;
          return ve.push(100), Rt(ve, M.stepped);
        }
        return M.mode === n.PipsMode.Positions ? Rt(M.values, M.stepped) : M.mode === n.PipsMode.Values ? M.stepped ? M.values.map((function(Le) {
          return d.fromStepping(d.getStep(d.toStepping(Le)));
        })) : M.values : [];
      }
      function Rt(M, Z) {
        return M.map((function(oe) {
          return d.fromStepping(Z ? d.getStep(oe) : oe);
        }));
      }
      function xa(M) {
        function Z(rt, Je) {
          return Number((rt + Je).toFixed(7));
        }
        var oe = zt(M), ve = {}, Le = d.xVal[0], Ce = d.xVal[d.xVal.length - 1], Ve = !1, Me = !1, st = 0;
        return (oe = l(oe.slice().sort((function(rt, Je) {
          return rt - Je;
        }))))[0] !== Le && (oe.unshift(Le), Ve = !0), oe[oe.length - 1] !== Ce && (oe.push(Ce), Me = !0), oe.forEach((function(rt, Je) {
          var nt, Ye, yt, Lt, dt, Di, gr, Mi, Oi, Ri, br = rt, Dn = oe[Je + 1], Fi = M.mode === n.PipsMode.Steps;
          for (Fi && (nt = d.xNumSteps[Je]), nt || (nt = Dn - br), Dn === void 0 && (Dn = br), nt = Math.max(nt, 1e-7), Ye = br; Ye <= Dn; Ye = Z(Ye, nt)) {
            for (Mi = (dt = (Lt = d.toStepping(Ye)) - st) / (M.density || 1), Ri = dt / (Oi = Math.round(Mi)), yt = 1; yt <= Oi; yt += 1) ve[(Di = st + yt * Ri).toFixed(5)] = [d.fromStepping(Di), 0];
            gr = oe.indexOf(Ye) > -1 ? n.PipsType.LargeValue : Fi ? n.PipsType.SmallValue : n.PipsType.NoValue, !Je && Ve && Ye !== Dn && (gr = 0), Ye === Dn && Me || (ve[Lt.toFixed(5)] = [Ye, gr]), st = Lt;
          }
        })), ve;
      }
      function ps(M, Z, oe) {
        var ve, Le, Ce = De.createElement("div"), Ve = ((ve = {})[n.PipsType.None] = "", ve[n.PipsType.NoValue] = S.cssClasses.valueNormal, ve[n.PipsType.LargeValue] = S.cssClasses.valueLarge, ve[n.PipsType.SmallValue] = S.cssClasses.valueSub, ve), Me = ((Le = {})[n.PipsType.None] = "", Le[n.PipsType.NoValue] = S.cssClasses.markerNormal, Le[n.PipsType.LargeValue] = S.cssClasses.markerLarge, Le[n.PipsType.SmallValue] = S.cssClasses.markerSub, Le), st = [S.cssClasses.valueHorizontal, S.cssClasses.valueVertical], rt = [S.cssClasses.markerHorizontal, S.cssClasses.markerVertical];
        function Je(Ye, yt) {
          var Lt = yt === S.cssClasses.value, dt = Lt ? Ve : Me;
          return yt + " " + (Lt ? st : rt)[S.ort] + " " + dt[Ye];
        }
        function nt(Ye, yt, Lt) {
          if ((Lt = Z ? Z(yt, Lt) : Lt) !== n.PipsType.None) {
            var dt = ft(Ce, !1);
            dt.className = Je(Lt, S.cssClasses.marker), dt.style[S.style] = Ye + "%", Lt > n.PipsType.NoValue && ((dt = ft(Ce, !1)).className = Je(Lt, S.cssClasses.value), dt.setAttribute("data-value", String(yt)), dt.style[S.style] = Ye + "%", dt.innerHTML = String(oe.to(yt)));
          }
        }
        return k(Ce, S.cssClasses.pips), k(Ce, S.ort === 0 ? S.cssClasses.pipsHorizontal : S.cssClasses.pipsVertical), Object.keys(M).forEach((function(Ye) {
          nt(Ye, M[Ye][0], M[Ye][1]);
        })), Ce;
      }
      function ur() {
        R && (i(R), R = null);
      }
      function cr(M) {
        ur();
        var Z = xa(M), oe = M.filter, ve = M.format || { to: function(Le) {
          return String(Math.round(Le));
        } };
        return R = $e.appendChild(ps(Z, oe, ve));
      }
      function _i() {
        var M = G.getBoundingClientRect(), Z = "offset" + ["Width", "Height"][S.ort];
        return S.ort === 0 ? M.width || G[Z] : M.height || G[Z];
      }
      function hn(M, Z, oe, ve) {
        var Le = function(Ve) {
          var Me = ys(Ve, ve.pageOffset, ve.target || Z);
          return !!Me && !(fn() && !ve.doNotReject) && !(b($e, S.cssClasses.tap) && !ve.doNotReject) && !(M === y.start && Me.buttons !== void 0 && Me.buttons > 1) && (!ve.hover || !Me.buttons) && (fe || Me.preventDefault(), Me.calcPoint = Me.points[S.ort], void oe(Me, ve));
        }, Ce = [];
        return M.split(" ").forEach((function(Ve) {
          Z.addEventListener(Ve, Le, !!fe && { passive: !0 }), Ce.push([Ve, Le]);
        })), Ce;
      }
      function ys(M, Z, oe) {
        var ve = M.type.indexOf("touch") === 0, Le = M.type.indexOf("mouse") === 0, Ce = M.type.indexOf("pointer") === 0, Ve = 0, Me = 0;
        if (M.type.indexOf("MSPointer") === 0 && (Ce = !0), M.type === "mousedown" && !M.buttons && !M.touches) return !1;
        if (ve) {
          var st = function(nt) {
            var Ye = nt.target;
            return Ye === oe || oe.contains(Ye) || M.composed && M.composedPath().shift() === oe;
          };
          if (M.type === "touchstart") {
            var rt = Array.prototype.filter.call(M.touches, st);
            if (rt.length > 1) return !1;
            Ve = rt[0].pageX, Me = rt[0].pageY;
          } else {
            var Je = Array.prototype.find.call(M.changedTouches, st);
            if (!Je) return !1;
            Ve = Je.pageX, Me = Je.pageY;
          }
        }
        return Z = Z || _(De), (Le || Ce) && (Ve = M.clientX + Z.x, Me = M.clientY + Z.y), M.pageOffset = Z, M.points = [Ve, Me], M.cursor = Le || Ce, M;
      }
      function Ci(M) {
        var Z = 100 * (M - v(G, S.ort)) / _i();
        return Z = m(Z), S.dir ? 100 - Z : Z;
      }
      function ws(M) {
        var Z = 100, oe = !1;
        return Y.forEach((function(ve, Le) {
          if (!nn(Le)) {
            var Ce = ne[Le], Ve = Math.abs(Ce - M);
            (Ve < Z || Ve <= Z && M > Ce || Ve === 100 && Z === 100) && (oe = Le, Z = Ve);
          }
        })), oe;
      }
      function xs(M, Z) {
        M.type === "mouseout" && M.target.nodeName === "HTML" && M.relatedTarget === null && dr(M, Z);
      }
      function ks(M, Z) {
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && M.buttons === 0 && Z.buttonsProperty !== 0) return dr(M, Z);
        var oe = (S.dir ? -1 : 1) * (M.calcPoint - Z.startCalcPoint);
        Ei(oe > 0, 100 * oe / Z.baseSize, Z.locations, Z.handleNumbers, Z.connect);
      }
      function dr(M, Z) {
        Z.handle && (g(Z.handle, S.cssClasses.active), N -= 1), Z.listeners.forEach((function(oe) {
          Se.removeEventListener(oe[0], oe[1]);
        })), N === 0 && (g($e, S.cssClasses.drag), mr(), M.cursor && (Ae.style.cursor = "", Ae.removeEventListener("selectstart", o))), S.events.smoothSteps && (Z.handleNumbers.forEach((function(oe) {
          vn(oe, ne[oe], !0, !0, !1, !1);
        })), Z.handleNumbers.forEach((function(oe) {
          ot("update", oe);
        }))), Z.handleNumbers.forEach((function(oe) {
          ot("change", oe), ot("set", oe), ot("end", oe);
        }));
      }
      function fr(M, Z) {
        if (!Z.handleNumbers.some(nn)) {
          var oe;
          Z.handleNumbers.length === 1 && (oe = Y[Z.handleNumbers[0]].children[0], N += 1, k(oe, S.cssClasses.active)), M.stopPropagation();
          var ve = [], Le = hn(y.move, Se, ks, { target: M.target, handle: oe, connect: Z.connect, listeners: ve, startCalcPoint: M.calcPoint, baseSize: _i(), pageOffset: M.pageOffset, handleNumbers: Z.handleNumbers, buttonsProperty: M.buttons, locations: ne.slice() }), Ce = hn(y.end, Se, dr, { target: M.target, handle: oe, listeners: ve, doNotReject: !0, handleNumbers: Z.handleNumbers }), Ve = hn("mouseout", Se, xs, { target: M.target, handle: oe, listeners: ve, doNotReject: !0, handleNumbers: Z.handleNumbers });
          ve.push.apply(ve, Le.concat(Ce, Ve)), M.cursor && (Ae.style.cursor = getComputedStyle(M.target).cursor, Y.length > 1 && k($e, S.cssClasses.drag), Ae.addEventListener("selectstart", o, !1)), Z.handleNumbers.forEach((function(Me) {
            ot("start", Me);
          }));
        }
      }
      function Ss(M) {
        M.stopPropagation();
        var Z = Ci(M.calcPoint), oe = ws(Z);
        oe !== !1 && (S.events.snap || f($e, S.cssClasses.tap, S.animationDuration), vn(oe, Z, !0, !0), mr(), ot("slide", oe, !0), ot("update", oe, !0), S.events.snap ? fr(M, { handleNumbers: [oe] }) : (ot("change", oe, !0), ot("set", oe, !0)));
      }
      function _s(M) {
        var Z = Ci(M.calcPoint), oe = d.getStep(Z), ve = d.fromStepping(oe);
        Object.keys(Q).forEach((function(Le) {
          Le.split(".")[0] === "hover" && Q[Le].forEach((function(Ce) {
            Ce.call(_a, ve);
          }));
        }));
      }
      function Cs(M, Z) {
        if (fn() || nn(Z)) return !1;
        var oe = ["Left", "Right"], ve = ["Down", "Up"], Le = ["PageDown", "PageUp"], Ce = ["Home", "End"];
        S.dir && !S.ort ? oe.reverse() : S.ort && !S.dir && (ve.reverse(), Le.reverse());
        var Ve, Me = M.key.replace("Arrow", ""), st = Me === Le[0], rt = Me === Le[1], Je = Me === ve[0] || Me === oe[0] || st, nt = Me === ve[1] || Me === oe[1] || rt, Ye = Me === Ce[0], yt = Me === Ce[1];
        if (!(Je || nt || Ye || yt)) return !0;
        if (M.preventDefault(), nt || Je) {
          var Lt = Je ? 0 : 1, dt = Ii(Z)[Lt];
          if (dt === null) return !1;
          dt === !1 && (dt = d.getDefaultStep(ne[Z], Je, S.keyboardDefaultStep)), dt *= rt || st ? S.keyboardPageMultiplier : S.keyboardMultiplier, dt = Math.max(dt, 1e-7), dt *= Je ? -1 : 1, Ve = re[Z] + dt;
        } else Ve = yt ? S.spectrum.xVal[S.spectrum.xVal.length - 1] : S.spectrum.xVal[0];
        return vn(Z, d.toStepping(Ve), !0, !0), ot("slide", Z), ot("update", Z), ot("change", Z), ot("set", Z), !1;
      }
      function Es(M) {
        M.fixed || Y.forEach((function(Z, oe) {
          hn(y.start, Z.children[0], fr, { handleNumbers: [oe] });
        })), M.tap && hn(y.start, G, Ss, {}), M.hover && hn(y.move, G, _s, { hover: !0 }), M.drag && se.forEach((function(Z, oe) {
          if (Z !== !1 && oe !== 0 && oe !== se.length - 1) {
            var ve = Y[oe - 1], Le = Y[oe], Ce = [Z], Ve = [ve, Le], Me = [oe - 1, oe];
            k(Z, S.cssClasses.draggable), M.fixed && (Ce.push(ve.children[0]), Ce.push(Le.children[0])), M.dragAll && (Ve = Y, Me = x), Ce.forEach((function(st) {
              hn(y.start, st, fr, { handles: Ve, handleNumbers: Me, connect: Z });
            }));
          }
        }));
      }
      function hr(M, Z) {
        Q[M] = Q[M] || [], Q[M].push(Z), M.split(".")[0] === "update" && Y.forEach((function(oe, ve) {
          ot("update", ve);
        }));
      }
      function Ts(M) {
        return M === ie.aria || M === ie.tooltips;
      }
      function Xn(M) {
        var Z = M && M.split(".")[0], oe = Z ? M.substring(Z.length) : M;
        Object.keys(Q).forEach((function(ve) {
          var Le = ve.split(".")[0], Ce = ve.substring(Le.length);
          Z && Z !== Le || oe && oe !== Ce || Ts(Ce) && oe !== Ce || delete Q[ve];
        }));
      }
      function ot(M, Z, oe) {
        Object.keys(Q).forEach((function(ve) {
          var Le = ve.split(".")[0];
          M === Le && Q[ve].forEach((function(Ce) {
            Ce.call(_a, re.map(S.format.to), Z, re.slice(), oe || !1, ne.slice(), _a);
          }));
        }));
      }
      function ka(M, Z, oe, ve, Le, Ce, Ve) {
        var Me;
        return Y.length > 1 && !S.events.unconstrained && (ve && Z > 0 && (Me = d.getAbsoluteDistance(M[Z - 1], S.margin, !1), oe = Math.max(oe, Me)), Le && Z < Y.length - 1 && (Me = d.getAbsoluteDistance(M[Z + 1], S.margin, !0), oe = Math.min(oe, Me))), Y.length > 1 && S.limit && (ve && Z > 0 && (Me = d.getAbsoluteDistance(M[Z - 1], S.limit, !1), oe = Math.min(oe, Me)), Le && Z < Y.length - 1 && (Me = d.getAbsoluteDistance(M[Z + 1], S.limit, !0), oe = Math.max(oe, Me))), S.padding && (Z === 0 && (Me = d.getAbsoluteDistance(0, S.padding[0], !1), oe = Math.max(oe, Me)), Z === Y.length - 1 && (Me = d.getAbsoluteDistance(100, S.padding[1], !0), oe = Math.min(oe, Me))), Ve || (oe = d.getStep(oe)), !((oe = m(oe)) === M[Z] && !Ce) && oe;
      }
      function vr(M, Z) {
        var oe = S.ort;
        return (oe ? Z : M) + ", " + (oe ? M : Z);
      }
      function Ei(M, Z, oe, ve, Le) {
        var Ce = oe.slice(), Ve = ve[0], Me = S.events.smoothSteps, st = [!M, M], rt = [M, !M];
        ve = ve.slice(), M && ve.reverse(), ve.length > 1 ? ve.forEach((function(nt, Ye) {
          var yt = ka(Ce, nt, Ce[nt] + Z, st[Ye], rt[Ye], !1, Me);
          yt === !1 ? Z = 0 : (Z = yt - Ce[nt], Ce[nt] = yt);
        })) : st = rt = [!0];
        var Je = !1;
        ve.forEach((function(nt, Ye) {
          Je = vn(nt, oe[nt] + Z, st[Ye], rt[Ye], !1, Me) || Je;
        })), Je && (ve.forEach((function(nt) {
          ot("update", nt), ot("slide", nt);
        })), Le != null && ot("drag", Ve));
      }
      function Ti(M, Z) {
        return S.dir ? 100 - M - Z : M;
      }
      function As(M, Z) {
        ne[M] = Z, re[M] = d.fromStepping(Z);
        var oe = "translate(" + vr(Ti(Z, 0) - Ue + "%", "0") + ")";
        Y[M].style[S.transformRule] = oe, Ai(M), Ai(M + 1);
      }
      function mr() {
        x.forEach((function(M) {
          var Z = ne[M] > 50 ? -1 : 1, oe = 3 + (Y.length + Z * M);
          Y[M].style.zIndex = String(oe);
        }));
      }
      function vn(M, Z, oe, ve, Le, Ce) {
        return Le || (Z = ka(ne, M, Z, oe, ve, !1, Ce)), Z !== !1 && (As(M, Z), !0);
      }
      function Ai(M) {
        if (se[M]) {
          var Z = 0, oe = 100;
          M !== 0 && (Z = ne[M - 1]), M !== se.length - 1 && (oe = ne[M]);
          var ve = oe - Z, Le = "translate(" + vr(Ti(Z, ve) + "%", "0") + ")", Ce = "scale(" + vr(ve / 100, "1") + ")";
          se[M].style[S.transformRule] = Le + " " + Ce;
        }
      }
      function Li(M, Z) {
        return M === null || M === !1 || M === void 0 ? ne[Z] : (typeof M == "number" && (M = String(M)), (M = S.format.from(M)) !== !1 && (M = d.toStepping(M)), M === !1 || isNaN(M) ? ne[Z] : M);
      }
      function Sa(M, Z, oe) {
        var ve = u(M), Le = ne[0] === void 0;
        Z = Z === void 0 || Z, S.animate && !Le && f($e, S.cssClasses.tap, S.animationDuration), x.forEach((function(Me) {
          vn(Me, Li(ve[Me], Me), !0, !1, oe);
        }));
        var Ce = x.length === 1 ? 0 : 1;
        if (Le && d.hasNoSize() && (oe = !0, ne[0] = 0, x.length > 1)) {
          var Ve = 100 / (x.length - 1);
          x.forEach((function(Me) {
            ne[Me] = Me * Ve;
          }));
        }
        for (; Ce < x.length; ++Ce) x.forEach((function(Me) {
          vn(Me, ne[Me], !0, !0, oe);
        }));
        mr(), x.forEach((function(Me) {
          ot("update", Me), ve[Me] !== null && Z && ot("set", Me);
        }));
      }
      function Ls(M) {
        Sa(S.start, M);
      }
      function $s(M, Z, oe, ve) {
        if (!((M = Number(M)) >= 0 && M < x.length)) throw new Error("noUiSlider: invalid handle number, got: " + M);
        vn(M, Li(Z, M), !0, !0, ve), ot("update", M), oe && ot("set", M);
      }
      function $i(M) {
        if (M === void 0 && (M = !1), M) return re.length === 1 ? re[0] : re.slice(0);
        var Z = re.map(S.format.to);
        return Z.length === 1 ? Z[0] : Z;
      }
      function Is() {
        for (Xn(ie.aria), Xn(ie.tooltips), Object.keys(S.cssClasses).forEach((function(M) {
          g($e, S.cssClasses[M]);
        })); $e.firstChild; ) $e.removeChild($e.firstChild);
        delete $e.noUiSlider;
      }
      function Ii(M) {
        var Z = ne[M], oe = d.getNearbySteps(Z), ve = re[M], Le = oe.thisStep.step, Ce = null;
        if (S.snap) return [ve - oe.stepBefore.startValue || null, oe.stepAfter.startValue - ve || null];
        Le !== !1 && ve + Le > oe.stepAfter.startValue && (Le = oe.stepAfter.startValue - ve), Ce = ve > oe.thisStep.startValue ? oe.thisStep.step : oe.stepBefore.step !== !1 && ve - oe.stepBefore.highestStep, Z === 100 ? Le = null : Z === 0 && (Ce = null);
        var Ve = d.countStepDecimals();
        return Le !== null && Le !== !1 && (Le = Number(Le.toFixed(Ve))), Ce !== null && Ce !== !1 && (Ce = Number(Ce.toFixed(Ve))), [Ce, Le];
      }
      function Ds() {
        return x.map(Ii);
      }
      function Ms(M, Z) {
        var oe = $i(), ve = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format", "pips", "tooltips"];
        ve.forEach((function(Ce) {
          M[Ce] !== void 0 && (w[Ce] = M[Ce]);
        }));
        var Le = xt(w);
        ve.forEach((function(Ce) {
          M[Ce] !== void 0 && (S[Ce] = Le[Ce]);
        })), d = Le.spectrum, S.margin = Le.margin, S.limit = Le.limit, S.padding = Le.padding, S.pips ? cr(S.pips) : ur(), S.tooltips ? At() : tt(), ne = [], Sa(a(M.start) ? M.start : oe, Z);
      }
      function Os() {
        G = pt($e), lt(S.connect, G), Es(S.events), Sa(S.start), S.pips && cr(S.pips), S.tooltips && At(), ht();
      }
      Os();
      var _a = { destroy: Is, steps: Ds, on: hr, off: Xn, get: $i, set: Sa, setHandle: $s, reset: Ls, __moveHandles: function(M, Z, oe) {
        Ei(M, Z, ne, oe);
      }, options: w, updateOptions: Ms, target: $e, removePips: ur, removeTooltips: tt, getPositions: function() {
        return ne.slice();
      }, getTooltips: function() {
        return le;
      }, getOrigins: function() {
        return Y;
      }, pips: cr };
      return _a;
    }
    function $t(D, S) {
      if (!D || !D.nodeName) throw new Error("noUiSlider: create requires a single element, got: " + D);
      if (D.noUiSlider) throw new Error("noUiSlider: Slider was already initialized.");
      var w = qt(D, xt(S), S);
      return D.noUiSlider = w, w;
    }
    var ct = { __spectrum: U, cssClasses: B, create: $t };
    n.create = $t, n.cssClasses = B, n.default = ct, Object.defineProperty(n, "__esModule", { value: !0 });
  })(t);
})));
function Kl(e, t) {
  if (!Array.isArray(e) || !Array.isArray(t)) return !1;
  const n = t.slice().sort();
  return e.length === t.length && e.slice().sort().every((function(r, s) {
    return r === n[s];
  }));
}
var Qr = { name: "Slider", emits: ["input", "update:modelValue", "start", "slide", "drag", "update", "change", "set", "end"], props: { value: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, modelValue: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, id: { type: [String, Number], required: !1 }, disabled: { type: Boolean, required: !1, default: !1 }, min: { type: Number, required: !1, default: 0 }, max: { type: Number, required: !1, default: 100 }, step: { type: Number, required: !1, default: 1 }, orientation: { type: String, required: !1, default: "horizontal" }, direction: { type: String, required: !1, default: "ltr" }, tooltips: { type: Boolean, required: !1, default: !0 }, options: { type: Object, required: !1, default: () => ({}) }, merge: { type: Number, required: !1, default: -1 }, format: { type: [Object, Function, Boolean], required: !1, default: null }, classes: { type: Object, required: !1, default: () => ({}) }, showTooltip: { type: String, required: !1, default: "always" }, tooltipPosition: { type: String, required: !1, default: null }, lazy: { type: Boolean, required: !1, default: !0 }, ariaLabelledby: { type: String, required: !1, default: void 0 }, aria: { required: !1, type: Object, default: () => ({}) } }, setup(e, t) {
  const n = (function(a, o, l) {
    const { value: h, modelValue: v, min: c } = Ca(a);
    let f = v && v.value !== void 0 ? v : h;
    const m = pe(f.value);
    if (Ma(f.value) && (f = pe(c.value)), Array.isArray(f.value) && f.value.length == 0) throw new Error("Slider v-model must not be an empty array");
    return { value: f, initialValue: m };
  })(e), r = (function(a, o, l) {
    const { classes: h, showTooltip: v, tooltipPosition: c, orientation: f } = Ca(a), m = W((() => ({ target: "slider-target", focused: "slider-focused", tooltipFocus: "slider-tooltip-focus", tooltipDrag: "slider-tooltip-drag", ltr: "slider-ltr", rtl: "slider-rtl", horizontal: "slider-horizontal", vertical: "slider-vertical", textDirectionRtl: "slider-txt-dir-rtl", textDirectionLtr: "slider-txt-dir-ltr", base: "slider-base", connects: "slider-connects", connect: "slider-connect", origin: "slider-origin", handle: "slider-handle", handleLower: "slider-handle-lower", handleUpper: "slider-handle-upper", touchArea: "slider-touch-area", tooltip: "slider-tooltip", tooltipTop: "slider-tooltip-top", tooltipBottom: "slider-tooltip-bottom", tooltipLeft: "slider-tooltip-left", tooltipRight: "slider-tooltip-right", tooltipHidden: "slider-tooltip-hidden", active: "slider-active", draggable: "slider-draggable", tap: "slider-state-tap", drag: "slider-state-drag", pips: "slider-pips", pipsHorizontal: "slider-pips-horizontal", pipsVertical: "slider-pips-vertical", marker: "slider-marker", markerHorizontal: "slider-marker-horizontal", markerVertical: "slider-marker-vertical", markerNormal: "slider-marker-normal", markerLarge: "slider-marker-large", markerSub: "slider-marker-sub", value: "slider-value", valueHorizontal: "slider-value-horizontal", valueVertical: "slider-value-vertical", valueNormal: "slider-value-normal", valueLarge: "slider-value-large", valueSub: "slider-value-sub", ...h.value })));
    return { classList: W((() => {
      const u = { ...m.value };
      return Object.keys(u).forEach(((p) => {
        u[p] = Array.isArray(u[p]) ? u[p].filter(((k) => k !== null)).join(" ") : u[p];
      })), v.value !== "always" && (u.target += ` ${v.value === "drag" ? u.tooltipDrag : u.tooltipFocus}`), f.value === "horizontal" && (u.tooltip += c.value === "bottom" ? ` ${u.tooltipBottom}` : ` ${u.tooltipTop}`), f.value === "vertical" && (u.tooltip += c.value === "right" ? ` ${u.tooltipRight}` : ` ${u.tooltipLeft}`), u;
    })) };
  })(e), s = (function(a, o, l) {
    const { format: h, step: v } = Ca(a), c = l.value, f = l.classList, m = W((() => h && h.value ? typeof h.value == "function" ? { to: h.value } : Gl({ ...h.value }) : Gl({ decimals: v.value >= 0 ? 0 : 2 }))), u = W((() => Array.isArray(c.value) ? c.value.map(((p) => m.value)) : m.value));
    return { tooltipFormat: m, tooltipsFormat: u, tooltipsMerge: (p, k, g) => {
      var b = getComputedStyle(p).direction === "rtl", _ = p.noUiSlider.options.direction === "rtl", E = p.noUiSlider.options.orientation === "vertical", I = p.noUiSlider.getTooltips(), L = p.noUiSlider.getOrigins();
      I.forEach((function(C, F) {
        C && L[F].appendChild(C);
      })), p.noUiSlider.on("update", (function(C, F, V, J, O) {
        var K = [[]], P = [[]], T = [[]], A = 0;
        I[0] && (K[0][0] = 0, P[0][0] = O[0], T[0][0] = m.value.to(parseFloat(C[0])));
        for (var z = 1; z < C.length; z++) (!I[z] || C[z] - C[z - 1] > k) && (K[++A] = [], T[A] = [], P[A] = []), I[z] && (K[A].push(z), T[A].push(m.value.to(parseFloat(C[z]))), P[A].push(O[z]));
        K.forEach((function(U, X) {
          for (var B = U.length, ie = 0; ie < B; ie++) {
            var H = U[ie];
            if (ie === B - 1) {
              var ee = 0;
              P[X].forEach((function(te) {
                ee += 1e3 - te;
              }));
              var ce = E ? "bottom" : "right", we = _ ? 0 : B - 1, ke = 1e3 - P[X][we];
              ee = (b && !E ? 100 : 0) + ee / B - ke, I[H].innerHTML = T[X].join(g), I[H].style.display = "block", I[H].style[ce] = ee + "%", f.value.tooltipHidden.split(" ").forEach(((te) => {
                I[H].classList.contains(te) && I[H].classList.remove(te);
              }));
            } else I[H].style.display = "none", f.value.tooltipHidden.split(" ").forEach(((te) => {
              I[H].classList.add(te);
            }));
          }
        }));
      }));
    } };
  })(e, 0, { value: n.value, classList: r.classList }), i = (function(a, o, l) {
    const { orientation: h, direction: v, tooltips: c, step: f, min: m, max: u, merge: p, id: k, disabled: g, options: b, classes: _, format: E, lazy: I, ariaLabelledby: L, aria: C } = Ca(a), F = l.value, V = l.initialValue, J = l.tooltipsFormat, O = l.tooltipsMerge, K = l.tooltipFormat, P = l.classList, T = pe(null), A = pe(null), z = pe(!1), U = W((() => {
      let te = { cssPrefix: "", cssClasses: P.value, orientation: h.value, direction: v.value, tooltips: !!c.value && J.value, connect: "lower", start: Ma(F.value) ? m.value : F.value, range: { min: m.value, max: u.value } };
      if (f.value > 0 && (te.step = f.value), Array.isArray(F.value) && (te.connect = !0), L && L.value || C && Object.keys(C.value).length) {
        let he = Array.isArray(F.value) ? F.value : [F.value];
        te.handleAttributes = he.map(((ge) => Object.assign({}, C.value, L && L.value ? { "aria-labelledby": L.value } : {})));
      }
      return E.value && (te.ariaFormat = K.value), te;
    })), X = W((() => {
      let te = { id: k && k.value ? k.value : void 0 };
      return g.value && (te.disabled = !0), te;
    })), B = W((() => Array.isArray(F.value))), ie = () => {
      let te = A.value.get();
      return Array.isArray(te) ? te.map(((he) => parseFloat(he))) : parseFloat(te);
    }, H = function(te) {
      let he = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
      A.value.set(te, he);
    }, ee = (te) => {
      o.emit("input", te), o.emit("update:modelValue", te), o.emit("update", te);
    }, ce = () => {
      A.value = pm.create(T.value, Object.assign({}, U.value, b.value)), c.value && B.value && p.value >= 0 && O(T.value, p.value, " - "), A.value.on("set", (() => {
        const te = ie();
        o.emit("change", te), o.emit("set", te), I.value && ee(te);
      })), A.value.on("update", (() => {
        if (!z.value) return;
        const te = ie();
        B.value && Kl(F.value, te) || !B.value && F.value == te ? o.emit("update", te) : I.value || ee(te);
      })), A.value.on("start", (() => {
        o.emit("start", ie());
      })), A.value.on("end", (() => {
        o.emit("end", ie());
      })), A.value.on("slide", (() => {
        o.emit("slide", ie());
      })), A.value.on("drag", (() => {
        o.emit("drag", ie());
      })), T.value.querySelectorAll("[data-handle]").forEach(((te) => {
        te.onblur = () => {
          T.value && P.value.focused.split(" ").forEach(((he) => {
            T.value.classList.remove(he);
          }));
        }, te.onfocus = () => {
          P.value.focused.split(" ").forEach(((he) => {
            T.value.classList.add(he);
          }));
        };
      })), z.value = !0;
    }, we = () => {
      A.value.off(), A.value.destroy(), A.value = null;
    }, ke = (te, he) => {
      z.value = !1, we(), ce();
    };
    return mt(ce), Ln(we), ze(B, ke, { immediate: !1 }), ze(m, ke, { immediate: !1 }), ze(u, ke, { immediate: !1 }), ze(f, ke, { immediate: !1 }), ze(h, ke, { immediate: !1 }), ze(v, ke, { immediate: !1 }), ze(c, ke, { immediate: !1 }), ze(p, ke, { immediate: !1 }), ze(E, ke, { immediate: !1, deep: !0 }), ze(b, ke, { immediate: !1, deep: !0 }), ze(_, ke, { immediate: !1, deep: !0 }), ze(F, ((te, he) => {
      he && (typeof he == "object" && typeof te == "object" && te && Object.keys(he) > Object.keys(te) || typeof he == "object" && typeof te != "object" || Ma(te)) && ke();
    }), { immediate: !1 }), ze(F, ((te) => {
      if (Ma(te)) return void H(m.value, !1);
      let he = ie();
      B.value && !Array.isArray(he) && (he = [he]), (B.value && !Kl(te, he) || !B.value && te != he) && H(te, !1);
    }), { deep: !0 }), { slider: T, slider$: A, isRange: B, sliderProps: X, init: ce, destroy: we, refresh: ke, update: H, reset: () => {
      ee(V.value);
    } };
  })(e, t, { value: n.value, initialValue: n.initialValue, tooltipFormat: s.tooltipFormat, tooltipsFormat: s.tooltipsFormat, tooltipsMerge: s.tooltipsMerge, classList: r.classList });
  return { ...r, ...s, ...i };
} };
Qr.render = function(e, t, n, r, s, i) {
  return $(), j("div", Te(e.sliderProps, { ref: "slider" }), null, 16);
}, Qr.__file = "src/Slider.vue";
const ym = ["data-click-name"], wm = { class: "lc-slider__wrap" }, xm = {
  key: 0,
  class: "lc-slider__min"
}, km = {
  key: 0,
  class: "lc-slider__slider-marks"
}, Sm = ["data-testid"], _m = {
  key: 1,
  class: "lc-slider__max"
}, Cm = 1, i2 = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcSlider",
  props: {
    containerClass: {},
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    format: { type: Function, default: (e) => String(e) },
    helpMessage: {},
    hideMax: { type: Boolean },
    hideMin: { type: Boolean },
    hideStepMarkers: { type: Boolean },
    lazy: { type: Boolean, default: !0 },
    marker: {},
    max: {},
    min: {},
    name: {},
    noFeedback: { type: Boolean },
    step: { default: 1 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = pe(!1), r = it("slider"), s = t, i = W({
      get: () => e.value,
      set: (f) => s("update:value", f)
    }), a = W(() => {
      if (!e.marker) return;
      const { snap: f, steps: m } = e.marker;
      return {
        range: {
          min: e.min,
          ...m,
          max: e.max
        },
        snap: f
      };
    }), o = W(() => {
      if (a.value) return Object.keys(a.value.range);
      const f = (e.max - e.min) / e.step + Cm;
      return Array.from({ length: f }, (m, u) => u);
    }), l = (f) => {
      const m = r.value;
      if (!m) return;
      const u = new Event(f, { bubbles: !0 });
      m.dispatchEvent(u);
    }, h = () => {
      n.value || (l("focusin"), l("focusout"));
    }, v = (f) => {
      n.value = f === "focusin", l(f);
    }, c = (f) => ["max", "min"].includes(String(f));
    return (f, m) => ($(), j("div", {
      ref: "slider",
      class: ye(["lc-slider", [
        {
          "lc-slider--disabled": e.disabled,
          "lc-slider--fixed-steps": !!a.value
        },
        e.containerClass,
        f.$attrs.class
      ]]),
      "data-click-name": e.dataClickName || `${e.name?.toLowerCase()}_slider`
    }, [
      ae("div", wm, [
        e.hideMin ? ue("", !0) : ($(), j("span", xm, [
          me(f.$slots, "min", _t(Dt({ min: e.min })), () => [
            wt(Ie(e.format(e.min)), 1)
          ])
        ])),
        ae("div", {
          class: "lc-slider__slider-container",
          onFocusin: m[1] || (m[1] = sa(() => v("focusin"), ["stop"])),
          onFocusout: m[2] || (m[2] = sa(() => v("focusout"), ["stop"]))
        }, [
          Oe(q(Qr), Te({
            ...Qt(f.$attrs, ["class"]),
            ...f.$props,
            lazy: e.lazy
          }, {
            modelValue: i.value,
            "onUpdate:modelValue": m[0] || (m[0] = (u) => i.value = u),
            class: "lc-slider__slider",
            options: a.value,
            onChange: h
          }), null, 16, ["modelValue", "options"]),
          e.hideStepMarkers ? ue("", !0) : ($(), j("div", km, [
            ($(!0), j(Ge, null, vt(o.value, (u) => ($(), j("span", {
              key: u,
              class: ye(["lc-slider__slider-mark", {
                [`lc-slider__slider-mark--${u}`]: c(u)
              }]),
              "data-testid": `lc-slider-mark-${u}`,
              style: Ct(
                typeof u == "string" && !c(u) ? `left:${u}%` : null
              )
            }, null, 14, Sm))), 128))
          ]))
        ], 32),
        e.hideMax ? ue("", !0) : ($(), j("span", _m, [
          me(f.$slots, "max", _t(Dt({ max: e.max })), () => [
            wt(Ie(e.format(e.max)), 1)
          ])
        ]))
      ]),
      e.noFeedback ? ue("", !0) : ($(), xe(q($n), Te({
        key: 0,
        class: "lc-slider__feedback"
      }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 10, ym));
  }
});
function xn() {
  return xn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xn.apply(this, arguments);
}
var Em = 0.996, Tm = function(t, n) {
  return n === void 0 && (n = Em), t * n / (1 - n);
};
function Am(e) {
  return e[e.length - 1];
}
function Lm(e) {
  return e.reduce(function(t, n) {
    return t + n;
  }) / e.length;
}
var $m = function(t, n, r) {
  return Math.min(Math.max(n, t), r);
};
function Br(e, t) {
  if (e.length !== t.length)
    throw new Error("vectors must be same length");
  return e.map(function(n, r) {
    return n + t[r];
  });
}
function Jl(e) {
  return Math.max.apply(Math, e.map(Math.abs));
}
function Zn(e) {
  return Object.freeze(e), Object.values(e).forEach(function(t) {
    t !== null && typeof t == "object" && !Object.isFrozen(t) && Zn(t);
  }), e;
}
function Im() {
  var e = {};
  function t(s, i) {
    return e[s] = (e[s] || []).concat(i), function() {
      return n(s, i);
    };
  }
  function n(s, i) {
    e[s] = (e[s] || []).filter(function(a) {
      return a !== i;
    });
  }
  function r(s, i) {
    s in e && e[s].forEach(function(a) {
      return a(i);
    });
  }
  return Zn({
    on: t,
    off: n,
    dispatch: r
  });
}
function Dm(e) {
  var t = [], n = function(a) {
    return a.addEventListener("wheel", e, {
      passive: !1
    }), t.push(a), function() {
      return r(a);
    };
  }, r = function(a) {
    a.removeEventListener("wheel", e), t = t.filter(function(o) {
      return o !== a;
    });
  }, s = function() {
    t.forEach(r);
  };
  return Zn({
    observe: n,
    unobserve: r,
    disconnect: s
  });
}
var Mm = 16 * 1.125, Om = typeof window < "u" && window.innerHeight || 800, Pr = [1, Mm, Om];
function Rm(e) {
  var t = e.deltaX * Pr[e.deltaMode], n = e.deltaY * Pr[e.deltaMode], r = (e.deltaZ || 0) * Pr[e.deltaMode];
  return {
    timeStamp: e.timeStamp,
    axisDelta: [t, n, r]
  };
}
var Fm = [-1, -1, -1];
function Nm(e, t) {
  if (!t)
    return e;
  var n = t === !0 ? Fm : t.map(function(r) {
    return r ? -1 : 1;
  });
  return xn({}, e, {
    axisDelta: e.axisDelta.map(function(r, s) {
      return r * n[s];
    })
  });
}
var Ql = 700, Bm = function(t) {
  return xn({}, t, {
    axisDelta: t.axisDelta.map(function(n) {
      return $m(n, -Ql, Ql);
    })
  });
}, zr = process.env.NODE_ENV !== "production", Pm = 0.6, zm = 0.96, Vm = 2, eo = 5, to = /* @__PURE__ */ Zn({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), Hm = 400;
function no() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: Hm
  };
}
function Um(e) {
  e === void 0 && (e = {});
  var t = Im(), n = t.on, r = t.off, s = t.dispatch, i = to, a = no(), o, l = !1, h, v = function(T) {
    Array.isArray(T) ? T.forEach(function(A) {
      return u(A);
    }) : u(T);
  }, c = function(T) {
    return T === void 0 && (T = {}), Object.values(T).some(function(A) {
      return A == null;
    }) ? (zr && console.error("updateOptions ignored! undefined & null options not allowed"), i) : i = Zn(xn({}, to, i, T));
  }, f = function(T) {
    var A = xn({
      event: o,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: a.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: a.axisVelocity,
      axisMovement: a.axisMovement,
      get axisMovementProjection() {
        return Br(A.axisMovement, A.axisVelocity.map(function(z) {
          return Tm(z);
        }));
      }
    }, T);
    s("wheel", xn({}, A, {
      previous: h
    })), h = A;
  }, m = function(T, A) {
    var z = i, U = z.preventWheelAction, X = A[0], B = A[1], ie = A[2];
    if (typeof U == "boolean") return U;
    switch (U) {
      case "x":
        return Math.abs(X) >= T;
      case "y":
        return Math.abs(B) >= T;
      case "z":
        return Math.abs(ie) >= T;
      default:
        return zr && console.warn("unsupported preventWheelAction value: " + U, "warn"), !1;
    }
  }, u = function(T) {
    var A = Bm(Nm(Rm(T), i.reverseSign)), z = A.axisDelta, U = A.timeStamp, X = Jl(z);
    if (T.preventDefault && m(X, z) && T.preventDefault(), a.isStarted ? a.isMomentum && X > Math.max(2, a.lastAbsDelta * 2) && (F(!0), L()) : L(), X === 0 && Object.is && Object.is(T.deltaX, -0)) {
      l = !0;
      return;
    }
    o = T, a.axisMovement = Br(a.axisMovement, z), a.lastAbsDelta = X, a.scrollPointsToMerge.push({
      axisDelta: z,
      timeStamp: U
    }), p(), f({
      axisDelta: z,
      isStart: !a.isStartPublished
    }), a.isStartPublished = !0, C();
  }, p = function() {
    a.scrollPointsToMerge.length === Vm ? (a.scrollPoints.unshift({
      axisDeltaSum: a.scrollPointsToMerge.map(function(T) {
        return T.axisDelta;
      }).reduce(Br),
      timeStamp: Lm(a.scrollPointsToMerge.map(function(T) {
        return T.timeStamp;
      }))
    }), g(), a.scrollPointsToMerge.length = 0, a.scrollPoints.length = 1, a.isMomentum || E()) : a.isStartPublished || k();
  }, k = function() {
    a.axisVelocity = Am(a.scrollPointsToMerge).axisDelta.map(function(T) {
      return T / a.willEndTimeout;
    });
  }, g = function() {
    var T = a.scrollPoints, A = T[0], z = T[1];
    if (!(!z || !A)) {
      var U = A.timeStamp - z.timeStamp;
      if (U <= 0) {
        zr && console.warn("invalid deltaTime");
        return;
      }
      var X = A.axisDeltaSum.map(function(ie) {
        return ie / U;
      }), B = X.map(function(ie, H) {
        return ie / (a.axisVelocity[H] || 1);
      });
      a.axisVelocity = X, a.accelerationFactors.push(B), b(U);
    }
  }, b = function(T) {
    var A = Math.ceil(T / 10) * 10 * 1.2;
    a.isMomentum || (A = Math.max(100, A * 2)), a.willEndTimeout = Math.min(1e3, Math.round(A));
  }, _ = function(T) {
    return T === 0 ? !0 : T <= zm && T >= Pm;
  }, E = function() {
    if (a.accelerationFactors.length >= eo) {
      if (l && (l = !1, Jl(a.axisVelocity) >= 0.2)) {
        I();
        return;
      }
      var T = a.accelerationFactors.slice(eo * -1), A = T.every(function(z) {
        var U = !!z.reduce(function(B, ie) {
          return B && B < 1 && B === ie ? 1 : 0;
        }), X = z.filter(_).length === z.length;
        return U || X;
      });
      A && I(), a.accelerationFactors = T;
    }
  }, I = function() {
    a.isMomentum = !0;
  }, L = function() {
    a = no(), a.isStarted = !0, a.startTime = Date.now(), h = void 0, l = !1;
  }, C = /* @__PURE__ */ (function() {
    var P;
    return function() {
      clearTimeout(P), P = setTimeout(F, a.willEndTimeout);
    };
  })(), F = function(T) {
    T === void 0 && (T = !1), a.isStarted && (a.isMomentum && T ? f({
      isEnding: !0,
      isMomentumCancel: !0
    }) : f({
      isEnding: !0
    }), a.isMomentum = !1, a.isStarted = !1);
  }, V = Dm(v), J = V.observe, O = V.unobserve, K = V.disconnect;
  return c(e), Zn({
    on: n,
    off: r,
    observe: J,
    unobserve: O,
    disconnect: K,
    feedWheel: v,
    updateOptions: c
  });
}
var qm = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0
};
Si.globalOptions = void 0;
var jm = process.env.NODE_ENV !== "production";
function Si(e) {
  e === void 0 && (e = {});
  var t, n = function() {
  };
  function r(i, a) {
    var o, l, h = a.mergeOptions, v = a.optionsAtMedia, c = h(qm, Si.globalOptions), f = h(c, e);
    t = v(f);
    var m = i.internalEngine(), u = (o = t.target) != null ? o : i.containerNode().parentNode, p = (l = t.forceWheelAxis) != null ? l : m.options.axis, k = Um({
      preventWheelAction: p,
      reverseSign: [!0, !0, !1]
    });
    function g() {
      C = (p === "x" ? m.containerRect.width : m.containerRect.height) / 2;
    }
    var b = k.observe(u), _ = k.on("wheel", X), E = !1, I, L = 0, C = 0, F = !1;
    g(), i.on("resize", g);
    function V(B) {
      try {
        I = new MouseEvent("mousedown", B.event), A(I);
      } catch {
        return jm && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), n();
      }
      E = !0, L = 0, O(), t.wheelDraggingClass && u.classList.add(t.wheelDraggingClass);
    }
    function J(B) {
      E = !1, A(T("mouseup", B)), K(), t.wheelDraggingClass && u.classList.remove(t.wheelDraggingClass);
    }
    function O() {
      document.documentElement.addEventListener("mousemove", P, !0), document.documentElement.addEventListener("mouseup", P, !0), document.documentElement.addEventListener("mousedown", P, !0);
    }
    function K() {
      document.documentElement.removeEventListener("mousemove", P, !0), document.documentElement.removeEventListener("mouseup", P, !0), document.documentElement.removeEventListener("mousedown", P, !0);
    }
    function P(B) {
      E && B.isTrusted && B.stopImmediatePropagation();
    }
    function T(B, ie) {
      var H, ee;
      if (p === m.options.axis) {
        var ce = ie.axisMovement;
        H = ce[0], ee = ce[1];
      } else {
        var we = ie.axisMovement;
        ee = we[0], H = we[1];
      }
      var ke = z(ie), te = ke.isAtBoundary;
      if (te) {
        var he = Math.min(L / C, 1), ge = 0.25 + he * 0.5, be = H > 0 ? -1 : 1, Pe = L * be, Ne = Pe * ge;
        H += Ne, ee += Ne;
      }
      if (!m.options.skipSnaps && !m.options.dragFree) {
        var de = m.containerRect.width, Re = m.containerRect.height;
        H = H < 0 ? Math.max(H, -de) : Math.min(H, de), ee = ee < 0 ? Math.max(ee, -Re) : Math.min(ee, Re);
      }
      return new MouseEvent(B, {
        clientX: I.clientX + H,
        clientY: I.clientY + ee,
        screenX: I.screenX + H,
        screenY: I.screenY + ee,
        movementX: H,
        movementY: ee,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0
      });
    }
    function A(B) {
      i.containerNode().dispatchEvent(B);
    }
    function z(B) {
      var ie = B.axisDelta, H = ie[0], ee = ie[1], ce = i.scrollProgress(), we = ce < 1, ke = ce > 0, te = p === "x" ? H : ee, he = te < 0, ge = te > 0, be = he && !we || ge && !ke;
      return {
        isAtBoundary: be,
        primaryAxisDelta: te
      };
    }
    function U(B) {
      var ie = z(B), H = ie.isAtBoundary, ee = ie.primaryAxisDelta;
      if (H && !B.isMomentum) {
        if (L += Math.abs(ee), L > C)
          return F = !0, J(B), !0;
      } else
        L = 0;
      return !1;
    }
    function X(B) {
      var ie = B.axisDelta, H = ie[0], ee = ie[1], ce = p === "x" ? H : ee, we = p === "x" ? ee : H, ke = B.isMomentum && B.previous && !B.previous.isMomentum, te = B.isEnding && !B.isMomentum || ke, he = Math.abs(ce) > Math.abs(we);
      he && !E && !B.isMomentum && !F && V(B), F && B.isEnding && (F = !1), E && (U(B) || (te ? J(B) : A(T("mousemove", B))));
    }
    n = function() {
      b(), _(), i.off("resize", g), K();
    };
  }
  var s = {
    name: "wheelGestures",
    options: e,
    init: r,
    destroy: function() {
      return n();
    }
  };
  return s;
}
const Zm = { class: "lc-slot-wheel__wrap" }, l2 = /* @__PURE__ */ _e({
  __name: "LcSlotWheel",
  props: {
    options: {},
    value: {}
  },
  emits: ["optionsChanged", "ready", "reInit", "update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = {
      axis: "y",
      loop: !0,
      skipSnaps: !0
    }, i = [
      Ja({
        draggable: "lc-slot-wheel--draggable",
        dragging: "lc-slot-wheel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-slot-wheel__slide--snapped"
      }),
      Si()
    ], [a, o] = er(
      {
        ...s,
        startIndex: Math.max(
          0,
          e.options.findIndex((L) => L.value === e.value)
        )
      },
      i
    ), l = Wn(Yr, () => null, !0), h = fo(), v = () => {
      o.value?.reInit({
        ...s,
        watchDrag: !1
      });
    }, c = () => {
      o.value?.reInit({
        ...s,
        watchDrag: !0
      });
    }, f = (L) => Math.max(
      0,
      e.options.findIndex((C) => C.value === L)
    ), m = (L) => !L || h.value === "reduce", u = (L, C = !0) => {
      o.value?.scrollTo(f(L), m(C));
    }, p = () => {
      I(), r("ready");
    }, k = () => {
      l?.disable();
    }, g = () => {
      l?.enable();
    }, b = () => {
      I(), r("reInit");
    }, _ = () => {
      const L = o.value?.selectedScrollSnap() ?? 0;
      r("update:value", e.options[L].value);
    }, E = () => {
      r("optionsChanged");
    }, I = () => {
      if (!o.value) return;
      const { rootNode: L, slideNodes: C } = o.value, V = L().getBoundingClientRect(), J = V.top + V.height / 2;
      C().forEach((O) => {
        const K = O.getBoundingClientRect(), A = (K.top + K.height / 2 - J) / (V.height / 2), z = Math.max(-1, Math.min(1, A)), U = 1 - Math.abs(z) * 0.3, X = O.style.transform.split(" ").filter((B) => !B.startsWith("scale("));
        X.push(`scale(${U})`), O.style.transform = X.join(" ");
      });
    };
    return mt(() => {
      o.value && o.value.on("init", p).on("pointerDown", k).on("pointerUp", g).on("reInit", b).on("scroll", I).on("select", _).on("slidesChanged", E);
    }), ze(
      () => e.value,
      (L) => u(L)
    ), t({
      disable: v,
      enable: c,
      moveToOption: u
    }), (L, C) => ($(), j("div", {
      ref_key: "emblaRef",
      ref: a,
      class: "lc-slot-wheel"
    }, [
      ae("div", Zm, [
        ($(!0), j(Ge, null, vt(e.options, (F, V) => ($(), j("div", {
          key: `${F.label}-${F.value}`,
          className: "lc-slot-wheel__option"
        }, [
          me(L.$slots, "option", Te({ ref_for: !0 }, { index: V, option: F }), () => [
            wt(Ie(F.label), 1)
          ])
        ]))), 128))
      ])
    ], 512));
  }
}), Wm = ["for"], Ym = ["id", "aria-label", "data-click-name"], Xm = { class: "lc-switch__toggle" }, o2 = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcSwitch",
  props: {
    ariaLabelText: {},
    dataClickName: {},
    disabled: { type: Boolean },
    icon: { default: "checkmark" },
    id: {},
    name: { default: "switch" },
    value: { type: Boolean },
    variant: { default: "success" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = Tt(e.id), { vibrate: s } = ho(), i = W(() => [
      "lc-switch",
      `lc-switch--variant-${e.variant}`,
      {
        "lc-switch--checked": e.value,
        "lc-switch--disabled": e.disabled
      }
    ]), a = W({
      get: () => e.value,
      set: (o) => {
        n("update:value", o), s();
      }
    });
    return (o, l) => ($(), j("label", {
      class: ye([i.value, o.$attrs.class]),
      for: q(r)
    }, [
      Jt(ae("input", Te({
        ...Qt(o.$attrs, ["class"]),
        disabled: e.disabled,
        name: e.name
      }, {
        id: q(r),
        "onUpdate:modelValue": l[0] || (l[0] = (h) => a.value = h),
        "aria-label": e.ariaLabelText,
        class: "lc-switch__input",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_switch`,
        role: "switch",
        type: "checkbox",
        onKeydown: l[1] || (l[1] = ai((h) => a.value = !a.value, ["enter"]))
      }), null, 16, Ym), [
        [lo, a.value]
      ]),
      l[2] || (l[2] = ae("div", { class: "lc-switch__track" }, null, -1)),
      ae("div", Xm, [
        Oe(q(Qe), {
          class: "lc-switch__icon",
          name: e.icon
        }, null, 8, ["name"])
      ])
    ], 10, Wm));
  }
}), s2 = ["info", "success"], u2 = /* @__PURE__ */ _e({
  __name: "LcTable",
  props: {
    bordered: { type: Boolean },
    padding: { default: "medium" }
  },
  setup(e) {
    const t = W(() => [
      "lc-table",
      `lc-table--padding-${e.padding}`,
      {
        "lc-table--bordered": e.bordered
      }
    ]);
    return (n, r) => ($(), j("table", {
      class: ye(t.value)
    }, [
      me(n.$slots, "default")
    ], 2));
  }
}), c2 = ["medium", "small"], d2 = ["column", "row"], f2 = ["bottom", "top"], h2 = ["automatic", "manual"], v2 = ["default", "divider"], m2 = /* @__PURE__ */ Symbol();
var Nn = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.End = "End", e.Home = "Home", e))(Nn || {});
const Gm = ["id"], Km = ["id"], Jm = { class: "lc-tabs__tablist-inner" }, Qm = ["id", "aria-controls", "aria-selected", "disabled", "tabindex", "onClickPassive"], e1 = {
  key: 1,
  class: "lc-tabs__header"
}, t1 = ["aria-labelledby"], n1 = ["id", "aria-labelledby"], g2 = /* @__PURE__ */ _e({
  __name: "LcTabs",
  props: {
    adaptiveHeight: { type: Boolean },
    disableSwipe: { type: Boolean },
    id: {},
    navigationPosition: { default: "top" },
    renderOnlyVisible: { type: Boolean },
    containerClass: {},
    tabFlexDirection: { default: "column" },
    tabs: {},
    trigger: { default: "automatic" },
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = it("carousel"), i = it("container"), a = it("tabs"), o = Tt(e.id), l = pe(0), h = pe(0), v = pe(null), c = pe(null), f = pe(!1), m = pe(!1);
    let u = null;
    const p = W(() => [
      "lc-tabs",
      `lc-tabs--navigation-${e.navigationPosition}`,
      `lc-tabs--variant-${e.variant}`,
      {
        "lc-tabs--tablist-hidden": b.value
      }
    ]), k = () => {
      m.value = !0, u && clearTimeout(u), u = setTimeout(() => m.value = !1, 250);
    }, g = () => {
      const O = a.value?.[l.value];
      O && (v.value = `${O.offsetWidth}px`, c.value = `${O.offsetLeft}px`);
    };
    on(window, "resize", [g, k]), Qs(i, g);
    const b = W(() => e.tabs.length <= 1), _ = (O, K) => {
      O !== l.value && (l.value = O, K?.skipCarousel || s.value?.moveToIndex(O), K?.skipUpdateEvent || r("update:value", e.tabs[O].name));
    }, E = (O) => {
      a.value?.[O].focus();
    }, I = (O) => {
      if (O !== l.value)
        return {
          "aria-hidden": "true",
          inert: "true"
        };
    }, L = () => h.value === e.tabs.length - 1 ? 0 : h.value + 1, C = () => h.value === 0 ? e.tabs.length - 1 : h.value - 1, F = (O) => e.tabs.findIndex((K) => K.name === O), V = (O) => {
      if (!en(O.key, Nn)) return;
      O.preventDefault(), O.stopPropagation();
      let K;
      switch (O.key) {
        case Nn.ArrowLeft:
          K = C();
          break;
        case Nn.ArrowRight:
          K = L();
          break;
        case Nn.End:
          K = e.tabs.length - 1;
          break;
        case Nn.Home:
          K = 0;
          break;
      }
      h.value = K, e.trigger === "automatic" && _(K);
    }, J = () => {
      const O = F(e.value);
      O !== -1 && (l.value = O, h.value = O);
    };
    return Hs(J), Us(J), mt(() => {
      g(), b.value || (f.value = !0);
    }), ze(l, g), ze(h, E), ze(
      () => e.value,
      (O) => {
        if (!O) return;
        const K = F(O);
        K !== -1 && _(K, { skipUpdateEvent: !0 });
      }
    ), t({
      containerRef: i
    }), (O, K) => ($(), j("section", {
      id: q(o),
      class: ye(p.value)
    }, [
      me(O.$slots, "top"),
      b.value ? ue("", !0) : ($(), j("div", {
        key: 0,
        ref: "container",
        class: ye(["lc-tabs__nav_container", e.containerClass])
      }, [
        ae("nav", {
          id: q(o),
          class: ye(["lc-tabs__tablist", {
            "lc-tabs__tablist--no-transition": m.value
          }]),
          role: "tablist",
          style: Ct({
            "--active-tab-index": l.value,
            ...c.value && { "--indicator-offset": c.value },
            ...v.value && { "--indicator-size": v.value },
            "--tab-count": e.tabs.length
          })
        }, [
          ae("div", Jm, [
            ($(!0), j(Ge, null, vt(e.tabs, (P, T) => ($(), j("button", {
              id: `${q(o)}-tab-${T}`,
              key: P.name,
              ref_for: !0,
              ref: "tabs",
              "aria-controls": `${q(o)}-tabpanel-${T}`,
              "aria-selected": l.value === T,
              class: ye(["lc-tabs__tab", `lc-tabs__tab--flex-${e.tabFlexDirection}`]),
              disabled: !f.value,
              role: "tab",
              tabindex: l.value !== T ? -1 : void 0,
              type: "button",
              onClickPassive: (A) => _(T),
              onKeydown: V
            }, [
              O.$slots.tab ? me(O.$slots, "tab", Te({ ref_for: !0 }, { tab: P, index: T }), void 0, void 0, 0) : ($(), j(Ge, { key: 1 }, [
                P.icon ? ($(), xe(q(Qe), {
                  key: 0,
                  name: P.icon,
                  size: e.variant === "divider" ? "small" : "medium"
                }, null, 8, ["name", "size"])) : ue("", !0),
                wt(" " + Ie(P.title ?? P.name), 1)
              ], 64))
            ], 42, Qm))), 128))
          ])
        ], 14, Km),
        me(O.$slots, "subnav")
      ], 2)),
      O.$slots.header ? ($(), j("header", e1, [
        me(O.$slots, "header")
      ])) : ue("", !0),
      !f.value && e.tabs.length > 0 ? ($(), j("div", {
        key: 2,
        "aria-labelledby": `${q(o)}-tab-${l.value}`,
        class: ye(["lc-tabs__tabpanel", "lc-tabs__tabpanel--single-tab"]),
        role: "tabpanel"
      }, [
        me(O.$slots, "tab-panel", {
          index: l.value,
          tab: e.tabs[l.value]
        })
      ], 8, t1)) : ue("", !0),
      b.value ? ue("", !0) : ($(), xe(q(Ud), {
        key: 3,
        ref: "carousel",
        "adaptive-height": e.renderOnlyVisible ? !1 : e.adaptiveHeight,
        class: ye(["lc-tabs__carousel", {
          "lc-tabs__carousel--unmounted": !f.value
        }]),
        "default-index": l.value,
        "disable-swipe": e.disableSwipe || b.value,
        duration: 15,
        "key-prop": "name",
        slides: e.tabs,
        onChanged: K[0] || (K[0] = (P) => _(P, { skipCarousel: !0 })),
        onReady: K[1] || (K[1] = (P) => f.value = !0)
      }, {
        slide: Ee(({ index: P, isVisible: T, slide: A }) => [
          ae("div", Te({
            id: `${q(o)}-tabpanel-${P}`
          }, I(P), {
            "aria-labelledby": `${q(o)}-tab-${P}`,
            class: "lc-tabs__tabpanel",
            role: "tabpanel"
          }), [
            !e.renderOnlyVisible || T || P === l.value ? me(O.$slots, "tab-panel", _t(Dt({ tab: A, index: P })), void 0, void 0, 0) : ue("", !0)
          ], 16, n1)
        ]),
        _: 3
      }, 8, ["adaptive-height", "class", "default-index", "disable-swipe", "slides"]))
    ], 10, Gm));
  }
}), a1 = ["for"], r1 = ["id"], i1 = ["id", "aria-labelledby", "data-click-error", "data-click-name"], l1 = { class: "lc-textarea__feedback-wrap" }, o1 = { class: "lc-textarea__counter" }, b2 = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcTextarea",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    maxlength: { default: 82 },
    name: { default: "textarea" },
    noFeedback: { type: Boolean },
    placeholder: {},
    resizeable: { type: Boolean },
    rows: { default: 2 },
    spellcheck: { type: Boolean },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = it("textarea"), s = Tt(e.id), i = pe(!1), a = W(() => [
      "lc-textarea",
      {
        "lc-textarea--disabled": e.disabled,
        "lc-textarea--error": !!e.errorMessage,
        "lc-textarea--has-label": !!e.label
      }
    ]), o = W(() => typeof h.value == "number" ? String(h.value).length : h.value?.length ?? 0), l = W(() => [
      "lc-textarea__label",
      {
        "lc-textarea__label--floating": i.value || !!e.value || typeof e.value == "number"
      }
    ]), h = W({
      get: () => e.value,
      set: (v) => n("update:value", v)
    });
    return mt(() => {
      e.autofocus && r.value?.focus();
    }), (v, c) => ($(), j("div", {
      class: ye([a.value, v.$attrs.class])
    }, [
      ae("label", {
        class: "lc-textarea__wrap",
        for: q(s)
      }, [
        e.label ? ($(), j("span", {
          key: 0,
          id: `${q(s)}-label`,
          class: ye(l.value)
        }, Ie(e.label), 11, r1)) : ue("", !0),
        Jt(ae("textarea", Te({
          id: q(s),
          ref: "textarea"
        }, {
          ...Qt(v.$attrs, ["class"]),
          disabled: e.disabled,
          maxlength: e.maxlength,
          name: e.name,
          placeholder: e.placeholder,
          resizeable: e.resizeable,
          rows: e.rows,
          spellcheck: e.spellcheck
        }, {
          "onUpdate:modelValue": c[0] || (c[0] = (f) => h.value = f),
          "aria-labelledby": e.label ? `${q(s)}-label` : void 0,
          class: "lc-textarea__input",
          "data-click-error": e.errorMessage ?? "",
          "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_textarea`,
          onFocusin: c[1] || (c[1] = (f) => i.value = !0),
          onFocusout: c[2] || (c[2] = (f) => i.value = !1)
        }), null, 16, i1), [
          [qs, h.value]
        ])
      ], 8, a1),
      ae("div", l1, [
        e.noFeedback ? ue("", !0) : ($(), xe(q($n), Te({ key: 0 }, { disabled: e.disabled }, {
          content: e.errorMessage || e.helpMessage,
          variant: e.errorMessage ? "error" : "default"
        }), null, 16, ["content", "variant"])),
        ae("span", o1, [
          ae("span", null, Ie(o.value) + "/" + Ie(e.maxlength), 1)
        ])
      ])
    ], 2));
  }
}), s1 = { class: "lc-toast__indicator" }, u1 = { class: "lc-toast__content" }, c1 = {
  key: 0,
  class: "lc-toast__title"
}, d1 = {
  key: 0,
  class: "lc-toast__text"
}, p2 = /* @__PURE__ */ _e({
  __name: "LcToast",
  props: {
    closable: { type: Boolean, default: !0 },
    headline: {},
    text: {},
    variant: { default: "info" }
  },
  emits: ["close"],
  setup(e) {
    const t = {
      danger: "alert-triangle",
      info: "info",
      success: "checkmark",
      warning: "bell",
      win: "winning"
    };
    return (n, r) => ($(), j("article", {
      class: ye(["lc-toast", `lc-toast--variant-${e.variant}`]),
      role: "alert"
    }, [
      ae("aside", s1, [
        Oe(q(Qe), {
          name: t[e.variant]
        }, null, 8, ["name"])
      ]),
      ae("section", u1, [
        e.headline ? ($(), j("span", c1, Ie(e.headline), 1)) : ue("", !0),
        me(n.$slots, "default", {}, () => [
          e.text ? ($(), j("p", d1, Ie(e.text), 1)) : ue("", !0)
        ])
      ]),
      e.closable ? ($(), xe(q(Et), {
        key: 0,
        "aria-label": q(je).lcToast.closeButtonAriaLabel,
        class: "lc-toast__button-close",
        icon: "close",
        size: "small",
        variant: "tertiary",
        onClickPassive: r[0] || (r[0] = (s) => n.$emit("close"))
      }, null, 8, ["aria-label"])) : ue("", !0)
    ], 2));
  }
}), y2 = ["danger", "info", "success", "warning", "win"], f1 = ["left", "right"], h1 = 0.4, v1 = 0.75, ao = 0.85, m1 = 0.2, g1 = 150, b1 = 8, p1 = {
  key: 1,
  class: "lc-swipeable__action-label"
}, w2 = /* @__PURE__ */ _e({
  __name: "LcSwipeable",
  props: {
    disabled: { type: Boolean },
    leftAction: {},
    pointerTypes: {},
    rightAction: {}
  },
  emits: ["swipe-end", "swipe-start", "trigger"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = it("lcSwipeableRef"), i = An(), a = pe(null), o = pe(0), l = pe(0), h = pe(0), v = pe(!1), c = pe(!1), f = pe(!1), m = pe(!1), u = pe(!1);
    let p = 0;
    const { distanceX: k } = eu(s, {
      pointerTypes: e.pointerTypes,
      threshold: b1,
      onSwipe: () => {
        if (e.disabled || !s.value) return;
        v.value || P();
        const H = s.value.clientWidth, ee = l.value - k.value, ce = J(ee);
        if (ce && !I(ce)) {
          o.value = 0;
          return;
        }
        const we = C(ce), ke = V(ee, H, L(ce));
        m.value = O(H, we), h.value = Math.min(1, Math.abs(k.value) / (H * we));
        const te = !!(ce && E(ce)?.fullSwipe && m.value);
        T(te), A(ce), o.value = te && ce ? K(ce, H) : ke, ce && ce !== a.value && z(ce);
      },
      onSwipeEnd: (H, ee) => {
        U();
        const ce = f.value;
        if (X(), m.value = !1, !(!e.disabled && (ee === "left" || ee === "right") && I(ee) && s.value !== null && O(s.value.clientWidth, C(ee)))) {
          o.value = 0;
          return;
        }
        ce || (o.value = 0), r("trigger", ee);
      }
    }), g = W(() => f1.map((H) => ({ side: H, action: E(H) }))), b = W(() => [
      "lc-swipeable__content",
      { "lc-swipeable__content--dragging": v.value && !c.value }
    ]), _ = W(() => ao + (1 - ao) * h.value), E = (H) => H === "left" ? e.leftAction : H === "right" ? e.rightAction : void 0, I = (H) => !!(E(H) || i[`${H}-action`]), L = (H) => E(H)?.resistanceThreshold ?? v1, C = (H) => {
      const ee = E(H);
      return ee?.fullSwipe ? L(H) : ee?.activationThreshold ?? h1;
    }, F = () => {
      if (!s.value) return 0;
      const H = s.value.querySelector(
        ".lc-swipeable__content"
      );
      if (!H) return 0;
      const ee = getComputedStyle(H).transform;
      if (!ee || ee === "none") return 0;
      const ce = new DOMMatrix(ee).m41;
      return Number.isFinite(ce) ? ce : 0;
    }, V = (H, ee, ce) => {
      const we = ee * ce, ke = Math.abs(H);
      if (ke <= we) return H;
      const te = ee * m1, ge = (1 - 1 / ((ke - we) / te + 1)) * te;
      return Math.sign(H) * (we + ge);
    }, J = (H) => H < 0 ? "left" : H > 0 ? "right" : null, O = (H, ee) => Math.abs(k.value) >= H * ee, K = (H, ee) => H === "left" ? -ee : ee, P = () => {
      l.value = F(), v.value = !0;
    }, T = (H) => {
      H !== f.value && (f.value = H, c.value = !0, p = performance.now());
    }, A = (H) => {
      !c.value || f.value || !(performance.now() - p >= g1) && H === a.value || (c.value = !1);
    }, z = (H) => {
      a.value = H, u.value = !0, r("swipe-start", H);
    }, U = () => {
      !u.value || !a.value || (u.value = !1, r("swipe-end", a.value));
    }, X = () => {
      l.value = 0, h.value = 0, v.value = !1, f.value = !1, c.value = !1;
    }, B = () => {
      c.value = !1, !v.value && o.value === 0 && (a.value = null);
    }, ie = () => {
      const H = a.value, ee = u.value;
      X(), o.value = 0, m.value = !1, u.value = !1, ee && H && r("swipe-end", H);
    };
    return on(s, "pointercancel", ie), ze(
      () => e.disabled,
      (H) => {
        H && ie();
      }
    ), t({ close: ie }), (H, ee) => ($(), j("div", {
      ref_key: "lcSwipeableRef",
      ref: s,
      class: "lc-swipeable"
    }, [
      ($(!0), j(Ge, null, vt(g.value, ({ side: ce, action: we }) => ($(), j(Ge, { key: ce }, [
        we || H.$slots[`${ce}-action`] ? ($(), j("div", {
          key: 0,
          class: ye([
            "lc-swipeable__action",
            `lc-swipeable__action--${ce}`,
            {
              "lc-swipeable__action--hidden": a.value !== ce,
              "lc-swipeable__action--dragging": v.value && !c.value,
              "lc-swipeable__action--past-threshold": m.value && a.value === ce
            }
          ])
        }, [
          me(H.$slots, `${ce}-action`, {}, () => [
            we ? ($(), j("span", {
              key: 0,
              class: "lc-swipeable__action-icon",
              style: Ct(a.value === ce ? { transform: `scale(${_.value})` } : void 0)
            }, [
              Oe(q(Qe), {
                name: we.icon
              }, null, 8, ["name"])
            ], 4)) : ue("", !0),
            we?.label ? ($(), j("span", p1, Ie(we.label), 1)) : ue("", !0)
          ])
        ], 2)) : ue("", !0)
      ], 64))), 128)),
      ae("div", {
        class: ye(b.value),
        style: Ct({ transform: `translateX(${o.value}px)` }),
        onTransitionend: sa(B, ["self"])
      }, [
        me(H.$slots, "default")
      ], 38)
    ], 512));
  }
}), y1 = { class: "lc-lottery-remaining-picks__headline" }, w1 = { class: "lc-lottery-remaining-picks__done" }, x1 = {
  "aria-hidden": "true",
  class: "lc-lottery-remaining-picks__check"
}, k1 = {
  key: 0,
  class: "lc-lottery-remaining-picks__label"
}, S1 = /* @__PURE__ */ _e({
  __name: "LcLotteryRemainingPicks",
  props: {
    complete: { type: Boolean, default: !1 },
    doneLabel: { default: () => je.lcLotteryRemainingPicks.doneLabel }
  },
  setup(e) {
    const t = pe(!1);
    ze(
      () => e.complete,
      (r, s) => {
        r && !s ? t.value = !0 : r || (t.value = !1);
      }
    );
    const n = (r) => {
      const s = e.doneLabel ? "lc-lottery-remaining-picks-label" : "lc-lottery-remaining-picks-pop";
      r.animationName === s && (t.value = !1);
    };
    return (r, s) => ($(), j("div", {
      class: ye([
        "lc-lottery-remaining-picks",
        {
          "lc-lottery-remaining-picks--complete": e.complete,
          "lc-lottery-remaining-picks--playing": t.value
        }
      ]),
      onAnimationend: n
    }, [
      ae("div", y1, [
        me(r.$slots, "default", { countClass: "lc-lottery-remaining-picks__count" })
      ]),
      ae("div", w1, [
        ae("span", x1, [
          Oe(q(Qe), {
            name: "checkmark-small",
            size: "medium"
          })
        ]),
        e.doneLabel ? ($(), j("span", k1, Ie(e.doneLabel), 1)) : ue("", !0)
      ])
    ], 34));
  }
}), _1 = ["aria-hidden"], C1 = ["aria-hidden"], E1 = {
  key: 1,
  class: "lc-lottery-editor-card__labels"
}, T1 = {
  key: 0,
  class: "lc-lottery-editor-card__label"
}, A1 = {
  key: 1,
  class: "lc-lottery-editor-card__label"
}, L1 = { class: "lc-lottery-editor-card__footer" }, $1 = "medium", x2 = /* @__PURE__ */ _e({
  __name: "LcLotteryEditorCard",
  props: /* @__PURE__ */ Sn({
    id: {},
    radius: { default: "large" },
    shadow: { default: "small" },
    betType: {},
    clearDisabled: { type: Boolean },
    clearLabel: { default: () => je.lcLotteryEditorCard.clearLabel },
    complete: { type: Boolean },
    doneLabel: {},
    expanded: { type: Boolean },
    fields: {},
    quickPickLabel: { default: () => je.lcLotteryEditorCard.quickPickLabel },
    remaining: {},
    toggleAriaLabel: { default: () => je.lcLotteryEditorCard.toggleAriaLabel },
    wager: {},
    separated: { type: Boolean, default: !1 }
  }, {
    expanded: { type: Boolean, default: !0 },
    expandedModifiers: {}
  }),
  emits: /* @__PURE__ */ Sn(["clear", "collapse", "collapsed", "expand", "expanded", "quick-pick", "update:expanded"], ["update:expanded"]),
  setup(e, { emit: t }) {
    const n = t, r = Wa(e, "expanded"), s = it("summary"), i = it("numbers"), a = (f) => i.value?.$el?.querySelector(f) ?? void 0, o = W(() => a(".lc-lottery-numbers__number")), { width: l } = Vr(s), { width: h } = Vr(o), v = W(
      () => e.fields?.reduce((f, { numbers: m }) => f + m.length, 0) ?? 0
    ), c = W(() => {
      if (!l.value || !h.value || !v.value) return;
      const f = a(".lc-lottery-numbers__list"), m = f && parseFloat(getComputedStyle(f).columnGap) || 0, u = Math.max(
        1,
        Math.floor((l.value + m) / (h.value + m))
      ), p = Math.ceil(v.value / u);
      return p > 1 ? p : void 0;
    });
    return (f, m) => ($(), xe(q(ya), Te({
      modelValue: r.value,
      "onUpdate:modelValue": m[2] || (m[2] = (u) => r.value = u),
      animated: "",
      "body-class": "lc-lottery-editor-card__body",
      class: ["lc-lottery-editor-card", { "lc-lottery-editor-card--separated": e.separated }],
      expandable: "",
      "footer-class": "lc-lottery-editor-card__footer-slot",
      "header-class": r.value ? "lc-lottery-editor-card__header--expanded" : "lc-lottery-editor-card__header"
    }, { id: e.id, radius: e.radius, shadow: e.shadow, toggleAriaLabel: e.toggleAriaLabel }, {
      onCollapse: m[3] || (m[3] = (u) => n("collapse")),
      onCollapsed: m[4] || (m[4] = (u) => n("collapsed")),
      onExpand: m[5] || (m[5] = (u) => n("expand")),
      onExpanded: m[6] || (m[6] = (u) => n("expanded"))
    }), {
      header: Ee(() => [
        ae("div", {
          class: ye([
            "lc-lottery-editor-card__header-content",
            { "lc-lottery-editor-card__header-content--collapsed": !r.value }
          ])
        }, [
          ae("div", {
            "aria-hidden": !r.value,
            class: "lc-lottery-editor-card__expanded"
          }, [
            Oe(q(S1), _t(Dt({ complete: e.complete, doneLabel: e.doneLabel, remaining: e.remaining })), {
              default: Ee(({ countClass: u }) => [
                me(f.$slots, "headline", _t(Dt({ countClass: u })))
              ]),
              _: 3
            }, 16)
          ], 8, _1),
          ae("div", {
            ref: "summary",
            "aria-hidden": r.value,
            class: "lc-lottery-editor-card__summary"
          }, [
            e.fields ? ($(), xe(q(Fh), Te({
              key: 0,
              ref: "numbers"
            }, { fields: e.fields }, {
              rows: c.value,
              size: $1
            }), null, 16, ["rows"])) : ue("", !0),
            e.wager || e.betType ? ($(), j("div", E1, [
              e.wager ? ($(), j("span", T1, Ie(e.wager), 1)) : ue("", !0),
              e.betType ? ($(), j("span", A1, Ie(e.betType), 1)) : ue("", !0)
            ])) : ue("", !0)
          ], 8, C1)
        ], 2)
      ]),
      footer: Ee(() => [
        ae("div", L1, [
          Oe(q(Et), {
            class: "lc-lottery-editor-card__clear",
            disabled: e.clearDisabled,
            icon: "trash-full",
            size: "medium",
            variant: e.clearDisabled ? "tertiary" : "raised",
            onClick: m[0] || (m[0] = (u) => n("clear"))
          }, {
            default: Ee(() => [
              wt(Ie(e.clearLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled", "variant"]),
          Oe(q(Et), {
            class: "lc-lottery-editor-card__quick-pick",
            icon: "flash",
            size: "medium",
            variant: "raised",
            onClick: m[1] || (m[1] = (u) => n("quick-pick"))
          }, {
            default: Ee(() => [
              wt(Ie(e.quickPickLabel), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: Ee(() => [
        e.separated ? ($(), xe(q(si), {
          key: 0,
          class: "lc-lottery-editor-card__divider"
        })) : ue("", !0),
        me(f.$slots, "default")
      ]),
      _: 3
    }, 16, ["modelValue", "class", "header-class"]));
  }
});
export {
  Ho as AmplitudeEvents,
  Nt as FORM_FIELD_EVENTS,
  G1 as LC_BOTTOM_SHEET_CLOSE_TRIGGERS,
  B1 as LC_BUTTON_ICON_POSITIONS,
  P1 as LC_BUTTON_SIZES,
  V1 as LC_BUTTON_TRIGGERS,
  z1 as LC_BUTTON_TYPES,
  H1 as LC_BUTTON_VARIANTS,
  q1 as LC_CARD_RADII,
  j1 as LC_CARD_SHADOWS,
  Z1 as LC_CARD_VARIANTS,
  J1 as LC_CAROUSEL_MOVE_TRIGGERS,
  K1 as LC_CAROUSEL_VARIANTS,
  eg as LC_COUNTDOWN_VARIANTS,
  fg as LC_FORM_FIELD_INTERACTION_MODES,
  R1 as LC_ICON_NAMES,
  O1 as LC_ICON_SIZES,
  gg as LC_INFO_BUTTON_VARIANTS,
  Cg as LC_INFO_TEXT_ICON_ALIGNMENTS,
  Eg as LC_INFO_TEXT_SIZES,
  ag as LC_INPUT_MODES,
  rg as LC_INPUT_TYPES,
  Lg as LC_LOTTERY_CUTOFF_TIME_VARIANTS,
  mg as LC_LOTTERY_JACPOT_SIZES,
  Dg as LC_LOTTERY_NUMBER_SELECTOR_VARIANTS,
  $g as LC_LOTTERY_NUMBER_SIZES,
  Ig as LC_LOTTERY_NUMBER_SPACINGS,
  Rg as LC_LOTTERY_TEASER_VARIANTS,
  Ng as LC_MENU_BUTTON_PLACEMENTS,
  zg as LC_MESSAGE_BOX_SIZES,
  Vg as LC_MESSAGE_BOX_VARIANTS,
  W1 as LC_MODAL_CLOSE_TRIGGERS,
  Y1 as LC_MODAL_SPACINGS,
  qg as LC_PASSWORD_INPUT_TYPES,
  Zg as LC_PROGRESS_INDICATOR_SIZES,
  Wg as LC_PROGRESS_INDICATOR_VARIANTS,
  Gg as LC_RADIO_GROUP_LAYOUTS,
  t2 as LC_SCRATCHCARD_TEASER_VARIANTS,
  a2 as LC_SELECT_LIST_VARIANTS,
  U1 as LC_SEPARATOR_VARIANTS,
  Jg as LC_SKELETON_RADII,
  s2 as LC_SWITCH_VARIANTS,
  c2 as LC_TABLE_PADDINGS,
  d2 as LC_TABS_FLEX_DIRECTIONS,
  f2 as LC_TABS_NAVIGATION_POSITIONS,
  h2 as LC_TABS_TRIGGERS,
  v2 as LC_TABS_VARIANTS,
  bg as LC_TEASER_BACKGROUND_PATTERNS,
  pg as LC_TEASER_BADGE_VARIANTS,
  yg as LC_TEASER_HERO_BADGE_VARIANTS,
  Wo as LC_TEASER_VARIANTS,
  y2 as LC_TOAST_VARIANTS,
  F1 as LcBadge,
  X1 as LcBottomSheet,
  Et as LcButton,
  jr as LcButtonActiveKeys,
  ya as LcCard,
  Ud as LcCarousel,
  Oa as LcCarouselActiveKeys,
  Q1 as LcCheckbox,
  Hr as LcCountBubble,
  Xd as LcCountdown,
  tg as LcDataList,
  ng as LcDataListItem,
  ig as LcDateInput,
  lg as LcDescriptionList,
  og as LcDigitInput,
  rn as LcDigitInputActiveKeys,
  sg as LcDigitInputGroup,
  Cf as LcExpandable,
  ug as LcExpandableList,
  cg as LcFlyOut,
  dg as LcForm,
  hg as LcFormField,
  vg as LcHeader,
  jf as LcHighFrequencyBall,
  Uo as LcHighFrequencyBallBackground,
  wg as LcHighFrequencyTeaser,
  xg as LcHighFrequencyTeaserWatch,
  Qe as LcIcon,
  Sg as LcImage,
  Zo as LcInfoButton,
  _g as LcInfoText,
  tr as LcInput,
  Tg as LcLinkList,
  Ag as LcLinkListItem,
  Pl as LcLotteryCutoffTime,
  x2 as LcLotteryEditorCard,
  qo as LcLotteryJackpot,
  Mg as LcLotteryNumberSelector,
  jt as LcLotteryNumberSelectorActiveKeys,
  Fh as LcLotteryNumbers,
  S1 as LcLotteryRemainingPicks,
  Og as LcLotteryTeaser,
  Fg as LcMaskedValueDisplay,
  Bg as LcMenuButton,
  Ht as LcMenuButtonActiveKeys,
  Pg as LcMessageBox,
  $o as LcModal,
  Hg as LcMoneyInput,
  Ug as LcPasswordInput,
  jg as LcProgressIndicator,
  nm as LcRadio,
  Yg as LcRadioCard,
  Xg as LcRadioGroup,
  Kg as LcRating,
  Qg as LcRemoteList,
  e2 as LcScratchcardTeaser,
  n2 as LcSelect,
  Xt as LcSelectActiveKeys,
  r2 as LcSelectList,
  Zt as LcSelectListActiveKeys,
  si as LcSeparator,
  om as LcSkeleton,
  i2 as LcSlider,
  l2 as LcSlotWheel,
  w2 as LcSwipeable,
  o2 as LcSwitch,
  u2 as LcTable,
  g2 as LcTabs,
  Nn as LcTabsActiveKeys,
  nr as LcTeaser,
  h0 as LcTeaserBadge,
  m0 as LcTeaserHeroBadge,
  Yo as LcTeaserHeroBadgeColor,
  b2 as LcTextarea,
  p2 as LcToast,
  Yr as carouselContext,
  je as globalConfig,
  g0 as isHeroBadge,
  cc as nuxtAppContext,
  N1 as setGlobalConfig,
  m2 as tabContext
};
